//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), s = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, c = (n, r, a) => (a = n == null ? {} : e(i(n)), s(r || !n || !n.__esModule ? t(a, "default", {
	value: n,
	enumerable: !0
}) : a, n)), l = /* @__PURE__ */ o(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.activity"), p = Symbol.iterator;
	function m(e) {
		return typeof e != "object" || !e ? null : (e = p && e[p] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var h = {
		isMounted: function() {
			return !1;
		},
		enqueueForceUpdate: function() {},
		enqueueReplaceState: function() {},
		enqueueSetState: function() {}
	}, g = Object.assign, _ = {};
	function v(e, t, n) {
		this.props = e, this.context = t, this.refs = _, this.updater = n || h;
	}
	v.prototype.isReactComponent = {}, v.prototype.setState = function(e, t) {
		if (typeof e != "object" && typeof e != "function" && e != null) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
		this.updater.enqueueSetState(this, e, t, "setState");
	}, v.prototype.forceUpdate = function(e) {
		this.updater.enqueueForceUpdate(this, e, "forceUpdate");
	};
	function y() {}
	y.prototype = v.prototype;
	function b(e, t, n) {
		this.props = e, this.context = t, this.refs = _, this.updater = n || h;
	}
	var x = b.prototype = new y();
	x.constructor = b, g(x, v.prototype), x.isPureReactComponent = !0;
	var ee = Array.isArray;
	function S() {}
	var C = {
		H: null,
		A: null,
		T: null,
		S: null
	}, w = Object.prototype.hasOwnProperty;
	function te(e, n, r) {
		var i = r.ref;
		return {
			$$typeof: t,
			type: e,
			key: n,
			ref: i === void 0 ? null : i,
			props: r
		};
	}
	function ne(e, t) {
		return te(e.type, t, e.props);
	}
	function re(e) {
		return typeof e == "object" && !!e && e.$$typeof === t;
	}
	function ie(e) {
		var t = {
			"=": "=0",
			":": "=2"
		};
		return "$" + e.replace(/[=:]/g, function(e) {
			return t[e];
		});
	}
	var ae = /\/+/g;
	function oe(e, t) {
		return typeof e == "object" && e && e.key != null ? ie("" + e.key) : t.toString(36);
	}
	function se(e) {
		switch (e.status) {
			case "fulfilled": return e.value;
			case "rejected": throw e.reason;
			default: switch (typeof e.status == "string" ? e.then(S, S) : (e.status = "pending", e.then(function(t) {
				e.status === "pending" && (e.status = "fulfilled", e.value = t);
			}, function(t) {
				e.status === "pending" && (e.status = "rejected", e.reason = t);
			})), e.status) {
				case "fulfilled": return e.value;
				case "rejected": throw e.reason;
			}
		}
		throw e;
	}
	function ce(e, r, i, a, o) {
		var s = typeof e;
		(s === "undefined" || s === "boolean") && (e = null);
		var c = !1;
		if (e === null) c = !0;
		else switch (s) {
			case "bigint":
			case "string":
			case "number":
				c = !0;
				break;
			case "object": switch (e.$$typeof) {
				case t:
				case n:
					c = !0;
					break;
				case d: return c = e._init, ce(c(e._payload), r, i, a, o);
			}
		}
		if (c) return o = o(e), c = a === "" ? "." + oe(e, 0) : a, ee(o) ? (i = "", c != null && (i = c.replace(ae, "$&/") + "/"), ce(o, r, i, "", function(e) {
			return e;
		})) : o != null && (re(o) && (o = ne(o, i + (o.key == null || e && e.key === o.key ? "" : ("" + o.key).replace(ae, "$&/") + "/") + c)), r.push(o)), 1;
		c = 0;
		var l = a === "" ? "." : a + ":";
		if (ee(e)) for (var u = 0; u < e.length; u++) a = e[u], s = l + oe(a, u), c += ce(a, r, i, s, o);
		else if (u = m(e), typeof u == "function") for (e = u.call(e), u = 0; !(a = e.next()).done;) a = a.value, s = l + oe(a, u++), c += ce(a, r, i, s, o);
		else if (s === "object") {
			if (typeof e.then == "function") return ce(se(e), r, i, a, o);
			throw r = String(e), Error("Objects are not valid as a React child (found: " + (r === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
		}
		return c;
	}
	function le(e, t, n) {
		if (e == null) return e;
		var r = [], i = 0;
		return ce(e, r, "", "", function(e) {
			return t.call(n, e, i++);
		}), r;
	}
	function ue(e) {
		if (e._status === -1) {
			var t = e._result;
			t = t(), t.then(function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 1, e._result = t);
			}, function(t) {
				(e._status === 0 || e._status === -1) && (e._status = 2, e._result = t);
			}), e._status === -1 && (e._status = 0, e._result = t);
		}
		if (e._status === 1) return e._result.default;
		throw e._result;
	}
	var T = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, E = {
		map: le,
		forEach: function(e, t, n) {
			le(e, function() {
				t.apply(this, arguments);
			}, n);
		},
		count: function(e) {
			var t = 0;
			return le(e, function() {
				t++;
			}), t;
		},
		toArray: function(e) {
			return le(e, function(e) {
				return e;
			}) || [];
		},
		only: function(e) {
			if (!re(e)) throw Error("React.Children.only expected to receive a single React element child.");
			return e;
		}
	};
	e.Activity = f, e.Children = E, e.Component = v, e.Fragment = r, e.Profiler = a, e.PureComponent = b, e.StrictMode = i, e.Suspense = l, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = C, e.__COMPILER_RUNTIME = {
		__proto__: null,
		c: function(e) {
			return C.H.useMemoCache(e);
		}
	}, e.cache = function(e) {
		return function() {
			return e.apply(null, arguments);
		};
	}, e.cacheSignal = function() {
		return null;
	}, e.cloneElement = function(e, t, n) {
		if (e == null) throw Error("The argument must be a React element, but you passed " + e + ".");
		var r = g({}, e.props), i = e.key;
		if (t != null) for (a in t.key !== void 0 && (i = "" + t.key), t) !w.call(t, a) || a === "key" || a === "__self" || a === "__source" || a === "ref" && t.ref === void 0 || (r[a] = t[a]);
		var a = arguments.length - 2;
		if (a === 1) r.children = n;
		else if (1 < a) {
			for (var o = Array(a), s = 0; s < a; s++) o[s] = arguments[s + 2];
			r.children = o;
		}
		return te(e.type, i, r);
	}, e.createContext = function(e) {
		return e = {
			$$typeof: s,
			_currentValue: e,
			_currentValue2: e,
			_threadCount: 0,
			Provider: null,
			Consumer: null
		}, e.Provider = e, e.Consumer = {
			$$typeof: o,
			_context: e
		}, e;
	}, e.createElement = function(e, t, n) {
		var r, i = {}, a = null;
		if (t != null) for (r in t.key !== void 0 && (a = "" + t.key), t) w.call(t, r) && r !== "key" && r !== "__self" && r !== "__source" && (i[r] = t[r]);
		var o = arguments.length - 2;
		if (o === 1) i.children = n;
		else if (1 < o) {
			for (var s = Array(o), c = 0; c < o; c++) s[c] = arguments[c + 2];
			i.children = s;
		}
		if (e && e.defaultProps) for (r in o = e.defaultProps, o) i[r] === void 0 && (i[r] = o[r]);
		return te(e, a, i);
	}, e.createRef = function() {
		return { current: null };
	}, e.forwardRef = function(e) {
		return {
			$$typeof: c,
			render: e
		};
	}, e.isValidElement = re, e.lazy = function(e) {
		return {
			$$typeof: d,
			_payload: {
				_status: -1,
				_result: e
			},
			_init: ue
		};
	}, e.memo = function(e, t) {
		return {
			$$typeof: u,
			type: e,
			compare: t === void 0 ? null : t
		};
	}, e.startTransition = function(e) {
		var t = C.T, n = {};
		C.T = n;
		try {
			var r = e(), i = C.S;
			i !== null && i(n, r), typeof r == "object" && r && typeof r.then == "function" && r.then(S, T);
		} catch (e) {
			T(e);
		} finally {
			t !== null && n.types !== null && (t.types = n.types), C.T = t;
		}
	}, e.unstable_useCacheRefresh = function() {
		return C.H.useCacheRefresh();
	}, e.use = function(e) {
		return C.H.use(e);
	}, e.useActionState = function(e, t, n) {
		return C.H.useActionState(e, t, n);
	}, e.useCallback = function(e, t) {
		return C.H.useCallback(e, t);
	}, e.useContext = function(e) {
		return C.H.useContext(e);
	}, e.useDebugValue = function() {}, e.useDeferredValue = function(e, t) {
		return C.H.useDeferredValue(e, t);
	}, e.useEffect = function(e, t) {
		return C.H.useEffect(e, t);
	}, e.useEffectEvent = function(e) {
		return C.H.useEffectEvent(e);
	}, e.useId = function() {
		return C.H.useId();
	}, e.useImperativeHandle = function(e, t, n) {
		return C.H.useImperativeHandle(e, t, n);
	}, e.useInsertionEffect = function(e, t) {
		return C.H.useInsertionEffect(e, t);
	}, e.useLayoutEffect = function(e, t) {
		return C.H.useLayoutEffect(e, t);
	}, e.useMemo = function(e, t) {
		return C.H.useMemo(e, t);
	}, e.useOptimistic = function(e, t) {
		return C.H.useOptimistic(e, t);
	}, e.useReducer = function(e, t, n) {
		return C.H.useReducer(e, t, n);
	}, e.useRef = function(e) {
		return C.H.useRef(e);
	}, e.useState = function(e) {
		return C.H.useState(e);
	}, e.useSyncExternalStore = function(e, t, n) {
		return C.H.useSyncExternalStore(e, t, n);
	}, e.useTransition = function() {
		return C.H.useTransition();
	}, e.version = "19.2.6";
})), u = /* @__PURE__ */ o(((e, t) => {
	t.exports = l();
})), d = /* @__PURE__ */ o(((e) => {
	function t(e, t) {
		var n = e.length;
		e.push(t);
		a: for (; 0 < n;) {
			var r = n - 1 >>> 1, a = e[r];
			if (0 < i(a, t)) e[r] = t, e[n] = a, n = r;
			else break a;
		}
	}
	function n(e) {
		return e.length === 0 ? null : e[0];
	}
	function r(e) {
		if (e.length === 0) return null;
		var t = e[0], n = e.pop();
		if (n !== t) {
			e[0] = n;
			a: for (var r = 0, a = e.length, o = a >>> 1; r < o;) {
				var s = 2 * (r + 1) - 1, c = e[s], l = s + 1, u = e[l];
				if (0 > i(c, n)) l < a && 0 > i(u, c) ? (e[r] = u, e[l] = n, r = l) : (e[r] = c, e[s] = n, r = s);
				else if (l < a && 0 > i(u, n)) e[r] = u, e[l] = n, r = l;
				else break a;
			}
		}
		return t;
	}
	function i(e, t) {
		var n = e.sortIndex - t.sortIndex;
		return n === 0 ? e.id - t.id : n;
	}
	if (e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
		var a = performance;
		e.unstable_now = function() {
			return a.now();
		};
	} else {
		var o = Date, s = o.now();
		e.unstable_now = function() {
			return o.now() - s;
		};
	}
	var c = [], l = [], u = 1, d = null, f = 3, p = !1, m = !1, h = !1, g = !1, _ = typeof setTimeout == "function" ? setTimeout : null, v = typeof clearTimeout == "function" ? clearTimeout : null, y = typeof setImmediate < "u" ? setImmediate : null;
	function b(e) {
		for (var i = n(l); i !== null;) {
			if (i.callback === null) r(l);
			else if (i.startTime <= e) r(l), i.sortIndex = i.expirationTime, t(c, i);
			else break;
			i = n(l);
		}
	}
	function x(e) {
		if (h = !1, b(e), !m) if (n(c) !== null) m = !0, ee || (ee = !0, re());
		else {
			var t = n(l);
			t !== null && oe(x, t.startTime - e);
		}
	}
	var ee = !1, S = -1, C = 5, w = -1;
	function te() {
		return g ? !0 : !(e.unstable_now() - w < C);
	}
	function ne() {
		if (g = !1, ee) {
			var t = e.unstable_now();
			w = t;
			var i = !0;
			try {
				a: {
					m = !1, h && (h = !1, v(S), S = -1), p = !0;
					var a = f;
					try {
						b: {
							for (b(t), d = n(c); d !== null && !(d.expirationTime > t && te());) {
								var o = d.callback;
								if (typeof o == "function") {
									d.callback = null, f = d.priorityLevel;
									var s = o(d.expirationTime <= t);
									if (t = e.unstable_now(), typeof s == "function") {
										d.callback = s, b(t), i = !0;
										break b;
									}
									d === n(c) && r(c), b(t);
								} else r(c);
								d = n(c);
							}
							if (d !== null) i = !0;
							else {
								var u = n(l);
								u !== null && oe(x, u.startTime - t), i = !1;
							}
						}
						break a;
					} finally {
						d = null, f = a, p = !1;
					}
					i = void 0;
				}
			} finally {
				i ? re() : ee = !1;
			}
		}
	}
	var re;
	if (typeof y == "function") re = function() {
		y(ne);
	};
	else if (typeof MessageChannel < "u") {
		var ie = new MessageChannel(), ae = ie.port2;
		ie.port1.onmessage = ne, re = function() {
			ae.postMessage(null);
		};
	} else re = function() {
		_(ne, 0);
	};
	function oe(t, n) {
		S = _(function() {
			t(e.unstable_now());
		}, n);
	}
	e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(e) {
		e.callback = null;
	}, e.unstable_forceFrameRate = function(e) {
		0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : C = 0 < e ? Math.floor(1e3 / e) : 5;
	}, e.unstable_getCurrentPriorityLevel = function() {
		return f;
	}, e.unstable_next = function(e) {
		switch (f) {
			case 1:
			case 2:
			case 3:
				var t = 3;
				break;
			default: t = f;
		}
		var n = f;
		f = t;
		try {
			return e();
		} finally {
			f = n;
		}
	}, e.unstable_requestPaint = function() {
		g = !0;
	}, e.unstable_runWithPriority = function(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 3:
			case 4:
			case 5: break;
			default: e = 3;
		}
		var n = f;
		f = e;
		try {
			return t();
		} finally {
			f = n;
		}
	}, e.unstable_scheduleCallback = function(r, i, a) {
		var o = e.unstable_now();
		switch (typeof a == "object" && a ? (a = a.delay, a = typeof a == "number" && 0 < a ? o + a : o) : a = o, r) {
			case 1:
				var s = -1;
				break;
			case 2:
				s = 250;
				break;
			case 5:
				s = 1073741823;
				break;
			case 4:
				s = 1e4;
				break;
			default: s = 5e3;
		}
		return s = a + s, r = {
			id: u++,
			callback: i,
			priorityLevel: r,
			startTime: a,
			expirationTime: s,
			sortIndex: -1
		}, a > o ? (r.sortIndex = a, t(l, r), n(c) === null && r === n(l) && (h ? (v(S), S = -1) : h = !0, oe(x, a - o))) : (r.sortIndex = s, t(c, r), m || p || (m = !0, ee || (ee = !0, re()))), r;
	}, e.unstable_shouldYield = te, e.unstable_wrapCallback = function(e) {
		var t = f;
		return function() {
			var n = f;
			f = t;
			try {
				return e.apply(this, arguments);
			} finally {
				f = n;
			}
		};
	};
})), f = /* @__PURE__ */ o(((e, t) => {
	t.exports = d();
})), p = /* @__PURE__ */ o(((e) => {
	var t = u();
	function n(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function r() {}
	var i = {
		d: {
			f: r,
			r: function() {
				throw Error(n(522));
			},
			D: r,
			C: r,
			L: r,
			m: r,
			X: r,
			S: r,
			M: r
		},
		p: 0,
		findDOMNode: null
	}, a = Symbol.for("react.portal");
	function o(e, t, n) {
		var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
		return {
			$$typeof: a,
			key: r == null ? null : "" + r,
			children: e,
			containerInfo: t,
			implementation: n
		};
	}
	var s = t.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
	function c(e, t) {
		if (e === "font") return "";
		if (typeof t == "string") return t === "use-credentials" ? t : "";
	}
	e.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = i, e.createPortal = function(e, t) {
		var r = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
		if (!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11) throw Error(n(299));
		return o(e, t, null, r);
	}, e.flushSync = function(e) {
		var t = s.T, n = i.p;
		try {
			if (s.T = null, i.p = 2, e) return e();
		} finally {
			s.T = t, i.p = n, i.d.f();
		}
	}, e.preconnect = function(e, t) {
		typeof e == "string" && (t ? (t = t.crossOrigin, t = typeof t == "string" ? t === "use-credentials" ? t : "" : void 0) : t = null, i.d.C(e, t));
	}, e.prefetchDNS = function(e) {
		typeof e == "string" && i.d.D(e);
	}, e.preinit = function(e, t) {
		if (typeof e == "string" && t && typeof t.as == "string") {
			var n = t.as, r = c(n, t.crossOrigin), a = typeof t.integrity == "string" ? t.integrity : void 0, o = typeof t.fetchPriority == "string" ? t.fetchPriority : void 0;
			n === "style" ? i.d.S(e, typeof t.precedence == "string" ? t.precedence : void 0, {
				crossOrigin: r,
				integrity: a,
				fetchPriority: o
			}) : n === "script" && i.d.X(e, {
				crossOrigin: r,
				integrity: a,
				fetchPriority: o,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0
			});
		}
	}, e.preinitModule = function(e, t) {
		if (typeof e == "string") if (typeof t == "object" && t) {
			if (t.as == null || t.as === "script") {
				var n = c(t.as, t.crossOrigin);
				i.d.M(e, {
					crossOrigin: n,
					integrity: typeof t.integrity == "string" ? t.integrity : void 0,
					nonce: typeof t.nonce == "string" ? t.nonce : void 0
				});
			}
		} else t ?? i.d.M(e);
	}, e.preload = function(e, t) {
		if (typeof e == "string" && typeof t == "object" && t && typeof t.as == "string") {
			var n = t.as, r = c(n, t.crossOrigin);
			i.d.L(e, n, {
				crossOrigin: r,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0,
				type: typeof t.type == "string" ? t.type : void 0,
				fetchPriority: typeof t.fetchPriority == "string" ? t.fetchPriority : void 0,
				referrerPolicy: typeof t.referrerPolicy == "string" ? t.referrerPolicy : void 0,
				imageSrcSet: typeof t.imageSrcSet == "string" ? t.imageSrcSet : void 0,
				imageSizes: typeof t.imageSizes == "string" ? t.imageSizes : void 0,
				media: typeof t.media == "string" ? t.media : void 0
			});
		}
	}, e.preloadModule = function(e, t) {
		if (typeof e == "string") if (t) {
			var n = c(t.as, t.crossOrigin);
			i.d.m(e, {
				as: typeof t.as == "string" && t.as !== "script" ? t.as : void 0,
				crossOrigin: n,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0
			});
		} else i.d.m(e);
	}, e.requestFormReset = function(e) {
		i.d.r(e);
	}, e.unstable_batchedUpdates = function(e, t) {
		return e(t);
	}, e.useFormState = function(e, t, n) {
		return s.H.useFormState(e, t, n);
	}, e.useFormStatus = function() {
		return s.H.useHostTransitionStatus();
	}, e.version = "19.2.6";
})), m = /* @__PURE__ */ o(((e, t) => {
	function n() {
		if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
			__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
		} catch (e) {
			console.error(e);
		}
	}
	n(), t.exports = p();
})), h = /* @__PURE__ */ o(((e) => {
	var t = f(), n = u(), r = m();
	function i(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function a(e) {
		return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
	}
	function o(e) {
		var t = e, n = e;
		if (e.alternate) for (; t.return;) t = t.return;
		else {
			e = t;
			do
				t = e, t.flags & 4098 && (n = t.return), e = t.return;
			while (e);
		}
		return t.tag === 3 ? n : null;
	}
	function s(e) {
		if (e.tag === 13) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function c(e) {
		if (e.tag === 31) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function l(e) {
		if (o(e) !== e) throw Error(i(188));
	}
	function d(e) {
		var t = e.alternate;
		if (!t) {
			if (t = o(e), t === null) throw Error(i(188));
			return t === e ? e : null;
		}
		for (var n = e, r = t;;) {
			var a = n.return;
			if (a === null) break;
			var s = a.alternate;
			if (s === null) {
				if (r = a.return, r !== null) {
					n = r;
					continue;
				}
				break;
			}
			if (a.child === s.child) {
				for (s = a.child; s;) {
					if (s === n) return l(a), e;
					if (s === r) return l(a), t;
					s = s.sibling;
				}
				throw Error(i(188));
			}
			if (n.return !== r.return) n = a, r = s;
			else {
				for (var c = !1, u = a.child; u;) {
					if (u === n) {
						c = !0, n = a, r = s;
						break;
					}
					if (u === r) {
						c = !0, r = a, n = s;
						break;
					}
					u = u.sibling;
				}
				if (!c) {
					for (u = s.child; u;) {
						if (u === n) {
							c = !0, n = s, r = a;
							break;
						}
						if (u === r) {
							c = !0, r = s, n = a;
							break;
						}
						u = u.sibling;
					}
					if (!c) throw Error(i(189));
				}
			}
			if (n.alternate !== r) throw Error(i(190));
		}
		if (n.tag !== 3) throw Error(i(188));
		return n.stateNode.current === n ? e : t;
	}
	function p(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e;
		for (e = e.child; e !== null;) {
			if (t = p(e), t !== null) return t;
			e = e.sibling;
		}
		return null;
	}
	var h = Object.assign, g = Symbol.for("react.element"), _ = Symbol.for("react.transitional.element"), v = Symbol.for("react.portal"), y = Symbol.for("react.fragment"), b = Symbol.for("react.strict_mode"), x = Symbol.for("react.profiler"), ee = Symbol.for("react.consumer"), S = Symbol.for("react.context"), C = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), te = Symbol.for("react.suspense_list"), ne = Symbol.for("react.memo"), re = Symbol.for("react.lazy"), ie = Symbol.for("react.activity"), ae = Symbol.for("react.memo_cache_sentinel"), oe = Symbol.iterator;
	function se(e) {
		return typeof e != "object" || !e ? null : (e = oe && e[oe] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var ce = Symbol.for("react.client.reference");
	function le(e) {
		if (e == null) return null;
		if (typeof e == "function") return e.$$typeof === ce ? null : e.displayName || e.name || null;
		if (typeof e == "string") return e;
		switch (e) {
			case y: return "Fragment";
			case x: return "Profiler";
			case b: return "StrictMode";
			case w: return "Suspense";
			case te: return "SuspenseList";
			case ie: return "Activity";
		}
		if (typeof e == "object") switch (e.$$typeof) {
			case v: return "Portal";
			case S: return e.displayName || "Context";
			case ee: return (e._context.displayName || "Context") + ".Consumer";
			case C:
				var t = e.render;
				return e = e.displayName, e ||= (e = t.displayName || t.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
			case ne: return t = e.displayName || null, t === null ? le(e.type) || "Memo" : t;
			case re:
				t = e._payload, e = e._init;
				try {
					return le(e(t));
				} catch {}
		}
		return null;
	}
	var ue = Array.isArray, T = n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, E = r.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, de = {
		pending: !1,
		data: null,
		method: null,
		action: null
	}, fe = [], pe = -1;
	function me(e) {
		return { current: e };
	}
	function D(e) {
		0 > pe || (e.current = fe[pe], fe[pe] = null, pe--);
	}
	function he(e, t) {
		pe++, fe[pe] = e.current, e.current = t;
	}
	var ge = me(null), _e = me(null), ve = me(null), ye = me(null);
	function be(e, t) {
		switch (he(ve, t), he(_e, e), he(ge, null), t.nodeType) {
			case 9:
			case 11:
				e = (e = t.documentElement) && (e = e.namespaceURI) ? Vd(e) : 0;
				break;
			default: if (e = t.tagName, t = t.namespaceURI) t = Vd(t), e = Hd(t, e);
			else switch (e) {
				case "svg":
					e = 1;
					break;
				case "math":
					e = 2;
					break;
				default: e = 0;
			}
		}
		D(ge), he(ge, e);
	}
	function xe() {
		D(ge), D(_e), D(ve);
	}
	function Se(e) {
		e.memoizedState !== null && he(ye, e);
		var t = ge.current, n = Hd(t, e.type);
		t !== n && (he(_e, e), he(ge, n));
	}
	function Ce(e) {
		_e.current === e && (D(ge), D(_e)), ye.current === e && (D(ye), Qf._currentValue = de);
	}
	var we, Te;
	function Ee(e) {
		if (we === void 0) try {
			throw Error();
		} catch (e) {
			var t = e.stack.trim().match(/\n( *(at )?)/);
			we = t && t[1] || "", Te = -1 < e.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
		}
		return "\n" + we + e + Te;
	}
	var De = !1;
	function O(e, t) {
		if (!e || De) return "";
		De = !0;
		var n = Error.prepareStackTrace;
		Error.prepareStackTrace = void 0;
		try {
			var r = { DetermineComponentFrameRoot: function() {
				try {
					if (t) {
						var n = function() {
							throw Error();
						};
						if (Object.defineProperty(n.prototype, "props", { set: function() {
							throw Error();
						} }), typeof Reflect == "object" && Reflect.construct) {
							try {
								Reflect.construct(n, []);
							} catch (e) {
								var r = e;
							}
							Reflect.construct(e, [], n);
						} else {
							try {
								n.call();
							} catch (e) {
								r = e;
							}
							e.call(n.prototype);
						}
					} else {
						try {
							throw Error();
						} catch (e) {
							r = e;
						}
						(n = e()) && typeof n.catch == "function" && n.catch(function() {});
					}
				} catch (e) {
					if (e && r && typeof e.stack == "string") return [e.stack, r.stack];
				}
				return [null, null];
			} };
			r.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
			var i = Object.getOwnPropertyDescriptor(r.DetermineComponentFrameRoot, "name");
			i && i.configurable && Object.defineProperty(r.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
			var a = r.DetermineComponentFrameRoot(), o = a[0], s = a[1];
			if (o && s) {
				var c = o.split("\n"), l = s.split("\n");
				for (i = r = 0; r < c.length && !c[r].includes("DetermineComponentFrameRoot");) r++;
				for (; i < l.length && !l[i].includes("DetermineComponentFrameRoot");) i++;
				if (r === c.length || i === l.length) for (r = c.length - 1, i = l.length - 1; 1 <= r && 0 <= i && c[r] !== l[i];) i--;
				for (; 1 <= r && 0 <= i; r--, i--) if (c[r] !== l[i]) {
					if (r !== 1 || i !== 1) do
						if (r--, i--, 0 > i || c[r] !== l[i]) {
							var u = "\n" + c[r].replace(" at new ", " at ");
							return e.displayName && u.includes("<anonymous>") && (u = u.replace("<anonymous>", e.displayName)), u;
						}
					while (1 <= r && 0 <= i);
					break;
				}
			}
		} finally {
			De = !1, Error.prepareStackTrace = n;
		}
		return (n = e ? e.displayName || e.name : "") ? Ee(n) : "";
	}
	function Oe(e, t) {
		switch (e.tag) {
			case 26:
			case 27:
			case 5: return Ee(e.type);
			case 16: return Ee("Lazy");
			case 13: return e.child !== t && t !== null ? Ee("Suspense Fallback") : Ee("Suspense");
			case 19: return Ee("SuspenseList");
			case 0:
			case 15: return O(e.type, !1);
			case 11: return O(e.type.render, !1);
			case 1: return O(e.type, !0);
			case 31: return Ee("Activity");
			default: return "";
		}
	}
	function ke(e) {
		try {
			var t = "", n = null;
			do
				t += Oe(e, n), n = e, e = e.return;
			while (e);
			return t;
		} catch (e) {
			return "\nError generating stack: " + e.message + "\n" + e.stack;
		}
	}
	var Ae = Object.prototype.hasOwnProperty, je = t.unstable_scheduleCallback, Me = t.unstable_cancelCallback, Ne = t.unstable_shouldYield, Pe = t.unstable_requestPaint, Fe = t.unstable_now, Ie = t.unstable_getCurrentPriorityLevel, Le = t.unstable_ImmediatePriority, Re = t.unstable_UserBlockingPriority, ze = t.unstable_NormalPriority, Be = t.unstable_LowPriority, Ve = t.unstable_IdlePriority, He = t.log, Ue = t.unstable_setDisableYieldValue, We = null, Ge = null;
	function Ke(e) {
		if (typeof He == "function" && Ue(e), Ge && typeof Ge.setStrictMode == "function") try {
			Ge.setStrictMode(We, e);
		} catch {}
	}
	var qe = Math.clz32 ? Math.clz32 : Xe, Je = Math.log, Ye = Math.LN2;
	function Xe(e) {
		return e >>>= 0, e === 0 ? 32 : 31 - (Je(e) / Ye | 0) | 0;
	}
	var Ze = 256, Qe = 262144, $e = 4194304;
	function et(e) {
		var t = e & 42;
		if (t !== 0) return t;
		switch (e & -e) {
			case 1: return 1;
			case 2: return 2;
			case 4: return 4;
			case 8: return 8;
			case 16: return 16;
			case 32: return 32;
			case 64: return 64;
			case 128: return 128;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072: return e & 261888;
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return e & 3932160;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return e & 62914560;
			case 67108864: return 67108864;
			case 134217728: return 134217728;
			case 268435456: return 268435456;
			case 536870912: return 536870912;
			case 1073741824: return 0;
			default: return e;
		}
	}
	function tt(e, t, n) {
		var r = e.pendingLanes;
		if (r === 0) return 0;
		var i = 0, a = e.suspendedLanes, o = e.pingedLanes;
		e = e.warmLanes;
		var s = r & 134217727;
		return s === 0 ? (s = r & ~a, s === 0 ? o === 0 ? n || (n = r & ~e, n !== 0 && (i = et(n))) : i = et(o) : i = et(s)) : (r = s & ~a, r === 0 ? (o &= s, o === 0 ? n || (n = s & ~e, n !== 0 && (i = et(n))) : i = et(o)) : i = et(r)), i === 0 ? 0 : t !== 0 && t !== i && (t & a) === 0 && (a = i & -i, n = t & -t, a >= n || a === 32 && n & 4194048) ? t : i;
	}
	function nt(e, t) {
		return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
	}
	function rt(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 4:
			case 8:
			case 64: return t + 250;
			case 16:
			case 32:
			case 128:
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return t + 5e3;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return -1;
			case 67108864:
			case 134217728:
			case 268435456:
			case 536870912:
			case 1073741824: return -1;
			default: return -1;
		}
	}
	function it() {
		var e = $e;
		return $e <<= 1, !($e & 62914560) && ($e = 4194304), e;
	}
	function at(e) {
		for (var t = [], n = 0; 31 > n; n++) t.push(e);
		return t;
	}
	function ot(e, t) {
		e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
	}
	function st(e, t, n, r, i, a) {
		var o = e.pendingLanes;
		e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0;
		var s = e.entanglements, c = e.expirationTimes, l = e.hiddenUpdates;
		for (n = o & ~n; 0 < n;) {
			var u = 31 - qe(n), d = 1 << u;
			s[u] = 0, c[u] = -1;
			var f = l[u];
			if (f !== null) for (l[u] = null, u = 0; u < f.length; u++) {
				var p = f[u];
				p !== null && (p.lane &= -536870913);
			}
			n &= ~d;
		}
		r !== 0 && ct(e, r, 0), a !== 0 && i === 0 && e.tag !== 0 && (e.suspendedLanes |= a & ~(o & ~t));
	}
	function ct(e, t, n) {
		e.pendingLanes |= t, e.suspendedLanes &= ~t;
		var r = 31 - qe(t);
		e.entangledLanes |= t, e.entanglements[r] = e.entanglements[r] | 1073741824 | n & 261930;
	}
	function lt(e, t) {
		var n = e.entangledLanes |= t;
		for (e = e.entanglements; n;) {
			var r = 31 - qe(n), i = 1 << r;
			i & t | e[r] & t && (e[r] |= t), n &= ~i;
		}
	}
	function ut(e, t) {
		var n = t & -t;
		return n = n & 42 ? 1 : dt(n), (n & (e.suspendedLanes | t)) === 0 ? n : 0;
	}
	function dt(e) {
		switch (e) {
			case 2:
				e = 1;
				break;
			case 8:
				e = 4;
				break;
			case 32:
				e = 16;
				break;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152:
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432:
				e = 128;
				break;
			case 268435456:
				e = 134217728;
				break;
			default: e = 0;
		}
		return e;
	}
	function ft(e) {
		return e &= -e, 2 < e ? 8 < e ? e & 134217727 ? 32 : 268435456 : 8 : 2;
	}
	function pt() {
		var e = E.p;
		return e === 0 ? (e = window.event, e === void 0 ? 32 : mp(e.type)) : e;
	}
	function mt(e, t) {
		var n = E.p;
		try {
			return E.p = e, t();
		} finally {
			E.p = n;
		}
	}
	var ht = Math.random().toString(36).slice(2), gt = "__reactFiber$" + ht, k = "__reactProps$" + ht, _t = "__reactContainer$" + ht, vt = "__reactEvents$" + ht, yt = "__reactListeners$" + ht, A = "__reactHandles$" + ht, j = "__reactResources$" + ht, bt = "__reactMarker$" + ht;
	function xt(e) {
		delete e[gt], delete e[k], delete e[vt], delete e[yt], delete e[A];
	}
	function M(e) {
		var t = e[gt];
		if (t) return t;
		for (var n = e.parentNode; n;) {
			if (t = n[_t] || n[gt]) {
				if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = df(e); e !== null;) {
					if (n = e[gt]) return n;
					e = df(e);
				}
				return t;
			}
			e = n, n = e.parentNode;
		}
		return null;
	}
	function St(e) {
		if (e = e[gt] || e[_t]) {
			var t = e.tag;
			if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3) return e;
		}
		return null;
	}
	function Ct(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
		throw Error(i(33));
	}
	function N(e) {
		var t = e[j];
		return t ||= e[j] = {
			hoistableStyles: /* @__PURE__ */ new Map(),
			hoistableScripts: /* @__PURE__ */ new Map()
		}, t;
	}
	function P(e) {
		e[bt] = !0;
	}
	var F = /* @__PURE__ */ new Set(), wt = {};
	function Tt(e, t) {
		Et(e, t), Et(e + "Capture", t);
	}
	function Et(e, t) {
		for (wt[e] = t, e = 0; e < t.length; e++) F.add(t[e]);
	}
	var Dt = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), Ot = {}, kt = {};
	function I(e) {
		return Ae.call(kt, e) ? !0 : Ae.call(Ot, e) ? !1 : Dt.test(e) ? kt[e] = !0 : (Ot[e] = !0, !1);
	}
	function At(e, t, n) {
		if (I(t)) if (n === null) e.removeAttribute(t);
		else {
			switch (typeof n) {
				case "undefined":
				case "function":
				case "symbol":
					e.removeAttribute(t);
					return;
				case "boolean":
					var r = t.toLowerCase().slice(0, 5);
					if (r !== "data-" && r !== "aria-") {
						e.removeAttribute(t);
						return;
					}
			}
			e.setAttribute(t, "" + n);
		}
	}
	function jt(e, t, n) {
		if (n === null) e.removeAttribute(t);
		else {
			switch (typeof n) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(t);
					return;
			}
			e.setAttribute(t, "" + n);
		}
	}
	function Mt(e, t, n, r) {
		if (r === null) e.removeAttribute(n);
		else {
			switch (typeof r) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(n);
					return;
			}
			e.setAttributeNS(t, n, "" + r);
		}
	}
	function Nt(e) {
		switch (typeof e) {
			case "bigint":
			case "boolean":
			case "number":
			case "string":
			case "undefined": return e;
			case "object": return e;
			default: return "";
		}
	}
	function Pt(e) {
		var t = e.type;
		return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
	}
	function Ft(e, t, n) {
		var r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
		if (!e.hasOwnProperty(t) && r !== void 0 && typeof r.get == "function" && typeof r.set == "function") {
			var i = r.get, a = r.set;
			return Object.defineProperty(e, t, {
				configurable: !0,
				get: function() {
					return i.call(this);
				},
				set: function(e) {
					n = "" + e, a.call(this, e);
				}
			}), Object.defineProperty(e, t, { enumerable: r.enumerable }), {
				getValue: function() {
					return n;
				},
				setValue: function(e) {
					n = "" + e;
				},
				stopTracking: function() {
					e._valueTracker = null, delete e[t];
				}
			};
		}
	}
	function It(e) {
		if (!e._valueTracker) {
			var t = Pt(e) ? "checked" : "value";
			e._valueTracker = Ft(e, t, "" + e[t]);
		}
	}
	function Lt(e) {
		if (!e) return !1;
		var t = e._valueTracker;
		if (!t) return !0;
		var n = t.getValue(), r = "";
		return e && (r = Pt(e) ? e.checked ? "true" : "false" : e.value), e = r, e === n ? !1 : (t.setValue(e), !0);
	}
	function Rt(e) {
		if (e ||= typeof document < "u" ? document : void 0, e === void 0) return null;
		try {
			return e.activeElement || e.body;
		} catch {
			return e.body;
		}
	}
	var zt = /[\n"\\]/g;
	function Bt(e) {
		return e.replace(zt, function(e) {
			return "\\" + e.charCodeAt(0).toString(16) + " ";
		});
	}
	function Vt(e, t, n, r, i, a, o, s) {
		e.name = "", o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" ? e.type = o : e.removeAttribute("type"), t == null ? o !== "submit" && o !== "reset" || e.removeAttribute("value") : o === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + Nt(t)) : e.value !== "" + Nt(t) && (e.value = "" + Nt(t)), t == null ? n == null ? r != null && e.removeAttribute("value") : Ut(e, o, Nt(n)) : Ut(e, o, Nt(t)), i == null && a != null && (e.defaultChecked = !!a), i != null && (e.checked = i && typeof i != "function" && typeof i != "symbol"), s != null && typeof s != "function" && typeof s != "symbol" && typeof s != "boolean" ? e.name = "" + Nt(s) : e.removeAttribute("name");
	}
	function Ht(e, t, n, r, i, a, o, s) {
		if (a != null && typeof a != "function" && typeof a != "symbol" && typeof a != "boolean" && (e.type = a), t != null || n != null) {
			if (!(a !== "submit" && a !== "reset" || t != null)) {
				It(e);
				return;
			}
			n = n == null ? "" : "" + Nt(n), t = t == null ? n : "" + Nt(t), s || t === e.value || (e.value = t), e.defaultValue = t;
		}
		r ??= i, r = typeof r != "function" && typeof r != "symbol" && !!r, e.checked = s ? e.checked : !!r, e.defaultChecked = !!r, o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" && (e.name = o), It(e);
	}
	function Ut(e, t, n) {
		t === "number" && Rt(e.ownerDocument) === e || e.defaultValue === "" + n || (e.defaultValue = "" + n);
	}
	function Wt(e, t, n, r) {
		if (e = e.options, t) {
			t = {};
			for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
			for (n = 0; n < e.length; n++) i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
		} else {
			for (n = "" + Nt(n), t = null, i = 0; i < e.length; i++) {
				if (e[i].value === n) {
					e[i].selected = !0, r && (e[i].defaultSelected = !0);
					return;
				}
				t !== null || e[i].disabled || (t = e[i]);
			}
			t !== null && (t.selected = !0);
		}
	}
	function Gt(e, t, n) {
		if (t != null && (t = "" + Nt(t), t !== e.value && (e.value = t), n == null)) {
			e.defaultValue !== t && (e.defaultValue = t);
			return;
		}
		e.defaultValue = n == null ? "" : "" + Nt(n);
	}
	function Kt(e, t, n, r) {
		if (t == null) {
			if (r != null) {
				if (n != null) throw Error(i(92));
				if (ue(r)) {
					if (1 < r.length) throw Error(i(93));
					r = r[0];
				}
				n = r;
			}
			n ??= "", t = n;
		}
		n = Nt(t), e.defaultValue = n, r = e.textContent, r === n && r !== "" && r !== null && (e.value = r), It(e);
	}
	function qt(e, t) {
		if (t) {
			var n = e.firstChild;
			if (n && n === e.lastChild && n.nodeType === 3) {
				n.nodeValue = t;
				return;
			}
		}
		e.textContent = t;
	}
	var L = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
	function Jt(e, t, n) {
		var r = t.indexOf("--") === 0;
		n == null || typeof n == "boolean" || n === "" ? r ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : r ? e.setProperty(t, n) : typeof n != "number" || n === 0 || L.has(t) ? t === "float" ? e.cssFloat = n : e[t] = ("" + n).trim() : e[t] = n + "px";
	}
	function Yt(e, t, n) {
		if (t != null && typeof t != "object") throw Error(i(62));
		if (e = e.style, n != null) {
			for (var r in n) !n.hasOwnProperty(r) || t != null && t.hasOwnProperty(r) || (r.indexOf("--") === 0 ? e.setProperty(r, "") : r === "float" ? e.cssFloat = "" : e[r] = "");
			for (var a in t) r = t[a], t.hasOwnProperty(a) && n[a] !== r && Jt(e, a, r);
		} else for (var o in t) t.hasOwnProperty(o) && Jt(e, o, t[o]);
	}
	function Xt(e) {
		if (e.indexOf("-") === -1) return !1;
		switch (e) {
			case "annotation-xml":
			case "color-profile":
			case "font-face":
			case "font-face-src":
			case "font-face-uri":
			case "font-face-format":
			case "font-face-name":
			case "missing-glyph": return !1;
			default: return !0;
		}
	}
	var R = new Map([
		["acceptCharset", "accept-charset"],
		["htmlFor", "for"],
		["httpEquiv", "http-equiv"],
		["crossOrigin", "crossorigin"],
		["accentHeight", "accent-height"],
		["alignmentBaseline", "alignment-baseline"],
		["arabicForm", "arabic-form"],
		["baselineShift", "baseline-shift"],
		["capHeight", "cap-height"],
		["clipPath", "clip-path"],
		["clipRule", "clip-rule"],
		["colorInterpolation", "color-interpolation"],
		["colorInterpolationFilters", "color-interpolation-filters"],
		["colorProfile", "color-profile"],
		["colorRendering", "color-rendering"],
		["dominantBaseline", "dominant-baseline"],
		["enableBackground", "enable-background"],
		["fillOpacity", "fill-opacity"],
		["fillRule", "fill-rule"],
		["floodColor", "flood-color"],
		["floodOpacity", "flood-opacity"],
		["fontFamily", "font-family"],
		["fontSize", "font-size"],
		["fontSizeAdjust", "font-size-adjust"],
		["fontStretch", "font-stretch"],
		["fontStyle", "font-style"],
		["fontVariant", "font-variant"],
		["fontWeight", "font-weight"],
		["glyphName", "glyph-name"],
		["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
		["glyphOrientationVertical", "glyph-orientation-vertical"],
		["horizAdvX", "horiz-adv-x"],
		["horizOriginX", "horiz-origin-x"],
		["imageRendering", "image-rendering"],
		["letterSpacing", "letter-spacing"],
		["lightingColor", "lighting-color"],
		["markerEnd", "marker-end"],
		["markerMid", "marker-mid"],
		["markerStart", "marker-start"],
		["overlinePosition", "overline-position"],
		["overlineThickness", "overline-thickness"],
		["paintOrder", "paint-order"],
		["panose-1", "panose-1"],
		["pointerEvents", "pointer-events"],
		["renderingIntent", "rendering-intent"],
		["shapeRendering", "shape-rendering"],
		["stopColor", "stop-color"],
		["stopOpacity", "stop-opacity"],
		["strikethroughPosition", "strikethrough-position"],
		["strikethroughThickness", "strikethrough-thickness"],
		["strokeDasharray", "stroke-dasharray"],
		["strokeDashoffset", "stroke-dashoffset"],
		["strokeLinecap", "stroke-linecap"],
		["strokeLinejoin", "stroke-linejoin"],
		["strokeMiterlimit", "stroke-miterlimit"],
		["strokeOpacity", "stroke-opacity"],
		["strokeWidth", "stroke-width"],
		["textAnchor", "text-anchor"],
		["textDecoration", "text-decoration"],
		["textRendering", "text-rendering"],
		["transformOrigin", "transform-origin"],
		["underlinePosition", "underline-position"],
		["underlineThickness", "underline-thickness"],
		["unicodeBidi", "unicode-bidi"],
		["unicodeRange", "unicode-range"],
		["unitsPerEm", "units-per-em"],
		["vAlphabetic", "v-alphabetic"],
		["vHanging", "v-hanging"],
		["vIdeographic", "v-ideographic"],
		["vMathematical", "v-mathematical"],
		["vectorEffect", "vector-effect"],
		["vertAdvY", "vert-adv-y"],
		["vertOriginX", "vert-origin-x"],
		["vertOriginY", "vert-origin-y"],
		["wordSpacing", "word-spacing"],
		["writingMode", "writing-mode"],
		["xmlnsXlink", "xmlns:xlink"],
		["xHeight", "x-height"]
	]), Zt = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
	function Qt(e) {
		return Zt.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
	}
	function $t() {}
	var en = null;
	function tn(e) {
		return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
	}
	var nn = null, rn = null;
	function an(e) {
		var t = St(e);
		if (t && (e = t.stateNode)) {
			var n = e[k] || null;
			a: switch (e = t.stateNode, t.type) {
				case "input":
					if (Vt(e, n.value, n.defaultValue, n.defaultValue, n.checked, n.defaultChecked, n.type, n.name), t = n.name, n.type === "radio" && t != null) {
						for (n = e; n.parentNode;) n = n.parentNode;
						for (n = n.querySelectorAll("input[name=\"" + Bt("" + t) + "\"][type=\"radio\"]"), t = 0; t < n.length; t++) {
							var r = n[t];
							if (r !== e && r.form === e.form) {
								var a = r[k] || null;
								if (!a) throw Error(i(90));
								Vt(r, a.value, a.defaultValue, a.defaultValue, a.checked, a.defaultChecked, a.type, a.name);
							}
						}
						for (t = 0; t < n.length; t++) r = n[t], r.form === e.form && Lt(r);
					}
					break a;
				case "textarea":
					Gt(e, n.value, n.defaultValue);
					break a;
				case "select": t = n.value, t != null && Wt(e, !!n.multiple, t, !1);
			}
		}
	}
	var on = !1;
	function sn(e, t, n) {
		if (on) return e(t, n);
		on = !0;
		try {
			return e(t);
		} finally {
			if (on = !1, (nn !== null || rn !== null) && (vu(), nn && (t = nn, e = rn, rn = nn = null, an(t), e))) for (t = 0; t < e.length; t++) an(e[t]);
		}
	}
	function cn(e, t) {
		var n = e.stateNode;
		if (n === null) return null;
		var r = n[k] || null;
		if (r === null) return null;
		n = r[t];
		a: switch (t) {
			case "onClick":
			case "onClickCapture":
			case "onDoubleClick":
			case "onDoubleClickCapture":
			case "onMouseDown":
			case "onMouseDownCapture":
			case "onMouseMove":
			case "onMouseMoveCapture":
			case "onMouseUp":
			case "onMouseUpCapture":
			case "onMouseEnter":
				(r = !r.disabled) || (e = e.type, r = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !r;
				break a;
			default: e = !1;
		}
		if (e) return null;
		if (n && typeof n != "function") throw Error(i(231, t, typeof n));
		return n;
	}
	var z = !(typeof window > "u" || window.document === void 0 || window.document.createElement === void 0), ln = !1;
	if (z) try {
		var un = {};
		Object.defineProperty(un, "passive", { get: function() {
			ln = !0;
		} }), window.addEventListener("test", un, un), window.removeEventListener("test", un, un);
	} catch {
		ln = !1;
	}
	var dn = null, fn = null, pn = null;
	function mn() {
		if (pn) return pn;
		var e, t = fn, n = t.length, r, i = "value" in dn ? dn.value : dn.textContent, a = i.length;
		for (e = 0; e < n && t[e] === i[e]; e++);
		var o = n - e;
		for (r = 1; r <= o && t[n - r] === i[a - r]; r++);
		return pn = i.slice(e, 1 < r ? 1 - r : void 0);
	}
	function B(e) {
		var t = e.keyCode;
		return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
	}
	function V() {
		return !0;
	}
	function hn() {
		return !1;
	}
	function H(e) {
		function t(t, n, r, i, a) {
			for (var o in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = a, this.currentTarget = null, e) e.hasOwnProperty(o) && (t = e[o], this[o] = t ? t(i) : i[o]);
			return this.isDefaultPrevented = (i.defaultPrevented == null ? !1 === i.returnValue : i.defaultPrevented) ? V : hn, this.isPropagationStopped = hn, this;
		}
		return h(t.prototype, {
			preventDefault: function() {
				this.defaultPrevented = !0;
				var e = this.nativeEvent;
				e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != "unknown" && (e.returnValue = !1), this.isDefaultPrevented = V);
			},
			stopPropagation: function() {
				var e = this.nativeEvent;
				e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != "unknown" && (e.cancelBubble = !0), this.isPropagationStopped = V);
			},
			persist: function() {},
			isPersistent: V
		}), t;
	}
	var gn = {
		eventPhase: 0,
		bubbles: 0,
		cancelable: 0,
		timeStamp: function(e) {
			return e.timeStamp || Date.now();
		},
		defaultPrevented: 0,
		isTrusted: 0
	}, _n = H(gn), vn = h({}, gn, {
		view: 0,
		detail: 0
	}), yn = H(vn), bn, xn, Sn, Cn = h({}, vn, {
		screenX: 0,
		screenY: 0,
		clientX: 0,
		clientY: 0,
		pageX: 0,
		pageY: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		getModifierState: Pn,
		button: 0,
		buttons: 0,
		relatedTarget: function(e) {
			return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
		},
		movementX: function(e) {
			return "movementX" in e ? e.movementX : (e !== Sn && (Sn && e.type === "mousemove" ? (bn = e.screenX - Sn.screenX, xn = e.screenY - Sn.screenY) : xn = bn = 0, Sn = e), bn);
		},
		movementY: function(e) {
			return "movementY" in e ? e.movementY : xn;
		}
	}), wn = H(Cn), Tn = H(h({}, Cn, { dataTransfer: 0 })), En = H(h({}, vn, { relatedTarget: 0 })), Dn = H(h({}, gn, {
		animationName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), On = H(h({}, gn, { clipboardData: function(e) {
		return "clipboardData" in e ? e.clipboardData : window.clipboardData;
	} })), kn = H(h({}, gn, { data: 0 })), An = {
		Esc: "Escape",
		Spacebar: " ",
		Left: "ArrowLeft",
		Up: "ArrowUp",
		Right: "ArrowRight",
		Down: "ArrowDown",
		Del: "Delete",
		Win: "OS",
		Menu: "ContextMenu",
		Apps: "ContextMenu",
		Scroll: "ScrollLock",
		MozPrintableKey: "Unidentified"
	}, jn = {
		8: "Backspace",
		9: "Tab",
		12: "Clear",
		13: "Enter",
		16: "Shift",
		17: "Control",
		18: "Alt",
		19: "Pause",
		20: "CapsLock",
		27: "Escape",
		32: " ",
		33: "PageUp",
		34: "PageDown",
		35: "End",
		36: "Home",
		37: "ArrowLeft",
		38: "ArrowUp",
		39: "ArrowRight",
		40: "ArrowDown",
		45: "Insert",
		46: "Delete",
		112: "F1",
		113: "F2",
		114: "F3",
		115: "F4",
		116: "F5",
		117: "F6",
		118: "F7",
		119: "F8",
		120: "F9",
		121: "F10",
		122: "F11",
		123: "F12",
		144: "NumLock",
		145: "ScrollLock",
		224: "Meta"
	}, Mn = {
		Alt: "altKey",
		Control: "ctrlKey",
		Meta: "metaKey",
		Shift: "shiftKey"
	};
	function Nn(e) {
		var t = this.nativeEvent;
		return t.getModifierState ? t.getModifierState(e) : (e = Mn[e]) ? !!t[e] : !1;
	}
	function Pn() {
		return Nn;
	}
	var Fn = H(h({}, vn, {
		key: function(e) {
			if (e.key) {
				var t = An[e.key] || e.key;
				if (t !== "Unidentified") return t;
			}
			return e.type === "keypress" ? (e = B(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? jn[e.keyCode] || "Unidentified" : "";
		},
		code: 0,
		location: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		repeat: 0,
		locale: 0,
		getModifierState: Pn,
		charCode: function(e) {
			return e.type === "keypress" ? B(e) : 0;
		},
		keyCode: function(e) {
			return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		},
		which: function(e) {
			return e.type === "keypress" ? B(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		}
	})), In = H(h({}, Cn, {
		pointerId: 0,
		width: 0,
		height: 0,
		pressure: 0,
		tangentialPressure: 0,
		tiltX: 0,
		tiltY: 0,
		twist: 0,
		pointerType: 0,
		isPrimary: 0
	})), Ln = H(h({}, vn, {
		touches: 0,
		targetTouches: 0,
		changedTouches: 0,
		altKey: 0,
		metaKey: 0,
		ctrlKey: 0,
		shiftKey: 0,
		getModifierState: Pn
	})), Rn = H(h({}, gn, {
		propertyName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), zn = H(h({}, Cn, {
		deltaX: function(e) {
			return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
		},
		deltaY: function(e) {
			return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
		},
		deltaZ: 0,
		deltaMode: 0
	})), Bn = H(h({}, gn, {
		newState: 0,
		oldState: 0
	})), Vn = [
		9,
		13,
		27,
		32
	], Hn = z && "CompositionEvent" in window, Un = null;
	z && "documentMode" in document && (Un = document.documentMode);
	var Wn = z && "TextEvent" in window && !Un, Gn = z && (!Hn || Un && 8 < Un && 11 >= Un), Kn = " ", qn = !1;
	function Jn(e, t) {
		switch (e) {
			case "keyup": return Vn.indexOf(t.keyCode) !== -1;
			case "keydown": return t.keyCode !== 229;
			case "keypress":
			case "mousedown":
			case "focusout": return !0;
			default: return !1;
		}
	}
	function Yn(e) {
		return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
	}
	var Xn = !1;
	function Zn(e, t) {
		switch (e) {
			case "compositionend": return Yn(t);
			case "keypress": return t.which === 32 ? (qn = !0, Kn) : null;
			case "textInput": return e = t.data, e === Kn && qn ? null : e;
			default: return null;
		}
	}
	function Qn(e, t) {
		if (Xn) return e === "compositionend" || !Hn && Jn(e, t) ? (e = mn(), pn = fn = dn = null, Xn = !1, e) : null;
		switch (e) {
			case "paste": return null;
			case "keypress":
				if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
					if (t.char && 1 < t.char.length) return t.char;
					if (t.which) return String.fromCharCode(t.which);
				}
				return null;
			case "compositionend": return Gn && t.locale !== "ko" ? null : t.data;
			default: return null;
		}
	}
	var $n = {
		color: !0,
		date: !0,
		datetime: !0,
		"datetime-local": !0,
		email: !0,
		month: !0,
		number: !0,
		password: !0,
		range: !0,
		search: !0,
		tel: !0,
		text: !0,
		time: !0,
		url: !0,
		week: !0
	};
	function er(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t === "input" ? !!$n[e.type] : t === "textarea";
	}
	function tr(e, t, n, r) {
		nn ? rn ? rn.push(r) : rn = [r] : nn = r, t = Td(t, "onChange"), 0 < t.length && (n = new _n("onChange", "change", null, n, r), e.push({
			event: n,
			listeners: t
		}));
	}
	var nr = null, rr = null;
	function ir(e) {
		vd(e, 0);
	}
	function ar(e) {
		if (Lt(Ct(e))) return e;
	}
	function or(e, t) {
		if (e === "change") return t;
	}
	var sr = !1;
	if (z) {
		var cr;
		if (z) {
			var lr = "oninput" in document;
			if (!lr) {
				var ur = document.createElement("div");
				ur.setAttribute("oninput", "return;"), lr = typeof ur.oninput == "function";
			}
			cr = lr;
		} else cr = !1;
		sr = cr && (!document.documentMode || 9 < document.documentMode);
	}
	function dr() {
		nr && (nr.detachEvent("onpropertychange", fr), rr = nr = null);
	}
	function fr(e) {
		if (e.propertyName === "value" && ar(rr)) {
			var t = [];
			tr(t, rr, e, tn(e)), sn(ir, t);
		}
	}
	function pr(e, t, n) {
		e === "focusin" ? (dr(), nr = t, rr = n, nr.attachEvent("onpropertychange", fr)) : e === "focusout" && dr();
	}
	function mr(e) {
		if (e === "selectionchange" || e === "keyup" || e === "keydown") return ar(rr);
	}
	function hr(e, t) {
		if (e === "click") return ar(t);
	}
	function gr(e, t) {
		if (e === "input" || e === "change") return ar(t);
	}
	function _r(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var vr = typeof Object.is == "function" ? Object.is : _r;
	function yr(e, t) {
		if (vr(e, t)) return !0;
		if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
		var n = Object.keys(e), r = Object.keys(t);
		if (n.length !== r.length) return !1;
		for (r = 0; r < n.length; r++) {
			var i = n[r];
			if (!Ae.call(t, i) || !vr(e[i], t[i])) return !1;
		}
		return !0;
	}
	function br(e) {
		for (; e && e.firstChild;) e = e.firstChild;
		return e;
	}
	function xr(e, t) {
		var n = br(e);
		e = 0;
		for (var r; n;) {
			if (n.nodeType === 3) {
				if (r = e + n.textContent.length, e <= t && r >= t) return {
					node: n,
					offset: t - e
				};
				e = r;
			}
			a: {
				for (; n;) {
					if (n.nextSibling) {
						n = n.nextSibling;
						break a;
					}
					n = n.parentNode;
				}
				n = void 0;
			}
			n = br(n);
		}
	}
	function Sr(e, t) {
		return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? Sr(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
	}
	function Cr(e) {
		e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
		for (var t = Rt(e.document); t instanceof e.HTMLIFrameElement;) {
			try {
				var n = typeof t.contentWindow.location.href == "string";
			} catch {
				n = !1;
			}
			if (n) e = t.contentWindow;
			else break;
			t = Rt(e.document);
		}
		return t;
	}
	function wr(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
	}
	var Tr = z && "documentMode" in document && 11 >= document.documentMode, Er = null, Dr = null, Or = null, kr = !1;
	function Ar(e, t, n) {
		var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
		kr || Er == null || Er !== Rt(r) || (r = Er, "selectionStart" in r && wr(r) ? r = {
			start: r.selectionStart,
			end: r.selectionEnd
		} : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
			anchorNode: r.anchorNode,
			anchorOffset: r.anchorOffset,
			focusNode: r.focusNode,
			focusOffset: r.focusOffset
		}), Or && yr(Or, r) || (Or = r, r = Td(Dr, "onSelect"), 0 < r.length && (t = new _n("onSelect", "select", null, t, n), e.push({
			event: t,
			listeners: r
		}), t.target = Er)));
	}
	function jr(e, t) {
		var n = {};
		return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
	}
	var Mr = {
		animationend: jr("Animation", "AnimationEnd"),
		animationiteration: jr("Animation", "AnimationIteration"),
		animationstart: jr("Animation", "AnimationStart"),
		transitionrun: jr("Transition", "TransitionRun"),
		transitionstart: jr("Transition", "TransitionStart"),
		transitioncancel: jr("Transition", "TransitionCancel"),
		transitionend: jr("Transition", "TransitionEnd")
	}, Nr = {}, Pr = {};
	z && (Pr = document.createElement("div").style, "AnimationEvent" in window || (delete Mr.animationend.animation, delete Mr.animationiteration.animation, delete Mr.animationstart.animation), "TransitionEvent" in window || delete Mr.transitionend.transition);
	function Fr(e) {
		if (Nr[e]) return Nr[e];
		if (!Mr[e]) return e;
		var t = Mr[e], n;
		for (n in t) if (t.hasOwnProperty(n) && n in Pr) return Nr[e] = t[n];
		return e;
	}
	var Ir = Fr("animationend"), Lr = Fr("animationiteration"), Rr = Fr("animationstart"), zr = Fr("transitionrun"), Br = Fr("transitionstart"), Vr = Fr("transitioncancel"), Hr = Fr("transitionend"), Ur = /* @__PURE__ */ new Map(), Wr = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
	Wr.push("scrollEnd");
	function Gr(e, t) {
		Ur.set(e, t), Tt(t, [e]);
	}
	var U = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, Kr = [], qr = 0, Jr = 0;
	function Yr() {
		for (var e = qr, t = Jr = qr = 0; t < e;) {
			var n = Kr[t];
			Kr[t++] = null;
			var r = Kr[t];
			Kr[t++] = null;
			var i = Kr[t];
			Kr[t++] = null;
			var a = Kr[t];
			if (Kr[t++] = null, r !== null && i !== null) {
				var o = r.pending;
				o === null ? i.next = i : (i.next = o.next, o.next = i), r.pending = i;
			}
			a !== 0 && $r(n, i, a);
		}
	}
	function Xr(e, t, n, r) {
		Kr[qr++] = e, Kr[qr++] = t, Kr[qr++] = n, Kr[qr++] = r, Jr |= r, e.lanes |= r, e = e.alternate, e !== null && (e.lanes |= r);
	}
	function Zr(e, t, n, r) {
		return Xr(e, t, n, r), ei(e);
	}
	function Qr(e, t) {
		return Xr(e, null, null, t), ei(e);
	}
	function $r(e, t, n) {
		e.lanes |= n;
		var r = e.alternate;
		r !== null && (r.lanes |= n);
		for (var i = !1, a = e.return; a !== null;) a.childLanes |= n, r = a.alternate, r !== null && (r.childLanes |= n), a.tag === 22 && (e = a.stateNode, e === null || e._visibility & 1 || (i = !0)), e = a, a = a.return;
		return e.tag === 3 ? (a = e.stateNode, i && t !== null && (i = 31 - qe(n), e = a.hiddenUpdates, r = e[i], r === null ? e[i] = [t] : r.push(t), t.lane = n | 536870912), a) : null;
	}
	function ei(e) {
		if (50 < lu) throw lu = 0, uu = null, Error(i(185));
		for (var t = e.return; t !== null;) e = t, t = e.return;
		return e.tag === 3 ? e.stateNode : null;
	}
	var W = {};
	function ti(e, t, n, r) {
		this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
	}
	function G(e, t, n, r) {
		return new ti(e, t, n, r);
	}
	function ni(e) {
		return e = e.prototype, !(!e || !e.isReactComponent);
	}
	function ri(e, t) {
		var n = e.alternate;
		return n === null ? (n = G(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 65011712, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n;
	}
	function ii(e, t) {
		e.flags &= 65011714;
		var n = e.alternate;
		return n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}), e;
	}
	function ai(e, t, n, r, a, o) {
		var s = 0;
		if (r = e, typeof e == "function") ni(e) && (s = 1);
		else if (typeof e == "string") s = Uf(e, n, ge.current) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
		else a: switch (e) {
			case ie: return e = G(31, n, t, a), e.elementType = ie, e.lanes = o, e;
			case y: return oi(n.children, a, o, t);
			case b:
				s = 8, a |= 24;
				break;
			case x: return e = G(12, n, t, a | 2), e.elementType = x, e.lanes = o, e;
			case w: return e = G(13, n, t, a), e.elementType = w, e.lanes = o, e;
			case te: return e = G(19, n, t, a), e.elementType = te, e.lanes = o, e;
			default:
				if (typeof e == "object" && e) switch (e.$$typeof) {
					case S:
						s = 10;
						break a;
					case ee:
						s = 9;
						break a;
					case C:
						s = 11;
						break a;
					case ne:
						s = 14;
						break a;
					case re:
						s = 16, r = null;
						break a;
				}
				s = 29, n = Error(i(130, e === null ? "null" : typeof e, "")), r = null;
		}
		return t = G(s, n, t, a), t.elementType = e, t.type = r, t.lanes = o, t;
	}
	function oi(e, t, n, r) {
		return e = G(7, e, r, t), e.lanes = n, e;
	}
	function si(e, t, n) {
		return e = G(6, e, null, t), e.lanes = n, e;
	}
	function ci(e) {
		var t = G(18, null, null, 0);
		return t.stateNode = e, t;
	}
	function K(e, t, n) {
		return t = G(4, e.children === null ? [] : e.children, e.key, t), t.lanes = n, t.stateNode = {
			containerInfo: e.containerInfo,
			pendingChildren: null,
			implementation: e.implementation
		}, t;
	}
	var li = /* @__PURE__ */ new WeakMap();
	function ui(e, t) {
		if (typeof e == "object" && e) {
			var n = li.get(e);
			return n === void 0 ? (t = {
				value: e,
				source: t,
				stack: ke(t)
			}, li.set(e, t), t) : n;
		}
		return {
			value: e,
			source: t,
			stack: ke(t)
		};
	}
	var di = [], fi = 0, pi = null, mi = 0, hi = [], gi = 0, _i = null, vi = 1, yi = "";
	function bi(e, t) {
		di[fi++] = mi, di[fi++] = pi, pi = e, mi = t;
	}
	function xi(e, t, n) {
		hi[gi++] = vi, hi[gi++] = yi, hi[gi++] = _i, _i = e;
		var r = vi;
		e = yi;
		var i = 32 - qe(r) - 1;
		r &= ~(1 << i), n += 1;
		var a = 32 - qe(t) + i;
		if (30 < a) {
			var o = i - i % 5;
			a = (r & (1 << o) - 1).toString(32), r >>= o, i -= o, vi = 1 << 32 - qe(t) + i | n << i | r, yi = a + e;
		} else vi = 1 << a | n << i | r, yi = e;
	}
	function q(e) {
		e.return !== null && (bi(e, 1), xi(e, 1, 0));
	}
	function J(e) {
		for (; e === pi;) pi = di[--fi], di[fi] = null, mi = di[--fi], di[fi] = null;
		for (; e === _i;) _i = hi[--gi], hi[gi] = null, yi = hi[--gi], hi[gi] = null, vi = hi[--gi], hi[gi] = null;
	}
	function Si(e, t) {
		hi[gi++] = vi, hi[gi++] = yi, hi[gi++] = _i, vi = t.id, yi = t.overflow, _i = e;
	}
	var Y = null, Ci = null, X = !1, wi = null, Ti = !1, Ei = Error(i(519));
	function Di(e) {
		throw Ni(ui(Error(i(418, 1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML", "")), e)), Ei;
	}
	function Oi(e) {
		var t = e.stateNode, n = e.type, r = e.memoizedProps;
		switch (t[gt] = e, t[k] = r, n) {
			case "dialog":
				$("cancel", t), $("close", t);
				break;
			case "iframe":
			case "object":
			case "embed":
				$("load", t);
				break;
			case "video":
			case "audio":
				for (n = 0; n < gd.length; n++) $(gd[n], t);
				break;
			case "source":
				$("error", t);
				break;
			case "img":
			case "image":
			case "link":
				$("error", t), $("load", t);
				break;
			case "details":
				$("toggle", t);
				break;
			case "input":
				$("invalid", t), Ht(t, r.value, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name, !0);
				break;
			case "select":
				$("invalid", t);
				break;
			case "textarea": $("invalid", t), Kt(t, r.value, r.defaultValue, r.children);
		}
		n = r.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || t.textContent === "" + n || !0 === r.suppressHydrationWarning || jd(t.textContent, n) ? (r.popover != null && ($("beforetoggle", t), $("toggle", t)), r.onScroll != null && $("scroll", t), r.onScrollEnd != null && $("scrollend", t), r.onClick != null && (t.onclick = $t), t = !0) : t = !1, t || Di(e, !0);
	}
	function ki(e) {
		for (Y = e.return; Y;) switch (Y.tag) {
			case 5:
			case 31:
			case 13:
				Ti = !1;
				return;
			case 27:
			case 3:
				Ti = !0;
				return;
			default: Y = Y.return;
		}
	}
	function Ai(e) {
		if (e !== Y) return !1;
		if (!X) return ki(e), X = !0, !1;
		var t = e.tag, n;
		if ((n = t !== 3 && t !== 27) && ((n = t === 5) && (n = e.type, n = !(n !== "form" && n !== "button") || Ud(e.type, e.memoizedProps)), n = !n), n && Ci && Di(e), ki(e), t === 13) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
			Ci = uf(e);
		} else if (t === 31) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(317));
			Ci = uf(e);
		} else t === 27 ? (t = Ci, Zd(e.type) ? (e = lf, lf = null, Ci = e) : Ci = t) : Ci = Y ? cf(e.stateNode.nextSibling) : null;
		return !0;
	}
	function ji() {
		Ci = Y = null, X = !1;
	}
	function Mi() {
		var e = wi;
		return e !== null && (Yl === null ? Yl = e : Yl.push.apply(Yl, e), wi = null), e;
	}
	function Ni(e) {
		wi === null ? wi = [e] : wi.push(e);
	}
	var Pi = me(null), Fi = null, Ii = null;
	function Li(e, t, n) {
		he(Pi, t._currentValue), t._currentValue = n;
	}
	function Ri(e) {
		e._currentValue = Pi.current, D(Pi);
	}
	function zi(e, t, n) {
		for (; e !== null;) {
			var r = e.alternate;
			if ((e.childLanes & t) === t ? r !== null && (r.childLanes & t) !== t && (r.childLanes |= t) : (e.childLanes |= t, r !== null && (r.childLanes |= t)), e === n) break;
			e = e.return;
		}
	}
	function Bi(e, t, n, r) {
		var a = e.child;
		for (a !== null && (a.return = e); a !== null;) {
			var o = a.dependencies;
			if (o !== null) {
				var s = a.child;
				o = o.firstContext;
				a: for (; o !== null;) {
					var c = o;
					o = a;
					for (var l = 0; l < t.length; l++) if (c.context === t[l]) {
						o.lanes |= n, c = o.alternate, c !== null && (c.lanes |= n), zi(o.return, n, e), r || (s = null);
						break a;
					}
					o = c.next;
				}
			} else if (a.tag === 18) {
				if (s = a.return, s === null) throw Error(i(341));
				s.lanes |= n, o = s.alternate, o !== null && (o.lanes |= n), zi(s, n, e), s = null;
			} else s = a.child;
			if (s !== null) s.return = a;
			else for (s = a; s !== null;) {
				if (s === e) {
					s = null;
					break;
				}
				if (a = s.sibling, a !== null) {
					a.return = s.return, s = a;
					break;
				}
				s = s.return;
			}
			a = s;
		}
	}
	function Vi(e, t, n, r) {
		e = null;
		for (var a = t, o = !1; a !== null;) {
			if (!o) {
				if (a.flags & 524288) o = !0;
				else if (a.flags & 262144) break;
			}
			if (a.tag === 10) {
				var s = a.alternate;
				if (s === null) throw Error(i(387));
				if (s = s.memoizedProps, s !== null) {
					var c = a.type;
					vr(a.pendingProps.value, s.value) || (e === null ? e = [c] : e.push(c));
				}
			} else if (a === ye.current) {
				if (s = a.alternate, s === null) throw Error(i(387));
				s.memoizedState.memoizedState !== a.memoizedState.memoizedState && (e === null ? e = [Qf] : e.push(Qf));
			}
			a = a.return;
		}
		e !== null && Bi(t, e, n, r), t.flags |= 262144;
	}
	function Hi(e) {
		for (e = e.firstContext; e !== null;) {
			if (!vr(e.context._currentValue, e.memoizedValue)) return !0;
			e = e.next;
		}
		return !1;
	}
	function Ui(e) {
		Fi = e, Ii = null, e = e.dependencies, e !== null && (e.firstContext = null);
	}
	function Wi(e) {
		return Ki(Fi, e);
	}
	function Gi(e, t) {
		return Fi === null && Ui(e), Ki(e, t);
	}
	function Ki(e, t) {
		var n = t._currentValue;
		if (t = {
			context: t,
			memoizedValue: n,
			next: null
		}, Ii === null) {
			if (e === null) throw Error(i(308));
			Ii = t, e.dependencies = {
				lanes: 0,
				firstContext: t
			}, e.flags |= 524288;
		} else Ii = Ii.next = t;
		return n;
	}
	var qi = typeof AbortController < "u" ? AbortController : function() {
		var e = [], t = this.signal = {
			aborted: !1,
			addEventListener: function(t, n) {
				e.push(n);
			}
		};
		this.abort = function() {
			t.aborted = !0, e.forEach(function(e) {
				return e();
			});
		};
	}, Ji = t.unstable_scheduleCallback, Yi = t.unstable_NormalPriority, Xi = {
		$$typeof: S,
		Consumer: null,
		Provider: null,
		_currentValue: null,
		_currentValue2: null,
		_threadCount: 0
	};
	function Zi() {
		return {
			controller: new qi(),
			data: /* @__PURE__ */ new Map(),
			refCount: 0
		};
	}
	function Qi(e) {
		e.refCount--, e.refCount === 0 && Ji(Yi, function() {
			e.controller.abort();
		});
	}
	var $i = null, ea = 0, ta = 0, na = null;
	function ra(e, t) {
		if ($i === null) {
			var n = $i = [];
			ea = 0, ta = ud(), na = {
				status: "pending",
				value: void 0,
				then: function(e) {
					n.push(e);
				}
			};
		}
		return ea++, t.then(ia, ia), t;
	}
	function ia() {
		if (--ea === 0 && $i !== null) {
			na !== null && (na.status = "fulfilled");
			var e = $i;
			$i = null, ta = 0, na = null;
			for (var t = 0; t < e.length; t++) (0, e[t])();
		}
	}
	function aa(e, t) {
		var n = [], r = {
			status: "pending",
			value: null,
			reason: null,
			then: function(e) {
				n.push(e);
			}
		};
		return e.then(function() {
			r.status = "fulfilled", r.value = t;
			for (var e = 0; e < n.length; e++) (0, n[e])(t);
		}, function(e) {
			for (r.status = "rejected", r.reason = e, e = 0; e < n.length; e++) (0, n[e])(void 0);
		}), r;
	}
	var oa = T.S;
	T.S = function(e, t) {
		Ql = Fe(), typeof t == "object" && t && typeof t.then == "function" && ra(e, t), oa !== null && oa(e, t);
	};
	var sa = me(null);
	function ca() {
		var e = sa.current;
		return e === null ? Nl.pooledCache : e;
	}
	function Z(e, t) {
		t === null ? he(sa, sa.current) : he(sa, t.pool);
	}
	function la() {
		var e = ca();
		return e === null ? null : {
			parent: Xi._currentValue,
			pool: e
		};
	}
	var ua = Error(i(460)), da = Error(i(474)), fa = Error(i(542)), pa = { then: function() {} };
	function ma(e) {
		return e = e.status, e === "fulfilled" || e === "rejected";
	}
	function ha(e, t, n) {
		switch (n = e[n], n === void 0 ? e.push(t) : n !== t && (t.then($t, $t), t = n), t.status) {
			case "fulfilled": return t.value;
			case "rejected": throw e = t.reason, ya(e), e;
			default:
				if (typeof t.status == "string") t.then($t, $t);
				else {
					if (e = Nl, e !== null && 100 < e.shellSuspendCounter) throw Error(i(482));
					e = t, e.status = "pending", e.then(function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "fulfilled", n.value = e;
						}
					}, function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "rejected", n.reason = e;
						}
					});
				}
				switch (t.status) {
					case "fulfilled": return t.value;
					case "rejected": throw e = t.reason, ya(e), e;
				}
				throw _a = t, ua;
		}
	}
	function ga(e) {
		try {
			var t = e._init;
			return t(e._payload);
		} catch (e) {
			throw typeof e == "object" && e && typeof e.then == "function" ? (_a = e, ua) : e;
		}
	}
	var _a = null;
	function va() {
		if (_a === null) throw Error(i(459));
		var e = _a;
		return _a = null, e;
	}
	function ya(e) {
		if (e === ua || e === fa) throw Error(i(483));
	}
	var ba = null, xa = 0;
	function Sa(e) {
		var t = xa;
		return xa += 1, ba === null && (ba = []), ha(ba, e, t);
	}
	function Ca(e, t) {
		t = t.props.ref, e.ref = t === void 0 ? null : t;
	}
	function wa(e, t) {
		throw t.$$typeof === g ? Error(i(525)) : (e = Object.prototype.toString.call(t), Error(i(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e)));
	}
	function Ta(e) {
		function t(t, n) {
			if (e) {
				var r = t.deletions;
				r === null ? (t.deletions = [n], t.flags |= 16) : r.push(n);
			}
		}
		function n(n, r) {
			if (!e) return null;
			for (; r !== null;) t(n, r), r = r.sibling;
			return null;
		}
		function r(e) {
			for (var t = /* @__PURE__ */ new Map(); e !== null;) e.key === null ? t.set(e.index, e) : t.set(e.key, e), e = e.sibling;
			return t;
		}
		function a(e, t) {
			return e = ri(e, t), e.index = 0, e.sibling = null, e;
		}
		function o(t, n, r) {
			return t.index = r, e ? (r = t.alternate, r === null ? (t.flags |= 67108866, n) : (r = r.index, r < n ? (t.flags |= 67108866, n) : r)) : (t.flags |= 1048576, n);
		}
		function s(t) {
			return e && t.alternate === null && (t.flags |= 67108866), t;
		}
		function c(e, t, n, r) {
			return t === null || t.tag !== 6 ? (t = si(n, e.mode, r), t.return = e, t) : (t = a(t, n), t.return = e, t);
		}
		function l(e, t, n, r) {
			var i = n.type;
			return i === y ? d(e, t, n.props.children, r, n.key) : t !== null && (t.elementType === i || typeof i == "object" && i && i.$$typeof === re && ga(i) === t.type) ? (t = a(t, n.props), Ca(t, n), t.return = e, t) : (t = ai(n.type, n.key, n.props, null, e.mode, r), Ca(t, n), t.return = e, t);
		}
		function u(e, t, n, r) {
			return t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? (t = K(n, e.mode, r), t.return = e, t) : (t = a(t, n.children || []), t.return = e, t);
		}
		function d(e, t, n, r, i) {
			return t === null || t.tag !== 7 ? (t = oi(n, e.mode, r, i), t.return = e, t) : (t = a(t, n), t.return = e, t);
		}
		function f(e, t, n) {
			if (typeof t == "string" && t !== "" || typeof t == "number" || typeof t == "bigint") return t = si("" + t, e.mode, n), t.return = e, t;
			if (typeof t == "object" && t) {
				switch (t.$$typeof) {
					case _: return n = ai(t.type, t.key, t.props, null, e.mode, n), Ca(n, t), n.return = e, n;
					case v: return t = K(t, e.mode, n), t.return = e, t;
					case re: return t = ga(t), f(e, t, n);
				}
				if (ue(t) || se(t)) return t = oi(t, e.mode, n, null), t.return = e, t;
				if (typeof t.then == "function") return f(e, Sa(t), n);
				if (t.$$typeof === S) return f(e, Gi(e, t), n);
				wa(e, t);
			}
			return null;
		}
		function p(e, t, n, r) {
			var i = t === null ? null : t.key;
			if (typeof n == "string" && n !== "" || typeof n == "number" || typeof n == "bigint") return i === null ? c(e, t, "" + n, r) : null;
			if (typeof n == "object" && n) {
				switch (n.$$typeof) {
					case _: return n.key === i ? l(e, t, n, r) : null;
					case v: return n.key === i ? u(e, t, n, r) : null;
					case re: return n = ga(n), p(e, t, n, r);
				}
				if (ue(n) || se(n)) return i === null ? d(e, t, n, r, null) : null;
				if (typeof n.then == "function") return p(e, t, Sa(n), r);
				if (n.$$typeof === S) return p(e, t, Gi(e, n), r);
				wa(e, n);
			}
			return null;
		}
		function m(e, t, n, r, i) {
			if (typeof r == "string" && r !== "" || typeof r == "number" || typeof r == "bigint") return e = e.get(n) || null, c(t, e, "" + r, i);
			if (typeof r == "object" && r) {
				switch (r.$$typeof) {
					case _: return e = e.get(r.key === null ? n : r.key) || null, l(t, e, r, i);
					case v: return e = e.get(r.key === null ? n : r.key) || null, u(t, e, r, i);
					case re: return r = ga(r), m(e, t, n, r, i);
				}
				if (ue(r) || se(r)) return e = e.get(n) || null, d(t, e, r, i, null);
				if (typeof r.then == "function") return m(e, t, n, Sa(r), i);
				if (r.$$typeof === S) return m(e, t, n, Gi(t, r), i);
				wa(t, r);
			}
			return null;
		}
		function h(i, a, s, c) {
			for (var l = null, u = null, d = a, h = a = 0, g = null; d !== null && h < s.length; h++) {
				d.index > h ? (g = d, d = null) : g = d.sibling;
				var _ = p(i, d, s[h], c);
				if (_ === null) {
					d === null && (d = g);
					break;
				}
				e && d && _.alternate === null && t(i, d), a = o(_, a, h), u === null ? l = _ : u.sibling = _, u = _, d = g;
			}
			if (h === s.length) return n(i, d), X && bi(i, h), l;
			if (d === null) {
				for (; h < s.length; h++) d = f(i, s[h], c), d !== null && (a = o(d, a, h), u === null ? l = d : u.sibling = d, u = d);
				return X && bi(i, h), l;
			}
			for (d = r(d); h < s.length; h++) g = m(d, i, h, s[h], c), g !== null && (e && g.alternate !== null && d.delete(g.key === null ? h : g.key), a = o(g, a, h), u === null ? l = g : u.sibling = g, u = g);
			return e && d.forEach(function(e) {
				return t(i, e);
			}), X && bi(i, h), l;
		}
		function g(a, s, c, l) {
			if (c == null) throw Error(i(151));
			for (var u = null, d = null, h = s, g = s = 0, _ = null, v = c.next(); h !== null && !v.done; g++, v = c.next()) {
				h.index > g ? (_ = h, h = null) : _ = h.sibling;
				var y = p(a, h, v.value, l);
				if (y === null) {
					h === null && (h = _);
					break;
				}
				e && h && y.alternate === null && t(a, h), s = o(y, s, g), d === null ? u = y : d.sibling = y, d = y, h = _;
			}
			if (v.done) return n(a, h), X && bi(a, g), u;
			if (h === null) {
				for (; !v.done; g++, v = c.next()) v = f(a, v.value, l), v !== null && (s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
				return X && bi(a, g), u;
			}
			for (h = r(h); !v.done; g++, v = c.next()) v = m(h, a, g, v.value, l), v !== null && (e && v.alternate !== null && h.delete(v.key === null ? g : v.key), s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
			return e && h.forEach(function(e) {
				return t(a, e);
			}), X && bi(a, g), u;
		}
		function b(e, r, o, c) {
			if (typeof o == "object" && o && o.type === y && o.key === null && (o = o.props.children), typeof o == "object" && o) {
				switch (o.$$typeof) {
					case _:
						a: {
							for (var l = o.key; r !== null;) {
								if (r.key === l) {
									if (l = o.type, l === y) {
										if (r.tag === 7) {
											n(e, r.sibling), c = a(r, o.props.children), c.return = e, e = c;
											break a;
										}
									} else if (r.elementType === l || typeof l == "object" && l && l.$$typeof === re && ga(l) === r.type) {
										n(e, r.sibling), c = a(r, o.props), Ca(c, o), c.return = e, e = c;
										break a;
									}
									n(e, r);
									break;
								} else t(e, r);
								r = r.sibling;
							}
							o.type === y ? (c = oi(o.props.children, e.mode, c, o.key), c.return = e, e = c) : (c = ai(o.type, o.key, o.props, null, e.mode, c), Ca(c, o), c.return = e, e = c);
						}
						return s(e);
					case v:
						a: {
							for (l = o.key; r !== null;) {
								if (r.key === l) if (r.tag === 4 && r.stateNode.containerInfo === o.containerInfo && r.stateNode.implementation === o.implementation) {
									n(e, r.sibling), c = a(r, o.children || []), c.return = e, e = c;
									break a;
								} else {
									n(e, r);
									break;
								}
								else t(e, r);
								r = r.sibling;
							}
							c = K(o, e.mode, c), c.return = e, e = c;
						}
						return s(e);
					case re: return o = ga(o), b(e, r, o, c);
				}
				if (ue(o)) return h(e, r, o, c);
				if (se(o)) {
					if (l = se(o), typeof l != "function") throw Error(i(150));
					return o = l.call(o), g(e, r, o, c);
				}
				if (typeof o.then == "function") return b(e, r, Sa(o), c);
				if (o.$$typeof === S) return b(e, r, Gi(e, o), c);
				wa(e, o);
			}
			return typeof o == "string" && o !== "" || typeof o == "number" || typeof o == "bigint" ? (o = "" + o, r !== null && r.tag === 6 ? (n(e, r.sibling), c = a(r, o), c.return = e, e = c) : (n(e, r), c = si(o, e.mode, c), c.return = e, e = c), s(e)) : n(e, r);
		}
		return function(e, t, n, r) {
			try {
				xa = 0;
				var i = b(e, t, n, r);
				return ba = null, i;
			} catch (t) {
				if (t === ua || t === fa) throw t;
				var a = G(29, t, null, e.mode);
				return a.lanes = r, a.return = e, a;
			}
		};
	}
	var Ea = Ta(!0), Da = Ta(!1), Oa = !1;
	function ka(e) {
		e.updateQueue = {
			baseState: e.memoizedState,
			firstBaseUpdate: null,
			lastBaseUpdate: null,
			shared: {
				pending: null,
				lanes: 0,
				hiddenCallbacks: null
			},
			callbacks: null
		};
	}
	function Aa(e, t) {
		e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
			baseState: e.baseState,
			firstBaseUpdate: e.firstBaseUpdate,
			lastBaseUpdate: e.lastBaseUpdate,
			shared: e.shared,
			callbacks: null
		});
	}
	function ja(e) {
		return {
			lane: e,
			tag: 0,
			payload: null,
			callback: null,
			next: null
		};
	}
	function Ma(e, t, n) {
		var r = e.updateQueue;
		if (r === null) return null;
		if (r = r.shared, Ml & 2) {
			var i = r.pending;
			return i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, t = ei(e), $r(e, null, n), t;
		}
		return Xr(e, r, t, n), ei(e);
	}
	function Na(e, t, n) {
		if (t = t.updateQueue, t !== null && (t = t.shared, n & 4194048)) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, lt(e, n);
		}
	}
	function Pa(e, t) {
		var n = e.updateQueue, r = e.alternate;
		if (r !== null && (r = r.updateQueue, n === r)) {
			var i = null, a = null;
			if (n = n.firstBaseUpdate, n !== null) {
				do {
					var o = {
						lane: n.lane,
						tag: n.tag,
						payload: n.payload,
						callback: null,
						next: null
					};
					a === null ? i = a = o : a = a.next = o, n = n.next;
				} while (n !== null);
				a === null ? i = a = t : a = a.next = t;
			} else i = a = t;
			n = {
				baseState: r.baseState,
				firstBaseUpdate: i,
				lastBaseUpdate: a,
				shared: r.shared,
				callbacks: r.callbacks
			}, e.updateQueue = n;
			return;
		}
		e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
	}
	var Fa = !1;
	function Ia() {
		if (Fa) {
			var e = na;
			if (e !== null) throw e;
		}
	}
	function La(e, t, n, r) {
		Fa = !1;
		var i = e.updateQueue;
		Oa = !1;
		var a = i.firstBaseUpdate, o = i.lastBaseUpdate, s = i.shared.pending;
		if (s !== null) {
			i.shared.pending = null;
			var c = s, l = c.next;
			c.next = null, o === null ? a = l : o.next = l, o = c;
			var u = e.alternate;
			u !== null && (u = u.updateQueue, s = u.lastBaseUpdate, s !== o && (s === null ? u.firstBaseUpdate = l : s.next = l, u.lastBaseUpdate = c));
		}
		if (a !== null) {
			var d = i.baseState;
			o = 0, u = l = c = null, s = a;
			do {
				var f = s.lane & -536870913, p = f !== s.lane;
				if (p ? (Fl & f) === f : (r & f) === f) {
					f !== 0 && f === ta && (Fa = !0), u !== null && (u = u.next = {
						lane: 0,
						tag: s.tag,
						payload: s.payload,
						callback: null,
						next: null
					});
					a: {
						var m = e, g = s;
						f = t;
						var _ = n;
						switch (g.tag) {
							case 1:
								if (m = g.payload, typeof m == "function") {
									d = m.call(_, d, f);
									break a;
								}
								d = m;
								break a;
							case 3: m.flags = m.flags & -65537 | 128;
							case 0:
								if (m = g.payload, f = typeof m == "function" ? m.call(_, d, f) : m, f == null) break a;
								d = h({}, d, f);
								break a;
							case 2: Oa = !0;
						}
					}
					f = s.callback, f !== null && (e.flags |= 64, p && (e.flags |= 8192), p = i.callbacks, p === null ? i.callbacks = [f] : p.push(f));
				} else p = {
					lane: f,
					tag: s.tag,
					payload: s.payload,
					callback: s.callback,
					next: null
				}, u === null ? (l = u = p, c = d) : u = u.next = p, o |= f;
				if (s = s.next, s === null) {
					if (s = i.shared.pending, s === null) break;
					p = s, s = p.next, p.next = null, i.lastBaseUpdate = p, i.shared.pending = null;
				}
			} while (1);
			u === null && (c = d), i.baseState = c, i.firstBaseUpdate = l, i.lastBaseUpdate = u, a === null && (i.shared.lanes = 0), Ul |= o, e.lanes = o, e.memoizedState = d;
		}
	}
	function Ra(e, t) {
		if (typeof e != "function") throw Error(i(191, e));
		e.call(t);
	}
	function za(e, t) {
		var n = e.callbacks;
		if (n !== null) for (e.callbacks = null, e = 0; e < n.length; e++) Ra(n[e], t);
	}
	var Ba = me(null), Va = me(0);
	function Ha(e, t) {
		e = Vl, he(Va, e), he(Ba, t), Vl = e | t.baseLanes;
	}
	function Ua() {
		he(Va, Vl), he(Ba, Ba.current);
	}
	function Wa() {
		Vl = Va.current, D(Ba), D(Va);
	}
	var Ga = me(null), Ka = null;
	function qa(e) {
		var t = e.alternate;
		he(Qa, Qa.current & 1), he(Ga, e), Ka === null && (t === null || Ba.current !== null || t.memoizedState !== null) && (Ka = e);
	}
	function Ja(e) {
		he(Qa, Qa.current), he(Ga, e), Ka === null && (Ka = e);
	}
	function Ya(e) {
		e.tag === 22 ? (he(Qa, Qa.current), he(Ga, e), Ka === null && (Ka = e)) : Xa(e);
	}
	function Xa() {
		he(Qa, Qa.current), he(Ga, Ga.current);
	}
	function Za(e) {
		D(Ga), Ka === e && (Ka = null), D(Qa);
	}
	var Qa = me(0);
	function $a(e) {
		for (var t = e; t !== null;) {
			if (t.tag === 13) {
				var n = t.memoizedState;
				if (n !== null && (n = n.dehydrated, n === null || af(n) || of(n))) return t;
			} else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
				if (t.flags & 128) return t;
			} else if (t.child !== null) {
				t.child.return = t, t = t.child;
				continue;
			}
			if (t === e) break;
			for (; t.sibling === null;) {
				if (t.return === null || t.return === e) return null;
				t = t.return;
			}
			t.sibling.return = t.return, t = t.sibling;
		}
		return null;
	}
	var eo = 0, Q = null, to = null, no = null, ro = !1, io = !1, ao = !1, oo = 0, so = 0, co = null, lo = 0;
	function uo() {
		throw Error(i(321));
	}
	function fo(e, t) {
		if (t === null) return !1;
		for (var n = 0; n < t.length && n < e.length; n++) if (!vr(e[n], t[n])) return !1;
		return !0;
	}
	function po(e, t, n, r, i, a) {
		return eo = a, Q = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, T.H = e === null || e.memoizedState === null ? As : js, ao = !1, a = n(r, i), ao = !1, io && (a = ho(t, n, r, i)), mo(e), a;
	}
	function mo(e) {
		T.H = ks;
		var t = to !== null && to.next !== null;
		if (eo = 0, no = to = Q = null, ro = !1, so = 0, co = null, t) throw Error(i(300));
		e === null || Js || (e = e.dependencies, e !== null && Hi(e) && (Js = !0));
	}
	function ho(e, t, n, r) {
		Q = e;
		var a = 0;
		do {
			if (io && (co = null), so = 0, io = !1, 25 <= a) throw Error(i(301));
			if (a += 1, no = to = null, e.updateQueue != null) {
				var o = e.updateQueue;
				o.lastEffect = null, o.events = null, o.stores = null, o.memoCache != null && (o.memoCache.index = 0);
			}
			T.H = Ms, o = t(n, r);
		} while (io);
		return o;
	}
	function go() {
		var e = T.H, t = e.useState()[0];
		return t = typeof t.then == "function" ? Co(t) : t, e = e.useState()[0], (to === null ? null : to.memoizedState) !== e && (Q.flags |= 1024), t;
	}
	function _o() {
		var e = oo !== 0;
		return oo = 0, e;
	}
	function vo(e, t, n) {
		t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n;
	}
	function yo(e) {
		if (ro) {
			for (e = e.memoizedState; e !== null;) {
				var t = e.queue;
				t !== null && (t.pending = null), e = e.next;
			}
			ro = !1;
		}
		eo = 0, no = to = Q = null, io = !1, so = oo = 0, co = null;
	}
	function bo() {
		var e = {
			memoizedState: null,
			baseState: null,
			baseQueue: null,
			queue: null,
			next: null
		};
		return no === null ? Q.memoizedState = no = e : no = no.next = e, no;
	}
	function xo() {
		if (to === null) {
			var e = Q.alternate;
			e = e === null ? null : e.memoizedState;
		} else e = to.next;
		var t = no === null ? Q.memoizedState : no.next;
		if (t !== null) no = t, to = e;
		else {
			if (e === null) throw Q.alternate === null ? Error(i(467)) : Error(i(310));
			to = e, e = {
				memoizedState: to.memoizedState,
				baseState: to.baseState,
				baseQueue: to.baseQueue,
				queue: to.queue,
				next: null
			}, no === null ? Q.memoizedState = no = e : no = no.next = e;
		}
		return no;
	}
	function So() {
		return {
			lastEffect: null,
			events: null,
			stores: null,
			memoCache: null
		};
	}
	function Co(e) {
		var t = so;
		return so += 1, co === null && (co = []), e = ha(co, e, t), t = Q, (no === null ? t.memoizedState : no.next) === null && (t = t.alternate, T.H = t === null || t.memoizedState === null ? As : js), e;
	}
	function wo(e) {
		if (typeof e == "object" && e) {
			if (typeof e.then == "function") return Co(e);
			if (e.$$typeof === S) return Wi(e);
		}
		throw Error(i(438, String(e)));
	}
	function To(e) {
		var t = null, n = Q.updateQueue;
		if (n !== null && (t = n.memoCache), t == null) {
			var r = Q.alternate;
			r !== null && (r = r.updateQueue, r !== null && (r = r.memoCache, r != null && (t = {
				data: r.data.map(function(e) {
					return e.slice();
				}),
				index: 0
			})));
		}
		if (t ??= {
			data: [],
			index: 0
		}, n === null && (n = So(), Q.updateQueue = n), n.memoCache = t, n = t.data[t.index], n === void 0) for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = ae;
		return t.index++, n;
	}
	function Eo(e, t) {
		return typeof t == "function" ? t(e) : t;
	}
	function Do(e) {
		return Oo(xo(), to, e);
	}
	function Oo(e, t, n) {
		var r = e.queue;
		if (r === null) throw Error(i(311));
		r.lastRenderedReducer = n;
		var a = e.baseQueue, o = r.pending;
		if (o !== null) {
			if (a !== null) {
				var s = a.next;
				a.next = o.next, o.next = s;
			}
			t.baseQueue = a = o, r.pending = null;
		}
		if (o = e.baseState, a === null) e.memoizedState = o;
		else {
			t = a.next;
			var c = s = null, l = null, u = t, d = !1;
			do {
				var f = u.lane & -536870913;
				if (f === u.lane ? (eo & f) === f : (Fl & f) === f) {
					var p = u.revertLane;
					if (p === 0) l !== null && (l = l.next = {
						lane: 0,
						revertLane: 0,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}), f === ta && (d = !0);
					else if ((eo & p) === p) {
						u = u.next, p === ta && (d = !0);
						continue;
					} else f = {
						lane: 0,
						revertLane: u.revertLane,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}, l === null ? (c = l = f, s = o) : l = l.next = f, Q.lanes |= p, Ul |= p;
					f = u.action, ao && n(o, f), o = u.hasEagerState ? u.eagerState : n(o, f);
				} else p = {
					lane: f,
					revertLane: u.revertLane,
					gesture: u.gesture,
					action: u.action,
					hasEagerState: u.hasEagerState,
					eagerState: u.eagerState,
					next: null
				}, l === null ? (c = l = p, s = o) : l = l.next = p, Q.lanes |= f, Ul |= f;
				u = u.next;
			} while (u !== null && u !== t);
			if (l === null ? s = o : l.next = c, !vr(o, e.memoizedState) && (Js = !0, d && (n = na, n !== null))) throw n;
			e.memoizedState = o, e.baseState = s, e.baseQueue = l, r.lastRenderedState = o;
		}
		return a === null && (r.lanes = 0), [e.memoizedState, r.dispatch];
	}
	function ko(e) {
		var t = xo(), n = t.queue;
		if (n === null) throw Error(i(311));
		n.lastRenderedReducer = e;
		var r = n.dispatch, a = n.pending, o = t.memoizedState;
		if (a !== null) {
			n.pending = null;
			var s = a = a.next;
			do
				o = e(o, s.action), s = s.next;
			while (s !== a);
			vr(o, t.memoizedState) || (Js = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
		}
		return [o, r];
	}
	function Ao(e, t, n) {
		var r = Q, a = xo(), o = X;
		if (o) {
			if (n === void 0) throw Error(i(407));
			n = n();
		} else n = t();
		var s = !vr((to || a).memoizedState, n);
		if (s && (a.memoizedState = n, Js = !0), a = a.queue, ts(No.bind(null, r, a, e), [e]), a.getSnapshot !== t || s || no !== null && no.memoizedState.tag & 1) {
			if (r.flags |= 2048, Xo(9, { destroy: void 0 }, Mo.bind(null, r, a, n, t), null), Nl === null) throw Error(i(349));
			o || eo & 127 || jo(r, t, n);
		}
		return n;
	}
	function jo(e, t, n) {
		e.flags |= 16384, e = {
			getSnapshot: t,
			value: n
		}, t = Q.updateQueue, t === null ? (t = So(), Q.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
	}
	function Mo(e, t, n, r) {
		t.value = n, t.getSnapshot = r, Po(t) && Fo(e);
	}
	function No(e, t, n) {
		return n(function() {
			Po(t) && Fo(e);
		});
	}
	function Po(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !vr(e, n);
		} catch {
			return !0;
		}
	}
	function Fo(e) {
		var t = Qr(e, 2);
		t !== null && pu(t, e, 2);
	}
	function Io(e) {
		var t = bo();
		if (typeof e == "function") {
			var n = e;
			if (e = n(), ao) {
				Ke(!0);
				try {
					n();
				} finally {
					Ke(!1);
				}
			}
		}
		return t.memoizedState = t.baseState = e, t.queue = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: Eo,
			lastRenderedState: e
		}, t;
	}
	function Lo(e, t, n, r) {
		return e.baseState = n, Oo(e, to, typeof r == "function" ? r : Eo);
	}
	function Ro(e, t, n, r, a) {
		if (Es(e)) throw Error(i(485));
		if (e = t.action, e !== null) {
			var o = {
				payload: a,
				action: e,
				next: null,
				isTransition: !0,
				status: "pending",
				value: null,
				reason: null,
				listeners: [],
				then: function(e) {
					o.listeners.push(e);
				}
			};
			T.T === null ? o.isTransition = !1 : n(!0), r(o), n = t.pending, n === null ? (o.next = t.pending = o, zo(t, o)) : (o.next = n.next, t.pending = n.next = o);
		}
	}
	function zo(e, t) {
		var n = t.action, r = t.payload, i = e.state;
		if (t.isTransition) {
			var a = T.T, o = {};
			T.T = o;
			try {
				var s = n(i, r), c = T.S;
				c !== null && c(o, s), Bo(e, t, s);
			} catch (n) {
				Ho(e, t, n);
			} finally {
				a !== null && o.types !== null && (a.types = o.types), T.T = a;
			}
		} else try {
			a = n(i, r), Bo(e, t, a);
		} catch (n) {
			Ho(e, t, n);
		}
	}
	function Bo(e, t, n) {
		typeof n == "object" && n && typeof n.then == "function" ? n.then(function(n) {
			Vo(e, t, n);
		}, function(n) {
			return Ho(e, t, n);
		}) : Vo(e, t, n);
	}
	function Vo(e, t, n) {
		t.status = "fulfilled", t.value = n, Uo(t), e.state = n, t = e.pending, t !== null && (n = t.next, n === t ? e.pending = null : (n = n.next, t.next = n, zo(e, n)));
	}
	function Ho(e, t, n) {
		var r = e.pending;
		if (e.pending = null, r !== null) {
			r = r.next;
			do
				t.status = "rejected", t.reason = n, Uo(t), t = t.next;
			while (t !== r);
		}
		e.action = null;
	}
	function Uo(e) {
		e = e.listeners;
		for (var t = 0; t < e.length; t++) (0, e[t])();
	}
	function Wo(e, t) {
		return t;
	}
	function Go(e, t) {
		if (X) {
			var n = Nl.formState;
			if (n !== null) {
				a: {
					var r = Q;
					if (X) {
						if (Ci) {
							b: {
								for (var i = Ci, a = Ti; i.nodeType !== 8;) {
									if (!a) {
										i = null;
										break b;
									}
									if (i = cf(i.nextSibling), i === null) {
										i = null;
										break b;
									}
								}
								a = i.data, i = a === "F!" || a === "F" ? i : null;
							}
							if (i) {
								Ci = cf(i.nextSibling), r = i.data === "F!";
								break a;
							}
						}
						Di(r);
					}
					r = !1;
				}
				r && (t = n[0]);
			}
		}
		return n = bo(), n.memoizedState = n.baseState = t, r = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: Wo,
			lastRenderedState: t
		}, n.queue = r, n = Cs.bind(null, Q, r), r.dispatch = n, r = Io(!1), a = Ts.bind(null, Q, !1, r.queue), r = bo(), i = {
			state: t,
			dispatch: null,
			action: e,
			pending: null
		}, r.queue = i, n = Ro.bind(null, Q, i, a, n), i.dispatch = n, r.memoizedState = e, [
			t,
			n,
			!1
		];
	}
	function Ko(e) {
		return qo(xo(), to, e);
	}
	function qo(e, t, n) {
		if (t = Oo(e, t, Wo)[0], e = Do(Eo)[0], typeof t == "object" && t && typeof t.then == "function") try {
			var r = Co(t);
		} catch (e) {
			throw e === ua ? fa : e;
		}
		else r = t;
		t = xo();
		var i = t.queue, a = i.dispatch;
		return n !== t.memoizedState && (Q.flags |= 2048, Xo(9, { destroy: void 0 }, Jo.bind(null, i, n), null)), [
			r,
			a,
			e
		];
	}
	function Jo(e, t) {
		e.action = t;
	}
	function Yo(e) {
		var t = xo(), n = to;
		if (n !== null) return qo(t, n, e);
		xo(), t = t.memoizedState, n = xo();
		var r = n.queue.dispatch;
		return n.memoizedState = e, [
			t,
			r,
			!1
		];
	}
	function Xo(e, t, n, r) {
		return e = {
			tag: e,
			create: n,
			deps: r,
			inst: t,
			next: null
		}, t = Q.updateQueue, t === null && (t = So(), Q.updateQueue = t), n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
	}
	function Zo() {
		return xo().memoizedState;
	}
	function Qo(e, t, n, r) {
		var i = bo();
		Q.flags |= e, i.memoizedState = Xo(1 | t, { destroy: void 0 }, n, r === void 0 ? null : r);
	}
	function $o(e, t, n, r) {
		var i = xo();
		r = r === void 0 ? null : r;
		var a = i.memoizedState.inst;
		to !== null && r !== null && fo(r, to.memoizedState.deps) ? i.memoizedState = Xo(t, a, n, r) : (Q.flags |= e, i.memoizedState = Xo(1 | t, a, n, r));
	}
	function es(e, t) {
		Qo(8390656, 8, e, t);
	}
	function ts(e, t) {
		$o(2048, 8, e, t);
	}
	function ns(e) {
		Q.flags |= 4;
		var t = Q.updateQueue;
		if (t === null) t = So(), Q.updateQueue = t, t.events = [e];
		else {
			var n = t.events;
			n === null ? t.events = [e] : n.push(e);
		}
	}
	function rs(e) {
		var t = xo().memoizedState;
		return ns({
			ref: t,
			nextImpl: e
		}), function() {
			if (Ml & 2) throw Error(i(440));
			return t.impl.apply(void 0, arguments);
		};
	}
	function is(e, t) {
		return $o(4, 2, e, t);
	}
	function as(e, t) {
		return $o(4, 4, e, t);
	}
	function os(e, t) {
		if (typeof t == "function") {
			e = e();
			var n = t(e);
			return function() {
				typeof n == "function" ? n() : t(null);
			};
		}
		if (t != null) return e = e(), t.current = e, function() {
			t.current = null;
		};
	}
	function ss(e, t, n) {
		n = n == null ? null : n.concat([e]), $o(4, 4, os.bind(null, t, e), n);
	}
	function cs() {}
	function ls(e, t) {
		var n = xo();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		return t !== null && fo(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
	}
	function us(e, t) {
		var n = xo();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		if (t !== null && fo(t, r[1])) return r[0];
		if (r = e(), ao) {
			Ke(!0);
			try {
				e();
			} finally {
				Ke(!1);
			}
		}
		return n.memoizedState = [r, t], r;
	}
	function ds(e, t, n) {
		return n === void 0 || eo & 1073741824 && !(Fl & 261930) ? e.memoizedState = t : (e.memoizedState = n, e = fu(), Q.lanes |= e, Ul |= e, n);
	}
	function fs(e, t, n, r) {
		return vr(n, t) ? n : Ba.current === null ? !(eo & 42) || eo & 1073741824 && !(Fl & 261930) ? (Js = !0, e.memoizedState = n) : (e = fu(), Q.lanes |= e, Ul |= e, t) : (e = ds(e, n, r), vr(e, t) || (Js = !0), e);
	}
	function ps(e, t, n, r, i) {
		var a = E.p;
		E.p = a !== 0 && 8 > a ? a : 8;
		var o = T.T, s = {};
		T.T = s, Ts(e, !1, t, n);
		try {
			var c = i(), l = T.S;
			l !== null && l(s, c), typeof c == "object" && c && typeof c.then == "function" ? ws(e, t, aa(c, r), du(e)) : ws(e, t, r, du(e));
		} catch (n) {
			ws(e, t, {
				then: function() {},
				status: "rejected",
				reason: n
			}, du());
		} finally {
			E.p = a, o !== null && s.types !== null && (o.types = s.types), T.T = o;
		}
	}
	function ms() {}
	function hs(e, t, n, r) {
		if (e.tag !== 5) throw Error(i(476));
		var a = gs(e).queue;
		ps(e, a, t, de, n === null ? ms : function() {
			return _s(e), n(r);
		});
	}
	function gs(e) {
		var t = e.memoizedState;
		if (t !== null) return t;
		t = {
			memoizedState: de,
			baseState: de,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: Eo,
				lastRenderedState: de
			},
			next: null
		};
		var n = {};
		return t.next = {
			memoizedState: n,
			baseState: n,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: Eo,
				lastRenderedState: n
			},
			next: null
		}, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
	}
	function _s(e) {
		var t = gs(e);
		t.next === null && (t = e.alternate.memoizedState), ws(e, t.next.queue, {}, du());
	}
	function vs() {
		return Wi(Qf);
	}
	function ys() {
		return xo().memoizedState;
	}
	function bs() {
		return xo().memoizedState;
	}
	function xs(e) {
		for (var t = e.return; t !== null;) {
			switch (t.tag) {
				case 24:
				case 3:
					var n = du();
					e = ja(n);
					var r = Ma(t, e, n);
					r !== null && (pu(r, t, n), Na(r, t, n)), t = { cache: Zi() }, e.payload = t;
					return;
			}
			t = t.return;
		}
	}
	function Ss(e, t, n) {
		var r = du();
		n = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, Es(e) ? Ds(t, n) : (n = Zr(e, t, n, r), n !== null && (pu(n, e, r), Os(n, t, r)));
	}
	function Cs(e, t, n) {
		ws(e, t, n, du());
	}
	function ws(e, t, n, r) {
		var i = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		};
		if (Es(e)) Ds(t, i);
		else {
			var a = e.alternate;
			if (e.lanes === 0 && (a === null || a.lanes === 0) && (a = t.lastRenderedReducer, a !== null)) try {
				var o = t.lastRenderedState, s = a(o, n);
				if (i.hasEagerState = !0, i.eagerState = s, vr(s, o)) return Xr(e, t, i, 0), Nl === null && Yr(), !1;
			} catch {}
			if (n = Zr(e, t, i, r), n !== null) return pu(n, e, r), Os(n, t, r), !0;
		}
		return !1;
	}
	function Ts(e, t, n, r) {
		if (r = {
			lane: 2,
			revertLane: ud(),
			gesture: null,
			action: r,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, Es(e)) {
			if (t) throw Error(i(479));
		} else t = Zr(e, n, r, 2), t !== null && pu(t, e, 2);
	}
	function Es(e) {
		var t = e.alternate;
		return e === Q || t !== null && t === Q;
	}
	function Ds(e, t) {
		io = ro = !0;
		var n = e.pending;
		n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
	}
	function Os(e, t, n) {
		if (n & 4194048) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, lt(e, n);
		}
	}
	var ks = {
		readContext: Wi,
		use: wo,
		useCallback: uo,
		useContext: uo,
		useEffect: uo,
		useImperativeHandle: uo,
		useLayoutEffect: uo,
		useInsertionEffect: uo,
		useMemo: uo,
		useReducer: uo,
		useRef: uo,
		useState: uo,
		useDebugValue: uo,
		useDeferredValue: uo,
		useTransition: uo,
		useSyncExternalStore: uo,
		useId: uo,
		useHostTransitionStatus: uo,
		useFormState: uo,
		useActionState: uo,
		useOptimistic: uo,
		useMemoCache: uo,
		useCacheRefresh: uo
	};
	ks.useEffectEvent = uo;
	var As = {
		readContext: Wi,
		use: wo,
		useCallback: function(e, t) {
			return bo().memoizedState = [e, t === void 0 ? null : t], e;
		},
		useContext: Wi,
		useEffect: es,
		useImperativeHandle: function(e, t, n) {
			n = n == null ? null : n.concat([e]), Qo(4194308, 4, os.bind(null, t, e), n);
		},
		useLayoutEffect: function(e, t) {
			return Qo(4194308, 4, e, t);
		},
		useInsertionEffect: function(e, t) {
			Qo(4, 2, e, t);
		},
		useMemo: function(e, t) {
			var n = bo();
			t = t === void 0 ? null : t;
			var r = e();
			if (ao) {
				Ke(!0);
				try {
					e();
				} finally {
					Ke(!1);
				}
			}
			return n.memoizedState = [r, t], r;
		},
		useReducer: function(e, t, n) {
			var r = bo();
			if (n !== void 0) {
				var i = n(t);
				if (ao) {
					Ke(!0);
					try {
						n(t);
					} finally {
						Ke(!1);
					}
				}
			} else i = t;
			return r.memoizedState = r.baseState = i, e = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: e,
				lastRenderedState: i
			}, r.queue = e, e = e.dispatch = Ss.bind(null, Q, e), [r.memoizedState, e];
		},
		useRef: function(e) {
			var t = bo();
			return e = { current: e }, t.memoizedState = e;
		},
		useState: function(e) {
			e = Io(e);
			var t = e.queue, n = Cs.bind(null, Q, t);
			return t.dispatch = n, [e.memoizedState, n];
		},
		useDebugValue: cs,
		useDeferredValue: function(e, t) {
			return ds(bo(), e, t);
		},
		useTransition: function() {
			var e = Io(!1);
			return e = ps.bind(null, Q, e.queue, !0, !1), bo().memoizedState = e, [!1, e];
		},
		useSyncExternalStore: function(e, t, n) {
			var r = Q, a = bo();
			if (X) {
				if (n === void 0) throw Error(i(407));
				n = n();
			} else {
				if (n = t(), Nl === null) throw Error(i(349));
				Fl & 127 || jo(r, t, n);
			}
			a.memoizedState = n;
			var o = {
				value: n,
				getSnapshot: t
			};
			return a.queue = o, es(No.bind(null, r, o, e), [e]), r.flags |= 2048, Xo(9, { destroy: void 0 }, Mo.bind(null, r, o, n, t), null), n;
		},
		useId: function() {
			var e = bo(), t = Nl.identifierPrefix;
			if (X) {
				var n = yi, r = vi;
				n = (r & ~(1 << 32 - qe(r) - 1)).toString(32) + n, t = "_" + t + "R_" + n, n = oo++, 0 < n && (t += "H" + n.toString(32)), t += "_";
			} else n = lo++, t = "_" + t + "r_" + n.toString(32) + "_";
			return e.memoizedState = t;
		},
		useHostTransitionStatus: vs,
		useFormState: Go,
		useActionState: Go,
		useOptimistic: function(e) {
			var t = bo();
			t.memoizedState = t.baseState = e;
			var n = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: null,
				lastRenderedState: null
			};
			return t.queue = n, t = Ts.bind(null, Q, !0, n), n.dispatch = t, [e, t];
		},
		useMemoCache: To,
		useCacheRefresh: function() {
			return bo().memoizedState = xs.bind(null, Q);
		},
		useEffectEvent: function(e) {
			var t = bo(), n = { impl: e };
			return t.memoizedState = n, function() {
				if (Ml & 2) throw Error(i(440));
				return n.impl.apply(void 0, arguments);
			};
		}
	}, js = {
		readContext: Wi,
		use: wo,
		useCallback: ls,
		useContext: Wi,
		useEffect: ts,
		useImperativeHandle: ss,
		useInsertionEffect: is,
		useLayoutEffect: as,
		useMemo: us,
		useReducer: Do,
		useRef: Zo,
		useState: function() {
			return Do(Eo);
		},
		useDebugValue: cs,
		useDeferredValue: function(e, t) {
			return fs(xo(), to.memoizedState, e, t);
		},
		useTransition: function() {
			var e = Do(Eo)[0], t = xo().memoizedState;
			return [typeof e == "boolean" ? e : Co(e), t];
		},
		useSyncExternalStore: Ao,
		useId: ys,
		useHostTransitionStatus: vs,
		useFormState: Ko,
		useActionState: Ko,
		useOptimistic: function(e, t) {
			return Lo(xo(), to, e, t);
		},
		useMemoCache: To,
		useCacheRefresh: bs
	};
	js.useEffectEvent = rs;
	var Ms = {
		readContext: Wi,
		use: wo,
		useCallback: ls,
		useContext: Wi,
		useEffect: ts,
		useImperativeHandle: ss,
		useInsertionEffect: is,
		useLayoutEffect: as,
		useMemo: us,
		useReducer: ko,
		useRef: Zo,
		useState: function() {
			return ko(Eo);
		},
		useDebugValue: cs,
		useDeferredValue: function(e, t) {
			var n = xo();
			return to === null ? ds(n, e, t) : fs(n, to.memoizedState, e, t);
		},
		useTransition: function() {
			var e = ko(Eo)[0], t = xo().memoizedState;
			return [typeof e == "boolean" ? e : Co(e), t];
		},
		useSyncExternalStore: Ao,
		useId: ys,
		useHostTransitionStatus: vs,
		useFormState: Yo,
		useActionState: Yo,
		useOptimistic: function(e, t) {
			var n = xo();
			return to === null ? (n.baseState = e, [e, n.queue.dispatch]) : Lo(n, to, e, t);
		},
		useMemoCache: To,
		useCacheRefresh: bs
	};
	Ms.useEffectEvent = rs;
	function Ns(e, t, n, r) {
		t = e.memoizedState, n = n(r, t), n = n == null ? t : h({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
	}
	var Ps = {
		enqueueSetState: function(e, t, n) {
			e = e._reactInternals;
			var r = du(), i = ja(r);
			i.payload = t, n != null && (i.callback = n), t = Ma(e, i, r), t !== null && (pu(t, e, r), Na(t, e, r));
		},
		enqueueReplaceState: function(e, t, n) {
			e = e._reactInternals;
			var r = du(), i = ja(r);
			i.tag = 1, i.payload = t, n != null && (i.callback = n), t = Ma(e, i, r), t !== null && (pu(t, e, r), Na(t, e, r));
		},
		enqueueForceUpdate: function(e, t) {
			e = e._reactInternals;
			var n = du(), r = ja(n);
			r.tag = 2, t != null && (r.callback = t), t = Ma(e, r, n), t !== null && (pu(t, e, n), Na(t, e, n));
		}
	};
	function Fs(e, t, n, r, i, a, o) {
		return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, a, o) : t.prototype && t.prototype.isPureReactComponent ? !yr(n, r) || !yr(i, a) : !0;
	}
	function Is(e, t, n, r) {
		e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Ps.enqueueReplaceState(t, t.state, null);
	}
	function Ls(e, t) {
		var n = t;
		if ("ref" in t) for (var r in n = {}, t) r !== "ref" && (n[r] = t[r]);
		if (e = e.defaultProps) for (var i in n === t && (n = h({}, n)), e) n[i] === void 0 && (n[i] = e[i]);
		return n;
	}
	function Rs(e) {
		U(e);
	}
	function zs(e) {
		console.error(e);
	}
	function Bs(e) {
		U(e);
	}
	function Vs(e, t) {
		try {
			var n = e.onUncaughtError;
			n(t.value, { componentStack: t.stack });
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function Hs(e, t, n) {
		try {
			var r = e.onCaughtError;
			r(n.value, {
				componentStack: n.stack,
				errorBoundary: t.tag === 1 ? t.stateNode : null
			});
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function Us(e, t, n) {
		return n = ja(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
			Vs(e, t);
		}, n;
	}
	function Ws(e) {
		return e = ja(e), e.tag = 3, e;
	}
	function Gs(e, t, n, r) {
		var i = n.type.getDerivedStateFromError;
		if (typeof i == "function") {
			var a = r.value;
			e.payload = function() {
				return i(a);
			}, e.callback = function() {
				Hs(t, n, r);
			};
		}
		var o = n.stateNode;
		o !== null && typeof o.componentDidCatch == "function" && (e.callback = function() {
			Hs(t, n, r), typeof i != "function" && (tu === null ? tu = new Set([this]) : tu.add(this));
			var e = r.stack;
			this.componentDidCatch(r.value, { componentStack: e === null ? "" : e });
		});
	}
	function Ks(e, t, n, r, a) {
		if (n.flags |= 32768, typeof r == "object" && r && typeof r.then == "function") {
			if (t = n.alternate, t !== null && Vi(t, n, a, !0), n = Ga.current, n !== null) {
				switch (n.tag) {
					case 31:
					case 13: return Ka === null ? Tu() : n.alternate === null && Hl === 0 && (Hl = 3), n.flags &= -257, n.flags |= 65536, n.lanes = a, r === pa ? n.flags |= 16384 : (t = n.updateQueue, t === null ? n.updateQueue = new Set([r]) : t.add(r), Wu(e, r, a)), !1;
					case 22: return n.flags |= 65536, r === pa ? n.flags |= 16384 : (t = n.updateQueue, t === null ? (t = {
						transitions: null,
						markerInstances: null,
						retryQueue: new Set([r])
					}, n.updateQueue = t) : (n = t.retryQueue, n === null ? t.retryQueue = new Set([r]) : n.add(r)), Wu(e, r, a)), !1;
				}
				throw Error(i(435, n.tag));
			}
			return Wu(e, r, a), Tu(), !1;
		}
		if (X) return t = Ga.current, t === null ? (r !== Ei && (t = Error(i(423), { cause: r }), Ni(ui(t, n))), e = e.current.alternate, e.flags |= 65536, a &= -a, e.lanes |= a, r = ui(r, n), a = Us(e.stateNode, r, a), Pa(e, a), Hl !== 4 && (Hl = 2)) : (!(t.flags & 65536) && (t.flags |= 256), t.flags |= 65536, t.lanes = a, r !== Ei && (e = Error(i(422), { cause: r }), Ni(ui(e, n)))), !1;
		var o = Error(i(520), { cause: r });
		if (o = ui(o, n), Jl === null ? Jl = [o] : Jl.push(o), Hl !== 4 && (Hl = 2), t === null) return !0;
		r = ui(r, n), n = t;
		do {
			switch (n.tag) {
				case 3: return n.flags |= 65536, e = a & -a, n.lanes |= e, e = Us(n.stateNode, r, e), Pa(n, e), !1;
				case 1: if (t = n.type, o = n.stateNode, !(n.flags & 128) && (typeof t.getDerivedStateFromError == "function" || o !== null && typeof o.componentDidCatch == "function" && (tu === null || !tu.has(o)))) return n.flags |= 65536, a &= -a, n.lanes |= a, a = Ws(a), Gs(a, e, n, r), Pa(n, a), !1;
			}
			n = n.return;
		} while (n !== null);
		return !1;
	}
	var qs = Error(i(461)), Js = !1;
	function Ys(e, t, n, r) {
		t.child = e === null ? Da(t, null, n, r) : Ea(t, e.child, n, r);
	}
	function Xs(e, t, n, r, i) {
		n = n.render;
		var a = t.ref;
		if ("ref" in r) {
			var o = {};
			for (var s in r) s !== "ref" && (o[s] = r[s]);
		} else o = r;
		return Ui(t), r = po(e, t, n, o, a, i), s = _o(), e !== null && !Js ? (vo(e, t, i), bc(e, t, i)) : (X && s && q(t), t.flags |= 1, Ys(e, t, r, i), t.child);
	}
	function Zs(e, t, n, r, i) {
		if (e === null) {
			var a = n.type;
			return typeof a == "function" && !ni(a) && a.defaultProps === void 0 && n.compare === null ? (t.tag = 15, t.type = a, Qs(e, t, a, r, i)) : (e = ai(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
		}
		if (a = e.child, !xc(e, i)) {
			var o = a.memoizedProps;
			if (n = n.compare, n = n === null ? yr : n, n(o, r) && e.ref === t.ref) return bc(e, t, i);
		}
		return t.flags |= 1, e = ri(a, r), e.ref = t.ref, e.return = t, t.child = e;
	}
	function Qs(e, t, n, r, i) {
		if (e !== null) {
			var a = e.memoizedProps;
			if (yr(a, r) && e.ref === t.ref) if (Js = !1, t.pendingProps = r = a, xc(e, i)) e.flags & 131072 && (Js = !0);
			else return t.lanes = e.lanes, bc(e, t, i);
		}
		return oc(e, t, n, r, i);
	}
	function $s(e, t, n, r) {
		var i = r.children, a = e === null ? null : e.memoizedState;
		if (e === null && t.stateNode === null && (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), r.mode === "hidden") {
			if (t.flags & 128) {
				if (a = a === null ? n : a.baseLanes | n, e !== null) {
					for (r = t.child = e.child, i = 0; r !== null;) i = i | r.lanes | r.childLanes, r = r.sibling;
					r = i & ~a;
				} else r = 0, t.child = null;
				return tc(e, t, a, n, r);
			}
			if (n & 536870912) t.memoizedState = {
				baseLanes: 0,
				cachePool: null
			}, e !== null && Z(t, a === null ? null : a.cachePool), a === null ? Ua() : Ha(t, a), Ya(t);
			else return r = t.lanes = 536870912, tc(e, t, a === null ? n : a.baseLanes | n, n, r);
		} else a === null ? (e !== null && Z(t, null), Ua(), Xa(t)) : (Z(t, a.cachePool), Ha(t, a), Xa(t), t.memoizedState = null);
		return Ys(e, t, i, n), t.child;
	}
	function ec(e, t) {
		return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), t.sibling;
	}
	function tc(e, t, n, r, i) {
		var a = ca();
		return a = a === null ? null : {
			parent: Xi._currentValue,
			pool: a
		}, t.memoizedState = {
			baseLanes: n,
			cachePool: a
		}, e !== null && Z(t, null), Ua(), Ya(t), e !== null && Vi(e, t, r, !0), t.childLanes = i, null;
	}
	function nc(e, t) {
		return t = hc({
			mode: t.mode,
			children: t.children
		}, e.mode), t.ref = e.ref, e.child = t, t.return = e, t;
	}
	function rc(e, t, n) {
		return Ea(t, e.child, null, n), e = nc(t, t.pendingProps), e.flags |= 2, Za(t), t.memoizedState = null, e;
	}
	function ic(e, t, n) {
		var r = t.pendingProps, a = (t.flags & 128) != 0;
		if (t.flags &= -129, e === null) {
			if (X) {
				if (r.mode === "hidden") return e = nc(t, r), t.lanes = 536870912, ec(null, e);
				if (Ja(t), (e = Ci) ? (e = rf(e, Ti), e = e !== null && e.data === "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: _i === null ? null : {
						id: vi,
						overflow: yi
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = ci(e), n.return = t, t.child = n, Y = t, Ci = null)) : e = null, e === null) throw Di(t);
				return t.lanes = 536870912, null;
			}
			return nc(t, r);
		}
		var o = e.memoizedState;
		if (o !== null) {
			var s = o.dehydrated;
			if (Ja(t), a) if (t.flags & 256) t.flags &= -257, t = rc(e, t, n);
			else if (t.memoizedState !== null) t.child = e.child, t.flags |= 128, t = null;
			else throw Error(i(558));
			else if (Js || Vi(e, t, n, !1), a = (n & e.childLanes) !== 0, Js || a) {
				if (r = Nl, r !== null && (s = ut(r, n), s !== 0 && s !== o.retryLane)) throw o.retryLane = s, Qr(e, s), pu(r, e, s), qs;
				Tu(), t = rc(e, t, n);
			} else e = o.treeContext, Ci = cf(s.nextSibling), Y = t, X = !0, wi = null, Ti = !1, e !== null && Si(t, e), t = nc(t, r), t.flags |= 4096;
			return t;
		}
		return e = ri(e.child, {
			mode: r.mode,
			children: r.children
		}), e.ref = t.ref, t.child = e, e.return = t, e;
	}
	function ac(e, t) {
		var n = t.ref;
		if (n === null) e !== null && e.ref !== null && (t.flags |= 4194816);
		else {
			if (typeof n != "function" && typeof n != "object") throw Error(i(284));
			(e === null || e.ref !== n) && (t.flags |= 4194816);
		}
	}
	function oc(e, t, n, r, i) {
		return Ui(t), n = po(e, t, n, r, void 0, i), r = _o(), e !== null && !Js ? (vo(e, t, i), bc(e, t, i)) : (X && r && q(t), t.flags |= 1, Ys(e, t, n, i), t.child);
	}
	function sc(e, t, n, r, i, a) {
		return Ui(t), t.updateQueue = null, n = ho(t, r, n, i), mo(e), r = _o(), e !== null && !Js ? (vo(e, t, a), bc(e, t, a)) : (X && r && q(t), t.flags |= 1, Ys(e, t, n, a), t.child);
	}
	function cc(e, t, n, r, i) {
		if (Ui(t), t.stateNode === null) {
			var a = W, o = n.contextType;
			typeof o == "object" && o && (a = Wi(o)), a = new n(r, a), t.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = Ps, t.stateNode = a, a._reactInternals = t, a = t.stateNode, a.props = r, a.state = t.memoizedState, a.refs = {}, ka(t), o = n.contextType, a.context = typeof o == "object" && o ? Wi(o) : W, a.state = t.memoizedState, o = n.getDerivedStateFromProps, typeof o == "function" && (Ns(t, n, o, r), a.state = t.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof a.getSnapshotBeforeUpdate == "function" || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (o = a.state, typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), o !== a.state && Ps.enqueueReplaceState(a, a.state, null), La(t, r, a, i), Ia(), a.state = t.memoizedState), typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !0;
		} else if (e === null) {
			a = t.stateNode;
			var s = t.memoizedProps, c = Ls(n, s);
			a.props = c;
			var l = a.context, u = n.contextType;
			o = W, typeof u == "object" && u && (o = Wi(u));
			var d = n.getDerivedStateFromProps;
			u = typeof d == "function" || typeof a.getSnapshotBeforeUpdate == "function", s = t.pendingProps !== s, u || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (s || l !== o) && Is(t, a, r, o), Oa = !1;
			var f = t.memoizedState;
			a.state = f, La(t, r, a, i), Ia(), l = t.memoizedState, s || f !== l || Oa ? (typeof d == "function" && (Ns(t, n, d, r), l = t.memoizedState), (c = Oa || Fs(t, n, c, r, f, l, o)) ? (u || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = o, r = c) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
		} else {
			a = t.stateNode, Aa(e, t), o = t.memoizedProps, u = Ls(n, o), a.props = u, d = t.pendingProps, f = a.context, l = n.contextType, c = W, typeof l == "object" && l && (c = Wi(l)), s = n.getDerivedStateFromProps, (l = typeof s == "function" || typeof a.getSnapshotBeforeUpdate == "function") || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (o !== d || f !== c) && Is(t, a, r, c), Oa = !1, f = t.memoizedState, a.state = f, La(t, r, a, i), Ia();
			var p = t.memoizedState;
			o !== d || f !== p || Oa || e !== null && e.dependencies !== null && Hi(e.dependencies) ? (typeof s == "function" && (Ns(t, n, s, r), p = t.memoizedState), (u = Oa || Fs(t, n, u, r, f, p, c) || e !== null && e.dependencies !== null && Hi(e.dependencies)) ? (l || typeof a.UNSAFE_componentWillUpdate != "function" && typeof a.componentWillUpdate != "function" || (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(r, p, c), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(r, p, c)), typeof a.componentDidUpdate == "function" && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = p), a.props = r, a.state = p, a.context = c, r = u) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
		}
		return a = r, ac(e, t), r = (t.flags & 128) != 0, a || r ? (a = t.stateNode, n = r && typeof n.getDerivedStateFromError != "function" ? null : a.render(), t.flags |= 1, e !== null && r ? (t.child = Ea(t, e.child, null, i), t.child = Ea(t, null, n, i)) : Ys(e, t, n, i), t.memoizedState = a.state, e = t.child) : e = bc(e, t, i), e;
	}
	function lc(e, t, n, r) {
		return ji(), t.flags |= 256, Ys(e, t, n, r), t.child;
	}
	var uc = {
		dehydrated: null,
		treeContext: null,
		retryLane: 0,
		hydrationErrors: null
	};
	function dc(e) {
		return {
			baseLanes: e,
			cachePool: la()
		};
	}
	function fc(e, t, n) {
		return e = e === null ? 0 : e.childLanes & ~n, t && (e |= Kl), e;
	}
	function pc(e, t, n) {
		var r = t.pendingProps, a = !1, o = (t.flags & 128) != 0, s;
		if ((s = o) || (s = e !== null && e.memoizedState === null ? !1 : (Qa.current & 2) != 0), s && (a = !0, t.flags &= -129), s = (t.flags & 32) != 0, t.flags &= -33, e === null) {
			if (X) {
				if (a ? qa(t) : Xa(t), (e = Ci) ? (e = rf(e, Ti), e = e !== null && e.data !== "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: _i === null ? null : {
						id: vi,
						overflow: yi
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = ci(e), n.return = t, t.child = n, Y = t, Ci = null)) : e = null, e === null) throw Di(t);
				return of(e) ? t.lanes = 32 : t.lanes = 536870912, null;
			}
			var c = r.children;
			return r = r.fallback, a ? (Xa(t), a = t.mode, c = hc({
				mode: "hidden",
				children: c
			}, a), r = oi(r, a, n, null), c.return = t, r.return = t, c.sibling = r, t.child = c, r = t.child, r.memoizedState = dc(n), r.childLanes = fc(e, s, n), t.memoizedState = uc, ec(null, r)) : (qa(t), mc(t, c));
		}
		var l = e.memoizedState;
		if (l !== null && (c = l.dehydrated, c !== null)) {
			if (o) t.flags & 256 ? (qa(t), t.flags &= -257, t = gc(e, t, n)) : t.memoizedState === null ? (Xa(t), c = r.fallback, a = t.mode, r = hc({
				mode: "visible",
				children: r.children
			}, a), c = oi(c, a, n, null), c.flags |= 2, r.return = t, c.return = t, r.sibling = c, t.child = r, Ea(t, e.child, null, n), r = t.child, r.memoizedState = dc(n), r.childLanes = fc(e, s, n), t.memoizedState = uc, t = ec(null, r)) : (Xa(t), t.child = e.child, t.flags |= 128, t = null);
			else if (qa(t), of(c)) {
				if (s = c.nextSibling && c.nextSibling.dataset, s) var u = s.dgst;
				s = u, r = Error(i(419)), r.stack = "", r.digest = s, Ni({
					value: r,
					source: null,
					stack: null
				}), t = gc(e, t, n);
			} else if (Js || Vi(e, t, n, !1), s = (n & e.childLanes) !== 0, Js || s) {
				if (s = Nl, s !== null && (r = ut(s, n), r !== 0 && r !== l.retryLane)) throw l.retryLane = r, Qr(e, r), pu(s, e, r), qs;
				af(c) || Tu(), t = gc(e, t, n);
			} else af(c) ? (t.flags |= 192, t.child = e.child, t = null) : (e = l.treeContext, Ci = cf(c.nextSibling), Y = t, X = !0, wi = null, Ti = !1, e !== null && Si(t, e), t = mc(t, r.children), t.flags |= 4096);
			return t;
		}
		return a ? (Xa(t), c = r.fallback, a = t.mode, l = e.child, u = l.sibling, r = ri(l, {
			mode: "hidden",
			children: r.children
		}), r.subtreeFlags = l.subtreeFlags & 65011712, u === null ? (c = oi(c, a, n, null), c.flags |= 2) : c = ri(u, c), c.return = t, r.return = t, r.sibling = c, t.child = r, ec(null, r), r = t.child, c = e.child.memoizedState, c === null ? c = dc(n) : (a = c.cachePool, a === null ? a = la() : (l = Xi._currentValue, a = a.parent === l ? a : {
			parent: l,
			pool: l
		}), c = {
			baseLanes: c.baseLanes | n,
			cachePool: a
		}), r.memoizedState = c, r.childLanes = fc(e, s, n), t.memoizedState = uc, ec(e.child, r)) : (qa(t), n = e.child, e = n.sibling, n = ri(n, {
			mode: "visible",
			children: r.children
		}), n.return = t, n.sibling = null, e !== null && (s = t.deletions, s === null ? (t.deletions = [e], t.flags |= 16) : s.push(e)), t.child = n, t.memoizedState = null, n);
	}
	function mc(e, t) {
		return t = hc({
			mode: "visible",
			children: t
		}, e.mode), t.return = e, e.child = t;
	}
	function hc(e, t) {
		return e = G(22, e, null, t), e.lanes = 0, e;
	}
	function gc(e, t, n) {
		return Ea(t, e.child, null, n), e = mc(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
	}
	function _c(e, t, n) {
		e.lanes |= t;
		var r = e.alternate;
		r !== null && (r.lanes |= t), zi(e.return, t, n);
	}
	function vc(e, t, n, r, i, a) {
		var o = e.memoizedState;
		o === null ? e.memoizedState = {
			isBackwards: t,
			rendering: null,
			renderingStartTime: 0,
			last: r,
			tail: n,
			tailMode: i,
			treeForkCount: a
		} : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i, o.treeForkCount = a);
	}
	function yc(e, t, n) {
		var r = t.pendingProps, i = r.revealOrder, a = r.tail;
		r = r.children;
		var o = Qa.current, s = (o & 2) != 0;
		if (s ? (o = o & 1 | 2, t.flags |= 128) : o &= 1, he(Qa, o), Ys(e, t, r, n), r = X ? mi : 0, !s && e !== null && e.flags & 128) a: for (e = t.child; e !== null;) {
			if (e.tag === 13) e.memoizedState !== null && _c(e, n, t);
			else if (e.tag === 19) _c(e, n, t);
			else if (e.child !== null) {
				e.child.return = e, e = e.child;
				continue;
			}
			if (e === t) break a;
			for (; e.sibling === null;) {
				if (e.return === null || e.return === t) break a;
				e = e.return;
			}
			e.sibling.return = e.return, e = e.sibling;
		}
		switch (i) {
			case "forwards":
				for (n = t.child, i = null; n !== null;) e = n.alternate, e !== null && $a(e) === null && (i = n), n = n.sibling;
				n = i, n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), vc(t, !1, i, n, a, r);
				break;
			case "backwards":
			case "unstable_legacy-backwards":
				for (n = null, i = t.child, t.child = null; i !== null;) {
					if (e = i.alternate, e !== null && $a(e) === null) {
						t.child = i;
						break;
					}
					e = i.sibling, i.sibling = n, n = i, i = e;
				}
				vc(t, !0, n, null, a, r);
				break;
			case "together":
				vc(t, !1, null, null, void 0, r);
				break;
			default: t.memoizedState = null;
		}
		return t.child;
	}
	function bc(e, t, n) {
		if (e !== null && (t.dependencies = e.dependencies), Ul |= t.lanes, (n & t.childLanes) === 0) if (e !== null) {
			if (Vi(e, t, n, !1), (n & t.childLanes) === 0) return null;
		} else return null;
		if (e !== null && t.child !== e.child) throw Error(i(153));
		if (t.child !== null) {
			for (e = t.child, n = ri(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null;) e = e.sibling, n = n.sibling = ri(e, e.pendingProps), n.return = t;
			n.sibling = null;
		}
		return t.child;
	}
	function xc(e, t) {
		return (e.lanes & t) === 0 ? (e = e.dependencies, !!(e !== null && Hi(e))) : !0;
	}
	function Sc(e, t, n) {
		switch (t.tag) {
			case 3:
				be(t, t.stateNode.containerInfo), Li(t, Xi, e.memoizedState.cache), ji();
				break;
			case 27:
			case 5:
				Se(t);
				break;
			case 4:
				be(t, t.stateNode.containerInfo);
				break;
			case 10:
				Li(t, t.type, t.memoizedProps.value);
				break;
			case 31:
				if (t.memoizedState !== null) return t.flags |= 128, Ja(t), null;
				break;
			case 13:
				var r = t.memoizedState;
				if (r !== null) return r.dehydrated === null ? (n & t.child.childLanes) === 0 ? (qa(t), e = bc(e, t, n), e === null ? null : e.sibling) : pc(e, t, n) : (qa(t), t.flags |= 128, null);
				qa(t);
				break;
			case 19:
				var i = (e.flags & 128) != 0;
				if (r = (n & t.childLanes) !== 0, r ||= (Vi(e, t, n, !1), (n & t.childLanes) !== 0), i) {
					if (r) return yc(e, t, n);
					t.flags |= 128;
				}
				if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), he(Qa, Qa.current), r) break;
				return null;
			case 22: return t.lanes = 0, $s(e, t, n, t.pendingProps);
			case 24: Li(t, Xi, e.memoizedState.cache);
		}
		return bc(e, t, n);
	}
	function Cc(e, t, n) {
		if (e !== null) if (e.memoizedProps !== t.pendingProps) Js = !0;
		else {
			if (!xc(e, n) && !(t.flags & 128)) return Js = !1, Sc(e, t, n);
			Js = !!(e.flags & 131072);
		}
		else Js = !1, X && t.flags & 1048576 && xi(t, mi, t.index);
		switch (t.lanes = 0, t.tag) {
			case 16:
				a: {
					var r = t.pendingProps;
					if (e = ga(t.elementType), t.type = e, typeof e == "function") ni(e) ? (r = Ls(e, r), t.tag = 1, t = cc(null, t, e, r, n)) : (t.tag = 0, t = oc(null, t, e, r, n));
					else {
						if (e != null) {
							var a = e.$$typeof;
							if (a === C) {
								t.tag = 11, t = Xs(null, t, e, r, n);
								break a;
							} else if (a === ne) {
								t.tag = 14, t = Zs(null, t, e, r, n);
								break a;
							}
						}
						throw t = le(e) || e, Error(i(306, t, ""));
					}
				}
				return t;
			case 0: return oc(e, t, t.type, t.pendingProps, n);
			case 1: return r = t.type, a = Ls(r, t.pendingProps), cc(e, t, r, a, n);
			case 3:
				a: {
					if (be(t, t.stateNode.containerInfo), e === null) throw Error(i(387));
					r = t.pendingProps;
					var o = t.memoizedState;
					a = o.element, Aa(e, t), La(t, r, null, n);
					var s = t.memoizedState;
					if (r = s.cache, Li(t, Xi, r), r !== o.cache && Bi(t, [Xi], n, !0), Ia(), r = s.element, o.isDehydrated) if (o = {
						element: r,
						isDehydrated: !1,
						cache: s.cache
					}, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
						t = lc(e, t, r, n);
						break a;
					} else if (r !== a) {
						a = ui(Error(i(424)), t), Ni(a), t = lc(e, t, r, n);
						break a;
					} else {
						switch (e = t.stateNode.containerInfo, e.nodeType) {
							case 9:
								e = e.body;
								break;
							default: e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
						}
						for (Ci = cf(e.firstChild), Y = t, X = !0, wi = null, Ti = !0, n = Da(t, null, r, n), t.child = n; n;) n.flags = n.flags & -3 | 4096, n = n.sibling;
					}
					else {
						if (ji(), r === a) {
							t = bc(e, t, n);
							break a;
						}
						Ys(e, t, r, n);
					}
					t = t.child;
				}
				return t;
			case 26: return ac(e, t), e === null ? (n = kf(t.type, null, t.pendingProps, null)) ? t.memoizedState = n : X || (n = t.type, e = t.pendingProps, r = Bd(ve.current).createElement(n), r[gt] = t, r[k] = e, Pd(r, n, e), P(r), t.stateNode = r) : t.memoizedState = kf(t.type, e.memoizedProps, t.pendingProps, e.memoizedState), null;
			case 27: return Se(t), e === null && X && (r = t.stateNode = ff(t.type, t.pendingProps, ve.current), Y = t, Ti = !0, a = Ci, Zd(t.type) ? (lf = a, Ci = cf(r.firstChild)) : Ci = a), Ys(e, t, t.pendingProps.children, n), ac(e, t), e === null && (t.flags |= 4194304), t.child;
			case 5: return e === null && X && ((a = r = Ci) && (r = tf(r, t.type, t.pendingProps, Ti), r === null ? a = !1 : (t.stateNode = r, Y = t, Ci = cf(r.firstChild), Ti = !1, a = !0)), a || Di(t)), Se(t), a = t.type, o = t.pendingProps, s = e === null ? null : e.memoizedProps, r = o.children, Ud(a, o) ? r = null : s !== null && Ud(a, s) && (t.flags |= 32), t.memoizedState !== null && (a = po(e, t, go, null, null, n), Qf._currentValue = a), ac(e, t), Ys(e, t, r, n), t.child;
			case 6: return e === null && X && ((e = n = Ci) && (n = nf(n, t.pendingProps, Ti), n === null ? e = !1 : (t.stateNode = n, Y = t, Ci = null, e = !0)), e || Di(t)), null;
			case 13: return pc(e, t, n);
			case 4: return be(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = Ea(t, null, r, n) : Ys(e, t, r, n), t.child;
			case 11: return Xs(e, t, t.type, t.pendingProps, n);
			case 7: return Ys(e, t, t.pendingProps, n), t.child;
			case 8: return Ys(e, t, t.pendingProps.children, n), t.child;
			case 12: return Ys(e, t, t.pendingProps.children, n), t.child;
			case 10: return r = t.pendingProps, Li(t, t.type, r.value), Ys(e, t, r.children, n), t.child;
			case 9: return a = t.type._context, r = t.pendingProps.children, Ui(t), a = Wi(a), r = r(a), t.flags |= 1, Ys(e, t, r, n), t.child;
			case 14: return Zs(e, t, t.type, t.pendingProps, n);
			case 15: return Qs(e, t, t.type, t.pendingProps, n);
			case 19: return yc(e, t, n);
			case 31: return ic(e, t, n);
			case 22: return $s(e, t, n, t.pendingProps);
			case 24: return Ui(t), r = Wi(Xi), e === null ? (a = ca(), a === null && (a = Nl, o = Zi(), a.pooledCache = o, o.refCount++, o !== null && (a.pooledCacheLanes |= n), a = o), t.memoizedState = {
				parent: r,
				cache: a
			}, ka(t), Li(t, Xi, a)) : ((e.lanes & n) !== 0 && (Aa(e, t), La(t, null, null, n), Ia()), a = e.memoizedState, o = t.memoizedState, a.parent === r ? (r = o.cache, Li(t, Xi, r), r !== a.cache && Bi(t, [Xi], n, !0)) : (a = {
				parent: r,
				cache: r
			}, t.memoizedState = a, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = a), Li(t, Xi, r))), Ys(e, t, t.pendingProps.children, n), t.child;
			case 29: throw t.pendingProps;
		}
		throw Error(i(156, t.tag));
	}
	function wc(e) {
		e.flags |= 4;
	}
	function Tc(e, t, n, r, i) {
		if ((t = (e.mode & 32) != 0) && (t = !1), t) {
			if (e.flags |= 16777216, (i & 335544128) === i) if (e.stateNode.complete) e.flags |= 8192;
			else if (Su()) e.flags |= 8192;
			else throw _a = pa, da;
		} else e.flags &= -16777217;
	}
	function Ec(e, t) {
		if (t.type !== "stylesheet" || t.state.loading & 4) e.flags &= -16777217;
		else if (e.flags |= 16777216, !Wf(t)) if (Su()) e.flags |= 8192;
		else throw _a = pa, da;
	}
	function Dc(e, t) {
		t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag === 22 ? 536870912 : it(), e.lanes |= t, ql |= t);
	}
	function Oc(e, t) {
		if (!X) switch (e.tailMode) {
			case "hidden":
				t = e.tail;
				for (var n = null; t !== null;) t.alternate !== null && (n = t), t = t.sibling;
				n === null ? e.tail = null : n.sibling = null;
				break;
			case "collapsed":
				n = e.tail;
				for (var r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
				r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
		}
	}
	function kc(e) {
		var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
		if (t) for (var i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 65011712, r |= i.flags & 65011712, i.return = e, i = i.sibling;
		else for (i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
		return e.subtreeFlags |= r, e.childLanes = n, t;
	}
	function Ac(e, t, n) {
		var r = t.pendingProps;
		switch (J(t), t.tag) {
			case 16:
			case 15:
			case 0:
			case 11:
			case 7:
			case 8:
			case 12:
			case 9:
			case 14: return kc(t), null;
			case 1: return kc(t), null;
			case 3: return n = t.stateNode, r = null, e !== null && (r = e.memoizedState.cache), t.memoizedState.cache !== r && (t.flags |= 2048), Ri(Xi), xe(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (Ai(t) ? wc(t) : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, Mi())), kc(t), null;
			case 26:
				var a = t.type, o = t.memoizedState;
				return e === null ? (wc(t), o === null ? (kc(t), Tc(t, a, null, r, n)) : (kc(t), Ec(t, o))) : o ? o === e.memoizedState ? (kc(t), t.flags &= -16777217) : (wc(t), kc(t), Ec(t, o)) : (e = e.memoizedProps, e !== r && wc(t), kc(t), Tc(t, a, e, r, n)), null;
			case 27:
				if (Ce(t), n = ve.current, a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && wc(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(i(166));
						return kc(t), null;
					}
					e = ge.current, Ai(t) ? Oi(t, e) : (e = ff(a, r, n), t.stateNode = e, wc(t));
				}
				return kc(t), null;
			case 5:
				if (Ce(t), a = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && wc(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(i(166));
						return kc(t), null;
					}
					if (o = ge.current, Ai(t)) Oi(t, o);
					else {
						var s = Bd(ve.current);
						switch (o) {
							case 1:
								o = s.createElementNS("http://www.w3.org/2000/svg", a);
								break;
							case 2:
								o = s.createElementNS("http://www.w3.org/1998/Math/MathML", a);
								break;
							default: switch (a) {
								case "svg":
									o = s.createElementNS("http://www.w3.org/2000/svg", a);
									break;
								case "math":
									o = s.createElementNS("http://www.w3.org/1998/Math/MathML", a);
									break;
								case "script":
									o = s.createElement("div"), o.innerHTML = "<script><\/script>", o = o.removeChild(o.firstChild);
									break;
								case "select":
									o = typeof r.is == "string" ? s.createElement("select", { is: r.is }) : s.createElement("select"), r.multiple ? o.multiple = !0 : r.size && (o.size = r.size);
									break;
								default: o = typeof r.is == "string" ? s.createElement(a, { is: r.is }) : s.createElement(a);
							}
						}
						o[gt] = t, o[k] = r;
						a: for (s = t.child; s !== null;) {
							if (s.tag === 5 || s.tag === 6) o.appendChild(s.stateNode);
							else if (s.tag !== 4 && s.tag !== 27 && s.child !== null) {
								s.child.return = s, s = s.child;
								continue;
							}
							if (s === t) break a;
							for (; s.sibling === null;) {
								if (s.return === null || s.return === t) break a;
								s = s.return;
							}
							s.sibling.return = s.return, s = s.sibling;
						}
						t.stateNode = o;
						a: switch (Pd(o, a, r), a) {
							case "button":
							case "input":
							case "select":
							case "textarea":
								r = !!r.autoFocus;
								break a;
							case "img":
								r = !0;
								break a;
							default: r = !1;
						}
						r && wc(t);
					}
				}
				return kc(t), Tc(t, t.type, e === null ? null : e.memoizedProps, t.pendingProps, n), null;
			case 6:
				if (e && t.stateNode != null) e.memoizedProps !== r && wc(t);
				else {
					if (typeof r != "string" && t.stateNode === null) throw Error(i(166));
					if (e = ve.current, Ai(t)) {
						if (e = t.stateNode, n = t.memoizedProps, r = null, a = Y, a !== null) switch (a.tag) {
							case 27:
							case 5: r = a.memoizedProps;
						}
						e[gt] = t, e = !!(e.nodeValue === n || r !== null && !0 === r.suppressHydrationWarning || jd(e.nodeValue, n)), e || Di(t, !0);
					} else e = Bd(e).createTextNode(r), e[gt] = t, t.stateNode = e;
				}
				return kc(t), null;
			case 31:
				if (n = t.memoizedState, e === null || e.memoizedState !== null) {
					if (r = Ai(t), n !== null) {
						if (e === null) {
							if (!r) throw Error(i(318));
							if (e = t.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(i(557));
							e[gt] = t;
						} else ji(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						kc(t), e = !1;
					} else n = Mi(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), e = !0;
					if (!e) return t.flags & 256 ? (Za(t), t) : (Za(t), null);
					if (t.flags & 128) throw Error(i(558));
				}
				return kc(t), null;
			case 13:
				if (r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
					if (a = Ai(t), r !== null && r.dehydrated !== null) {
						if (e === null) {
							if (!a) throw Error(i(318));
							if (a = t.memoizedState, a = a === null ? null : a.dehydrated, !a) throw Error(i(317));
							a[gt] = t;
						} else ji(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						kc(t), a = !1;
					} else a = Mi(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = a), a = !0;
					if (!a) return t.flags & 256 ? (Za(t), t) : (Za(t), null);
				}
				return Za(t), t.flags & 128 ? (t.lanes = n, t) : (n = r !== null, e = e !== null && e.memoizedState !== null, n && (r = t.child, a = null, r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null && (a = r.alternate.memoizedState.cachePool.pool), o = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (o = r.memoizedState.cachePool.pool), o !== a && (r.flags |= 2048)), n !== e && n && (t.child.flags |= 8192), Dc(t, t.updateQueue), kc(t), null);
			case 4: return xe(), e === null && xd(t.stateNode.containerInfo), kc(t), null;
			case 10: return Ri(t.type), kc(t), null;
			case 19:
				if (D(Qa), r = t.memoizedState, r === null) return kc(t), null;
				if (a = (t.flags & 128) != 0, o = r.rendering, o === null) if (a) Oc(r, !1);
				else {
					if (Hl !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null;) {
						if (o = $a(e), o !== null) {
							for (t.flags |= 128, Oc(r, !1), e = o.updateQueue, t.updateQueue = e, Dc(t, e), t.subtreeFlags = 0, e = n, n = t.child; n !== null;) ii(n, e), n = n.sibling;
							return he(Qa, Qa.current & 1 | 2), X && bi(t, r.treeForkCount), t.child;
						}
						e = e.sibling;
					}
					r.tail !== null && Fe() > $l && (t.flags |= 128, a = !0, Oc(r, !1), t.lanes = 4194304);
				}
				else {
					if (!a) if (e = $a(o), e !== null) {
						if (t.flags |= 128, a = !0, e = e.updateQueue, t.updateQueue = e, Dc(t, e), Oc(r, !0), r.tail === null && r.tailMode === "hidden" && !o.alternate && !X) return kc(t), null;
					} else 2 * Fe() - r.renderingStartTime > $l && n !== 536870912 && (t.flags |= 128, a = !0, Oc(r, !1), t.lanes = 4194304);
					r.isBackwards ? (o.sibling = t.child, t.child = o) : (e = r.last, e === null ? t.child = o : e.sibling = o, r.last = o);
				}
				return r.tail === null ? (kc(t), null) : (e = r.tail, r.rendering = e, r.tail = e.sibling, r.renderingStartTime = Fe(), e.sibling = null, n = Qa.current, he(Qa, a ? n & 1 | 2 : n & 1), X && bi(t, r.treeForkCount), e);
			case 22:
			case 23: return Za(t), Wa(), r = t.memoizedState !== null, e === null ? r && (t.flags |= 8192) : e.memoizedState !== null !== r && (t.flags |= 8192), r ? n & 536870912 && !(t.flags & 128) && (kc(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : kc(t), n = t.updateQueue, n !== null && Dc(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), r = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (r = t.memoizedState.cachePool.pool), r !== n && (t.flags |= 2048), e !== null && D(sa), null;
			case 24: return n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), Ri(Xi), kc(t), null;
			case 25: return null;
			case 30: return null;
		}
		throw Error(i(156, t.tag));
	}
	function jc(e, t) {
		switch (J(t), t.tag) {
			case 1: return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 3: return Ri(Xi), xe(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
			case 26:
			case 27:
			case 5: return Ce(t), null;
			case 31:
				if (t.memoizedState !== null) {
					if (Za(t), t.alternate === null) throw Error(i(340));
					ji();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 13:
				if (Za(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
					if (t.alternate === null) throw Error(i(340));
					ji();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 19: return D(Qa), null;
			case 4: return xe(), null;
			case 10: return Ri(t.type), null;
			case 22:
			case 23: return Za(t), Wa(), e !== null && D(sa), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 24: return Ri(Xi), null;
			case 25: return null;
			default: return null;
		}
	}
	function Mc(e, t) {
		switch (J(t), t.tag) {
			case 3:
				Ri(Xi), xe();
				break;
			case 26:
			case 27:
			case 5:
				Ce(t);
				break;
			case 4:
				xe();
				break;
			case 31:
				t.memoizedState !== null && Za(t);
				break;
			case 13:
				Za(t);
				break;
			case 19:
				D(Qa);
				break;
			case 10:
				Ri(t.type);
				break;
			case 22:
			case 23:
				Za(t), Wa(), e !== null && D(sa);
				break;
			case 24: Ri(Xi);
		}
	}
	function Nc(e, t) {
		try {
			var n = t.updateQueue, r = n === null ? null : n.lastEffect;
			if (r !== null) {
				var i = r.next;
				n = i;
				do {
					if ((n.tag & e) === e) {
						r = void 0;
						var a = n.create, o = n.inst;
						r = a(), o.destroy = r;
					}
					n = n.next;
				} while (n !== i);
			}
		} catch (e) {
			Uu(t, t.return, e);
		}
	}
	function Pc(e, t, n) {
		try {
			var r = t.updateQueue, i = r === null ? null : r.lastEffect;
			if (i !== null) {
				var a = i.next;
				r = a;
				do {
					if ((r.tag & e) === e) {
						var o = r.inst, s = o.destroy;
						if (s !== void 0) {
							o.destroy = void 0, i = t;
							var c = n, l = s;
							try {
								l();
							} catch (e) {
								Uu(i, c, e);
							}
						}
					}
					r = r.next;
				} while (r !== a);
			}
		} catch (e) {
			Uu(t, t.return, e);
		}
	}
	function Fc(e) {
		var t = e.updateQueue;
		if (t !== null) {
			var n = e.stateNode;
			try {
				za(t, n);
			} catch (t) {
				Uu(e, e.return, t);
			}
		}
	}
	function Ic(e, t, n) {
		n.props = Ls(e.type, e.memoizedProps), n.state = e.memoizedState;
		try {
			n.componentWillUnmount();
		} catch (n) {
			Uu(e, t, n);
		}
	}
	function Lc(e, t) {
		try {
			var n = e.ref;
			if (n !== null) {
				switch (e.tag) {
					case 26:
					case 27:
					case 5:
						var r = e.stateNode;
						break;
					case 30:
						r = e.stateNode;
						break;
					default: r = e.stateNode;
				}
				typeof n == "function" ? e.refCleanup = n(r) : n.current = r;
			}
		} catch (n) {
			Uu(e, t, n);
		}
	}
	function Rc(e, t) {
		var n = e.ref, r = e.refCleanup;
		if (n !== null) if (typeof r == "function") try {
			r();
		} catch (n) {
			Uu(e, t, n);
		} finally {
			e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
		}
		else if (typeof n == "function") try {
			n(null);
		} catch (n) {
			Uu(e, t, n);
		}
		else n.current = null;
	}
	function zc(e) {
		var t = e.type, n = e.memoizedProps, r = e.stateNode;
		try {
			a: switch (t) {
				case "button":
				case "input":
				case "select":
				case "textarea":
					n.autoFocus && r.focus();
					break a;
				case "img": n.src ? r.src = n.src : n.srcSet && (r.srcset = n.srcSet);
			}
		} catch (t) {
			Uu(e, e.return, t);
		}
	}
	function Bc(e, t, n) {
		try {
			var r = e.stateNode;
			Fd(r, e.type, n, t), r[k] = t;
		} catch (t) {
			Uu(e, e.return, t);
		}
	}
	function Vc(e) {
		return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Zd(e.type) || e.tag === 4;
	}
	function Hc(e) {
		a: for (;;) {
			for (; e.sibling === null;) {
				if (e.return === null || Vc(e.return)) return null;
				e = e.return;
			}
			for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18;) {
				if (e.tag === 27 && Zd(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue a;
				e.child.return = e, e = e.child;
			}
			if (!(e.flags & 2)) return e.stateNode;
		}
	}
	function Uc(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(e, t) : (t = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, t.appendChild(e), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = $t));
		else if (r !== 4 && (r === 27 && Zd(e.type) && (n = e.stateNode, t = null), e = e.child, e !== null)) for (Uc(e, t, n), e = e.sibling; e !== null;) Uc(e, t, n), e = e.sibling;
	}
	function Wc(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
		else if (r !== 4 && (r === 27 && Zd(e.type) && (n = e.stateNode), e = e.child, e !== null)) for (Wc(e, t, n), e = e.sibling; e !== null;) Wc(e, t, n), e = e.sibling;
	}
	function Gc(e) {
		var t = e.stateNode, n = e.memoizedProps;
		try {
			for (var r = e.type, i = t.attributes; i.length;) t.removeAttributeNode(i[0]);
			Pd(t, r, n), t[gt] = e, t[k] = n;
		} catch (t) {
			Uu(e, e.return, t);
		}
	}
	var Kc = !1, qc = !1, Jc = !1, Yc = typeof WeakSet == "function" ? WeakSet : Set, Xc = null;
	function Zc(e, t) {
		if (e = e.containerInfo, Rd = sp, e = Cr(e), wr(e)) {
			if ("selectionStart" in e) var n = {
				start: e.selectionStart,
				end: e.selectionEnd
			};
			else a: {
				n = (n = e.ownerDocument) && n.defaultView || window;
				var r = n.getSelection && n.getSelection();
				if (r && r.rangeCount !== 0) {
					n = r.anchorNode;
					var a = r.anchorOffset, o = r.focusNode;
					r = r.focusOffset;
					try {
						n.nodeType, o.nodeType;
					} catch {
						n = null;
						break a;
					}
					var s = 0, c = -1, l = -1, u = 0, d = 0, f = e, p = null;
					b: for (;;) {
						for (var m; f !== n || a !== 0 && f.nodeType !== 3 || (c = s + a), f !== o || r !== 0 && f.nodeType !== 3 || (l = s + r), f.nodeType === 3 && (s += f.nodeValue.length), (m = f.firstChild) !== null;) p = f, f = m;
						for (;;) {
							if (f === e) break b;
							if (p === n && ++u === a && (c = s), p === o && ++d === r && (l = s), (m = f.nextSibling) !== null) break;
							f = p, p = f.parentNode;
						}
						f = m;
					}
					n = c === -1 || l === -1 ? null : {
						start: c,
						end: l
					};
				} else n = null;
			}
			n ||= {
				start: 0,
				end: 0
			};
		} else n = null;
		for (zd = {
			focusedElem: e,
			selectionRange: n
		}, sp = !1, Xc = t; Xc !== null;) if (t = Xc, e = t.child, t.subtreeFlags & 1028 && e !== null) e.return = t, Xc = e;
		else for (; Xc !== null;) {
			switch (t = Xc, o = t.alternate, e = t.flags, t.tag) {
				case 0:
					if (e & 4 && (e = t.updateQueue, e = e === null ? null : e.events, e !== null)) for (n = 0; n < e.length; n++) a = e[n], a.ref.impl = a.nextImpl;
					break;
				case 11:
				case 15: break;
				case 1:
					if (e & 1024 && o !== null) {
						e = void 0, n = t, a = o.memoizedProps, o = o.memoizedState, r = n.stateNode;
						try {
							var h = Ls(n.type, a);
							e = r.getSnapshotBeforeUpdate(h, o), r.__reactInternalSnapshotBeforeUpdate = e;
						} catch (e) {
							Uu(n, n.return, e);
						}
					}
					break;
				case 3:
					if (e & 1024) {
						if (e = t.stateNode.containerInfo, n = e.nodeType, n === 9) ef(e);
						else if (n === 1) switch (e.nodeName) {
							case "HEAD":
							case "HTML":
							case "BODY":
								ef(e);
								break;
							default: e.textContent = "";
						}
					}
					break;
				case 5:
				case 26:
				case 27:
				case 6:
				case 4:
				case 17: break;
				default: if (e & 1024) throw Error(i(163));
			}
			if (e = t.sibling, e !== null) {
				e.return = t.return, Xc = e;
				break;
			}
			Xc = t.return;
		}
	}
	function Qc(e, t, n) {
		var r = n.flags;
		switch (n.tag) {
			case 0:
			case 11:
			case 15:
				pl(e, n), r & 4 && Nc(5, n);
				break;
			case 1:
				if (pl(e, n), r & 4) if (e = n.stateNode, t === null) try {
					e.componentDidMount();
				} catch (e) {
					Uu(n, n.return, e);
				}
				else {
					var i = Ls(n.type, t.memoizedProps);
					t = t.memoizedState;
					try {
						e.componentDidUpdate(i, t, e.__reactInternalSnapshotBeforeUpdate);
					} catch (e) {
						Uu(n, n.return, e);
					}
				}
				r & 64 && Fc(n), r & 512 && Lc(n, n.return);
				break;
			case 3:
				if (pl(e, n), r & 64 && (e = n.updateQueue, e !== null)) {
					if (t = null, n.child !== null) switch (n.child.tag) {
						case 27:
						case 5:
							t = n.child.stateNode;
							break;
						case 1: t = n.child.stateNode;
					}
					try {
						za(e, t);
					} catch (e) {
						Uu(n, n.return, e);
					}
				}
				break;
			case 27: t === null && r & 4 && Gc(n);
			case 26:
			case 5:
				pl(e, n), t === null && r & 4 && zc(n), r & 512 && Lc(n, n.return);
				break;
			case 12:
				pl(e, n);
				break;
			case 31:
				pl(e, n), r & 4 && il(e, n);
				break;
			case 13:
				pl(e, n), r & 4 && al(e, n), r & 64 && (e = n.memoizedState, e !== null && (e = e.dehydrated, e !== null && (n = qu.bind(null, n), sf(e, n))));
				break;
			case 22:
				if (r = n.memoizedState !== null || Kc, !r) {
					t = t !== null && t.memoizedState !== null || qc, i = Kc;
					var a = qc;
					Kc = r, (qc = t) && !a ? hl(e, n, (n.subtreeFlags & 8772) != 0) : pl(e, n), Kc = i, qc = a;
				}
				break;
			case 30: break;
			default: pl(e, n);
		}
	}
	function $c(e) {
		var t = e.alternate;
		t !== null && (e.alternate = null, $c(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && xt(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
	}
	var el = null, tl = !1;
	function nl(e, t, n) {
		for (n = n.child; n !== null;) rl(e, t, n), n = n.sibling;
	}
	function rl(e, t, n) {
		if (Ge && typeof Ge.onCommitFiberUnmount == "function") try {
			Ge.onCommitFiberUnmount(We, n);
		} catch {}
		switch (n.tag) {
			case 26:
				qc || Rc(n, t), nl(e, t, n), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
				break;
			case 27:
				qc || Rc(n, t);
				var r = el, i = tl;
				Zd(n.type) && (el = n.stateNode, tl = !1), nl(e, t, n), pf(n.stateNode), el = r, tl = i;
				break;
			case 5: qc || Rc(n, t);
			case 6:
				if (r = el, i = tl, el = null, nl(e, t, n), el = r, tl = i, el !== null) if (tl) try {
					(el.nodeType === 9 ? el.body : el.nodeName === "HTML" ? el.ownerDocument.body : el).removeChild(n.stateNode);
				} catch (e) {
					Uu(n, t, e);
				}
				else try {
					el.removeChild(n.stateNode);
				} catch (e) {
					Uu(n, t, e);
				}
				break;
			case 18:
				el !== null && (tl ? (e = el, Qd(e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, n.stateNode), Np(e)) : Qd(el, n.stateNode));
				break;
			case 4:
				r = el, i = tl, el = n.stateNode.containerInfo, tl = !0, nl(e, t, n), el = r, tl = i;
				break;
			case 0:
			case 11:
			case 14:
			case 15:
				Pc(2, n, t), qc || Pc(4, n, t), nl(e, t, n);
				break;
			case 1:
				qc || (Rc(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function" && Ic(n, t, r)), nl(e, t, n);
				break;
			case 21:
				nl(e, t, n);
				break;
			case 22:
				qc = (r = qc) || n.memoizedState !== null, nl(e, t, n), qc = r;
				break;
			default: nl(e, t, n);
		}
	}
	function il(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
			e = e.dehydrated;
			try {
				Np(e);
			} catch (e) {
				Uu(t, t.return, e);
			}
		}
	}
	function al(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null)))) try {
			Np(e);
		} catch (e) {
			Uu(t, t.return, e);
		}
	}
	function ol(e) {
		switch (e.tag) {
			case 31:
			case 13:
			case 19:
				var t = e.stateNode;
				return t === null && (t = e.stateNode = new Yc()), t;
			case 22: return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new Yc()), t;
			default: throw Error(i(435, e.tag));
		}
	}
	function sl(e, t) {
		var n = ol(e);
		t.forEach(function(t) {
			if (!n.has(t)) {
				n.add(t);
				var r = Ju.bind(null, e, t);
				t.then(r, r);
			}
		});
	}
	function cl(e, t) {
		var n = t.deletions;
		if (n !== null) for (var r = 0; r < n.length; r++) {
			var a = n[r], o = e, s = t, c = s;
			a: for (; c !== null;) {
				switch (c.tag) {
					case 27:
						if (Zd(c.type)) {
							el = c.stateNode, tl = !1;
							break a;
						}
						break;
					case 5:
						el = c.stateNode, tl = !1;
						break a;
					case 3:
					case 4:
						el = c.stateNode.containerInfo, tl = !0;
						break a;
				}
				c = c.return;
			}
			if (el === null) throw Error(i(160));
			rl(o, s, a), el = null, tl = !1, o = a.alternate, o !== null && (o.return = null), a.return = null;
		}
		if (t.subtreeFlags & 13886) for (t = t.child; t !== null;) ul(t, e), t = t.sibling;
	}
	var ll = null;
	function ul(e, t) {
		var n = e.alternate, r = e.flags;
		switch (e.tag) {
			case 0:
			case 11:
			case 14:
			case 15:
				cl(t, e), dl(e), r & 4 && (Pc(3, e, e.return), Nc(3, e), Pc(5, e, e.return));
				break;
			case 1:
				cl(t, e), dl(e), r & 512 && (qc || n === null || Rc(n, n.return)), r & 64 && Kc && (e = e.updateQueue, e !== null && (r = e.callbacks, r !== null && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = n === null ? r : n.concat(r))));
				break;
			case 26:
				var a = ll;
				if (cl(t, e), dl(e), r & 512 && (qc || n === null || Rc(n, n.return)), r & 4) {
					var o = n === null ? null : n.memoizedState;
					if (r = e.memoizedState, n === null) if (r === null) if (e.stateNode === null) {
						a: {
							r = e.type, n = e.memoizedProps, a = a.ownerDocument || a;
							b: switch (r) {
								case "title":
									o = a.getElementsByTagName("title")[0], (!o || o[bt] || o[gt] || o.namespaceURI === "http://www.w3.org/2000/svg" || o.hasAttribute("itemprop")) && (o = a.createElement(r), a.head.insertBefore(o, a.querySelector("head > title"))), Pd(o, r, n), o[gt] = e, P(o), r = o;
									break a;
								case "link":
									var s = Vf("link", "href", a).get(r + (n.href || ""));
									if (s) {
										for (var c = 0; c < s.length; c++) if (o = s[c], o.getAttribute("href") === (n.href == null || n.href === "" ? null : n.href) && o.getAttribute("rel") === (n.rel == null ? null : n.rel) && o.getAttribute("title") === (n.title == null ? null : n.title) && o.getAttribute("crossorigin") === (n.crossOrigin == null ? null : n.crossOrigin)) {
											s.splice(c, 1);
											break b;
										}
									}
									o = a.createElement(r), Pd(o, r, n), a.head.appendChild(o);
									break;
								case "meta":
									if (s = Vf("meta", "content", a).get(r + (n.content || ""))) {
										for (c = 0; c < s.length; c++) if (o = s[c], o.getAttribute("content") === (n.content == null ? null : "" + n.content) && o.getAttribute("name") === (n.name == null ? null : n.name) && o.getAttribute("property") === (n.property == null ? null : n.property) && o.getAttribute("http-equiv") === (n.httpEquiv == null ? null : n.httpEquiv) && o.getAttribute("charset") === (n.charSet == null ? null : n.charSet)) {
											s.splice(c, 1);
											break b;
										}
									}
									o = a.createElement(r), Pd(o, r, n), a.head.appendChild(o);
									break;
								default: throw Error(i(468, r));
							}
							o[gt] = e, P(o), r = o;
						}
						e.stateNode = r;
					} else Hf(a, e.type, e.stateNode);
					else e.stateNode = If(a, r, e.memoizedProps);
					else o === r ? r === null && e.stateNode !== null && Bc(e, e.memoizedProps, n.memoizedProps) : (o === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : o.count--, r === null ? Hf(a, e.type, e.stateNode) : If(a, r, e.memoizedProps));
				}
				break;
			case 27:
				cl(t, e), dl(e), r & 512 && (qc || n === null || Rc(n, n.return)), n !== null && r & 4 && Bc(e, e.memoizedProps, n.memoizedProps);
				break;
			case 5:
				if (cl(t, e), dl(e), r & 512 && (qc || n === null || Rc(n, n.return)), e.flags & 32) {
					a = e.stateNode;
					try {
						qt(a, "");
					} catch (t) {
						Uu(e, e.return, t);
					}
				}
				r & 4 && e.stateNode != null && (a = e.memoizedProps, Bc(e, a, n === null ? a : n.memoizedProps)), r & 1024 && (Jc = !0);
				break;
			case 6:
				if (cl(t, e), dl(e), r & 4) {
					if (e.stateNode === null) throw Error(i(162));
					r = e.memoizedProps, n = e.stateNode;
					try {
						n.nodeValue = r;
					} catch (t) {
						Uu(e, e.return, t);
					}
				}
				break;
			case 3:
				if (Bf = null, a = ll, ll = gf(t.containerInfo), cl(t, e), ll = a, dl(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
					Np(t.containerInfo);
				} catch (t) {
					Uu(e, e.return, t);
				}
				Jc && (Jc = !1, fl(e));
				break;
			case 4:
				r = ll, ll = gf(e.stateNode.containerInfo), cl(t, e), dl(e), ll = r;
				break;
			case 12:
				cl(t, e), dl(e);
				break;
			case 31:
				cl(t, e), dl(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, sl(e, r)));
				break;
			case 13:
				cl(t, e), dl(e), e.child.flags & 8192 && e.memoizedState !== null != (n !== null && n.memoizedState !== null) && (Zl = Fe()), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, sl(e, r)));
				break;
			case 22:
				a = e.memoizedState !== null;
				var l = n !== null && n.memoizedState !== null, u = Kc, d = qc;
				if (Kc = u || a, qc = d || l, cl(t, e), qc = d, Kc = u, dl(e), r & 8192) a: for (t = e.stateNode, t._visibility = a ? t._visibility & -2 : t._visibility | 1, a && (n === null || l || Kc || qc || ml(e)), n = null, t = e;;) {
					if (t.tag === 5 || t.tag === 26) {
						if (n === null) {
							l = n = t;
							try {
								if (o = l.stateNode, a) s = o.style, typeof s.setProperty == "function" ? s.setProperty("display", "none", "important") : s.display = "none";
								else {
									c = l.stateNode;
									var f = l.memoizedProps.style, p = f != null && f.hasOwnProperty("display") ? f.display : null;
									c.style.display = p == null || typeof p == "boolean" ? "" : ("" + p).trim();
								}
							} catch (e) {
								Uu(l, l.return, e);
							}
						}
					} else if (t.tag === 6) {
						if (n === null) {
							l = t;
							try {
								l.stateNode.nodeValue = a ? "" : l.memoizedProps;
							} catch (e) {
								Uu(l, l.return, e);
							}
						}
					} else if (t.tag === 18) {
						if (n === null) {
							l = t;
							try {
								var m = l.stateNode;
								a ? $d(m, !0) : $d(l.stateNode, !1);
							} catch (e) {
								Uu(l, l.return, e);
							}
						}
					} else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
						t.child.return = t, t = t.child;
						continue;
					}
					if (t === e) break a;
					for (; t.sibling === null;) {
						if (t.return === null || t.return === e) break a;
						n === t && (n = null), t = t.return;
					}
					n === t && (n = null), t.sibling.return = t.return, t = t.sibling;
				}
				r & 4 && (r = e.updateQueue, r !== null && (n = r.retryQueue, n !== null && (r.retryQueue = null, sl(e, n))));
				break;
			case 19:
				cl(t, e), dl(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, sl(e, r)));
				break;
			case 30: break;
			case 21: break;
			default: cl(t, e), dl(e);
		}
	}
	function dl(e) {
		var t = e.flags;
		if (t & 2) {
			try {
				for (var n, r = e.return; r !== null;) {
					if (Vc(r)) {
						n = r;
						break;
					}
					r = r.return;
				}
				if (n == null) throw Error(i(160));
				switch (n.tag) {
					case 27:
						var a = n.stateNode;
						Wc(e, Hc(e), a);
						break;
					case 5:
						var o = n.stateNode;
						n.flags & 32 && (qt(o, ""), n.flags &= -33), Wc(e, Hc(e), o);
						break;
					case 3:
					case 4:
						var s = n.stateNode.containerInfo;
						Uc(e, Hc(e), s);
						break;
					default: throw Error(i(161));
				}
			} catch (t) {
				Uu(e, e.return, t);
			}
			e.flags &= -3;
		}
		t & 4096 && (e.flags &= -4097);
	}
	function fl(e) {
		if (e.subtreeFlags & 1024) for (e = e.child; e !== null;) {
			var t = e;
			fl(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
		}
	}
	function pl(e, t) {
		if (t.subtreeFlags & 8772) for (t = t.child; t !== null;) Qc(e, t.alternate, t), t = t.sibling;
	}
	function ml(e) {
		for (e = e.child; e !== null;) {
			var t = e;
			switch (t.tag) {
				case 0:
				case 11:
				case 14:
				case 15:
					Pc(4, t, t.return), ml(t);
					break;
				case 1:
					Rc(t, t.return);
					var n = t.stateNode;
					typeof n.componentWillUnmount == "function" && Ic(t, t.return, n), ml(t);
					break;
				case 27: pf(t.stateNode);
				case 26:
				case 5:
					Rc(t, t.return), ml(t);
					break;
				case 22:
					t.memoizedState === null && ml(t);
					break;
				case 30:
					ml(t);
					break;
				default: ml(t);
			}
			e = e.sibling;
		}
	}
	function hl(e, t, n) {
		for (n &&= (t.subtreeFlags & 8772) != 0, t = t.child; t !== null;) {
			var r = t.alternate, i = e, a = t, o = a.flags;
			switch (a.tag) {
				case 0:
				case 11:
				case 15:
					hl(i, a, n), Nc(4, a);
					break;
				case 1:
					if (hl(i, a, n), r = a, i = r.stateNode, typeof i.componentDidMount == "function") try {
						i.componentDidMount();
					} catch (e) {
						Uu(r, r.return, e);
					}
					if (r = a, i = r.updateQueue, i !== null) {
						var s = r.stateNode;
						try {
							var c = i.shared.hiddenCallbacks;
							if (c !== null) for (i.shared.hiddenCallbacks = null, i = 0; i < c.length; i++) Ra(c[i], s);
						} catch (e) {
							Uu(r, r.return, e);
						}
					}
					n && o & 64 && Fc(a), Lc(a, a.return);
					break;
				case 27: Gc(a);
				case 26:
				case 5:
					hl(i, a, n), n && r === null && o & 4 && zc(a), Lc(a, a.return);
					break;
				case 12:
					hl(i, a, n);
					break;
				case 31:
					hl(i, a, n), n && o & 4 && il(i, a);
					break;
				case 13:
					hl(i, a, n), n && o & 4 && al(i, a);
					break;
				case 22:
					a.memoizedState === null && hl(i, a, n), Lc(a, a.return);
					break;
				case 30: break;
				default: hl(i, a, n);
			}
			t = t.sibling;
		}
	}
	function gl(e, t) {
		var n = null;
		e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && e.refCount++, n != null && Qi(n));
	}
	function _l(e, t) {
		e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && Qi(e));
	}
	function vl(e, t, n, r) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) yl(e, t, n, r), t = t.sibling;
	}
	function yl(e, t, n, r) {
		var i = t.flags;
		switch (t.tag) {
			case 0:
			case 11:
			case 15:
				vl(e, t, n, r), i & 2048 && Nc(9, t);
				break;
			case 1:
				vl(e, t, n, r);
				break;
			case 3:
				vl(e, t, n, r), i & 2048 && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && Qi(e)));
				break;
			case 12:
				if (i & 2048) {
					vl(e, t, n, r), e = t.stateNode;
					try {
						var a = t.memoizedProps, o = a.id, s = a.onPostCommit;
						typeof s == "function" && s(o, t.alternate === null ? "mount" : "update", e.passiveEffectDuration, -0);
					} catch (e) {
						Uu(t, t.return, e);
					}
				} else vl(e, t, n, r);
				break;
			case 31:
				vl(e, t, n, r);
				break;
			case 13:
				vl(e, t, n, r);
				break;
			case 23: break;
			case 22:
				a = t.stateNode, o = t.alternate, t.memoizedState === null ? a._visibility & 2 ? vl(e, t, n, r) : (a._visibility |= 2, bl(e, t, n, r, (t.subtreeFlags & 10256) != 0 || !1)) : a._visibility & 2 ? vl(e, t, n, r) : xl(e, t), i & 2048 && gl(o, t);
				break;
			case 24:
				vl(e, t, n, r), i & 2048 && _l(t.alternate, t);
				break;
			default: vl(e, t, n, r);
		}
	}
	function bl(e, t, n, r, i) {
		for (i &&= (t.subtreeFlags & 10256) != 0 || !1, t = t.child; t !== null;) {
			var a = e, o = t, s = n, c = r, l = o.flags;
			switch (o.tag) {
				case 0:
				case 11:
				case 15:
					bl(a, o, s, c, i), Nc(8, o);
					break;
				case 23: break;
				case 22:
					var u = o.stateNode;
					o.memoizedState === null ? (u._visibility |= 2, bl(a, o, s, c, i)) : u._visibility & 2 ? bl(a, o, s, c, i) : xl(a, o), i && l & 2048 && gl(o.alternate, o);
					break;
				case 24:
					bl(a, o, s, c, i), i && l & 2048 && _l(o.alternate, o);
					break;
				default: bl(a, o, s, c, i);
			}
			t = t.sibling;
		}
	}
	function xl(e, t) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) {
			var n = e, r = t, i = r.flags;
			switch (r.tag) {
				case 22:
					xl(n, r), i & 2048 && gl(r.alternate, r);
					break;
				case 24:
					xl(n, r), i & 2048 && _l(r.alternate, r);
					break;
				default: xl(n, r);
			}
			t = t.sibling;
		}
	}
	var Sl = 8192;
	function Cl(e, t, n) {
		if (e.subtreeFlags & Sl) for (e = e.child; e !== null;) wl(e, t, n), e = e.sibling;
	}
	function wl(e, t, n) {
		switch (e.tag) {
			case 26:
				Cl(e, t, n), e.flags & Sl && e.memoizedState !== null && Gf(n, ll, e.memoizedState, e.memoizedProps);
				break;
			case 5:
				Cl(e, t, n);
				break;
			case 3:
			case 4:
				var r = ll;
				ll = gf(e.stateNode.containerInfo), Cl(e, t, n), ll = r;
				break;
			case 22:
				e.memoizedState === null && (r = e.alternate, r !== null && r.memoizedState !== null ? (r = Sl, Sl = 16777216, Cl(e, t, n), Sl = r) : Cl(e, t, n));
				break;
			default: Cl(e, t, n);
		}
	}
	function Tl(e) {
		var t = e.alternate;
		if (t !== null && (e = t.child, e !== null)) {
			t.child = null;
			do
				t = e.sibling, e.sibling = null, e = t;
			while (e !== null);
		}
	}
	function El(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				Xc = r, kl(r, e);
			}
			Tl(e);
		}
		if (e.subtreeFlags & 10256) for (e = e.child; e !== null;) Dl(e), e = e.sibling;
	}
	function Dl(e) {
		switch (e.tag) {
			case 0:
			case 11:
			case 15:
				El(e), e.flags & 2048 && Pc(9, e, e.return);
				break;
			case 3:
				El(e);
				break;
			case 12:
				El(e);
				break;
			case 22:
				var t = e.stateNode;
				e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, Ol(e)) : El(e);
				break;
			default: El(e);
		}
	}
	function Ol(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				Xc = r, kl(r, e);
			}
			Tl(e);
		}
		for (e = e.child; e !== null;) {
			switch (t = e, t.tag) {
				case 0:
				case 11:
				case 15:
					Pc(8, t, t.return), Ol(t);
					break;
				case 22:
					n = t.stateNode, n._visibility & 2 && (n._visibility &= -3, Ol(t));
					break;
				default: Ol(t);
			}
			e = e.sibling;
		}
	}
	function kl(e, t) {
		for (; Xc !== null;) {
			var n = Xc;
			switch (n.tag) {
				case 0:
				case 11:
				case 15:
					Pc(8, n, t);
					break;
				case 23:
				case 22:
					if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
						var r = n.memoizedState.cachePool.pool;
						r != null && r.refCount++;
					}
					break;
				case 24: Qi(n.memoizedState.cache);
			}
			if (r = n.child, r !== null) r.return = n, Xc = r;
			else a: for (n = e; Xc !== null;) {
				r = Xc;
				var i = r.sibling, a = r.return;
				if ($c(r), r === n) {
					Xc = null;
					break a;
				}
				if (i !== null) {
					i.return = a, Xc = i;
					break a;
				}
				Xc = a;
			}
		}
	}
	var Al = {
		getCacheForType: function(e) {
			var t = Wi(Xi), n = t.data.get(e);
			return n === void 0 && (n = e(), t.data.set(e, n)), n;
		},
		cacheSignal: function() {
			return Wi(Xi).controller.signal;
		}
	}, jl = typeof WeakMap == "function" ? WeakMap : Map, Ml = 0, Nl = null, Pl = null, Fl = 0, Il = 0, Ll = null, Rl = !1, zl = !1, Bl = !1, Vl = 0, Hl = 0, Ul = 0, Wl = 0, Gl = 0, Kl = 0, ql = 0, Jl = null, Yl = null, Xl = !1, Zl = 0, Ql = 0, $l = Infinity, eu = null, tu = null, nu = 0, ru = null, iu = null, au = 0, ou = 0, su = null, cu = null, lu = 0, uu = null;
	function du() {
		return Ml & 2 && Fl !== 0 ? Fl & -Fl : T.T === null ? pt() : ud();
	}
	function fu() {
		if (Kl === 0) if (!(Fl & 536870912) || X) {
			var e = Qe;
			Qe <<= 1, !(Qe & 3932160) && (Qe = 262144), Kl = e;
		} else Kl = 536870912;
		return e = Ga.current, e !== null && (e.flags |= 32), Kl;
	}
	function pu(e, t, n) {
		(e === Nl && (Il === 2 || Il === 9) || e.cancelPendingCommit !== null) && (bu(e, 0), _u(e, Fl, Kl, !1)), ot(e, n), (!(Ml & 2) || e !== Nl) && (e === Nl && (!(Ml & 2) && (Wl |= n), Hl === 4 && _u(e, Fl, Kl, !1)), nd(e));
	}
	function mu(e, t, n) {
		if (Ml & 6) throw Error(i(327));
		var r = !n && (t & 127) == 0 && (t & e.expiredLanes) === 0 || nt(e, t), a = r ? Ou(e, t) : Eu(e, t, !0), o = r;
		do {
			if (a === 0) {
				zl && !r && _u(e, t, 0, !1);
				break;
			} else {
				if (n = e.current.alternate, o && !gu(n)) {
					a = Eu(e, t, !1), o = !1;
					continue;
				}
				if (a === 2) {
					if (o = t, e.errorRecoveryDisabledLanes & o) var s = 0;
					else s = e.pendingLanes & -536870913, s = s === 0 ? s & 536870912 ? 536870912 : 0 : s;
					if (s !== 0) {
						t = s;
						a: {
							var c = e;
							a = Jl;
							var l = c.current.memoizedState.isDehydrated;
							if (l && (bu(c, s).flags |= 256), s = Eu(c, s, !1), s !== 2) {
								if (Bl && !l) {
									c.errorRecoveryDisabledLanes |= o, Wl |= o, a = 4;
									break a;
								}
								o = Yl, Yl = a, o !== null && (Yl === null ? Yl = o : Yl.push.apply(Yl, o));
							}
							a = s;
						}
						if (o = !1, a !== 2) continue;
					}
				}
				if (a === 1) {
					bu(e, 0), _u(e, t, 0, !0);
					break;
				}
				a: {
					switch (r = e, o = a, o) {
						case 0:
						case 1: throw Error(i(345));
						case 4: if ((t & 4194048) !== t) break;
						case 6:
							_u(r, t, Kl, !Rl);
							break a;
						case 2:
							Yl = null;
							break;
						case 3:
						case 5: break;
						default: throw Error(i(329));
					}
					if ((t & 62914560) === t && (a = Zl + 300 - Fe(), 10 < a)) {
						if (_u(r, t, Kl, !Rl), tt(r, 0, !0) !== 0) break a;
						au = t, r.timeoutHandle = Kd(hu.bind(null, r, n, Yl, eu, Xl, t, Kl, Wl, ql, Rl, o, "Throttled", -0, 0), a);
						break a;
					}
					hu(r, n, Yl, eu, Xl, t, Kl, Wl, ql, Rl, o, null, -0, 0);
				}
			}
			break;
		} while (1);
		nd(e);
	}
	function hu(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
		if (e.timeoutHandle = -1, d = t.subtreeFlags, d & 8192 || (d & 16785408) == 16785408) {
			d = {
				stylesheets: null,
				count: 0,
				imgCount: 0,
				imgBytes: 0,
				suspenseyImages: [],
				waitingForImages: !0,
				waitingForViewTransition: !1,
				unsuspend: $t
			}, wl(t, a, d);
			var m = (a & 62914560) === a ? Zl - Fe() : (a & 4194048) === a ? Ql - Fe() : 0;
			if (m = qf(d, m), m !== null) {
				au = a, e.cancelPendingCommit = m(Fu.bind(null, e, t, a, n, r, i, o, s, c, u, d, null, f, p)), _u(e, a, o, !l);
				return;
			}
		}
		Fu(e, t, a, n, r, i, o, s, c);
	}
	function gu(e) {
		for (var t = e;;) {
			var n = t.tag;
			if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null))) for (var r = 0; r < n.length; r++) {
				var i = n[r], a = i.getSnapshot;
				i = i.value;
				try {
					if (!vr(a(), i)) return !1;
				} catch {
					return !1;
				}
			}
			if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
			else {
				if (t === e) break;
				for (; t.sibling === null;) {
					if (t.return === null || t.return === e) return !0;
					t = t.return;
				}
				t.sibling.return = t.return, t = t.sibling;
			}
		}
		return !0;
	}
	function _u(e, t, n, r) {
		t &= ~Gl, t &= ~Wl, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes;
		for (var i = t; 0 < i;) {
			var a = 31 - qe(i), o = 1 << a;
			r[a] = -1, i &= ~o;
		}
		n !== 0 && ct(e, n, t);
	}
	function vu() {
		return Ml & 6 ? !0 : (rd(0, !1), !1);
	}
	function yu() {
		if (Pl !== null) {
			if (Il === 0) var e = Pl.return;
			else e = Pl, Ii = Fi = null, yo(e), ba = null, xa = 0, e = Pl;
			for (; e !== null;) Mc(e.alternate, e), e = e.return;
			Pl = null;
		}
	}
	function bu(e, t) {
		var n = e.timeoutHandle;
		n !== -1 && (e.timeoutHandle = -1, qd(n)), n = e.cancelPendingCommit, n !== null && (e.cancelPendingCommit = null, n()), au = 0, yu(), Nl = e, Pl = n = ri(e.current, null), Fl = t, Il = 0, Ll = null, Rl = !1, zl = nt(e, t), Bl = !1, ql = Kl = Gl = Wl = Ul = Hl = 0, Yl = Jl = null, Xl = !1, t & 8 && (t |= t & 32);
		var r = e.entangledLanes;
		if (r !== 0) for (e = e.entanglements, r &= t; 0 < r;) {
			var i = 31 - qe(r), a = 1 << i;
			t |= e[i], r &= ~a;
		}
		return Vl = t, Yr(), n;
	}
	function xu(e, t) {
		Q = null, T.H = ks, t === ua || t === fa ? (t = va(), Il = 3) : t === da ? (t = va(), Il = 4) : Il = t === qs ? 8 : typeof t == "object" && t && typeof t.then == "function" ? 6 : 1, Ll = t, Pl === null && (Hl = 1, Vs(e, ui(t, e.current)));
	}
	function Su() {
		var e = Ga.current;
		return e === null ? !0 : (Fl & 4194048) === Fl ? Ka === null : (Fl & 62914560) === Fl || Fl & 536870912 ? e === Ka : !1;
	}
	function Cu() {
		var e = T.H;
		return T.H = ks, e === null ? ks : e;
	}
	function wu() {
		var e = T.A;
		return T.A = Al, e;
	}
	function Tu() {
		Hl = 4, Rl || (Fl & 4194048) !== Fl && Ga.current !== null || (zl = !0), !(Ul & 134217727) && !(Wl & 134217727) || Nl === null || _u(Nl, Fl, Kl, !1);
	}
	function Eu(e, t, n) {
		var r = Ml;
		Ml |= 2;
		var i = Cu(), a = wu();
		(Nl !== e || Fl !== t) && (eu = null, bu(e, t)), t = !1;
		var o = Hl;
		a: do
			try {
				if (Il !== 0 && Pl !== null) {
					var s = Pl, c = Ll;
					switch (Il) {
						case 8:
							yu(), o = 6;
							break a;
						case 3:
						case 2:
						case 9:
						case 6:
							Ga.current === null && (t = !0);
							var l = Il;
							if (Il = 0, Ll = null, Mu(e, s, c, l), n && zl) {
								o = 0;
								break a;
							}
							break;
						default: l = Il, Il = 0, Ll = null, Mu(e, s, c, l);
					}
				}
				Du(), o = Hl;
				break;
			} catch (t) {
				xu(e, t);
			}
		while (1);
		return t && e.shellSuspendCounter++, Ii = Fi = null, Ml = r, T.H = i, T.A = a, Pl === null && (Nl = null, Fl = 0, Yr()), o;
	}
	function Du() {
		for (; Pl !== null;) Au(Pl);
	}
	function Ou(e, t) {
		var n = Ml;
		Ml |= 2;
		var r = Cu(), a = wu();
		Nl !== e || Fl !== t ? (eu = null, $l = Fe() + 500, bu(e, t)) : zl = nt(e, t);
		a: do
			try {
				if (Il !== 0 && Pl !== null) {
					t = Pl;
					var o = Ll;
					b: switch (Il) {
						case 1:
							Il = 0, Ll = null, Mu(e, t, o, 1);
							break;
						case 2:
						case 9:
							if (ma(o)) {
								Il = 0, Ll = null, ju(t);
								break;
							}
							t = function() {
								Il !== 2 && Il !== 9 || Nl !== e || (Il = 7), nd(e);
							}, o.then(t, t);
							break a;
						case 3:
							Il = 7;
							break a;
						case 4:
							Il = 5;
							break a;
						case 7:
							ma(o) ? (Il = 0, Ll = null, ju(t)) : (Il = 0, Ll = null, Mu(e, t, o, 7));
							break;
						case 5:
							var s = null;
							switch (Pl.tag) {
								case 26: s = Pl.memoizedState;
								case 5:
								case 27:
									var c = Pl;
									if (s ? Wf(s) : c.stateNode.complete) {
										Il = 0, Ll = null;
										var l = c.sibling;
										if (l !== null) Pl = l;
										else {
											var u = c.return;
											u === null ? Pl = null : (Pl = u, Nu(u));
										}
										break b;
									}
							}
							Il = 0, Ll = null, Mu(e, t, o, 5);
							break;
						case 6:
							Il = 0, Ll = null, Mu(e, t, o, 6);
							break;
						case 8:
							yu(), Hl = 6;
							break a;
						default: throw Error(i(462));
					}
				}
				ku();
				break;
			} catch (t) {
				xu(e, t);
			}
		while (1);
		return Ii = Fi = null, T.H = r, T.A = a, Ml = n, Pl === null ? (Nl = null, Fl = 0, Yr(), Hl) : 0;
	}
	function ku() {
		for (; Pl !== null && !Ne();) Au(Pl);
	}
	function Au(e) {
		var t = Cc(e.alternate, e, Vl);
		e.memoizedProps = e.pendingProps, t === null ? Nu(e) : Pl = t;
	}
	function ju(e) {
		var t = e, n = t.alternate;
		switch (t.tag) {
			case 15:
			case 0:
				t = sc(n, t, t.pendingProps, t.type, void 0, Fl);
				break;
			case 11:
				t = sc(n, t, t.pendingProps, t.type.render, t.ref, Fl);
				break;
			case 5: yo(t);
			default: Mc(n, t), t = Pl = ii(t, Vl), t = Cc(n, t, Vl);
		}
		e.memoizedProps = e.pendingProps, t === null ? Nu(e) : Pl = t;
	}
	function Mu(e, t, n, r) {
		Ii = Fi = null, yo(t), ba = null, xa = 0;
		var i = t.return;
		try {
			if (Ks(e, i, t, n, Fl)) {
				Hl = 1, Vs(e, ui(n, e.current)), Pl = null;
				return;
			}
		} catch (t) {
			if (i !== null) throw Pl = i, t;
			Hl = 1, Vs(e, ui(n, e.current)), Pl = null;
			return;
		}
		t.flags & 32768 ? (X || r === 1 ? e = !0 : zl || Fl & 536870912 ? e = !1 : (Rl = e = !0, (r === 2 || r === 9 || r === 3 || r === 6) && (r = Ga.current, r !== null && r.tag === 13 && (r.flags |= 16384))), Pu(t, e)) : Nu(t);
	}
	function Nu(e) {
		var t = e;
		do {
			if (t.flags & 32768) {
				Pu(t, Rl);
				return;
			}
			e = t.return;
			var n = Ac(t.alternate, t, Vl);
			if (n !== null) {
				Pl = n;
				return;
			}
			if (t = t.sibling, t !== null) {
				Pl = t;
				return;
			}
			Pl = t = e;
		} while (t !== null);
		Hl === 0 && (Hl = 5);
	}
	function Pu(e, t) {
		do {
			var n = jc(e.alternate, e);
			if (n !== null) {
				n.flags &= 32767, Pl = n;
				return;
			}
			if (n = e.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling, e !== null)) {
				Pl = e;
				return;
			}
			Pl = e = n;
		} while (e !== null);
		Hl = 6, Pl = null;
	}
	function Fu(e, t, n, r, a, o, s, c, l) {
		e.cancelPendingCommit = null;
		do
			Bu();
		while (nu !== 0);
		if (Ml & 6) throw Error(i(327));
		if (t !== null) {
			if (t === e.current) throw Error(i(177));
			if (o = t.lanes | t.childLanes, o |= Jr, st(e, n, o, s, c, l), e === Nl && (Pl = Nl = null, Fl = 0), iu = t, ru = e, au = n, ou = o, su = a, cu = r, t.subtreeFlags & 10256 || t.flags & 10256 ? (e.callbackNode = null, e.callbackPriority = 0, Yu(ze, function() {
				return Vu(), null;
			})) : (e.callbackNode = null, e.callbackPriority = 0), r = (t.flags & 13878) != 0, t.subtreeFlags & 13878 || r) {
				r = T.T, T.T = null, a = E.p, E.p = 2, s = Ml, Ml |= 4;
				try {
					Zc(e, t, n);
				} finally {
					Ml = s, E.p = a, T.T = r;
				}
			}
			nu = 1, Iu(), Lu(), Ru();
		}
	}
	function Iu() {
		if (nu === 1) {
			nu = 0;
			var e = ru, t = iu, n = (t.flags & 13878) != 0;
			if (t.subtreeFlags & 13878 || n) {
				n = T.T, T.T = null;
				var r = E.p;
				E.p = 2;
				var i = Ml;
				Ml |= 4;
				try {
					ul(t, e);
					var a = zd, o = Cr(e.containerInfo), s = a.focusedElem, c = a.selectionRange;
					if (o !== s && s && s.ownerDocument && Sr(s.ownerDocument.documentElement, s)) {
						if (c !== null && wr(s)) {
							var l = c.start, u = c.end;
							if (u === void 0 && (u = l), "selectionStart" in s) s.selectionStart = l, s.selectionEnd = Math.min(u, s.value.length);
							else {
								var d = s.ownerDocument || document, f = d && d.defaultView || window;
								if (f.getSelection) {
									var p = f.getSelection(), m = s.textContent.length, h = Math.min(c.start, m), g = c.end === void 0 ? h : Math.min(c.end, m);
									!p.extend && h > g && (o = g, g = h, h = o);
									var _ = xr(s, h), v = xr(s, g);
									if (_ && v && (p.rangeCount !== 1 || p.anchorNode !== _.node || p.anchorOffset !== _.offset || p.focusNode !== v.node || p.focusOffset !== v.offset)) {
										var y = d.createRange();
										y.setStart(_.node, _.offset), p.removeAllRanges(), h > g ? (p.addRange(y), p.extend(v.node, v.offset)) : (y.setEnd(v.node, v.offset), p.addRange(y));
									}
								}
							}
						}
						for (d = [], p = s; p = p.parentNode;) p.nodeType === 1 && d.push({
							element: p,
							left: p.scrollLeft,
							top: p.scrollTop
						});
						for (typeof s.focus == "function" && s.focus(), s = 0; s < d.length; s++) {
							var b = d[s];
							b.element.scrollLeft = b.left, b.element.scrollTop = b.top;
						}
					}
					sp = !!Rd, zd = Rd = null;
				} finally {
					Ml = i, E.p = r, T.T = n;
				}
			}
			e.current = t, nu = 2;
		}
	}
	function Lu() {
		if (nu === 2) {
			nu = 0;
			var e = ru, t = iu, n = (t.flags & 8772) != 0;
			if (t.subtreeFlags & 8772 || n) {
				n = T.T, T.T = null;
				var r = E.p;
				E.p = 2;
				var i = Ml;
				Ml |= 4;
				try {
					Qc(e, t.alternate, t);
				} finally {
					Ml = i, E.p = r, T.T = n;
				}
			}
			nu = 3;
		}
	}
	function Ru() {
		if (nu === 4 || nu === 3) {
			nu = 0, Pe();
			var e = ru, t = iu, n = au, r = cu;
			t.subtreeFlags & 10256 || t.flags & 10256 ? nu = 5 : (nu = 0, iu = ru = null, zu(e, e.pendingLanes));
			var i = e.pendingLanes;
			if (i === 0 && (tu = null), ft(n), t = t.stateNode, Ge && typeof Ge.onCommitFiberRoot == "function") try {
				Ge.onCommitFiberRoot(We, t, void 0, (t.current.flags & 128) == 128);
			} catch {}
			if (r !== null) {
				t = T.T, i = E.p, E.p = 2, T.T = null;
				try {
					for (var a = e.onRecoverableError, o = 0; o < r.length; o++) {
						var s = r[o];
						a(s.value, { componentStack: s.stack });
					}
				} finally {
					T.T = t, E.p = i;
				}
			}
			au & 3 && Bu(), nd(e), i = e.pendingLanes, n & 261930 && i & 42 ? e === uu ? lu++ : (lu = 0, uu = e) : lu = 0, rd(0, !1);
		}
	}
	function zu(e, t) {
		(e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, Qi(t)));
	}
	function Bu() {
		return Iu(), Lu(), Ru(), Vu();
	}
	function Vu() {
		if (nu !== 5) return !1;
		var e = ru, t = ou;
		ou = 0;
		var n = ft(au), r = T.T, a = E.p;
		try {
			E.p = 32 > n ? 32 : n, T.T = null, n = su, su = null;
			var o = ru, s = au;
			if (nu = 0, iu = ru = null, au = 0, Ml & 6) throw Error(i(331));
			var c = Ml;
			if (Ml |= 4, Dl(o.current), yl(o, o.current, s, n), Ml = c, rd(0, !1), Ge && typeof Ge.onPostCommitFiberRoot == "function") try {
				Ge.onPostCommitFiberRoot(We, o);
			} catch {}
			return !0;
		} finally {
			E.p = a, T.T = r, zu(e, t);
		}
	}
	function Hu(e, t, n) {
		t = ui(n, t), t = Us(e.stateNode, t, 2), e = Ma(e, t, 2), e !== null && (ot(e, 2), nd(e));
	}
	function Uu(e, t, n) {
		if (e.tag === 3) Hu(e, e, n);
		else for (; t !== null;) {
			if (t.tag === 3) {
				Hu(t, e, n);
				break;
			} else if (t.tag === 1) {
				var r = t.stateNode;
				if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (tu === null || !tu.has(r))) {
					e = ui(n, e), n = Ws(2), r = Ma(t, n, 2), r !== null && (Gs(n, r, t, e), ot(r, 2), nd(r));
					break;
				}
			}
			t = t.return;
		}
	}
	function Wu(e, t, n) {
		var r = e.pingCache;
		if (r === null) {
			r = e.pingCache = new jl();
			var i = /* @__PURE__ */ new Set();
			r.set(t, i);
		} else i = r.get(t), i === void 0 && (i = /* @__PURE__ */ new Set(), r.set(t, i));
		i.has(n) || (Bl = !0, i.add(n), e = Gu.bind(null, e, t, n), t.then(e, e));
	}
	function Gu(e, t, n) {
		var r = e.pingCache;
		r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, Nl === e && (Fl & n) === n && (Hl === 4 || Hl === 3 && (Fl & 62914560) === Fl && 300 > Fe() - Zl ? !(Ml & 2) && bu(e, 0) : Gl |= n, ql === Fl && (ql = 0)), nd(e);
	}
	function Ku(e, t) {
		t === 0 && (t = it()), e = Qr(e, t), e !== null && (ot(e, t), nd(e));
	}
	function qu(e) {
		var t = e.memoizedState, n = 0;
		t !== null && (n = t.retryLane), Ku(e, n);
	}
	function Ju(e, t) {
		var n = 0;
		switch (e.tag) {
			case 31:
			case 13:
				var r = e.stateNode, a = e.memoizedState;
				a !== null && (n = a.retryLane);
				break;
			case 19:
				r = e.stateNode;
				break;
			case 22:
				r = e.stateNode._retryCache;
				break;
			default: throw Error(i(314));
		}
		r !== null && r.delete(t), Ku(e, n);
	}
	function Yu(e, t) {
		return je(e, t);
	}
	var Xu = null, Zu = null, Qu = !1, $u = !1, ed = !1, td = 0;
	function nd(e) {
		e !== Zu && e.next === null && (Zu === null ? Xu = Zu = e : Zu = Zu.next = e), $u = !0, Qu || (Qu = !0, ld());
	}
	function rd(e, t) {
		if (!ed && $u) {
			ed = !0;
			do
				for (var n = !1, r = Xu; r !== null;) {
					if (!t) if (e !== 0) {
						var i = r.pendingLanes;
						if (i === 0) var a = 0;
						else {
							var o = r.suspendedLanes, s = r.pingedLanes;
							a = (1 << 31 - qe(42 | e) + 1) - 1, a &= i & ~(o & ~s), a = a & 201326741 ? a & 201326741 | 1 : a ? a | 2 : 0;
						}
						a !== 0 && (n = !0, cd(r, a));
					} else a = Fl, a = tt(r, r === Nl ? a : 0, r.cancelPendingCommit !== null || r.timeoutHandle !== -1), !(a & 3) || nt(r, a) || (n = !0, cd(r, a));
					r = r.next;
				}
			while (n);
			ed = !1;
		}
	}
	function id() {
		ad();
	}
	function ad() {
		$u = Qu = !1;
		var e = 0;
		td !== 0 && Gd() && (e = td);
		for (var t = Fe(), n = null, r = Xu; r !== null;) {
			var i = r.next, a = od(r, t);
			a === 0 ? (r.next = null, n === null ? Xu = i : n.next = i, i === null && (Zu = n)) : (n = r, (e !== 0 || a & 3) && ($u = !0)), r = i;
		}
		nu !== 0 && nu !== 5 || rd(e, !1), td !== 0 && (td = 0);
	}
	function od(e, t) {
		for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, a = e.pendingLanes & -62914561; 0 < a;) {
			var o = 31 - qe(a), s = 1 << o, c = i[o];
			c === -1 ? ((s & n) === 0 || (s & r) !== 0) && (i[o] = rt(s, t)) : c <= t && (e.expiredLanes |= s), a &= ~s;
		}
		if (t = Nl, n = Fl, n = tt(e, e === t ? n : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r = e.callbackNode, n === 0 || e === t && (Il === 2 || Il === 9) || e.cancelPendingCommit !== null) return r !== null && r !== null && Me(r), e.callbackNode = null, e.callbackPriority = 0;
		if (!(n & 3) || nt(e, n)) {
			if (t = n & -n, t === e.callbackPriority) return t;
			switch (r !== null && Me(r), ft(n)) {
				case 2:
				case 8:
					n = Re;
					break;
				case 32:
					n = ze;
					break;
				case 268435456:
					n = Ve;
					break;
				default: n = ze;
			}
			return r = sd.bind(null, e), n = je(n, r), e.callbackPriority = t, e.callbackNode = n, t;
		}
		return r !== null && r !== null && Me(r), e.callbackPriority = 2, e.callbackNode = null, 2;
	}
	function sd(e, t) {
		if (nu !== 0 && nu !== 5) return e.callbackNode = null, e.callbackPriority = 0, null;
		var n = e.callbackNode;
		if (Bu() && e.callbackNode !== n) return null;
		var r = Fl;
		return r = tt(e, e === Nl ? r : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r === 0 ? null : (mu(e, r, t), od(e, Fe()), e.callbackNode != null && e.callbackNode === n ? sd.bind(null, e) : null);
	}
	function cd(e, t) {
		if (Bu()) return null;
		mu(e, t, !0);
	}
	function ld() {
		Yd(function() {
			Ml & 6 ? je(Le, id) : ad();
		});
	}
	function ud() {
		if (td === 0) {
			var e = ta;
			e === 0 && (e = Ze, Ze <<= 1, !(Ze & 261888) && (Ze = 256)), td = e;
		}
		return td;
	}
	function dd(e) {
		return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : Qt("" + e);
	}
	function fd(e, t) {
		var n = t.ownerDocument.createElement("input");
		return n.name = t.name, n.value = t.value, e.id && n.setAttribute("form", e.id), t.parentNode.insertBefore(n, t), e = new FormData(e), n.parentNode.removeChild(n), e;
	}
	function pd(e, t, n, r, i) {
		if (t === "submit" && n && n.stateNode === i) {
			var a = dd((i[k] || null).action), o = r.submitter;
			o && (t = (t = o[k] || null) ? dd(t.formAction) : o.getAttribute("formAction"), t !== null && (a = t, o = null));
			var s = new _n("action", "action", null, r, i);
			e.push({
				event: s,
				listeners: [{
					instance: null,
					listener: function() {
						if (r.defaultPrevented) {
							if (td !== 0) {
								var e = o ? fd(i, o) : new FormData(i);
								hs(n, {
									pending: !0,
									data: e,
									method: i.method,
									action: a
								}, null, e);
							}
						} else typeof a == "function" && (s.preventDefault(), e = o ? fd(i, o) : new FormData(i), hs(n, {
							pending: !0,
							data: e,
							method: i.method,
							action: a
						}, a, e));
					},
					currentTarget: i
				}]
			});
		}
	}
	for (var md = 0; md < Wr.length; md++) {
		var hd = Wr[md];
		Gr(hd.toLowerCase(), "on" + (hd[0].toUpperCase() + hd.slice(1)));
	}
	Gr(Ir, "onAnimationEnd"), Gr(Lr, "onAnimationIteration"), Gr(Rr, "onAnimationStart"), Gr("dblclick", "onDoubleClick"), Gr("focusin", "onFocus"), Gr("focusout", "onBlur"), Gr(zr, "onTransitionRun"), Gr(Br, "onTransitionStart"), Gr(Vr, "onTransitionCancel"), Gr(Hr, "onTransitionEnd"), Et("onMouseEnter", ["mouseout", "mouseover"]), Et("onMouseLeave", ["mouseout", "mouseover"]), Et("onPointerEnter", ["pointerout", "pointerover"]), Et("onPointerLeave", ["pointerout", "pointerover"]), Tt("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), Tt("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), Tt("onBeforeInput", [
		"compositionend",
		"keypress",
		"textInput",
		"paste"
	]), Tt("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), Tt("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), Tt("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
	var gd = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), _d = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(gd));
	function vd(e, t) {
		t = (t & 4) != 0;
		for (var n = 0; n < e.length; n++) {
			var r = e[n], i = r.event;
			r = r.listeners;
			a: {
				var a = void 0;
				if (t) for (var o = r.length - 1; 0 <= o; o--) {
					var s = r[o], c = s.instance, l = s.currentTarget;
					if (s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						U(e);
					}
					i.currentTarget = null, a = c;
				}
				else for (o = 0; o < r.length; o++) {
					if (s = r[o], c = s.instance, l = s.currentTarget, s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						U(e);
					}
					i.currentTarget = null, a = c;
				}
			}
		}
	}
	function $(e, t) {
		var n = t[vt];
		n === void 0 && (n = t[vt] = /* @__PURE__ */ new Set());
		var r = e + "__bubble";
		n.has(r) || (Sd(t, e, 2, !1), n.add(r));
	}
	function yd(e, t, n) {
		var r = 0;
		t && (r |= 4), Sd(n, e, r, t);
	}
	var bd = "_reactListening" + Math.random().toString(36).slice(2);
	function xd(e) {
		if (!e[bd]) {
			e[bd] = !0, F.forEach(function(t) {
				t !== "selectionchange" && (_d.has(t) || yd(t, !1, e), yd(t, !0, e));
			});
			var t = e.nodeType === 9 ? e : e.ownerDocument;
			t === null || t[bd] || (t[bd] = !0, yd("selectionchange", !1, t));
		}
	}
	function Sd(e, t, n, r) {
		switch (mp(t)) {
			case 2:
				var i = cp;
				break;
			case 8:
				i = lp;
				break;
			default: i = up;
		}
		n = i.bind(null, t, n, e), i = void 0, !ln || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (i = !0), r ? i === void 0 ? e.addEventListener(t, n, !0) : e.addEventListener(t, n, {
			capture: !0,
			passive: i
		}) : i === void 0 ? e.addEventListener(t, n, !1) : e.addEventListener(t, n, { passive: i });
	}
	function Cd(e, t, n, r, i) {
		var a = r;
		if (!(t & 1) && !(t & 2) && r !== null) a: for (;;) {
			if (r === null) return;
			var s = r.tag;
			if (s === 3 || s === 4) {
				var c = r.stateNode.containerInfo;
				if (c === i) break;
				if (s === 4) for (s = r.return; s !== null;) {
					var l = s.tag;
					if ((l === 3 || l === 4) && s.stateNode.containerInfo === i) return;
					s = s.return;
				}
				for (; c !== null;) {
					if (s = M(c), s === null) return;
					if (l = s.tag, l === 5 || l === 6 || l === 26 || l === 27) {
						r = a = s;
						continue a;
					}
					c = c.parentNode;
				}
			}
			r = r.return;
		}
		sn(function() {
			var r = a, i = tn(n), s = [];
			a: {
				var c = Ur.get(e);
				if (c !== void 0) {
					var l = _n, u = e;
					switch (e) {
						case "keypress": if (B(n) === 0) break a;
						case "keydown":
						case "keyup":
							l = Fn;
							break;
						case "focusin":
							u = "focus", l = En;
							break;
						case "focusout":
							u = "blur", l = En;
							break;
						case "beforeblur":
						case "afterblur":
							l = En;
							break;
						case "click": if (n.button === 2) break a;
						case "auxclick":
						case "dblclick":
						case "mousedown":
						case "mousemove":
						case "mouseup":
						case "mouseout":
						case "mouseover":
						case "contextmenu":
							l = wn;
							break;
						case "drag":
						case "dragend":
						case "dragenter":
						case "dragexit":
						case "dragleave":
						case "dragover":
						case "dragstart":
						case "drop":
							l = Tn;
							break;
						case "touchcancel":
						case "touchend":
						case "touchmove":
						case "touchstart":
							l = Ln;
							break;
						case Ir:
						case Lr:
						case Rr:
							l = Dn;
							break;
						case Hr:
							l = Rn;
							break;
						case "scroll":
						case "scrollend":
							l = yn;
							break;
						case "wheel":
							l = zn;
							break;
						case "copy":
						case "cut":
						case "paste":
							l = On;
							break;
						case "gotpointercapture":
						case "lostpointercapture":
						case "pointercancel":
						case "pointerdown":
						case "pointermove":
						case "pointerout":
						case "pointerover":
						case "pointerup":
							l = In;
							break;
						case "toggle":
						case "beforetoggle": l = Bn;
					}
					var d = (t & 4) != 0, f = !d && (e === "scroll" || e === "scrollend"), p = d ? c === null ? null : c + "Capture" : c;
					d = [];
					for (var m = r, h; m !== null;) {
						var g = m;
						if (h = g.stateNode, g = g.tag, g !== 5 && g !== 26 && g !== 27 || h === null || p === null || (g = cn(m, p), g != null && d.push(wd(m, g, h))), f) break;
						m = m.return;
					}
					0 < d.length && (c = new l(c, u, null, n, i), s.push({
						event: c,
						listeners: d
					}));
				}
			}
			if (!(t & 7)) {
				a: {
					if (c = e === "mouseover" || e === "pointerover", l = e === "mouseout" || e === "pointerout", c && n !== en && (u = n.relatedTarget || n.fromElement) && (M(u) || u[_t])) break a;
					if ((l || c) && (c = i.window === i ? i : (c = i.ownerDocument) ? c.defaultView || c.parentWindow : window, l ? (u = n.relatedTarget || n.toElement, l = r, u = u ? M(u) : null, u !== null && (f = o(u), d = u.tag, u !== f || d !== 5 && d !== 27 && d !== 6) && (u = null)) : (l = null, u = r), l !== u)) {
						if (d = wn, g = "onMouseLeave", p = "onMouseEnter", m = "mouse", (e === "pointerout" || e === "pointerover") && (d = In, g = "onPointerLeave", p = "onPointerEnter", m = "pointer"), f = l == null ? c : Ct(l), h = u == null ? c : Ct(u), c = new d(g, m + "leave", l, n, i), c.target = f, c.relatedTarget = h, g = null, M(i) === r && (d = new d(p, m + "enter", u, n, i), d.target = h, d.relatedTarget = f, g = d), f = g, l && u) b: {
							for (d = Ed, p = l, m = u, h = 0, g = p; g; g = d(g)) h++;
							g = 0;
							for (var _ = m; _; _ = d(_)) g++;
							for (; 0 < h - g;) p = d(p), h--;
							for (; 0 < g - h;) m = d(m), g--;
							for (; h--;) {
								if (p === m || m !== null && p === m.alternate) {
									d = p;
									break b;
								}
								p = d(p), m = d(m);
							}
							d = null;
						}
						else d = null;
						l !== null && Dd(s, c, l, d, !1), u !== null && f !== null && Dd(s, f, u, d, !0);
					}
				}
				a: {
					if (c = r ? Ct(r) : window, l = c.nodeName && c.nodeName.toLowerCase(), l === "select" || l === "input" && c.type === "file") var v = or;
					else if (er(c)) if (sr) v = gr;
					else {
						v = mr;
						var y = pr;
					}
					else l = c.nodeName, !l || l.toLowerCase() !== "input" || c.type !== "checkbox" && c.type !== "radio" ? r && Xt(r.elementType) && (v = or) : v = hr;
					if (v &&= v(e, r)) {
						tr(s, v, n, i);
						break a;
					}
					y && y(e, c, r), e === "focusout" && r && c.type === "number" && r.memoizedProps.value != null && Ut(c, "number", c.value);
				}
				switch (y = r ? Ct(r) : window, e) {
					case "focusin":
						(er(y) || y.contentEditable === "true") && (Er = y, Dr = r, Or = null);
						break;
					case "focusout":
						Or = Dr = Er = null;
						break;
					case "mousedown":
						kr = !0;
						break;
					case "contextmenu":
					case "mouseup":
					case "dragend":
						kr = !1, Ar(s, n, i);
						break;
					case "selectionchange": if (Tr) break;
					case "keydown":
					case "keyup": Ar(s, n, i);
				}
				var b;
				if (Hn) b: {
					switch (e) {
						case "compositionstart":
							var x = "onCompositionStart";
							break b;
						case "compositionend":
							x = "onCompositionEnd";
							break b;
						case "compositionupdate":
							x = "onCompositionUpdate";
							break b;
					}
					x = void 0;
				}
				else Xn ? Jn(e, n) && (x = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (x = "onCompositionStart");
				x && (Gn && n.locale !== "ko" && (Xn || x !== "onCompositionStart" ? x === "onCompositionEnd" && Xn && (b = mn()) : (dn = i, fn = "value" in dn ? dn.value : dn.textContent, Xn = !0)), y = Td(r, x), 0 < y.length && (x = new kn(x, e, null, n, i), s.push({
					event: x,
					listeners: y
				}), b ? x.data = b : (b = Yn(n), b !== null && (x.data = b)))), (b = Wn ? Zn(e, n) : Qn(e, n)) && (x = Td(r, "onBeforeInput"), 0 < x.length && (y = new kn("onBeforeInput", "beforeinput", null, n, i), s.push({
					event: y,
					listeners: x
				}), y.data = b)), pd(s, e, r, n, i);
			}
			vd(s, t);
		});
	}
	function wd(e, t, n) {
		return {
			instance: e,
			listener: t,
			currentTarget: n
		};
	}
	function Td(e, t) {
		for (var n = t + "Capture", r = []; e !== null;) {
			var i = e, a = i.stateNode;
			if (i = i.tag, i !== 5 && i !== 26 && i !== 27 || a === null || (i = cn(e, n), i != null && r.unshift(wd(e, i, a)), i = cn(e, t), i != null && r.push(wd(e, i, a))), e.tag === 3) return r;
			e = e.return;
		}
		return [];
	}
	function Ed(e) {
		if (e === null) return null;
		do
			e = e.return;
		while (e && e.tag !== 5 && e.tag !== 27);
		return e || null;
	}
	function Dd(e, t, n, r, i) {
		for (var a = t._reactName, o = []; n !== null && n !== r;) {
			var s = n, c = s.alternate, l = s.stateNode;
			if (s = s.tag, c !== null && c === r) break;
			s !== 5 && s !== 26 && s !== 27 || l === null || (c = l, i ? (l = cn(n, a), l != null && o.unshift(wd(n, l, c))) : i || (l = cn(n, a), l != null && o.push(wd(n, l, c)))), n = n.return;
		}
		o.length !== 0 && e.push({
			event: t,
			listeners: o
		});
	}
	var Od = /\r\n?/g, kd = /\u0000|\uFFFD/g;
	function Ad(e) {
		return (typeof e == "string" ? e : "" + e).replace(Od, "\n").replace(kd, "");
	}
	function jd(e, t) {
		return t = Ad(t), Ad(e) === t;
	}
	function Md(e, t, n, r, a, o) {
		switch (n) {
			case "children":
				typeof r == "string" ? t === "body" || t === "textarea" && r === "" || qt(e, r) : (typeof r == "number" || typeof r == "bigint") && t !== "body" && qt(e, "" + r);
				break;
			case "className":
				jt(e, "class", r);
				break;
			case "tabIndex":
				jt(e, "tabindex", r);
				break;
			case "dir":
			case "role":
			case "viewBox":
			case "width":
			case "height":
				jt(e, n, r);
				break;
			case "style":
				Yt(e, r, o);
				break;
			case "data": if (t !== "object") {
				jt(e, "data", r);
				break;
			}
			case "src":
			case "href":
				if (r === "" && (t !== "a" || n !== "href")) {
					e.removeAttribute(n);
					break;
				}
				if (r == null || typeof r == "function" || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = Qt("" + r), e.setAttribute(n, r);
				break;
			case "action":
			case "formAction":
				if (typeof r == "function") {
					e.setAttribute(n, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
					break;
				} else typeof o == "function" && (n === "formAction" ? (t !== "input" && Md(e, t, "name", a.name, a, null), Md(e, t, "formEncType", a.formEncType, a, null), Md(e, t, "formMethod", a.formMethod, a, null), Md(e, t, "formTarget", a.formTarget, a, null)) : (Md(e, t, "encType", a.encType, a, null), Md(e, t, "method", a.method, a, null), Md(e, t, "target", a.target, a, null)));
				if (r == null || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = Qt("" + r), e.setAttribute(n, r);
				break;
			case "onClick":
				r != null && (e.onclick = $t);
				break;
			case "onScroll":
				r != null && $("scroll", e);
				break;
			case "onScrollEnd":
				r != null && $("scrollend", e);
				break;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(i(61));
					if (n = r.__html, n != null) {
						if (a.children != null) throw Error(i(60));
						e.innerHTML = n;
					}
				}
				break;
			case "multiple":
				e.multiple = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "muted":
				e.muted = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "defaultValue":
			case "defaultChecked":
			case "innerHTML":
			case "ref": break;
			case "autoFocus": break;
			case "xlinkHref":
				if (r == null || typeof r == "function" || typeof r == "boolean" || typeof r == "symbol") {
					e.removeAttribute("xlink:href");
					break;
				}
				n = Qt("" + r), e.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", n);
				break;
			case "contentEditable":
			case "spellCheck":
			case "draggable":
			case "value":
			case "autoReverse":
			case "externalResourcesRequired":
			case "focusable":
			case "preserveAlpha":
				r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "" + r) : e.removeAttribute(n);
				break;
			case "inert":
			case "allowFullScreen":
			case "async":
			case "autoPlay":
			case "controls":
			case "default":
			case "defer":
			case "disabled":
			case "disablePictureInPicture":
			case "disableRemotePlayback":
			case "formNoValidate":
			case "hidden":
			case "loop":
			case "noModule":
			case "noValidate":
			case "open":
			case "playsInline":
			case "readOnly":
			case "required":
			case "reversed":
			case "scoped":
			case "seamless":
			case "itemScope":
				r && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "") : e.removeAttribute(n);
				break;
			case "capture":
			case "download":
				!0 === r ? e.setAttribute(n, "") : !1 !== r && r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "cols":
			case "rows":
			case "size":
			case "span":
				r != null && typeof r != "function" && typeof r != "symbol" && !isNaN(r) && 1 <= r ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "rowSpan":
			case "start":
				r == null || typeof r == "function" || typeof r == "symbol" || isNaN(r) ? e.removeAttribute(n) : e.setAttribute(n, r);
				break;
			case "popover":
				$("beforetoggle", e), $("toggle", e), At(e, "popover", r);
				break;
			case "xlinkActuate":
				Mt(e, "http://www.w3.org/1999/xlink", "xlink:actuate", r);
				break;
			case "xlinkArcrole":
				Mt(e, "http://www.w3.org/1999/xlink", "xlink:arcrole", r);
				break;
			case "xlinkRole":
				Mt(e, "http://www.w3.org/1999/xlink", "xlink:role", r);
				break;
			case "xlinkShow":
				Mt(e, "http://www.w3.org/1999/xlink", "xlink:show", r);
				break;
			case "xlinkTitle":
				Mt(e, "http://www.w3.org/1999/xlink", "xlink:title", r);
				break;
			case "xlinkType":
				Mt(e, "http://www.w3.org/1999/xlink", "xlink:type", r);
				break;
			case "xmlBase":
				Mt(e, "http://www.w3.org/XML/1998/namespace", "xml:base", r);
				break;
			case "xmlLang":
				Mt(e, "http://www.w3.org/XML/1998/namespace", "xml:lang", r);
				break;
			case "xmlSpace":
				Mt(e, "http://www.w3.org/XML/1998/namespace", "xml:space", r);
				break;
			case "is":
				At(e, "is", r);
				break;
			case "innerText":
			case "textContent": break;
			default: (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") && (n = R.get(n) || n, At(e, n, r));
		}
	}
	function Nd(e, t, n, r, a, o) {
		switch (n) {
			case "style":
				Yt(e, r, o);
				break;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(i(61));
					if (n = r.__html, n != null) {
						if (a.children != null) throw Error(i(60));
						e.innerHTML = n;
					}
				}
				break;
			case "children":
				typeof r == "string" ? qt(e, r) : (typeof r == "number" || typeof r == "bigint") && qt(e, "" + r);
				break;
			case "onScroll":
				r != null && $("scroll", e);
				break;
			case "onScrollEnd":
				r != null && $("scrollend", e);
				break;
			case "onClick":
				r != null && (e.onclick = $t);
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "innerHTML":
			case "ref": break;
			case "innerText":
			case "textContent": break;
			default: if (!wt.hasOwnProperty(n)) a: {
				if (n[0] === "o" && n[1] === "n" && (a = n.endsWith("Capture"), t = n.slice(2, a ? n.length - 7 : void 0), o = e[k] || null, o = o == null ? null : o[n], typeof o == "function" && e.removeEventListener(t, o, a), typeof r == "function")) {
					typeof o != "function" && o !== null && (n in e ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(t, r, a);
					break a;
				}
				n in e ? e[n] = r : !0 === r ? e.setAttribute(n, "") : At(e, n, r);
			}
		}
	}
	function Pd(e, t, n) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "img":
				$("error", e), $("load", e);
				var r = !1, a = !1, o;
				for (o in n) if (n.hasOwnProperty(o)) {
					var s = n[o];
					if (s != null) switch (o) {
						case "src":
							r = !0;
							break;
						case "srcSet":
							a = !0;
							break;
						case "children":
						case "dangerouslySetInnerHTML": throw Error(i(137, t));
						default: Md(e, t, o, s, n, null);
					}
				}
				a && Md(e, t, "srcSet", n.srcSet, n, null), r && Md(e, t, "src", n.src, n, null);
				return;
			case "input":
				$("invalid", e);
				var c = o = s = a = null, l = null, u = null;
				for (r in n) if (n.hasOwnProperty(r)) {
					var d = n[r];
					if (d != null) switch (r) {
						case "name":
							a = d;
							break;
						case "type":
							s = d;
							break;
						case "checked":
							l = d;
							break;
						case "defaultChecked":
							u = d;
							break;
						case "value":
							o = d;
							break;
						case "defaultValue":
							c = d;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (d != null) throw Error(i(137, t));
							break;
						default: Md(e, t, r, d, n, null);
					}
				}
				Ht(e, o, c, l, u, s, a, !1);
				return;
			case "select":
				for (a in $("invalid", e), r = s = o = null, n) if (n.hasOwnProperty(a) && (c = n[a], c != null)) switch (a) {
					case "value":
						o = c;
						break;
					case "defaultValue":
						s = c;
						break;
					case "multiple": r = c;
					default: Md(e, t, a, c, n, null);
				}
				t = o, n = s, e.multiple = !!r, t == null ? n != null && Wt(e, !!r, n, !0) : Wt(e, !!r, t, !1);
				return;
			case "textarea":
				for (s in $("invalid", e), o = a = r = null, n) if (n.hasOwnProperty(s) && (c = n[s], c != null)) switch (s) {
					case "value":
						r = c;
						break;
					case "defaultValue":
						a = c;
						break;
					case "children":
						o = c;
						break;
					case "dangerouslySetInnerHTML":
						if (c != null) throw Error(i(91));
						break;
					default: Md(e, t, s, c, n, null);
				}
				Kt(e, r, a, o);
				return;
			case "option":
				for (l in n) if (n.hasOwnProperty(l) && (r = n[l], r != null)) switch (l) {
					case "selected":
						e.selected = r && typeof r != "function" && typeof r != "symbol";
						break;
					default: Md(e, t, l, r, n, null);
				}
				return;
			case "dialog":
				$("beforetoggle", e), $("toggle", e), $("cancel", e), $("close", e);
				break;
			case "iframe":
			case "object":
				$("load", e);
				break;
			case "video":
			case "audio":
				for (r = 0; r < gd.length; r++) $(gd[r], e);
				break;
			case "image":
				$("error", e), $("load", e);
				break;
			case "details":
				$("toggle", e);
				break;
			case "embed":
			case "source":
			case "link": $("error", e), $("load", e);
			case "area":
			case "base":
			case "br":
			case "col":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "track":
			case "wbr":
			case "menuitem":
				for (u in n) if (n.hasOwnProperty(u) && (r = n[u], r != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML": throw Error(i(137, t));
					default: Md(e, t, u, r, n, null);
				}
				return;
			default: if (Xt(t)) {
				for (d in n) n.hasOwnProperty(d) && (r = n[d], r !== void 0 && Nd(e, t, d, r, n, void 0));
				return;
			}
		}
		for (c in n) n.hasOwnProperty(c) && (r = n[c], r != null && Md(e, t, c, r, n, null));
	}
	function Fd(e, t, n, r) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "input":
				var a = null, o = null, s = null, c = null, l = null, u = null, d = null;
				for (m in n) {
					var f = n[m];
					if (n.hasOwnProperty(m) && f != null) switch (m) {
						case "checked": break;
						case "value": break;
						case "defaultValue": l = f;
						default: r.hasOwnProperty(m) || Md(e, t, m, null, r, f);
					}
				}
				for (var p in r) {
					var m = r[p];
					if (f = n[p], r.hasOwnProperty(p) && (m != null || f != null)) switch (p) {
						case "type":
							o = m;
							break;
						case "name":
							a = m;
							break;
						case "checked":
							u = m;
							break;
						case "defaultChecked":
							d = m;
							break;
						case "value":
							s = m;
							break;
						case "defaultValue":
							c = m;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (m != null) throw Error(i(137, t));
							break;
						default: m !== f && Md(e, t, p, m, r, f);
					}
				}
				Vt(e, s, c, l, u, d, o, a);
				return;
			case "select":
				for (o in m = s = c = p = null, n) if (l = n[o], n.hasOwnProperty(o) && l != null) switch (o) {
					case "value": break;
					case "multiple": m = l;
					default: r.hasOwnProperty(o) || Md(e, t, o, null, r, l);
				}
				for (a in r) if (o = r[a], l = n[a], r.hasOwnProperty(a) && (o != null || l != null)) switch (a) {
					case "value":
						p = o;
						break;
					case "defaultValue":
						c = o;
						break;
					case "multiple": s = o;
					default: o !== l && Md(e, t, a, o, r, l);
				}
				t = c, n = s, r = m, p == null ? !!r != !!n && (t == null ? Wt(e, !!n, n ? [] : "", !1) : Wt(e, !!n, t, !0)) : Wt(e, !!n, p, !1);
				return;
			case "textarea":
				for (c in m = p = null, n) if (a = n[c], n.hasOwnProperty(c) && a != null && !r.hasOwnProperty(c)) switch (c) {
					case "value": break;
					case "children": break;
					default: Md(e, t, c, null, r, a);
				}
				for (s in r) if (a = r[s], o = n[s], r.hasOwnProperty(s) && (a != null || o != null)) switch (s) {
					case "value":
						p = a;
						break;
					case "defaultValue":
						m = a;
						break;
					case "children": break;
					case "dangerouslySetInnerHTML":
						if (a != null) throw Error(i(91));
						break;
					default: a !== o && Md(e, t, s, a, r, o);
				}
				Gt(e, p, m);
				return;
			case "option":
				for (var h in n) if (p = n[h], n.hasOwnProperty(h) && p != null && !r.hasOwnProperty(h)) switch (h) {
					case "selected":
						e.selected = !1;
						break;
					default: Md(e, t, h, null, r, p);
				}
				for (l in r) if (p = r[l], m = n[l], r.hasOwnProperty(l) && p !== m && (p != null || m != null)) switch (l) {
					case "selected":
						e.selected = p && typeof p != "function" && typeof p != "symbol";
						break;
					default: Md(e, t, l, p, r, m);
				}
				return;
			case "img":
			case "link":
			case "area":
			case "base":
			case "br":
			case "col":
			case "embed":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "source":
			case "track":
			case "wbr":
			case "menuitem":
				for (var g in n) p = n[g], n.hasOwnProperty(g) && p != null && !r.hasOwnProperty(g) && Md(e, t, g, null, r, p);
				for (u in r) if (p = r[u], m = n[u], r.hasOwnProperty(u) && p !== m && (p != null || m != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML":
						if (p != null) throw Error(i(137, t));
						break;
					default: Md(e, t, u, p, r, m);
				}
				return;
			default: if (Xt(t)) {
				for (var _ in n) p = n[_], n.hasOwnProperty(_) && p !== void 0 && !r.hasOwnProperty(_) && Nd(e, t, _, void 0, r, p);
				for (d in r) p = r[d], m = n[d], !r.hasOwnProperty(d) || p === m || p === void 0 && m === void 0 || Nd(e, t, d, p, r, m);
				return;
			}
		}
		for (var v in n) p = n[v], n.hasOwnProperty(v) && p != null && !r.hasOwnProperty(v) && Md(e, t, v, null, r, p);
		for (f in r) p = r[f], m = n[f], !r.hasOwnProperty(f) || p === m || p == null && m == null || Md(e, t, f, p, r, m);
	}
	function Id(e) {
		switch (e) {
			case "css":
			case "script":
			case "font":
			case "img":
			case "image":
			case "input":
			case "link": return !0;
			default: return !1;
		}
	}
	function Ld() {
		if (typeof performance.getEntriesByType == "function") {
			for (var e = 0, t = 0, n = performance.getEntriesByType("resource"), r = 0; r < n.length; r++) {
				var i = n[r], a = i.transferSize, o = i.initiatorType, s = i.duration;
				if (a && s && Id(o)) {
					for (o = 0, s = i.responseEnd, r += 1; r < n.length; r++) {
						var c = n[r], l = c.startTime;
						if (l > s) break;
						var u = c.transferSize, d = c.initiatorType;
						u && Id(d) && (c = c.responseEnd, o += u * (c < s ? 1 : (s - l) / (c - l)));
					}
					if (--r, t += 8 * (a + o) / (i.duration / 1e3), e++, 10 < e) break;
				}
			}
			if (0 < e) return t / e / 1e6;
		}
		return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
	}
	var Rd = null, zd = null;
	function Bd(e) {
		return e.nodeType === 9 ? e : e.ownerDocument;
	}
	function Vd(e) {
		switch (e) {
			case "http://www.w3.org/2000/svg": return 1;
			case "http://www.w3.org/1998/Math/MathML": return 2;
			default: return 0;
		}
	}
	function Hd(e, t) {
		if (e === 0) switch (t) {
			case "svg": return 1;
			case "math": return 2;
			default: return 0;
		}
		return e === 1 && t === "foreignObject" ? 0 : e;
	}
	function Ud(e, t) {
		return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
	}
	var Wd = null;
	function Gd() {
		var e = window.event;
		return e && e.type === "popstate" ? e === Wd ? !1 : (Wd = e, !0) : (Wd = null, !1);
	}
	var Kd = typeof setTimeout == "function" ? setTimeout : void 0, qd = typeof clearTimeout == "function" ? clearTimeout : void 0, Jd = typeof Promise == "function" ? Promise : void 0, Yd = typeof queueMicrotask == "function" ? queueMicrotask : Jd === void 0 ? Kd : function(e) {
		return Jd.resolve(null).then(e).catch(Xd);
	};
	function Xd(e) {
		setTimeout(function() {
			throw e;
		});
	}
	function Zd(e) {
		return e === "head";
	}
	function Qd(e, t) {
		var n = t, r = 0;
		do {
			var i = n.nextSibling;
			if (e.removeChild(n), i && i.nodeType === 8) if (n = i.data, n === "/$" || n === "/&") {
				if (r === 0) {
					e.removeChild(i), Np(t);
					return;
				}
				r--;
			} else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&") r++;
			else if (n === "html") pf(e.ownerDocument.documentElement);
			else if (n === "head") {
				n = e.ownerDocument.head, pf(n);
				for (var a = n.firstChild; a;) {
					var o = a.nextSibling, s = a.nodeName;
					a[bt] || s === "SCRIPT" || s === "STYLE" || s === "LINK" && a.rel.toLowerCase() === "stylesheet" || n.removeChild(a), a = o;
				}
			} else n === "body" && pf(e.ownerDocument.body);
			n = i;
		} while (n);
		Np(t);
	}
	function $d(e, t) {
		var n = e;
		e = 0;
		do {
			var r = n.nextSibling;
			if (n.nodeType === 1 ? t ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (t ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), r && r.nodeType === 8) if (n = r.data, n === "/$") {
				if (e === 0) break;
				e--;
			} else n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || e++;
			n = r;
		} while (n);
	}
	function ef(e) {
		var t = e.firstChild;
		for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
			var n = t;
			switch (t = t.nextSibling, n.nodeName) {
				case "HTML":
				case "HEAD":
				case "BODY":
					ef(n), xt(n);
					continue;
				case "SCRIPT":
				case "STYLE": continue;
				case "LINK": if (n.rel.toLowerCase() === "stylesheet") continue;
			}
			e.removeChild(n);
		}
	}
	function tf(e, t, n, r) {
		for (; e.nodeType === 1;) {
			var i = n;
			if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
				if (!r && (e.nodeName !== "INPUT" || e.type !== "hidden")) break;
			} else if (!r) if (t === "input" && e.type === "hidden") {
				var a = i.name == null ? null : "" + i.name;
				if (i.type === "hidden" && e.getAttribute("name") === a) return e;
			} else return e;
			else if (!e[bt]) switch (t) {
				case "meta":
					if (!e.hasAttribute("itemprop")) break;
					return e;
				case "link":
					if (a = e.getAttribute("rel"), a === "stylesheet" && e.hasAttribute("data-precedence") || a !== i.rel || e.getAttribute("href") !== (i.href == null || i.href === "" ? null : i.href) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin) || e.getAttribute("title") !== (i.title == null ? null : i.title)) break;
					return e;
				case "style":
					if (e.hasAttribute("data-precedence")) break;
					return e;
				case "script":
					if (a = e.getAttribute("src"), (a !== (i.src == null ? null : i.src) || e.getAttribute("type") !== (i.type == null ? null : i.type) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin)) && a && e.hasAttribute("async") && !e.hasAttribute("itemprop")) break;
					return e;
				default: return e;
			}
			if (e = cf(e.nextSibling), e === null) break;
		}
		return null;
	}
	function nf(e, t, n) {
		if (t === "") return null;
		for (; e.nodeType !== 3;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !n || (e = cf(e.nextSibling), e === null)) return null;
		return e;
	}
	function rf(e, t) {
		for (; e.nodeType !== 8;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = cf(e.nextSibling), e === null)) return null;
		return e;
	}
	function af(e) {
		return e.data === "$?" || e.data === "$~";
	}
	function of(e) {
		return e.data === "$!" || e.data === "$?" && e.ownerDocument.readyState !== "loading";
	}
	function sf(e, t) {
		var n = e.ownerDocument;
		if (e.data === "$~") e._reactRetry = t;
		else if (e.data !== "$?" || n.readyState !== "loading") t();
		else {
			var r = function() {
				t(), n.removeEventListener("DOMContentLoaded", r);
			};
			n.addEventListener("DOMContentLoaded", r), e._reactRetry = r;
		}
	}
	function cf(e) {
		for (; e != null; e = e.nextSibling) {
			var t = e.nodeType;
			if (t === 1 || t === 3) break;
			if (t === 8) {
				if (t = e.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F") break;
				if (t === "/$" || t === "/&") return null;
			}
		}
		return e;
	}
	var lf = null;
	function uf(e) {
		e = e.nextSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "/$" || n === "/&") {
					if (t === 0) return cf(e.nextSibling);
					t--;
				} else n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || t++;
			}
			e = e.nextSibling;
		}
		return null;
	}
	function df(e) {
		e = e.previousSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
					if (t === 0) return e;
					t--;
				} else n !== "/$" && n !== "/&" || t++;
			}
			e = e.previousSibling;
		}
		return null;
	}
	function ff(e, t, n) {
		switch (t = Bd(n), e) {
			case "html":
				if (e = t.documentElement, !e) throw Error(i(452));
				return e;
			case "head":
				if (e = t.head, !e) throw Error(i(453));
				return e;
			case "body":
				if (e = t.body, !e) throw Error(i(454));
				return e;
			default: throw Error(i(451));
		}
	}
	function pf(e) {
		for (var t = e.attributes; t.length;) e.removeAttributeNode(t[0]);
		xt(e);
	}
	var mf = /* @__PURE__ */ new Map(), hf = /* @__PURE__ */ new Set();
	function gf(e) {
		return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
	}
	var _f = E.d;
	E.d = {
		f: vf,
		r: yf,
		D: Sf,
		C: Cf,
		L: wf,
		m: Tf,
		X: Df,
		S: Ef,
		M: Of
	};
	function vf() {
		var e = _f.f(), t = vu();
		return e || t;
	}
	function yf(e) {
		var t = St(e);
		t !== null && t.tag === 5 && t.type === "form" ? _s(t) : _f.r(e);
	}
	var bf = typeof document > "u" ? null : document;
	function xf(e, t, n) {
		var r = bf;
		if (r && typeof t == "string" && t) {
			var i = Bt(t);
			i = "link[rel=\"" + e + "\"][href=\"" + i + "\"]", typeof n == "string" && (i += "[crossorigin=\"" + n + "\"]"), hf.has(i) || (hf.add(i), e = {
				rel: e,
				crossOrigin: n,
				href: t
			}, r.querySelector(i) === null && (t = r.createElement("link"), Pd(t, "link", e), P(t), r.head.appendChild(t)));
		}
	}
	function Sf(e) {
		_f.D(e), xf("dns-prefetch", e, null);
	}
	function Cf(e, t) {
		_f.C(e, t), xf("preconnect", e, t);
	}
	function wf(e, t, n) {
		_f.L(e, t, n);
		var r = bf;
		if (r && e && t) {
			var i = "link[rel=\"preload\"][as=\"" + Bt(t) + "\"]";
			t === "image" && n && n.imageSrcSet ? (i += "[imagesrcset=\"" + Bt(n.imageSrcSet) + "\"]", typeof n.imageSizes == "string" && (i += "[imagesizes=\"" + Bt(n.imageSizes) + "\"]")) : i += "[href=\"" + Bt(e) + "\"]";
			var a = i;
			switch (t) {
				case "style":
					a = Af(e);
					break;
				case "script": a = Pf(e);
			}
			mf.has(a) || (e = h({
				rel: "preload",
				href: t === "image" && n && n.imageSrcSet ? void 0 : e,
				as: t
			}, n), mf.set(a, e), r.querySelector(i) !== null || t === "style" && r.querySelector(jf(a)) || t === "script" && r.querySelector(Ff(a)) || (t = r.createElement("link"), Pd(t, "link", e), P(t), r.head.appendChild(t)));
		}
	}
	function Tf(e, t) {
		_f.m(e, t);
		var n = bf;
		if (n && e) {
			var r = t && typeof t.as == "string" ? t.as : "script", i = "link[rel=\"modulepreload\"][as=\"" + Bt(r) + "\"][href=\"" + Bt(e) + "\"]", a = i;
			switch (r) {
				case "audioworklet":
				case "paintworklet":
				case "serviceworker":
				case "sharedworker":
				case "worker":
				case "script": a = Pf(e);
			}
			if (!mf.has(a) && (e = h({
				rel: "modulepreload",
				href: e
			}, t), mf.set(a, e), n.querySelector(i) === null)) {
				switch (r) {
					case "audioworklet":
					case "paintworklet":
					case "serviceworker":
					case "sharedworker":
					case "worker":
					case "script": if (n.querySelector(Ff(a))) return;
				}
				r = n.createElement("link"), Pd(r, "link", e), P(r), n.head.appendChild(r);
			}
		}
	}
	function Ef(e, t, n) {
		_f.S(e, t, n);
		var r = bf;
		if (r && e) {
			var i = N(r).hoistableStyles, a = Af(e);
			t ||= "default";
			var o = i.get(a);
			if (!o) {
				var s = {
					loading: 0,
					preload: null
				};
				if (o = r.querySelector(jf(a))) s.loading = 5;
				else {
					e = h({
						rel: "stylesheet",
						href: e,
						"data-precedence": t
					}, n), (n = mf.get(a)) && Rf(e, n);
					var c = o = r.createElement("link");
					P(c), Pd(c, "link", e), c._p = new Promise(function(e, t) {
						c.onload = e, c.onerror = t;
					}), c.addEventListener("load", function() {
						s.loading |= 1;
					}), c.addEventListener("error", function() {
						s.loading |= 2;
					}), s.loading |= 4, Lf(o, t, r);
				}
				o = {
					type: "stylesheet",
					instance: o,
					count: 1,
					state: s
				}, i.set(a, o);
			}
		}
	}
	function Df(e, t) {
		_f.X(e, t);
		var n = bf;
		if (n && e) {
			var r = N(n).hoistableScripts, i = Pf(e), a = r.get(i);
			a || (a = n.querySelector(Ff(i)), a || (e = h({
				src: e,
				async: !0
			}, t), (t = mf.get(i)) && zf(e, t), a = n.createElement("script"), P(a), Pd(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function Of(e, t) {
		_f.M(e, t);
		var n = bf;
		if (n && e) {
			var r = N(n).hoistableScripts, i = Pf(e), a = r.get(i);
			a || (a = n.querySelector(Ff(i)), a || (e = h({
				src: e,
				async: !0,
				type: "module"
			}, t), (t = mf.get(i)) && zf(e, t), a = n.createElement("script"), P(a), Pd(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function kf(e, t, n, r) {
		var a = (a = ve.current) ? gf(a) : null;
		if (!a) throw Error(i(446));
		switch (e) {
			case "meta":
			case "title": return null;
			case "style": return typeof n.precedence == "string" && typeof n.href == "string" ? (t = Af(n.href), n = N(a).hoistableStyles, r = n.get(t), r || (r = {
				type: "style",
				instance: null,
				count: 0,
				state: null
			}, n.set(t, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			case "link":
				if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
					e = Af(n.href);
					var o = N(a).hoistableStyles, s = o.get(e);
					if (s || (a = a.ownerDocument || a, s = {
						type: "stylesheet",
						instance: null,
						count: 0,
						state: {
							loading: 0,
							preload: null
						}
					}, o.set(e, s), (o = a.querySelector(jf(e))) && !o._p && (s.instance = o, s.state.loading = 5), mf.has(e) || (n = {
						rel: "preload",
						as: "style",
						href: n.href,
						crossOrigin: n.crossOrigin,
						integrity: n.integrity,
						media: n.media,
						hrefLang: n.hrefLang,
						referrerPolicy: n.referrerPolicy
					}, mf.set(e, n), o || Nf(a, e, n, s.state))), t && r === null) throw Error(i(528, ""));
					return s;
				}
				if (t && r !== null) throw Error(i(529, ""));
				return null;
			case "script": return t = n.async, n = n.src, typeof n == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = Pf(n), n = N(a).hoistableScripts, r = n.get(t), r || (r = {
				type: "script",
				instance: null,
				count: 0,
				state: null
			}, n.set(t, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			default: throw Error(i(444, e));
		}
	}
	function Af(e) {
		return "href=\"" + Bt(e) + "\"";
	}
	function jf(e) {
		return "link[rel=\"stylesheet\"][" + e + "]";
	}
	function Mf(e) {
		return h({}, e, {
			"data-precedence": e.precedence,
			precedence: null
		});
	}
	function Nf(e, t, n, r) {
		e.querySelector("link[rel=\"preload\"][as=\"style\"][" + t + "]") ? r.loading = 1 : (t = e.createElement("link"), r.preload = t, t.addEventListener("load", function() {
			return r.loading |= 1;
		}), t.addEventListener("error", function() {
			return r.loading |= 2;
		}), Pd(t, "link", n), P(t), e.head.appendChild(t));
	}
	function Pf(e) {
		return "[src=\"" + Bt(e) + "\"]";
	}
	function Ff(e) {
		return "script[async]" + e;
	}
	function If(e, t, n) {
		if (t.count++, t.instance === null) switch (t.type) {
			case "style":
				var r = e.querySelector("style[data-href~=\"" + Bt(n.href) + "\"]");
				if (r) return t.instance = r, P(r), r;
				var a = h({}, n, {
					"data-href": n.href,
					"data-precedence": n.precedence,
					href: null,
					precedence: null
				});
				return r = (e.ownerDocument || e).createElement("style"), P(r), Pd(r, "style", a), Lf(r, n.precedence, e), t.instance = r;
			case "stylesheet":
				a = Af(n.href);
				var o = e.querySelector(jf(a));
				if (o) return t.state.loading |= 4, t.instance = o, P(o), o;
				r = Mf(n), (a = mf.get(a)) && Rf(r, a), o = (e.ownerDocument || e).createElement("link"), P(o);
				var s = o;
				return s._p = new Promise(function(e, t) {
					s.onload = e, s.onerror = t;
				}), Pd(o, "link", r), t.state.loading |= 4, Lf(o, n.precedence, e), t.instance = o;
			case "script": return o = Pf(n.src), (a = e.querySelector(Ff(o))) ? (t.instance = a, P(a), a) : (r = n, (a = mf.get(o)) && (r = h({}, n), zf(r, a)), e = e.ownerDocument || e, a = e.createElement("script"), P(a), Pd(a, "link", r), e.head.appendChild(a), t.instance = a);
			case "void": return null;
			default: throw Error(i(443, t.type));
		}
		else t.type === "stylesheet" && !(t.state.loading & 4) && (r = t.instance, t.state.loading |= 4, Lf(r, n.precedence, e));
		return t.instance;
	}
	function Lf(e, t, n) {
		for (var r = n.querySelectorAll("link[rel=\"stylesheet\"][data-precedence],style[data-precedence]"), i = r.length ? r[r.length - 1] : null, a = i, o = 0; o < r.length; o++) {
			var s = r[o];
			if (s.dataset.precedence === t) a = s;
			else if (a !== i) break;
		}
		a ? a.parentNode.insertBefore(e, a.nextSibling) : (t = n.nodeType === 9 ? n.head : n, t.insertBefore(e, t.firstChild));
	}
	function Rf(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.title ??= t.title;
	}
	function zf(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.integrity ??= t.integrity;
	}
	var Bf = null;
	function Vf(e, t, n) {
		if (Bf === null) {
			var r = /* @__PURE__ */ new Map(), i = Bf = /* @__PURE__ */ new Map();
			i.set(n, r);
		} else i = Bf, r = i.get(n), r || (r = /* @__PURE__ */ new Map(), i.set(n, r));
		if (r.has(e)) return r;
		for (r.set(e, null), n = n.getElementsByTagName(e), i = 0; i < n.length; i++) {
			var a = n[i];
			if (!(a[bt] || a[gt] || e === "link" && a.getAttribute("rel") === "stylesheet") && a.namespaceURI !== "http://www.w3.org/2000/svg") {
				var o = a.getAttribute(t) || "";
				o = e + o;
				var s = r.get(o);
				s ? s.push(a) : r.set(o, [a]);
			}
		}
		return r;
	}
	function Hf(e, t, n) {
		e = e.ownerDocument || e, e.head.insertBefore(n, t === "title" ? e.querySelector("head > title") : null);
	}
	function Uf(e, t, n) {
		if (n === 1 || t.itemProp != null) return !1;
		switch (e) {
			case "meta":
			case "title": return !0;
			case "style":
				if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "") break;
				return !0;
			case "link":
				if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError) break;
				switch (t.rel) {
					case "stylesheet": return e = t.disabled, typeof t.precedence == "string" && e == null;
					default: return !0;
				}
			case "script": if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string") return !0;
		}
		return !1;
	}
	function Wf(e) {
		return !(e.type === "stylesheet" && !(e.state.loading & 3));
	}
	function Gf(e, t, n, r) {
		if (n.type === "stylesheet" && (typeof r.media != "string" || !1 !== matchMedia(r.media).matches) && !(n.state.loading & 4)) {
			if (n.instance === null) {
				var i = Af(r.href), a = t.querySelector(jf(i));
				if (a) {
					t = a._p, typeof t == "object" && t && typeof t.then == "function" && (e.count++, e = Jf.bind(e), t.then(e, e)), n.state.loading |= 4, n.instance = a, P(a);
					return;
				}
				a = t.ownerDocument || t, r = Mf(r), (i = mf.get(i)) && Rf(r, i), a = a.createElement("link"), P(a);
				var o = a;
				o._p = new Promise(function(e, t) {
					o.onload = e, o.onerror = t;
				}), Pd(a, "link", r), n.instance = a;
			}
			e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(n, t), (t = n.state.preload) && !(n.state.loading & 3) && (e.count++, n = Jf.bind(e), t.addEventListener("load", n), t.addEventListener("error", n));
		}
	}
	var Kf = 0;
	function qf(e, t) {
		return e.stylesheets && e.count === 0 && Xf(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(n) {
			var r = setTimeout(function() {
				if (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, 6e4 + t);
			0 < e.imgBytes && Kf === 0 && (Kf = 62500 * Ld());
			var i = setTimeout(function() {
				if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend)) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, (e.imgBytes > Kf ? 50 : 800) + t);
			return e.unsuspend = n, function() {
				e.unsuspend = null, clearTimeout(r), clearTimeout(i);
			};
		} : null;
	}
	function Jf() {
		if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
			if (this.stylesheets) Xf(this, this.stylesheets);
			else if (this.unsuspend) {
				var e = this.unsuspend;
				this.unsuspend = null, e();
			}
		}
	}
	var Yf = null;
	function Xf(e, t) {
		e.stylesheets = null, e.unsuspend !== null && (e.count++, Yf = /* @__PURE__ */ new Map(), t.forEach(Zf, e), Yf = null, Jf.call(e));
	}
	function Zf(e, t) {
		if (!(t.state.loading & 4)) {
			var n = Yf.get(e);
			if (n) var r = n.get(null);
			else {
				n = /* @__PURE__ */ new Map(), Yf.set(e, n);
				for (var i = e.querySelectorAll("link[data-precedence],style[data-precedence]"), a = 0; a < i.length; a++) {
					var o = i[a];
					(o.nodeName === "LINK" || o.getAttribute("media") !== "not all") && (n.set(o.dataset.precedence, o), r = o);
				}
				r && n.set(null, r);
			}
			i = t.instance, o = i.getAttribute("data-precedence"), a = n.get(o) || r, a === r && n.set(null, i), n.set(o, i), this.count++, r = Jf.bind(this), i.addEventListener("load", r), i.addEventListener("error", r), a ? a.parentNode.insertBefore(i, a.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(i, e.firstChild)), t.state.loading |= 4;
		}
	}
	var Qf = {
		$$typeof: S,
		Provider: null,
		Consumer: null,
		_currentValue: de,
		_currentValue2: de,
		_threadCount: 0
	};
	function $f(e, t, n, r, i, a, o, s, c) {
		this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = at(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = at(0), this.hiddenUpdates = at(null), this.identifierPrefix = r, this.onUncaughtError = i, this.onCaughtError = a, this.onRecoverableError = o, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = c, this.incompleteTransitions = /* @__PURE__ */ new Map();
	}
	function ep(e, t, n, r, i, a, o, s, c, l, u, d) {
		return e = new $f(e, t, n, o, c, l, u, d, s), t = 1, !0 === a && (t |= 24), a = G(3, null, null, t), e.current = a, a.stateNode = e, t = Zi(), t.refCount++, e.pooledCache = t, t.refCount++, a.memoizedState = {
			element: r,
			isDehydrated: n,
			cache: t
		}, ka(a), e;
	}
	function tp(e) {
		return e ? (e = W, e) : W;
	}
	function np(e, t, n, r, i, a) {
		i = tp(i), r.context === null ? r.context = i : r.pendingContext = i, r = ja(t), r.payload = { element: n }, a = a === void 0 ? null : a, a !== null && (r.callback = a), n = Ma(e, r, t), n !== null && (pu(n, e, t), Na(n, e, t));
	}
	function rp(e, t) {
		if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
			var n = e.retryLane;
			e.retryLane = n !== 0 && n < t ? n : t;
		}
	}
	function ip(e, t) {
		rp(e, t), (e = e.alternate) && rp(e, t);
	}
	function ap(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = Qr(e, 67108864);
			t !== null && pu(t, e, 67108864), ip(e, 67108864);
		}
	}
	function op(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = du();
			t = dt(t);
			var n = Qr(e, t);
			n !== null && pu(n, e, t), ip(e, t);
		}
	}
	var sp = !0;
	function cp(e, t, n, r) {
		var i = T.T;
		T.T = null;
		var a = E.p;
		try {
			E.p = 2, up(e, t, n, r);
		} finally {
			E.p = a, T.T = i;
		}
	}
	function lp(e, t, n, r) {
		var i = T.T;
		T.T = null;
		var a = E.p;
		try {
			E.p = 8, up(e, t, n, r);
		} finally {
			E.p = a, T.T = i;
		}
	}
	function up(e, t, n, r) {
		if (sp) {
			var i = dp(r);
			if (i === null) Cd(e, t, r, fp, n), Cp(e, r);
			else if (Tp(i, e, t, n, r)) r.stopPropagation();
			else if (Cp(e, r), t & 4 && -1 < Sp.indexOf(e)) {
				for (; i !== null;) {
					var a = St(i);
					if (a !== null) switch (a.tag) {
						case 3:
							if (a = a.stateNode, a.current.memoizedState.isDehydrated) {
								var o = et(a.pendingLanes);
								if (o !== 0) {
									var s = a;
									for (s.pendingLanes |= 2, s.entangledLanes |= 2; o;) {
										var c = 1 << 31 - qe(o);
										s.entanglements[1] |= c, o &= ~c;
									}
									nd(a), !(Ml & 6) && ($l = Fe() + 500, rd(0, !1));
								}
							}
							break;
						case 31:
						case 13: s = Qr(a, 2), s !== null && pu(s, a, 2), vu(), ip(a, 2);
					}
					if (a = dp(r), a === null && Cd(e, t, r, fp, n), a === i) break;
					i = a;
				}
				i !== null && r.stopPropagation();
			} else Cd(e, t, r, null, n);
		}
	}
	function dp(e) {
		return e = tn(e), pp(e);
	}
	var fp = null;
	function pp(e) {
		if (fp = null, e = M(e), e !== null) {
			var t = o(e);
			if (t === null) e = null;
			else {
				var n = t.tag;
				if (n === 13) {
					if (e = s(t), e !== null) return e;
					e = null;
				} else if (n === 31) {
					if (e = c(t), e !== null) return e;
					e = null;
				} else if (n === 3) {
					if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
					e = null;
				} else t !== e && (e = null);
			}
		}
		return fp = e, null;
	}
	function mp(e) {
		switch (e) {
			case "beforetoggle":
			case "cancel":
			case "click":
			case "close":
			case "contextmenu":
			case "copy":
			case "cut":
			case "auxclick":
			case "dblclick":
			case "dragend":
			case "dragstart":
			case "drop":
			case "focusin":
			case "focusout":
			case "input":
			case "invalid":
			case "keydown":
			case "keypress":
			case "keyup":
			case "mousedown":
			case "mouseup":
			case "paste":
			case "pause":
			case "play":
			case "pointercancel":
			case "pointerdown":
			case "pointerup":
			case "ratechange":
			case "reset":
			case "resize":
			case "seeked":
			case "submit":
			case "toggle":
			case "touchcancel":
			case "touchend":
			case "touchstart":
			case "volumechange":
			case "change":
			case "selectionchange":
			case "textInput":
			case "compositionstart":
			case "compositionend":
			case "compositionupdate":
			case "beforeblur":
			case "afterblur":
			case "beforeinput":
			case "blur":
			case "fullscreenchange":
			case "focus":
			case "hashchange":
			case "popstate":
			case "select":
			case "selectstart": return 2;
			case "drag":
			case "dragenter":
			case "dragexit":
			case "dragleave":
			case "dragover":
			case "mousemove":
			case "mouseout":
			case "mouseover":
			case "pointermove":
			case "pointerout":
			case "pointerover":
			case "scroll":
			case "touchmove":
			case "wheel":
			case "mouseenter":
			case "mouseleave":
			case "pointerenter":
			case "pointerleave": return 8;
			case "message": switch (Ie()) {
				case Le: return 2;
				case Re: return 8;
				case ze:
				case Be: return 32;
				case Ve: return 268435456;
				default: return 32;
			}
			default: return 32;
		}
	}
	var hp = !1, gp = null, _p = null, vp = null, yp = /* @__PURE__ */ new Map(), bp = /* @__PURE__ */ new Map(), xp = [], Sp = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
	function Cp(e, t) {
		switch (e) {
			case "focusin":
			case "focusout":
				gp = null;
				break;
			case "dragenter":
			case "dragleave":
				_p = null;
				break;
			case "mouseover":
			case "mouseout":
				vp = null;
				break;
			case "pointerover":
			case "pointerout":
				yp.delete(t.pointerId);
				break;
			case "gotpointercapture":
			case "lostpointercapture": bp.delete(t.pointerId);
		}
	}
	function wp(e, t, n, r, i, a) {
		return e === null || e.nativeEvent !== a ? (e = {
			blockedOn: t,
			domEventName: n,
			eventSystemFlags: r,
			nativeEvent: a,
			targetContainers: [i]
		}, t !== null && (t = St(t), t !== null && ap(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
	}
	function Tp(e, t, n, r, i) {
		switch (t) {
			case "focusin": return gp = wp(gp, e, t, n, r, i), !0;
			case "dragenter": return _p = wp(_p, e, t, n, r, i), !0;
			case "mouseover": return vp = wp(vp, e, t, n, r, i), !0;
			case "pointerover":
				var a = i.pointerId;
				return yp.set(a, wp(yp.get(a) || null, e, t, n, r, i)), !0;
			case "gotpointercapture": return a = i.pointerId, bp.set(a, wp(bp.get(a) || null, e, t, n, r, i)), !0;
		}
		return !1;
	}
	function Ep(e) {
		var t = M(e.target);
		if (t !== null) {
			var n = o(t);
			if (n !== null) {
				if (t = n.tag, t === 13) {
					if (t = s(n), t !== null) {
						e.blockedOn = t, mt(e.priority, function() {
							op(n);
						});
						return;
					}
				} else if (t === 31) {
					if (t = c(n), t !== null) {
						e.blockedOn = t, mt(e.priority, function() {
							op(n);
						});
						return;
					}
				} else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
					e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
					return;
				}
			}
		}
		e.blockedOn = null;
	}
	function Dp(e) {
		if (e.blockedOn !== null) return !1;
		for (var t = e.targetContainers; 0 < t.length;) {
			var n = dp(e.nativeEvent);
			if (n === null) {
				n = e.nativeEvent;
				var r = new n.constructor(n.type, n);
				en = r, n.target.dispatchEvent(r), en = null;
			} else return t = St(n), t !== null && ap(t), e.blockedOn = n, !1;
			t.shift();
		}
		return !0;
	}
	function Op(e, t, n) {
		Dp(e) && n.delete(t);
	}
	function kp() {
		hp = !1, gp !== null && Dp(gp) && (gp = null), _p !== null && Dp(_p) && (_p = null), vp !== null && Dp(vp) && (vp = null), yp.forEach(Op), bp.forEach(Op);
	}
	function Ap(e, n) {
		e.blockedOn === n && (e.blockedOn = null, hp || (hp = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, kp)));
	}
	var jp = null;
	function Mp(e) {
		jp !== e && (jp = e, t.unstable_scheduleCallback(t.unstable_NormalPriority, function() {
			jp === e && (jp = null);
			for (var t = 0; t < e.length; t += 3) {
				var n = e[t], r = e[t + 1], i = e[t + 2];
				if (typeof r != "function") {
					if (pp(r || n) === null) continue;
					break;
				}
				var a = St(n);
				a !== null && (e.splice(t, 3), t -= 3, hs(a, {
					pending: !0,
					data: i,
					method: n.method,
					action: r
				}, r, i));
			}
		}));
	}
	function Np(e) {
		function t(t) {
			return Ap(t, e);
		}
		gp !== null && Ap(gp, e), _p !== null && Ap(_p, e), vp !== null && Ap(vp, e), yp.forEach(t), bp.forEach(t);
		for (var n = 0; n < xp.length; n++) {
			var r = xp[n];
			r.blockedOn === e && (r.blockedOn = null);
		}
		for (; 0 < xp.length && (n = xp[0], n.blockedOn === null);) Ep(n), n.blockedOn === null && xp.shift();
		if (n = (e.ownerDocument || e).$$reactFormReplay, n != null) for (r = 0; r < n.length; r += 3) {
			var i = n[r], a = n[r + 1], o = i[k] || null;
			if (typeof a == "function") o || Mp(n);
			else if (o) {
				var s = null;
				if (a && a.hasAttribute("formAction")) {
					if (i = a, o = a[k] || null) s = o.formAction;
					else if (pp(i) !== null) continue;
				} else s = o.action;
				typeof s == "function" ? n[r + 1] = s : (n.splice(r, 3), r -= 3), Mp(n);
			}
		}
	}
	function Pp() {
		function e(e) {
			e.canIntercept && e.info === "react-transition" && e.intercept({
				handler: function() {
					return new Promise(function(e) {
						return i = e;
					});
				},
				focusReset: "manual",
				scroll: "manual"
			});
		}
		function t() {
			i !== null && (i(), i = null), r || setTimeout(n, 20);
		}
		function n() {
			if (!r && !navigation.transition) {
				var e = navigation.currentEntry;
				e && e.url != null && navigation.navigate(e.url, {
					state: e.getState(),
					info: "react-transition",
					history: "replace"
				});
			}
		}
		if (typeof navigation == "object") {
			var r = !1, i = null;
			return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(n, 100), function() {
				r = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), i !== null && (i(), i = null);
			};
		}
	}
	function Fp(e) {
		this._internalRoot = e;
	}
	Ip.prototype.render = Fp.prototype.render = function(e) {
		var t = this._internalRoot;
		if (t === null) throw Error(i(409));
		var n = t.current;
		np(n, du(), e, t, null, null);
	}, Ip.prototype.unmount = Fp.prototype.unmount = function() {
		var e = this._internalRoot;
		if (e !== null) {
			this._internalRoot = null;
			var t = e.containerInfo;
			np(e.current, 2, null, e, null, null), vu(), t[_t] = null;
		}
	};
	function Ip(e) {
		this._internalRoot = e;
	}
	Ip.prototype.unstable_scheduleHydration = function(e) {
		if (e) {
			var t = pt();
			e = {
				blockedOn: null,
				target: e,
				priority: t
			};
			for (var n = 0; n < xp.length && t !== 0 && t < xp[n].priority; n++);
			xp.splice(n, 0, e), n === 0 && Ep(e);
		}
	};
	var Lp = n.version;
	if (Lp !== "19.2.6") throw Error(i(527, Lp, "19.2.6"));
	E.findDOMNode = function(e) {
		var t = e._reactInternals;
		if (t === void 0) throw typeof e.render == "function" ? Error(i(188)) : (e = Object.keys(e).join(","), Error(i(268, e)));
		return e = d(t), e = e === null ? null : p(e), e = e === null ? null : e.stateNode, e;
	};
	var Rp = {
		bundleType: 0,
		version: "19.2.6",
		rendererPackageName: "react-dom",
		currentDispatcherRef: T,
		reconcilerVersion: "19.2.6"
	};
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
		var zp = __REACT_DEVTOOLS_GLOBAL_HOOK__;
		if (!zp.isDisabled && zp.supportsFiber) try {
			We = zp.inject(Rp), Ge = zp;
		} catch {}
	}
	e.createRoot = function(e, t) {
		if (!a(e)) throw Error(i(299));
		var n = !1, r = "", o = Rs, s = zs, c = Bs;
		return t != null && (!0 === t.unstable_strictMode && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onUncaughtError !== void 0 && (o = t.onUncaughtError), t.onCaughtError !== void 0 && (s = t.onCaughtError), t.onRecoverableError !== void 0 && (c = t.onRecoverableError)), t = ep(e, 1, !1, null, null, n, r, null, o, s, c, Pp), e[_t] = t.current, xd(e), new Fp(t);
	};
})), g = /* @__PURE__ */ o(((e, t) => {
	function n() {
		if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
			__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
		} catch (e) {
			console.error(e);
		}
	}
	n(), t.exports = h();
})), _ = /* @__PURE__ */ c(u(), 1), v = m(), y = g();
async function b(e, t, n = 1) {
	if (e.dataset.moving === "true") {
		t();
		return;
	}
	let r = e.querySelector(".room-active .drawer-svg, .hairline-stage svg");
	if (!r || matchMedia("(prefers-reduced-motion: reduce)").matches) {
		t();
		return;
	}
	e.dataset.moving = "true";
	let i = r.getBoundingClientRect(), a = Math.max(0, e.querySelector(".cabinet-brand")?.getBoundingClientRect().bottom ?? 0), o = document.createElement("div");
	o.className = "drawer-motion-layer", o.setAttribute("aria-hidden", "true"), Object.assign(o.style, {
		position: "fixed",
		inset: `${a}px 0 0`,
		overflow: "hidden",
		pointerEvents: "none",
		zIndex: "19"
	});
	let s = document.createElement("div");
	Object.assign(s.style, {
		position: "absolute",
		left: `${i.left}px`,
		top: `${i.top - a}px`,
		width: `${i.width}px`,
		height: `${i.height}px`
	});
	function c(e) {
		let t = e.cloneNode(!0), n = [e, ...e.querySelectorAll("*")], r = [t, ...t.querySelectorAll("*")];
		return n.forEach((e, t) => {
			let n = getComputedStyle(e), i = r[t];
			for (let e of [
				"fill",
				"stroke",
				"stroke-width",
				"stroke-dasharray",
				"font-family",
				"font-size",
				"font-weight",
				"color",
				"opacity",
				"visibility"
			]) i.style.setProperty(e, n.getPropertyValue(e));
		}), t.removeAttribute("id"), t.style.cssText += ";position:absolute;inset:0;width:100%;height:100%;max-height:none;min-height:0;visibility:visible;transform:none;", t;
	}
	let l = c(r);
	s.appendChild(l), o.appendChild(s), e.appendChild(o);
	let u = null, d = [], f = () => d.forEach((e) => e.cancel());
	try {
		if (t(), window.scrollTo({
			top: Math.max(0, e.getBoundingClientRect().top + window.scrollY),
			behavior: "instant"
		}), u = e.querySelector(".room-active .drawer-svg, .hairline-stage svg"), u && (u.style.visibility, u.style.visibility = "hidden"), await new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(() => e()))), u ??= e.querySelector(".room-active .drawer-svg, .hairline-stage svg"), !u) return;
		u.style.removeProperty("visibility");
		let r = u.getBoundingClientRect(), o = c(u);
		s.appendChild(o), u.style.visibility = "hidden";
		let p = {
			duration: 850,
			easing: "cubic-bezier(.22,.68,.14,1)",
			fill: "both"
		};
		d = [
			s.animate([{
				left: `${i.left}px`,
				top: `${i.top - a}px`,
				width: `${i.width}px`,
				height: `${i.height}px`
			}, {
				left: `${r.left}px`,
				top: `${r.top - a}px`,
				width: `${r.width}px`,
				height: `${r.height}px`
			}], p),
			l.animate([{
				opacity: 1,
				transform: "perspective(1400px) rotateX(0deg)"
			}, {
				opacity: 0,
				transform: `perspective(1400px) rotateX(${n * 5}deg) translateY(${-n * 24}px)`
			}], p),
			o.animate([{
				opacity: 0,
				transform: `perspective(1400px) rotateX(${-n * 5}deg) translateY(${n * 24}px)`
			}, {
				opacity: 1,
				transform: "perspective(1400px) rotateX(0deg) translateY(0)"
			}], p)
		], window.addEventListener("resize", f, { once: !0 }), await Promise.allSettled(d.map((e) => e.finished));
	} finally {
		window.removeEventListener("resize", f), u && u.style.removeProperty("visibility"), o.remove(), delete e.dataset.moving;
	}
}
//#endregion
//#region node_modules/.pnpm/lucide-react@1.31.0_react@19.2.6/node_modules/lucide-react/dist/esm/shared/src/utils/mergeClasses.mjs
var x = (...e) => e.filter((e, t, n) => !!e && e.trim() !== "" && n.indexOf(e) === t).join(" ").trim(), ee = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), S = (e) => e.replace(/^([A-Z])|[\s-_]+(\w)/g, (e, t, n) => n ? n.toUpperCase() : t.toLowerCase()), C = (e) => {
	let t = S(e);
	return t.charAt(0).toUpperCase() + t.slice(1);
}, w = {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}, te = (e) => {
	for (let t in e) if (t.startsWith("aria-") || t === "role" || t === "title") return !0;
	return !1;
}, ne = (0, _.createContext)({}), re = () => (0, _.useContext)(ne), ie = (0, _.forwardRef)(({ color: e, size: t, strokeWidth: n, absoluteStrokeWidth: r, className: i = "", children: a, iconNode: o, ...s }, c) => {
	let { size: l = 24, strokeWidth: u = 2, absoluteStrokeWidth: d = !1, color: f = "currentColor", className: p = "" } = re() ?? {}, m = r ?? d ? Number(n ?? u) * 24 / Number(t ?? l) : n ?? u;
	return (0, _.createElement)("svg", {
		ref: c,
		...w,
		width: t ?? l ?? w.width,
		height: t ?? l ?? w.height,
		stroke: e ?? f,
		strokeWidth: m,
		className: x("lucide", p, i),
		...!a && !te(s) && { "aria-hidden": "true" },
		...s
	}, [...o.map(([e, t]) => (0, _.createElement)(e, t)), ...Array.isArray(a) ? a : [a]]);
}), ae = (e, t) => {
	let n = (0, _.forwardRef)(({ className: n, ...r }, i) => (0, _.createElement)(ie, {
		ref: i,
		iconNode: t,
		className: x(`lucide-${ee(C(e))}`, `lucide-${e}`, n),
		...r
	}));
	return n.displayName = C(e), n;
}, oe = ae("arrow-left", [["path", {
	d: "m12 19-7-7 7-7",
	key: "1l729n"
}], ["path", {
	d: "M19 12H5",
	key: "x3x0zl"
}]]), se = ae("arrow-right", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}], ["path", {
	d: "m12 5 7 7-7 7",
	key: "xquz4c"
}]]), ce = ae("check", [["path", {
	d: "M20 6 9 17l-5-5",
	key: "1gmf2c"
}]]), le = ae("chevron-right", [["path", {
	d: "m9 18 6-6-6-6",
	key: "mthhwq"
}]]), ue = ae("circle-check", [["circle", {
	cx: "12",
	cy: "12",
	r: "10",
	key: "1mglay"
}], ["path", {
	d: "m9 12 2 2 4-4",
	key: "dzmm74"
}]]), T = ae("download", [
	["path", {
		d: "M12 15V3",
		key: "m9g1x1"
	}],
	["path", {
		d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
		key: "ih7n3h"
	}],
	["path", {
		d: "m7 10 5 5 5-5",
		key: "brsn70"
	}]
]), E = ae("eraser", [["path", {
	d: "M21 21H8a2 2 0 0 1-1.42-.587l-3.994-3.999a2 2 0 0 1 0-2.828l10-10a2 2 0 0 1 2.829 0l5.999 6a2 2 0 0 1 0 2.828L12.834 21",
	key: "g5wo59"
}], ["path", {
	d: "m5.082 11.09 8.828 8.828",
	key: "1wx5vj"
}]]), de = ae("grip-vertical", [
	["circle", {
		cx: "9",
		cy: "12",
		r: "1",
		key: "1vctgf"
	}],
	["circle", {
		cx: "9",
		cy: "5",
		r: "1",
		key: "hp0tcf"
	}],
	["circle", {
		cx: "9",
		cy: "19",
		r: "1",
		key: "fkjjf6"
	}],
	["circle", {
		cx: "15",
		cy: "12",
		r: "1",
		key: "1tmaij"
	}],
	["circle", {
		cx: "15",
		cy: "5",
		r: "1",
		key: "19l28e"
	}],
	["circle", {
		cx: "15",
		cy: "19",
		r: "1",
		key: "f4zoj3"
	}]
]), fe = ae("layers-2", [["path", {
	d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74z",
	key: "15q6uc"
}], ["path", {
	d: "m20 14.285 1.5.845a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74l1.5-.845",
	key: "byia6g"
}]]), pe = ae("move-horizontal", [
	["path", {
		d: "m18 8 4 4-4 4",
		key: "1ak13k"
	}],
	["path", {
		d: "M2 12h20",
		key: "9i4pu4"
	}],
	["path", {
		d: "m6 8-4 4 4 4",
		key: "15zrgr"
	}]
]), me = ae("pencil", [["path", {
	d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
	key: "1a8usu"
}], ["path", {
	d: "m15 5 4 4",
	key: "1mk7zo"
}]]), D = ae("shopping-bag", [
	["path", {
		d: "M16 10a4 4 0 0 1-8 0",
		key: "1ltviw"
	}],
	["path", {
		d: "M3.103 6.034h17.794",
		key: "awc11p"
	}],
	["path", {
		d: "M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z",
		key: "o988cm"
	}]
]), he = ae("trash-2", [
	["path", {
		d: "M10 11v6",
		key: "nco0om"
	}],
	["path", {
		d: "M14 11v6",
		key: "outv1u"
	}],
	["path", {
		d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
		key: "miytrc"
	}],
	["path", {
		d: "M3 6h18",
		key: "d0wm0j"
	}],
	["path", {
		d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
		key: "e791ji"
	}]
]), ge = ae("undo-2", [["path", {
	d: "M9 14 4 9l5-5",
	key: "102s5s"
}], ["path", {
	d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11",
	key: "f3b9sd"
}]]), _e = ae("wand-sparkles", [
	["path", {
		d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
		key: "ul74o6"
	}],
	["path", {
		d: "m14 7 3 3",
		key: "1r5n42"
	}],
	["path", {
		d: "M5 6v4",
		key: "ilb8ba"
	}],
	["path", {
		d: "M19 14v4",
		key: "blhpug"
	}],
	["path", {
		d: "M10 2v2",
		key: "7u0qdc"
	}],
	["path", {
		d: "M7 8H3",
		key: "zfb6yr"
	}],
	["path", {
		d: "M21 16h-4",
		key: "1cnmox"
	}],
	["path", {
		d: "M11 3H9",
		key: "1obp7u"
	}]
]), ve = (e, t) => (e.anchor ?? "left") === (t.anchor ?? "left") && e.x < t.x + t.width - 1 && t.x < e.x + e.width - 1 && e.y < t.y + t.depth - 1 && t.y < e.y + e.depth - 1, ye = (e) => e.name.split(" | ")[0], be = (e) => e.pockets?.length ? e.pockets : e.pocket ? [e.pocket] : [], xe = (e) => (e ?? "").split(","), Se = (e, t) => Number.isFinite(e.minDepth) && e.minDepth < e.depth ? Math.max(0, t.depth - O.depth - e.depth) : 0, Ce = (e) => Number.isFinite(e.minDepth) && e.minDepth > 0 && e.minDepth < e.depth ? e.minDepth : e.depth, we = (e) => e.trim || e.expand === !0, Te = [
	"stainless",
	"clear",
	"other",
	"bamboo",
	"timber"
];
function Ee(e, t = "all", n = "", r = "") {
	return e.filter((e) => (!r || e.brand === r) && (!n || !e.rooms?.length || e.rooms.includes(n)) && (t === "all" || e.finish === t || t === "anthracite" && (e.finish === "black" || e.finish === "grey") || !e.finish || !!e.finish && Te.includes(e.finish) || e.premium === !0));
}
var De = (e) => Number.isFinite(e.y) && e.y > O.depth / 2 ? e.y - O.depth / 2 : 0, O = {
	width: 4,
	depth: 4,
	height: 3,
	pair: 2
}, Oe = (e) => e.trim || e.brand === "Blum" || e.brand === "DTC" || /^Krome/i.test(e.name), ke = (e) => Oe(e) ? 0 : O.width, Ae = (e) => Oe(e) || Me(e) || je(e) ? 0 : O.depth, je = (e) => e.brand === "Blum" || e.trim ? "" : /TANDEMBOX/i.test(e.name) ? "orga" : /LEGRABOX|MERIVOBOX/i.test(e.name) ? "ambia" : "", Me = (e) => e.brand === "KitchenLibrary" && /Stainless Steel Cutlery Organiser/i.test(e.name), Ne = (e) => Math.round(e * 10) / 10;
function Pe(e) {
	return [
		"width",
		"depth",
		"height"
	].flatMap((t) => !Number.isFinite(e[t]) || e[t] <= 0 ? [`Enter a usable ${t} greater than zero.`] : e[t] > (t === "height" ? 500 : 2e3) ? [`Check the ${t}: enter millimetres, up to ${t === "height" ? 500 : 2e3}mm.`] : []);
}
function Fe(e) {
	return be(e).every((t) => {
		let n = e.trim ? e.trimEdges === "right" ? {
			l: 0,
			r: e.width - e.minWidth
		} : {
			l: (e.width - e.minWidth) / 2,
			r: (e.width - e.minWidth) / 2
		} : {
			l: 0,
			r: 0
		};
		return !e.insertOnly && [
			t.x,
			t.y,
			t.width,
			t.depth,
			t.height
		].every(Number.isFinite) && t.x >= n.l - .01 && t.y >= 0 && t.width > 0 && t.depth > 0 && t.height > 0 && t.x + t.width <= e.width - n.r + .01 && (e.trim || t.x + t.width <= e.minWidth) && t.y + t.depth <= e.depth && Array.isArray(t.accepts) && t.accepts.every((e) => typeof e == "string") && typeof t.approved == "boolean";
	}) && !!e.id && !!e.name && Number.isFinite(e.price) && e.price >= 0 && [
		e.width,
		e.minWidth,
		e.depth,
		e.height,
		e.step
	].every((e) => Number.isFinite(e) && e > 0) && e.minWidth <= e.width && !(e.trim && e.expand) && (we(e) ? !0 : e.minWidth === e.width) && (e.minDepth == null || Number.isFinite(e.minDepth) && e.minDepth > 0 && e.minDepth <= e.depth) && (e.trimEdges == null || e.trim && (e.trimEdges === "right" || e.trimEdges === "both")) && Array.isArray(e.compartments) && e.compartments.every((t) => [
		t.x,
		t.y,
		t.width,
		t.depth
	].every(Number.isFinite) && t.x >= 0 && t.y >= 0 && t.width > 0 && t.depth > 0 && t.x + t.width <= e.width + .1 && t.y + t.depth <= e.depth + .1);
}
function Ie(e, t, n) {
	let r = Pe(e), i = [], a = () => ({
		ok: !1,
		errors: r,
		placed: i,
		spare: 0,
		used: 0
	});
	if (r.length) return a();
	let o = new Map(n.map((e) => [e.id, e])), s = (e) => {
		if (!e) return e;
		let t = e.width, n = e.depth, r = (e) => ({
			...e,
			x: e.anchor === "right" ? e.x : t - e.x - e.width,
			y: n - e.y - e.depth,
			anchor: void 0
		});
		return {
			...e,
			turned: !0,
			pocket: e.pocket ? r(e.pocket) : e.pocket,
			pockets: e.pockets?.map(r)
		};
	}, c = t.map((e) => ({
		lane: e,
		products: e.items.map((t, n) => e.turned?.includes(n) ? s(o.get(t)) : o.get(t))
	}));
	for (let { lane: t, products: n } of c) {
		if (!n.length || n.length > 10 || n.some((e) => !e || !Fe(e))) {
			r.push("An organiser in this layout is no longer supported. Remove it and choose again.");
			continue;
		}
		let i = n;
		if (De(t) + i.reduce((e, t) => e + (i.length === 1 ? Ce(t) : t.depth), 0) + (i.length - 1) * O.pair > e.depth - (i.every((e) => Ae(e) === 0) ? 0 : O.depth)) {
			let n = Math.round(De(t) + i.reduce((e, t) => e + (i.length === 1 ? Ce(t) : t.depth), 0) + (i.length - 1) * O.pair + (i.every(Oe) ? 0 : O.depth));
			r.push(`${i.map(ye).join(" + ")} ${i.length > 1 ? "need" : "needs"} a drawer at least ${n} mm deep inside. Yours is ${Ne(e.depth)} mm.`);
		}
		for (let t of i) t.height > e.height - O.height && r.push(`${ye(t)} needs ${Ne(t.height + O.height)} mm clear height.`), t.available || r.push(`${ye(t)} is currently unavailable.`);
		t.id || r.push("This layout needs to be reset.");
	}
	if (r.length) return a();
	let l = c.map((e) => e.products);
	if (l.flat().some((e) => e.insertOnly)) return r.push("Place this insert inside a compatible frame."), a();
	let u = l.map((e, t) => c[t].lane.width ?? Math.max(...e.map((e) => e.minWidth)));
	for (let e = 0; e < c.length; e++) {
		let t = c[e].lane.width;
		t !== void 0 && (!Number.isFinite(t) || t < Math.max(...l[e].map((e) => e.minWidth)) || t > Math.max(...l[e].map((e) => e.width))) && r.push("The saved finished width is outside the allowed product range.");
	}
	new Set(t.map((e) => e.id)).size !== t.length && r.push("Duplicate layout identifiers. Reset this layout.");
	for (let t of new Set(l.flat())) Ve(t, e) || r.push(`${t.name} suits drawers up to ${t.maxDrawerDepth} mm deep. Choose another tray for this drawer.`);
	if (r.length) return a();
	let d = c.every((e) => e.lane.items.every((e) => {
		let t = n.find((t) => t.id === e);
		return !!t && Oe(t);
	})) ? 0 : O.width, f = c.every((e) => e.lane.items.every((e) => {
		let t = n.find((t) => t.id === e);
		return !!t && Ae(t) === 0;
	})), p = Ne(e.width - d);
	function m() {
		let t = [];
		return c.forEach((n, r) => {
			let i = (f ? 0 : O.depth / 2) + De(n.lane);
			l[r].forEach((a, o) => {
				let s = we(a) ? Ne(a.minWidth + Math.floor((Math.min(u[r], a.width) - a.minWidth + 1e-8) / a.step) * a.step) : a.width, c = (e) => e.product.railVariant ? e.x <= O.width / 2 + 1 ? e.product.railWidth ?? 0 : e.product.railExtra ?? e.product.railWidth ?? 0 : 0, p = Number.isFinite(n.lane.x) ? n.lane.x : 0, m = Math.max(0, ...t.filter((e) => e.y < i + a.depth && e.y + e.depth > i).map((e) => e.x + e.width + c(e))), h = Math.max(d / 2, p, m);
				a.railVariant && m > p && h > d / 2 + 1 && (h += a.railWidth ?? 0);
				let g = l[r].length === 1 ? Math.max(Ce(a), Math.min(a.depth, e.depth - (f ? 0 : O.depth) - De(n.lane))) : a.depth;
				t.push({
					key: `${n.lane.id}-${o}`,
					laneId: n.lane.id,
					product: a,
					x: Ne(h),
					y: i,
					width: s,
					depth: g
				}), i += g + O.pair;
			});
		}), t;
	}
	let h = (e) => Ne(Math.max(d / 2, ...e.map((t) => t.x + t.width + (t.product.railVariant && t.x <= d / 2 + 1 && e.some((e) => e !== t && e.x > t.x) ? t.product.railWidth ?? 0 : 0))) - d / 2), g = m(), _ = h(g);
	if (_ > p) return r.push(`These organisers need ${Ne(_ - p)}mm more width. Remove a piece or choose a narrower one.`), a();
	let v = c.some((e) => Number.isFinite(e.lane.x) || Number.isFinite(e.lane.y));
	for (let e = 0; e < u.length; e++) v || c[e].lane.width !== void 0 || (u[e] += Math.min(Math.max(...l[e].map((e) => e.width)) - u[e], p - _), g = m(), _ = h(g));
	i.push(...g);
	for (let { lane: t } of c) for (let [n, a] of Object.entries(t.inserts ?? {})) xe(a).forEach((a, s) => {
		if (!a) return;
		let c = g.find((e) => e.key === `${t.id}-${n}`), l = o.get(a);
		if (!c || !l || !Je(c.product, l, e, s)) {
			r.push("This frame and insert combination is not compatible. Remove the insert and check the exact products.");
			return;
		}
		let u = be(c.product)[s], d = c.product.trim && c.product.trimEdges !== "right" ? (c.product.width - c.width) / 2 : 0, f = u.anchor === "right" ? c.x + c.width - u.x - u.width : c.x + u.x - d, p = c.product.depthTrim === "back" ? 0 : Math.max(0, (c.product.depth - c.depth) / 2);
		i.push({
			key: `${c.key}-insert${s || ""}`,
			parentKey: c.key,
			laneId: t.id,
			product: l,
			x: f,
			y: c.y + Math.max(0, u.y - p),
			width: l.width,
			depth: l.depth
		});
	});
	for (let { lane: e } of c) for (let [t, n] of Object.entries(e.inserts ?? {})) {
		let i = g.find((n) => n.key === `${e.id}-${t}`);
		if (!i) continue;
		let a = be(i.product), o = xe(n).map((e, t) => e ? t : -1).filter((e) => e >= 0);
		o.some((e, t) => o.some((n, r) => r > t && a[e] && a[n] && ve(a[e], a[n]))) && r.push("Two inserts would sit in the same space. Remove one.");
	}
	for (let { lane: e } of c) for (let [t, r] of Object.entries(e.dividers ?? {})) {
		let [a, o] = t.split("-").map(Number), s = g.find((t) => t.key === `${e.id}-${a}`), c = s && Ue(s.product)[o], l = Ue(s?.product);
		if (!s || !c || c.sub || !(r > 0)) continue;
		let u = i.filter((e) => e.parentKey === s.key && /-insert/.test(e.key) && l.some((t, n) => e.key === `${s.key}-insert${n || ""}` && (n === o || ve(t, c)))), d = Math.max(s.y + c.y, ...u.map((e) => e.y + e.depth)), f = s.y + c.y + c.depth;
		if (f - d < 60) continue;
		let p = n.filter((e) => e.insertOnly && /Divider/i.test(e.name) && !/Set/i.test(e.name) && e.brand === s.product.brand && e.available && e.width <= c.width).sort((e, t) => Number(t.finishName === s.product.finishName) - Number(e.finishName === s.product.finishName) || t.width - e.width)[0];
		if (!p) continue;
		let m = s.product.trimEdges === "right" ? 0 : (s.product.width - s.width) / 2, h = c.anchor === "right" ? s.x + s.width - c.x - c.width : s.x + c.x - m;
		for (let t = 1; t <= Math.min(12, r); t++) i.push({
			key: `${s.key}-div${o}-${t}`,
			parentKey: s.key,
			laneId: e.id,
			product: p,
			x: h + (c.width - p.width) / 2,
			y: d + (f - d) * t / (r + 1) - p.depth / 2,
			width: p.width,
			depth: p.depth
		});
	}
	return r.length ? a() : {
		ok: !0,
		errors: [],
		placed: i,
		spare: Ne(p - _),
		used: _
	};
}
var Le = (e, t) => !we(e) || e.width >= t.width - ke(e), Re = (e) => e.brand === "Blum" ? /AMBIA/i.test(e.name) ? "Blum AMBIA-LINE" : "Blum ORGA-LINE" : e.brand ?? "";
function ze(e, t, n = 5) {
	let r = /* @__PURE__ */ new Set(), i = t.filter((t) => !t.insertOnly && Le(t, e) && Se(t, e) <= 10 && Fe(t) && t.available && t.minWidth + (t.railWidth ?? 0) <= e.width - 4 && Ve(t, e) && Ce(t) <= e.depth - 4 && t.height <= e.height - 3).sort((e, t) => t.width * t.depth - e.width * e.depth).filter((e) => {
		let t = `${e.minWidth}-${e.width}-${e.depth}`;
		return r.has(t) ? !1 : (r.add(t), !0);
	}).slice(0, 12), a = [], o = i.flatMap((t, n) => [[t.id], ...i.slice(n).filter((n) => t.depth + n.depth + O.pair <= e.depth - O.depth).map((e) => [t.id, e.id])]);
	function s(r, i) {
		if (r.length) {
			let i = r.map((e, t) => ({
				id: `suggest-${t}`,
				items: e
			})), o = Ie(e, i, t);
			if (!o.ok) return;
			let s = new Set(r.flat()).size, c = o.placed.reduce((e, t) => e + t.width * t.depth, 0) / (e.width * e.depth), l = -o.spare + s * 8 - r.flat().length * 2 + c * 20, u = JSON.stringify(r);
			a.some((e) => e.key === u) || (a.push({
				lanes: i,
				score: l,
				key: u
			}), a.sort((e, t) => t.score - e.score), a.splice(n));
		}
		if (r.length !== 3) for (let e = i; e < o.length; e++) s([...r, o[e]], e);
	}
	return s([], 0), a.map((e) => e.lanes);
}
function Be(e, t, n, r, i, a = "", o = !1) {
	if (!o) {
		let i = [...t].sort((e, t) => Number(t.id === a) - Number(e.id === a));
		for (let a of i) {
			if (a.items.length >= 10) continue;
			let i = t.map((e) => e.id === a.id ? {
				...e,
				items: [...e.items, r]
			} : e);
			if (Ie(e, i, n).ok) return {
				lanes: i,
				laneId: a.id,
				stacked: !0
			};
		}
	}
	if (t.length >= 10) throw Error("This planner supports up to 10 lanes.");
	let s = [...t, {
		id: i,
		items: [r]
	}], c = Ie(e, s, n);
	if (!c.ok) throw Error(c.errors[0]);
	return {
		lanes: s,
		laneId: i,
		stacked: !1
	};
}
var Ve = (e, t) => !e.maxDrawerDepth || t.depth <= e.maxDrawerDepth;
function He(e, t) {
	let n = e.product.railWidth ?? 0, r = e.product.railExtra ?? n, i = O.width / 2 + 1, a = e.x <= i, o = e.x + e.width >= t.width - i, s = e.x - O.width / 2, c = t.width - O.width / 2 - (e.x + e.width);
	return a && o ? {
		sides: [],
		extra: !1,
		room: !1
	} : a ? {
		sides: [{
			side: "right",
			w: n
		}],
		extra: !1,
		room: c >= n
	} : o ? {
		sides: [{
			side: "left",
			w: n
		}],
		extra: !1,
		room: s >= n
	} : {
		sides: [{
			side: "left",
			w: n
		}, {
			side: "right",
			w: r
		}],
		extra: !0,
		room: s >= n && c >= r
	};
}
function Ue(e) {
	let t = be(e);
	return t.length ? t : /Agoform SKY/i.test(e.name) ? e.compartments.filter((e) => e.width >= 170).map((e) => ({
		x: e.x,
		y: e.y,
		width: e.width,
		depth: e.depth,
		accepts: [],
		approved: !0
	})) : [];
}
var We = (e) => Number(/(\d+)\s*Pack/i.exec(e.name)?.[1] ?? 1);
function Ge(e, t, n, r) {
	if (!e.ok || !e.placed.length || e.placed.some((e) => !e.product.variantId || !e.product.available)) throw Error("Only available Shopify variants can be added.");
	let i = r ? e.placed.flatMap((e, i) => e.product.railVariant && He(e, r).extra ? [{
		id: e.product.railVariant,
		quantity: 1,
		properties: {
			_drawer_id: t,
			_piece_id: `${i + 1}-rail`,
			_config_version: "2",
			"Drawer name": n || "My drawer",
			"Second side rail for": e.product.name
		}
	}] : []) : [], a = /* @__PURE__ */ new Map();
	for (let t of e.placed) if (t.key.includes("-div")) {
		let e = t.product.variantId;
		a.set(e, {
			p: t,
			n: (a.get(e)?.n ?? 0) + 1
		});
	}
	return [
		...[...a.values()].map(({ p: e, n: r }) => ({
			id: e.product.variantId,
			quantity: Math.ceil(r / We(e.product)),
			properties: {
				_drawer_id: t,
				_piece_id: `dividers-${e.product.variantId}`,
				_config_version: "2",
				"Drawer name": n || "My drawer",
				Dividers: String(r)
			}
		})),
		...e.placed.filter((e) => !e.key.includes("-div")).map((r, i) => ({
			id: r.product.variantId,
			quantity: 1,
			properties: {
				_drawer_id: t,
				_piece_id: String(i + 1),
				_config_version: "2",
				...r.parentKey ? {
					"Inside frame": e.placed.find((e) => e.key === r.parentKey)?.product.name ?? "",
					_parent_piece_id: String(e.placed.findIndex((e) => e.key === r.parentKey) + 1)
				} : {},
				"Drawer name": n || "My drawer",
				...r.depth < r.product.depth ? { "Cut depth to": `${r.depth}mm (${r.product.depthTrim === "back" ? "cut from the back" : "equal front and back"})` } : {},
				...r.product.expand ? { "Set width to": `${r.width}mm` } : r.product.trim ? { "Cut to size": r.product.trimEdges === "both" ? `${r.width}mm (equal from both sides)` : `${r.width}mm` } : {}
			}
		})),
		...i
	];
}
function Ke(e, t, n, r, i, a, o, s) {
	if (s?.insert) throw Error("Move this insert to a compatible frame.");
	let c = t.map((e) => ({
		...e,
		items: [...e.items],
		...e.inserts ? { inserts: { ...e.inserts } } : {}
	})), l = s ? c.find((e) => e.id === s.laneId)?.inserts?.[s.index] : void 0;
	if (s) {
		let e = c.find((e) => e.id === s.laneId);
		if (!e || e.items[s.index] !== r) throw Error("This piece has changed. Select it and try again.");
		c = Ye(c, s, !1), a === s.laneId && s.index < o && o--;
	}
	let u = c.find((e) => e.id === a), d = i;
	if (u ? (o = Math.max(0, Math.min(o, u.items.length)), u.inserts &&= Object.fromEntries(Object.entries(u.inserts).map(([e, t]) => [Number(e) >= o ? Number(e) + 1 : Number(e), t])), u.items.splice(o, 0, r), l && (u.inserts = {
		...u.inserts,
		[o]: l
	}), d = u.id) : c.splice(Math.max(0, Math.min(o, c.length)), 0, {
		id: i,
		items: [r],
		...l ? { inserts: { 0: l } } : {}
	}), c = c.filter((e) => e.items.length), c.length > 10) throw Error("This planner supports up to 10 lanes.");
	let f = Ie(e, c, n);
	if (!f.ok) throw Error(f.errors[0]);
	return {
		lanes: c,
		laneId: d
	};
}
function qe(e, t, n, r, i) {
	let a = t.find((e) => e.id === r), o = n.find((e) => e.id === a?.items[0]);
	if (!a || a.items.length !== 1 || !o || !we(o) || !Number.isFinite(i)) throw Error("Choose a single adjustable tray to change its width.");
	let s = o.minWidth, c = Math.min(o.width, Math.max(o.minWidth, i));
	if (!Ie(e, t.map((e) => e.id === r ? {
		...e,
		width: s
	} : e), n).ok) throw Error("There is not enough width for this tray’s minimum safe cut.");
	for (let i = 0; i < 40; i++) {
		let i = (s + c) / 2;
		Ie(e, t.map((e) => e.id === r ? {
			...e,
			width: i
		} : e), n).ok ? s = i : c = i;
	}
	let l = Ne(o.minWidth + Math.floor((s - o.minWidth + 1e-5) / o.step) * o.step), u = t.map((e) => e.id === r ? {
		...e,
		width: l
	} : e), d = Ie(e, u, n);
	if (!d.ok) throw Error(d.errors[0]);
	return u;
}
function Je(e, t, n, r = 0) {
	let i = be(e)[r];
	return !!i && Fe(e) && Fe(t) && t.insertOnly === !0 && !t.pocket && !we(t) && t.available && i.accepts.includes(t.id) && (!e.verified && !t.verified || i.approved) && t.width <= i.width + 8 && t.depth <= i.depth + 8 && t.height + O.height <= n.height;
}
function Ye(e, t, n = !0) {
	let r = e.map((e) => {
		if (e.id !== t.laneId) return e;
		let n = {
			...e,
			items: [...e.items]
		};
		if (t.insert) {
			n.inserts = { ...e.inserts };
			let r = xe(n.inserts[t.index]);
			r[t.slot ?? 0] = "", r.some(Boolean) ? n.inserts[t.index] = r.join(",") : delete n.inserts[t.index];
		} else n.items.splice(t.index, 1), e.inserts && (n.inserts = Object.fromEntries(Object.entries(e.inserts).filter(([e]) => Number(e) !== t.index).map(([e, n]) => [Number(e) > t.index ? Number(e) - 1 : Number(e), n])));
		return n.inserts && !Object.keys(n.inserts).length && delete n.inserts, n;
	});
	return n ? r.filter((e) => e.items.length) : r;
}
function Xe(e, t, n, r, i, a) {
	if (a && !a.insert) throw Error("Only compatible inserts can be placed inside a frame.");
	let o = n.find((e) => e.id === r);
	if (a && xe(t.find((e) => e.id === a.laneId)?.inserts?.[a.index])[a.slot ?? 0] !== r) throw Error("This insert has changed. Select it again.");
	let s = a ? Ye(t, a) : t, c = Ie(e, s, n).placed.find((e) => e.key === i && !e.parentKey);
	if (!c || !o || !be(c.product).some((t, n) => Je(c.product, o, e, n))) throw Error("Choose a compatible frame for this insert.");
	let l = Number(c.key.slice(c.key.lastIndexOf("-") + 1)), u = xe(s.find((e) => e.id === c.laneId)?.inserts?.[l]), d = be(c.product), f = d.findIndex((t, n) => !u[n] && Je(c.product, o, e, n) && !d.some((e, r) => r !== n && !!u[r] && ve(t, e)));
	if (f < 0) throw Error("This frame is full.");
	u[f] = r;
	let p = s.map((e) => e.id === c.laneId ? {
		...e,
		inserts: {
			...e.inserts,
			[l]: Array.from({ length: Math.max(u.length, f + 1) }, (e, t) => u[t] ?? "").join(",")
		}
	} : e), m = Ie(e, p, n);
	if (!m.ok) throw Error(m.errors[0]);
	return {
		lanes: p,
		laneId: c.laneId,
		piece: m.placed.find((e) => e.key === `${i}-insert${f || ""}`)
	};
}
var Ze = (e) => !!e.plannerOnly && !!e.cutToSize;
function Qe(e, t, n) {
	let r = Ze(e) ? Math.round(t.width) + 50 : Math.round(Number.isFinite(n) && n > 0 ? n : t.width);
	return e.cutToSize ? {
		quantity: Math.max(1, Math.ceil(r / (e.sellUnitMm || 1e3))),
		cutLength: r,
		sheetDepth: e.rollWidth ?? 0
	} : {
		quantity: 1,
		cutLength: t.width,
		sheetDepth: t.depth
	};
}
var $e = [
	{
		id: "sample-charcoal",
		name: "Charcoal",
		colour: "#777a74"
	},
	{
		id: "sample-stone",
		name: "Stone",
		colour: "#c9c7bc"
	},
	{
		id: "sample-pearl",
		name: "Pearl",
		colour: "#e7e7df"
	}
], et = (e) => Math.max(1, e - 100);
function tt(e, t, n) {
	if (!e) return "";
	if (e.available === !1) return "This liner colour is unavailable.";
	if (e.cutToSize || it(e)) {
		let r = Qe(e, t, n);
		return e.rollWidth !== void 0 && (!Number.isFinite(e.rollWidth) || e.rollWidth < t.depth) ? "This liner is narrower than your drawer depth." : e.rollLength !== void 0 && (!Number.isFinite(e.rollLength) || e.rollLength < r.cutLength) ? "This cabinet is wider than the liner roll." : e.thickness !== void 0 && (!Number.isFinite(e.thickness) || e.thickness < 0 || e.thickness >= t.height) ? "Check the liner thickness and drawer clearance." : "";
	}
	return e.rollWidth !== void 0 && (!Number.isFinite(e.rollWidth) || e.rollWidth < t.width) ? "The liner roll is too narrow for this drawer." : e.rollLength !== void 0 && (!Number.isFinite(e.rollLength) || e.rollLength < t.depth) ? "The liner roll is too short for this drawer." : e.thickness !== void 0 && (!Number.isFinite(e.thickness) || e.thickness < 0 || e.thickness >= t.height) ? "Check the liner thickness and drawer clearance." : "";
}
function nt(e, t) {
	return e.verified === !0 && e.available === !0 && Number.isSafeInteger(e.variantId) && e.variantId > 0 && Number.isFinite(e.price) && e.price >= 0 && e.currency === t && Number.isFinite(e.rollWidth) && e.rollWidth > 0 && Number.isFinite(e.rollLength) && e.rollLength > 0 && Number.isFinite(e.thickness) && e.thickness > 0 && (!e.cutToSize || Number.isFinite(e.sellUnitMm) && e.sellUnitMm > 0);
}
function rt(e, t) {
	return {
		...e,
		height: e.height - (Number.isFinite(t?.thickness) ? Math.max(0, t.thickness) : 0)
	};
}
var it = (e) => !e.cutToSize && Number.isFinite(e.rollLength) && (e.rollLength ?? 0) > 0;
function at(e, t) {
	let n = [];
	for (let r of [...e].sort((e, t) => t - e)) {
		let e = n.findIndex((e) => e >= r);
		e >= 0 ? n[e] -= r : n.push(t - r);
	}
	return {
		rolls: n.length,
		spare: n.length ? n[n.length - 1] : 0
	};
}
//#endregion
//#region ../../../node_modules/qrcode-generator/dist/qrcode.mjs
var ot = function(e, t) {
	let n = e, r = ct[t], i = null, a = 0, o = null, s = [], c = {}, l = function(e, t) {
		a = n * 4 + 17, i = function(e) {
			let t = Array(e);
			for (let n = 0; n < e; n += 1) {
				t[n] = Array(e);
				for (let r = 0; r < e; r += 1) t[n][r] = null;
			}
			return t;
		}(a), u(0, 0), u(a - 7, 0), u(0, a - 7), p(), f(), h(e, t), n >= 7 && m(e), o ??= v(n, r, s), g(o, t);
	}, u = function(e, t) {
		for (let n = -1; n <= 7; n += 1) if (!(e + n <= -1 || a <= e + n)) for (let r = -1; r <= 7; r += 1) t + r <= -1 || a <= t + r || (0 <= n && n <= 6 && (r == 0 || r == 6) || 0 <= r && r <= 6 && (n == 0 || n == 6) || 2 <= n && n <= 4 && 2 <= r && r <= 4 ? i[e + n][t + r] = !0 : i[e + n][t + r] = !1);
	}, d = function() {
		let e = 0, t = 0;
		for (let n = 0; n < 8; n += 1) {
			l(!0, n);
			let r = ut.getLostPoint(c);
			(n == 0 || e > r) && (e = r, t = n);
		}
		return t;
	}, f = function() {
		for (let e = 8; e < a - 8; e += 1) i[e][6] ?? (i[e][6] = e % 2 == 0);
		for (let e = 8; e < a - 8; e += 1) i[6][e] ?? (i[6][e] = e % 2 == 0);
	}, p = function() {
		let e = ut.getPatternPosition(n);
		for (let t = 0; t < e.length; t += 1) for (let n = 0; n < e.length; n += 1) {
			let r = e[t], a = e[n];
			if (i[r][a] == null) for (let e = -2; e <= 2; e += 1) for (let t = -2; t <= 2; t += 1) e == -2 || e == 2 || t == -2 || t == 2 || e == 0 && t == 0 ? i[r + e][a + t] = !0 : i[r + e][a + t] = !1;
		}
	}, m = function(e) {
		let t = ut.getBCHTypeNumber(n);
		for (let n = 0; n < 18; n += 1) {
			let r = !e && (t >> n & 1) == 1;
			i[Math.floor(n / 3)][n % 3 + a - 8 - 3] = r;
		}
		for (let n = 0; n < 18; n += 1) {
			let r = !e && (t >> n & 1) == 1;
			i[n % 3 + a - 8 - 3][Math.floor(n / 3)] = r;
		}
	}, h = function(e, t) {
		let n = r << 3 | t, o = ut.getBCHTypeInfo(n);
		for (let t = 0; t < 15; t += 1) {
			let n = !e && (o >> t & 1) == 1;
			t < 6 ? i[t][8] = n : t < 8 ? i[t + 1][8] = n : i[a - 15 + t][8] = n;
		}
		for (let t = 0; t < 15; t += 1) {
			let n = !e && (o >> t & 1) == 1;
			t < 8 ? i[8][a - t - 1] = n : t < 9 ? i[8][15 - t - 1 + 1] = n : i[8][15 - t - 1] = n;
		}
		i[a - 8][8] = !e;
	}, g = function(e, t) {
		let n = -1, r = a - 1, o = 7, s = 0, c = ut.getMaskFunction(t);
		for (let t = a - 1; t > 0; t -= 2) for (t == 6 && --t;;) {
			for (let n = 0; n < 2; n += 1) if (i[r][t - n] == null) {
				let a = !1;
				s < e.length && (a = (e[s] >>> o & 1) == 1), c(r, t - n) && (a = !a), i[r][t - n] = a, --o, o == -1 && (s += 1, o = 7);
			}
			if (r += n, r < 0 || a <= r) {
				r -= n, n = -n;
				break;
			}
		}
	}, _ = function(e, t) {
		let n = 0, r = 0, i = 0, a = Array(t.length), o = Array(t.length);
		for (let s = 0; s < t.length; s += 1) {
			let c = t[s].dataCount, l = t[s].totalCount - c;
			r = Math.max(r, c), i = Math.max(i, l), a[s] = Array(c);
			for (let t = 0; t < a[s].length; t += 1) a[s][t] = 255 & e.getBuffer()[t + n];
			n += c;
			let u = ut.getErrorCorrectPolynomial(l), d = ft(a[s], u.getLength() - 1).mod(u);
			o[s] = Array(u.getLength() - 1);
			for (let e = 0; e < o[s].length; e += 1) {
				let t = e + d.getLength() - o[s].length;
				o[s][e] = t >= 0 ? d.getAt(t) : 0;
			}
		}
		let s = 0;
		for (let e = 0; e < t.length; e += 1) s += t[e].totalCount;
		let c = Array(s), l = 0;
		for (let e = 0; e < r; e += 1) for (let n = 0; n < t.length; n += 1) e < a[n].length && (c[l] = a[n][e], l += 1);
		for (let e = 0; e < i; e += 1) for (let n = 0; n < t.length; n += 1) e < o[n].length && (c[l] = o[n][e], l += 1);
		return c;
	}, v = function(e, t, n) {
		let r = pt.getRSBlocks(e, t), i = mt();
		for (let t = 0; t < n.length; t += 1) {
			let r = n[t];
			i.put(r.getMode(), 4), i.put(r.getLength(), ut.getLengthInBits(r.getMode(), e)), r.write(i);
		}
		let a = 0;
		for (let e = 0; e < r.length; e += 1) a += r[e].dataCount;
		if (i.getLengthInBits() > a * 8) throw "code length overflow. (" + i.getLengthInBits() + ">" + a * 8 + ")";
		for (i.getLengthInBits() + 4 <= a * 8 && i.put(0, 4); i.getLengthInBits() % 8 != 0;) i.putBit(!1);
		for (; !(i.getLengthInBits() >= a * 8 || (i.put(236, 8), i.getLengthInBits() >= a * 8));) i.put(17, 8);
		return _(i, r);
	};
	c.addData = function(e, t) {
		t ||= "Byte";
		let n = null;
		switch (t) {
			case "Numeric":
				n = ht(e);
				break;
			case "Alphanumeric":
				n = gt(e);
				break;
			case "Byte":
				n = k(e);
				break;
			case "Kanji":
				n = _t(e);
				break;
			default: throw "mode:" + t;
		}
		s.push(n), o = null;
	}, c.isDark = function(e, t) {
		if (e < 0 || a <= e || t < 0 || a <= t) throw e + "," + t;
		return i[e][t];
	}, c.getModuleCount = function() {
		return a;
	}, c.make = function() {
		if (n < 1) {
			let e = 1;
			for (; e < 40; e++) {
				let t = pt.getRSBlocks(e, r), n = mt();
				for (let t = 0; t < s.length; t++) {
					let r = s[t];
					n.put(r.getMode(), 4), n.put(r.getLength(), ut.getLengthInBits(r.getMode(), e)), r.write(n);
				}
				let i = 0;
				for (let e = 0; e < t.length; e++) i += t[e].dataCount;
				if (n.getLengthInBits() <= i * 8) break;
			}
			n = e;
		}
		l(!1, d());
	}, c.createTableTag = function(e, t) {
		e ||= 2, t = t === void 0 ? e * 4 : t;
		let n = "";
		n += "<table style=\"", n += " border-width: 0px; border-style: none;", n += " border-collapse: collapse;", n += " padding: 0px; margin: " + t + "px;", n += "\">", n += "<tbody>";
		for (let t = 0; t < c.getModuleCount(); t += 1) {
			n += "<tr>";
			for (let r = 0; r < c.getModuleCount(); r += 1) n += "<td style=\"", n += " border-width: 0px; border-style: none;", n += " border-collapse: collapse;", n += " padding: 0px; margin: 0px;", n += " width: " + e + "px;", n += " height: " + e + "px;", n += " background-color: ", n += c.isDark(t, r) ? "#000000" : "#ffffff", n += ";", n += "\"/>";
			n += "</tr>";
		}
		return n += "</tbody>", n += "</table>", n;
	}, c.createSvgTag = function(e, t, n, r) {
		let i = {};
		typeof arguments[0] == "object" && (i = arguments[0], e = i.cellSize, t = i.margin, n = i.alt, r = i.title), e ||= 2, t = t === void 0 ? e * 4 : t, n = typeof n == "string" ? { text: n } : n || {}, n.text = n.text || null, n.id = n.text ? n.id || "qrcode-description" : null, r = typeof r == "string" ? { text: r } : r || {}, r.text = r.text || null, r.id = r.text ? r.id || "qrcode-title" : null;
		let a = c.getModuleCount() * e + t * 2, o, s, l, u, d = "", f;
		for (f = "l" + e + ",0 0," + e + " -" + e + ",0 0,-" + e + "z ", d += "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"", d += i.scalable ? "" : " width=\"" + a + "px\" height=\"" + a + "px\"", d += " viewBox=\"0 0 " + a + " " + a + "\" ", d += " preserveAspectRatio=\"xMinYMin meet\"", d += r.text || n.text ? " role=\"img\" aria-labelledby=\"" + y([r.id, n.id].join(" ").trim()) + "\"" : "", d += ">", d += r.text ? "<title id=\"" + y(r.id) + "\">" + y(r.text) + "</title>" : "", d += n.text ? "<description id=\"" + y(n.id) + "\">" + y(n.text) + "</description>" : "", d += "<rect width=\"100%\" height=\"100%\" fill=\"white\" cx=\"0\" cy=\"0\"/>", d += "<path d=\"", l = 0; l < c.getModuleCount(); l += 1) for (u = l * e + t, o = 0; o < c.getModuleCount(); o += 1) c.isDark(l, o) && (s = o * e + t, d += "M" + s + "," + u + f);
		return d += "\" stroke=\"transparent\" fill=\"black\"/>", d += "</svg>", d;
	}, c.createDataURL = function(e, t) {
		e ||= 2, t = t === void 0 ? e * 4 : t;
		let n = c.getModuleCount() * e + t * 2, r = t, i = n - t;
		return bt(n, n, function(t, n) {
			if (r <= t && t < i && r <= n && n < i) {
				let i = Math.floor((t - r) / e), a = Math.floor((n - r) / e);
				return +!c.isDark(a, i);
			} else return 1;
		});
	}, c.createImgTag = function(e, t, n) {
		e ||= 2, t = t === void 0 ? e * 4 : t;
		let r = c.getModuleCount() * e + t * 2, i = "";
		return i += "<img", i += " src=\"", i += c.createDataURL(e, t), i += "\"", i += " width=\"", i += r, i += "\"", i += " height=\"", i += r, i += "\"", n && (i += " alt=\"", i += y(n), i += "\""), i += "/>", i;
	};
	let y = function(e) {
		let t = "";
		for (let n = 0; n < e.length; n += 1) {
			let r = e.charAt(n);
			switch (r) {
				case "<":
					t += "&lt;";
					break;
				case ">":
					t += "&gt;";
					break;
				case "&":
					t += "&amp;";
					break;
				case "\"":
					t += "&quot;";
					break;
				default:
					t += r;
					break;
			}
		}
		return t;
	}, b = function(e) {
		e = e === void 0 ? 2 : e;
		let t = c.getModuleCount() * 1 + e * 2, n = e, r = t - e, i, a, o, s, l, u = {
			"██": "█",
			"█ ": "▀",
			" █": "▄",
			"  ": " "
		}, d = {
			"██": "▀",
			"█ ": "▀",
			" █": " ",
			"  ": " "
		}, f = "";
		for (i = 0; i < t; i += 2) {
			for (o = Math.floor((i - n) / 1), s = Math.floor((i + 1 - n) / 1), a = 0; a < t; a += 1) l = "█", n <= a && a < r && n <= i && i < r && c.isDark(o, Math.floor((a - n) / 1)) && (l = " "), n <= a && a < r && n <= i + 1 && i + 1 < r && c.isDark(s, Math.floor((a - n) / 1)) ? l += " " : l += "█", f += e < 1 && i + 1 >= r ? d[l] : u[l];
			f += "\n";
		}
		return t % 2 && e > 0 ? f.substring(0, f.length - t - 1) + Array(t + 1).join("▀") : f.substring(0, f.length - 1);
	};
	return c.createASCII = function(e, t) {
		if (e ||= 1, e < 2) return b(t);
		--e, t = t === void 0 ? e * 2 : t;
		let n = c.getModuleCount() * e + t * 2, r = t, i = n - t, a, o, s, l, u = Array(e + 1).join("██"), d = Array(e + 1).join("  "), f = "", p = "";
		for (a = 0; a < n; a += 1) {
			for (s = Math.floor((a - r) / e), p = "", o = 0; o < n; o += 1) l = 1, r <= o && o < i && r <= a && a < i && c.isDark(s, Math.floor((o - r) / e)) && (l = 0), p += l ? u : d;
			for (s = 0; s < e; s += 1) f += p + "\n";
		}
		return f.substring(0, f.length - 1);
	}, c.renderTo2dContext = function(e, t) {
		t ||= 2;
		let n = c.getModuleCount();
		for (let r = 0; r < n; r++) for (let i = 0; i < n; i++) e.fillStyle = c.isDark(r, i) ? "black" : "white", e.fillRect(i * t, r * t, t, t);
	}, c;
};
ot.stringToBytes = function(e) {
	let t = [];
	for (let n = 0; n < e.length; n += 1) {
		let r = e.charCodeAt(n);
		t.push(r & 255);
	}
	return t;
}, ot.createStringToBytes = function(e, t) {
	let n = function() {
		let n = A(e), r = function() {
			let e = n.read();
			if (e == -1) throw "eof";
			return e;
		}, i = 0, a = {};
		for (;;) {
			let e = n.read();
			if (e == -1) break;
			let t = r(), o = r(), s = r(), c = String.fromCharCode(e << 8 | t);
			a[c] = o << 8 | s, i += 1;
		}
		if (i != t) throw i + " != " + t;
		return a;
	}();
	return function(e) {
		let t = [];
		for (let r = 0; r < e.length; r += 1) {
			let i = e.charCodeAt(r);
			if (i < 128) t.push(i);
			else {
				let i = n[e.charAt(r)];
				typeof i == "number" ? (i & 255) == i ? t.push(i) : (t.push(i >>> 8), t.push(i & 255)) : t.push(63);
			}
		}
		return t;
	};
};
var st = {
	MODE_NUMBER: 1,
	MODE_ALPHA_NUM: 2,
	MODE_8BIT_BYTE: 4,
	MODE_KANJI: 8
}, ct = {
	L: 1,
	M: 0,
	Q: 3,
	H: 2
}, lt = {
	PATTERN000: 0,
	PATTERN001: 1,
	PATTERN010: 2,
	PATTERN011: 3,
	PATTERN100: 4,
	PATTERN101: 5,
	PATTERN110: 6,
	PATTERN111: 7
}, ut = function() {
	let e = [
		[],
		[6, 18],
		[6, 22],
		[6, 26],
		[6, 30],
		[6, 34],
		[
			6,
			22,
			38
		],
		[
			6,
			24,
			42
		],
		[
			6,
			26,
			46
		],
		[
			6,
			28,
			50
		],
		[
			6,
			30,
			54
		],
		[
			6,
			32,
			58
		],
		[
			6,
			34,
			62
		],
		[
			6,
			26,
			46,
			66
		],
		[
			6,
			26,
			48,
			70
		],
		[
			6,
			26,
			50,
			74
		],
		[
			6,
			30,
			54,
			78
		],
		[
			6,
			30,
			56,
			82
		],
		[
			6,
			30,
			58,
			86
		],
		[
			6,
			34,
			62,
			90
		],
		[
			6,
			28,
			50,
			72,
			94
		],
		[
			6,
			26,
			50,
			74,
			98
		],
		[
			6,
			30,
			54,
			78,
			102
		],
		[
			6,
			28,
			54,
			80,
			106
		],
		[
			6,
			32,
			58,
			84,
			110
		],
		[
			6,
			30,
			58,
			86,
			114
		],
		[
			6,
			34,
			62,
			90,
			118
		],
		[
			6,
			26,
			50,
			74,
			98,
			122
		],
		[
			6,
			30,
			54,
			78,
			102,
			126
		],
		[
			6,
			26,
			52,
			78,
			104,
			130
		],
		[
			6,
			30,
			56,
			82,
			108,
			134
		],
		[
			6,
			34,
			60,
			86,
			112,
			138
		],
		[
			6,
			30,
			58,
			86,
			114,
			142
		],
		[
			6,
			34,
			62,
			90,
			118,
			146
		],
		[
			6,
			30,
			54,
			78,
			102,
			126,
			150
		],
		[
			6,
			24,
			50,
			76,
			102,
			128,
			154
		],
		[
			6,
			28,
			54,
			80,
			106,
			132,
			158
		],
		[
			6,
			32,
			58,
			84,
			110,
			136,
			162
		],
		[
			6,
			26,
			54,
			82,
			110,
			138,
			166
		],
		[
			6,
			30,
			58,
			86,
			114,
			142,
			170
		]
	], t = 1335, n = 7973, r = {}, i = function(e) {
		let t = 0;
		for (; e != 0;) t += 1, e >>>= 1;
		return t;
	};
	return r.getBCHTypeInfo = function(e) {
		let n = e << 10;
		for (; i(n) - i(t) >= 0;) n ^= t << i(n) - i(t);
		return (e << 10 | n) ^ 21522;
	}, r.getBCHTypeNumber = function(e) {
		let t = e << 12;
		for (; i(t) - i(n) >= 0;) t ^= n << i(t) - i(n);
		return e << 12 | t;
	}, r.getPatternPosition = function(t) {
		return e[t - 1];
	}, r.getMaskFunction = function(e) {
		switch (e) {
			case lt.PATTERN000: return function(e, t) {
				return (e + t) % 2 == 0;
			};
			case lt.PATTERN001: return function(e, t) {
				return e % 2 == 0;
			};
			case lt.PATTERN010: return function(e, t) {
				return t % 3 == 0;
			};
			case lt.PATTERN011: return function(e, t) {
				return (e + t) % 3 == 0;
			};
			case lt.PATTERN100: return function(e, t) {
				return (Math.floor(e / 2) + Math.floor(t / 3)) % 2 == 0;
			};
			case lt.PATTERN101: return function(e, t) {
				return e * t % 2 + e * t % 3 == 0;
			};
			case lt.PATTERN110: return function(e, t) {
				return (e * t % 2 + e * t % 3) % 2 == 0;
			};
			case lt.PATTERN111: return function(e, t) {
				return (e * t % 3 + (e + t) % 2) % 2 == 0;
			};
			default: throw "bad maskPattern:" + e;
		}
	}, r.getErrorCorrectPolynomial = function(e) {
		let t = ft([1], 0);
		for (let n = 0; n < e; n += 1) t = t.multiply(ft([1, dt.gexp(n)], 0));
		return t;
	}, r.getLengthInBits = function(e, t) {
		if (1 <= t && t < 10) switch (e) {
			case st.MODE_NUMBER: return 10;
			case st.MODE_ALPHA_NUM: return 9;
			case st.MODE_8BIT_BYTE: return 8;
			case st.MODE_KANJI: return 8;
			default: throw "mode:" + e;
		}
		else if (t < 27) switch (e) {
			case st.MODE_NUMBER: return 12;
			case st.MODE_ALPHA_NUM: return 11;
			case st.MODE_8BIT_BYTE: return 16;
			case st.MODE_KANJI: return 10;
			default: throw "mode:" + e;
		}
		else if (t < 41) switch (e) {
			case st.MODE_NUMBER: return 14;
			case st.MODE_ALPHA_NUM: return 13;
			case st.MODE_8BIT_BYTE: return 16;
			case st.MODE_KANJI: return 12;
			default: throw "mode:" + e;
		}
		else throw "type:" + t;
	}, r.getLostPoint = function(e) {
		let t = e.getModuleCount(), n = 0;
		for (let r = 0; r < t; r += 1) for (let i = 0; i < t; i += 1) {
			let a = 0, o = e.isDark(r, i);
			for (let n = -1; n <= 1; n += 1) if (!(r + n < 0 || t <= r + n)) for (let s = -1; s <= 1; s += 1) i + s < 0 || t <= i + s || n == 0 && s == 0 || o == e.isDark(r + n, i + s) && (a += 1);
			a > 5 && (n += 3 + a - 5);
		}
		for (let r = 0; r < t - 1; r += 1) for (let i = 0; i < t - 1; i += 1) {
			let t = 0;
			e.isDark(r, i) && (t += 1), e.isDark(r + 1, i) && (t += 1), e.isDark(r, i + 1) && (t += 1), e.isDark(r + 1, i + 1) && (t += 1), (t == 0 || t == 4) && (n += 3);
		}
		for (let r = 0; r < t; r += 1) for (let i = 0; i < t - 6; i += 1) e.isDark(r, i) && !e.isDark(r, i + 1) && e.isDark(r, i + 2) && e.isDark(r, i + 3) && e.isDark(r, i + 4) && !e.isDark(r, i + 5) && e.isDark(r, i + 6) && (n += 40);
		for (let r = 0; r < t; r += 1) for (let i = 0; i < t - 6; i += 1) e.isDark(i, r) && !e.isDark(i + 1, r) && e.isDark(i + 2, r) && e.isDark(i + 3, r) && e.isDark(i + 4, r) && !e.isDark(i + 5, r) && e.isDark(i + 6, r) && (n += 40);
		let r = 0;
		for (let n = 0; n < t; n += 1) for (let i = 0; i < t; i += 1) e.isDark(i, n) && (r += 1);
		let i = Math.abs(100 * r / t / t - 50) / 5;
		return n += i * 10, n;
	}, r;
}(), dt = function() {
	let e = Array(256), t = Array(256);
	for (let t = 0; t < 8; t += 1) e[t] = 1 << t;
	for (let t = 8; t < 256; t += 1) e[t] = e[t - 4] ^ e[t - 5] ^ e[t - 6] ^ e[t - 8];
	for (let n = 0; n < 255; n += 1) t[e[n]] = n;
	let n = {};
	return n.glog = function(e) {
		if (e < 1) throw "glog(" + e + ")";
		return t[e];
	}, n.gexp = function(t) {
		for (; t < 0;) t += 255;
		for (; t >= 256;) t -= 255;
		return e[t];
	}, n;
}(), ft = function(e, t) {
	if (e.length === void 0) throw e.length + "/" + t;
	let n = function() {
		let n = 0;
		for (; n < e.length && e[n] == 0;) n += 1;
		let r = Array(e.length - n + t);
		for (let t = 0; t < e.length - n; t += 1) r[t] = e[t + n];
		return r;
	}(), r = {};
	return r.getAt = function(e) {
		return n[e];
	}, r.getLength = function() {
		return n.length;
	}, r.multiply = function(e) {
		let t = Array(r.getLength() + e.getLength() - 1);
		for (let n = 0; n < r.getLength(); n += 1) for (let i = 0; i < e.getLength(); i += 1) t[n + i] ^= dt.gexp(dt.glog(r.getAt(n)) + dt.glog(e.getAt(i)));
		return ft(t, 0);
	}, r.mod = function(e) {
		if (r.getLength() - e.getLength() < 0) return r;
		let t = dt.glog(r.getAt(0)) - dt.glog(e.getAt(0)), n = Array(r.getLength());
		for (let e = 0; e < r.getLength(); e += 1) n[e] = r.getAt(e);
		for (let r = 0; r < e.getLength(); r += 1) n[r] ^= dt.gexp(dt.glog(e.getAt(r)) + t);
		return ft(n, 0).mod(e);
	}, r;
}, pt = function() {
	let e = [
		[
			1,
			26,
			19
		],
		[
			1,
			26,
			16
		],
		[
			1,
			26,
			13
		],
		[
			1,
			26,
			9
		],
		[
			1,
			44,
			34
		],
		[
			1,
			44,
			28
		],
		[
			1,
			44,
			22
		],
		[
			1,
			44,
			16
		],
		[
			1,
			70,
			55
		],
		[
			1,
			70,
			44
		],
		[
			2,
			35,
			17
		],
		[
			2,
			35,
			13
		],
		[
			1,
			100,
			80
		],
		[
			2,
			50,
			32
		],
		[
			2,
			50,
			24
		],
		[
			4,
			25,
			9
		],
		[
			1,
			134,
			108
		],
		[
			2,
			67,
			43
		],
		[
			2,
			33,
			15,
			2,
			34,
			16
		],
		[
			2,
			33,
			11,
			2,
			34,
			12
		],
		[
			2,
			86,
			68
		],
		[
			4,
			43,
			27
		],
		[
			4,
			43,
			19
		],
		[
			4,
			43,
			15
		],
		[
			2,
			98,
			78
		],
		[
			4,
			49,
			31
		],
		[
			2,
			32,
			14,
			4,
			33,
			15
		],
		[
			4,
			39,
			13,
			1,
			40,
			14
		],
		[
			2,
			121,
			97
		],
		[
			2,
			60,
			38,
			2,
			61,
			39
		],
		[
			4,
			40,
			18,
			2,
			41,
			19
		],
		[
			4,
			40,
			14,
			2,
			41,
			15
		],
		[
			2,
			146,
			116
		],
		[
			3,
			58,
			36,
			2,
			59,
			37
		],
		[
			4,
			36,
			16,
			4,
			37,
			17
		],
		[
			4,
			36,
			12,
			4,
			37,
			13
		],
		[
			2,
			86,
			68,
			2,
			87,
			69
		],
		[
			4,
			69,
			43,
			1,
			70,
			44
		],
		[
			6,
			43,
			19,
			2,
			44,
			20
		],
		[
			6,
			43,
			15,
			2,
			44,
			16
		],
		[
			4,
			101,
			81
		],
		[
			1,
			80,
			50,
			4,
			81,
			51
		],
		[
			4,
			50,
			22,
			4,
			51,
			23
		],
		[
			3,
			36,
			12,
			8,
			37,
			13
		],
		[
			2,
			116,
			92,
			2,
			117,
			93
		],
		[
			6,
			58,
			36,
			2,
			59,
			37
		],
		[
			4,
			46,
			20,
			6,
			47,
			21
		],
		[
			7,
			42,
			14,
			4,
			43,
			15
		],
		[
			4,
			133,
			107
		],
		[
			8,
			59,
			37,
			1,
			60,
			38
		],
		[
			8,
			44,
			20,
			4,
			45,
			21
		],
		[
			12,
			33,
			11,
			4,
			34,
			12
		],
		[
			3,
			145,
			115,
			1,
			146,
			116
		],
		[
			4,
			64,
			40,
			5,
			65,
			41
		],
		[
			11,
			36,
			16,
			5,
			37,
			17
		],
		[
			11,
			36,
			12,
			5,
			37,
			13
		],
		[
			5,
			109,
			87,
			1,
			110,
			88
		],
		[
			5,
			65,
			41,
			5,
			66,
			42
		],
		[
			5,
			54,
			24,
			7,
			55,
			25
		],
		[
			11,
			36,
			12,
			7,
			37,
			13
		],
		[
			5,
			122,
			98,
			1,
			123,
			99
		],
		[
			7,
			73,
			45,
			3,
			74,
			46
		],
		[
			15,
			43,
			19,
			2,
			44,
			20
		],
		[
			3,
			45,
			15,
			13,
			46,
			16
		],
		[
			1,
			135,
			107,
			5,
			136,
			108
		],
		[
			10,
			74,
			46,
			1,
			75,
			47
		],
		[
			1,
			50,
			22,
			15,
			51,
			23
		],
		[
			2,
			42,
			14,
			17,
			43,
			15
		],
		[
			5,
			150,
			120,
			1,
			151,
			121
		],
		[
			9,
			69,
			43,
			4,
			70,
			44
		],
		[
			17,
			50,
			22,
			1,
			51,
			23
		],
		[
			2,
			42,
			14,
			19,
			43,
			15
		],
		[
			3,
			141,
			113,
			4,
			142,
			114
		],
		[
			3,
			70,
			44,
			11,
			71,
			45
		],
		[
			17,
			47,
			21,
			4,
			48,
			22
		],
		[
			9,
			39,
			13,
			16,
			40,
			14
		],
		[
			3,
			135,
			107,
			5,
			136,
			108
		],
		[
			3,
			67,
			41,
			13,
			68,
			42
		],
		[
			15,
			54,
			24,
			5,
			55,
			25
		],
		[
			15,
			43,
			15,
			10,
			44,
			16
		],
		[
			4,
			144,
			116,
			4,
			145,
			117
		],
		[
			17,
			68,
			42
		],
		[
			17,
			50,
			22,
			6,
			51,
			23
		],
		[
			19,
			46,
			16,
			6,
			47,
			17
		],
		[
			2,
			139,
			111,
			7,
			140,
			112
		],
		[
			17,
			74,
			46
		],
		[
			7,
			54,
			24,
			16,
			55,
			25
		],
		[
			34,
			37,
			13
		],
		[
			4,
			151,
			121,
			5,
			152,
			122
		],
		[
			4,
			75,
			47,
			14,
			76,
			48
		],
		[
			11,
			54,
			24,
			14,
			55,
			25
		],
		[
			16,
			45,
			15,
			14,
			46,
			16
		],
		[
			6,
			147,
			117,
			4,
			148,
			118
		],
		[
			6,
			73,
			45,
			14,
			74,
			46
		],
		[
			11,
			54,
			24,
			16,
			55,
			25
		],
		[
			30,
			46,
			16,
			2,
			47,
			17
		],
		[
			8,
			132,
			106,
			4,
			133,
			107
		],
		[
			8,
			75,
			47,
			13,
			76,
			48
		],
		[
			7,
			54,
			24,
			22,
			55,
			25
		],
		[
			22,
			45,
			15,
			13,
			46,
			16
		],
		[
			10,
			142,
			114,
			2,
			143,
			115
		],
		[
			19,
			74,
			46,
			4,
			75,
			47
		],
		[
			28,
			50,
			22,
			6,
			51,
			23
		],
		[
			33,
			46,
			16,
			4,
			47,
			17
		],
		[
			8,
			152,
			122,
			4,
			153,
			123
		],
		[
			22,
			73,
			45,
			3,
			74,
			46
		],
		[
			8,
			53,
			23,
			26,
			54,
			24
		],
		[
			12,
			45,
			15,
			28,
			46,
			16
		],
		[
			3,
			147,
			117,
			10,
			148,
			118
		],
		[
			3,
			73,
			45,
			23,
			74,
			46
		],
		[
			4,
			54,
			24,
			31,
			55,
			25
		],
		[
			11,
			45,
			15,
			31,
			46,
			16
		],
		[
			7,
			146,
			116,
			7,
			147,
			117
		],
		[
			21,
			73,
			45,
			7,
			74,
			46
		],
		[
			1,
			53,
			23,
			37,
			54,
			24
		],
		[
			19,
			45,
			15,
			26,
			46,
			16
		],
		[
			5,
			145,
			115,
			10,
			146,
			116
		],
		[
			19,
			75,
			47,
			10,
			76,
			48
		],
		[
			15,
			54,
			24,
			25,
			55,
			25
		],
		[
			23,
			45,
			15,
			25,
			46,
			16
		],
		[
			13,
			145,
			115,
			3,
			146,
			116
		],
		[
			2,
			74,
			46,
			29,
			75,
			47
		],
		[
			42,
			54,
			24,
			1,
			55,
			25
		],
		[
			23,
			45,
			15,
			28,
			46,
			16
		],
		[
			17,
			145,
			115
		],
		[
			10,
			74,
			46,
			23,
			75,
			47
		],
		[
			10,
			54,
			24,
			35,
			55,
			25
		],
		[
			19,
			45,
			15,
			35,
			46,
			16
		],
		[
			17,
			145,
			115,
			1,
			146,
			116
		],
		[
			14,
			74,
			46,
			21,
			75,
			47
		],
		[
			29,
			54,
			24,
			19,
			55,
			25
		],
		[
			11,
			45,
			15,
			46,
			46,
			16
		],
		[
			13,
			145,
			115,
			6,
			146,
			116
		],
		[
			14,
			74,
			46,
			23,
			75,
			47
		],
		[
			44,
			54,
			24,
			7,
			55,
			25
		],
		[
			59,
			46,
			16,
			1,
			47,
			17
		],
		[
			12,
			151,
			121,
			7,
			152,
			122
		],
		[
			12,
			75,
			47,
			26,
			76,
			48
		],
		[
			39,
			54,
			24,
			14,
			55,
			25
		],
		[
			22,
			45,
			15,
			41,
			46,
			16
		],
		[
			6,
			151,
			121,
			14,
			152,
			122
		],
		[
			6,
			75,
			47,
			34,
			76,
			48
		],
		[
			46,
			54,
			24,
			10,
			55,
			25
		],
		[
			2,
			45,
			15,
			64,
			46,
			16
		],
		[
			17,
			152,
			122,
			4,
			153,
			123
		],
		[
			29,
			74,
			46,
			14,
			75,
			47
		],
		[
			49,
			54,
			24,
			10,
			55,
			25
		],
		[
			24,
			45,
			15,
			46,
			46,
			16
		],
		[
			4,
			152,
			122,
			18,
			153,
			123
		],
		[
			13,
			74,
			46,
			32,
			75,
			47
		],
		[
			48,
			54,
			24,
			14,
			55,
			25
		],
		[
			42,
			45,
			15,
			32,
			46,
			16
		],
		[
			20,
			147,
			117,
			4,
			148,
			118
		],
		[
			40,
			75,
			47,
			7,
			76,
			48
		],
		[
			43,
			54,
			24,
			22,
			55,
			25
		],
		[
			10,
			45,
			15,
			67,
			46,
			16
		],
		[
			19,
			148,
			118,
			6,
			149,
			119
		],
		[
			18,
			75,
			47,
			31,
			76,
			48
		],
		[
			34,
			54,
			24,
			34,
			55,
			25
		],
		[
			20,
			45,
			15,
			61,
			46,
			16
		]
	], t = function(e, t) {
		let n = {};
		return n.totalCount = e, n.dataCount = t, n;
	}, n = {}, r = function(t, n) {
		switch (n) {
			case ct.L: return e[(t - 1) * 4 + 0];
			case ct.M: return e[(t - 1) * 4 + 1];
			case ct.Q: return e[(t - 1) * 4 + 2];
			case ct.H: return e[(t - 1) * 4 + 3];
			default: return;
		}
	};
	return n.getRSBlocks = function(e, n) {
		let i = r(e, n);
		if (i === void 0) throw "bad rs block @ typeNumber:" + e + "/errorCorrectionLevel:" + n;
		let a = i.length / 3, o = [];
		for (let e = 0; e < a; e += 1) {
			let n = i[e * 3 + 0], r = i[e * 3 + 1], a = i[e * 3 + 2];
			for (let e = 0; e < n; e += 1) o.push(t(r, a));
		}
		return o;
	}, n;
}(), mt = function() {
	let e = [], t = 0, n = {};
	return n.getBuffer = function() {
		return e;
	}, n.getAt = function(t) {
		return (e[Math.floor(t / 8)] >>> 7 - t % 8 & 1) == 1;
	}, n.put = function(e, t) {
		for (let r = 0; r < t; r += 1) n.putBit((e >>> t - r - 1 & 1) == 1);
	}, n.getLengthInBits = function() {
		return t;
	}, n.putBit = function(n) {
		let r = Math.floor(t / 8);
		e.length <= r && e.push(0), n && (e[r] |= 128 >>> t % 8), t += 1;
	}, n;
}, ht = function(e) {
	let t = st.MODE_NUMBER, n = e, r = {};
	r.getMode = function() {
		return t;
	}, r.getLength = function(e) {
		return n.length;
	}, r.write = function(e) {
		let t = n, r = 0;
		for (; r + 2 < t.length;) e.put(i(t.substring(r, r + 3)), 10), r += 3;
		r < t.length && (t.length - r == 1 ? e.put(i(t.substring(r, r + 1)), 4) : t.length - r == 2 && e.put(i(t.substring(r, r + 2)), 7));
	};
	let i = function(e) {
		let t = 0;
		for (let n = 0; n < e.length; n += 1) t = t * 10 + a(e.charAt(n));
		return t;
	}, a = function(e) {
		if ("0" <= e && e <= "9") return e.charCodeAt(0) - 48;
		throw "illegal char :" + e;
	};
	return r;
}, gt = function(e) {
	let t = st.MODE_ALPHA_NUM, n = e, r = {};
	r.getMode = function() {
		return t;
	}, r.getLength = function(e) {
		return n.length;
	}, r.write = function(e) {
		let t = n, r = 0;
		for (; r + 1 < t.length;) e.put(i(t.charAt(r)) * 45 + i(t.charAt(r + 1)), 11), r += 2;
		r < t.length && e.put(i(t.charAt(r)), 6);
	};
	let i = function(e) {
		if ("0" <= e && e <= "9") return e.charCodeAt(0) - 48;
		if ("A" <= e && e <= "Z") return e.charCodeAt(0) - 65 + 10;
		switch (e) {
			case " ": return 36;
			case "$": return 37;
			case "%": return 38;
			case "*": return 39;
			case "+": return 40;
			case "-": return 41;
			case ".": return 42;
			case "/": return 43;
			case ":": return 44;
			default: throw "illegal char :" + e;
		}
	};
	return r;
}, k = function(e) {
	let t = st.MODE_8BIT_BYTE, n = ot.stringToBytes(e), r = {};
	return r.getMode = function() {
		return t;
	}, r.getLength = function(e) {
		return n.length;
	}, r.write = function(e) {
		for (let t = 0; t < n.length; t += 1) e.put(n[t], 8);
	}, r;
}, _t = function(e) {
	let t = st.MODE_KANJI, n = ot.stringToBytes;
	(function(e, t) {
		let r = n(e);
		if (r.length != 2 || (r[0] << 8 | r[1]) != t) throw "sjis not supported.";
	})("友", 38726);
	let r = n(e), i = {};
	return i.getMode = function() {
		return t;
	}, i.getLength = function(e) {
		return ~~(r.length / 2);
	}, i.write = function(e) {
		let t = r, n = 0;
		for (; n + 1 < t.length;) {
			let r = (255 & t[n]) << 8 | 255 & t[n + 1];
			if (33088 <= r && r <= 40956) r -= 33088;
			else if (57408 <= r && r <= 60351) r -= 49472;
			else throw "illegal char at " + (n + 1) + "/" + r;
			r = (r >>> 8 & 255) * 192 + (r & 255), e.put(r, 13), n += 2;
		}
		if (n < t.length) throw "illegal char at " + (n + 1);
	}, i;
}, vt = function() {
	let e = [], t = {};
	return t.writeByte = function(t) {
		e.push(t & 255);
	}, t.writeShort = function(e) {
		t.writeByte(e), t.writeByte(e >>> 8);
	}, t.writeBytes = function(e, n, r) {
		n ||= 0, r ||= e.length;
		for (let i = 0; i < r; i += 1) t.writeByte(e[i + n]);
	}, t.writeString = function(e) {
		for (let n = 0; n < e.length; n += 1) t.writeByte(e.charCodeAt(n));
	}, t.toByteArray = function() {
		return e;
	}, t.toString = function() {
		let t = "";
		t += "[";
		for (let n = 0; n < e.length; n += 1) n > 0 && (t += ","), t += e[n];
		return t += "]", t;
	}, t;
}, yt = function() {
	let e = 0, t = 0, n = 0, r = "", i = {}, a = function(e) {
		r += String.fromCharCode(o(e & 63));
	}, o = function(e) {
		if (e < 0) throw "n:" + e;
		if (e < 26) return 65 + e;
		if (e < 52) return 97 + (e - 26);
		if (e < 62) return 48 + (e - 52);
		if (e == 62) return 43;
		if (e == 63) return 47;
		throw "n:" + e;
	};
	return i.writeByte = function(r) {
		for (e = e << 8 | r & 255, t += 8, n += 1; t >= 6;) a(e >>> t - 6), t -= 6;
	}, i.flush = function() {
		if (t > 0 && (a(e << 6 - t), e = 0, t = 0), n % 3 != 0) {
			let e = 3 - n % 3;
			for (let t = 0; t < e; t += 1) r += "=";
		}
	}, i.toString = function() {
		return r;
	}, i;
}, A = function(e) {
	let t = e, n = 0, r = 0, i = 0, a = {};
	a.read = function() {
		for (; i < 8;) {
			if (n >= t.length) {
				if (i == 0) return -1;
				throw "unexpected end of file./" + i;
			}
			let e = t.charAt(n);
			if (n += 1, e == "=") return i = 0, -1;
			e.match(/^\s$/) || (r = r << 6 | o(e.charCodeAt(0)), i += 6);
		}
		let e = r >>> i - 8 & 255;
		return i -= 8, e;
	};
	let o = function(e) {
		if (65 <= e && e <= 90) return e - 65;
		if (97 <= e && e <= 122) return e - 97 + 26;
		if (48 <= e && e <= 57) return e - 48 + 52;
		if (e == 43) return 62;
		if (e == 47) return 63;
		throw "c:" + e;
	};
	return a;
}, j = function(e, t) {
	let n = e, r = t, i = Array(e * t), a = {};
	a.setPixel = function(e, t, r) {
		i[t * n + e] = r;
	}, a.write = function(e) {
		e.writeString("GIF87a"), e.writeShort(n), e.writeShort(r), e.writeByte(128), e.writeByte(0), e.writeByte(0), e.writeByte(0), e.writeByte(0), e.writeByte(0), e.writeByte(255), e.writeByte(255), e.writeByte(255), e.writeString(","), e.writeShort(0), e.writeShort(0), e.writeShort(n), e.writeShort(r), e.writeByte(0);
		let t = s(2);
		e.writeByte(2);
		let i = 0;
		for (; t.length - i > 255;) e.writeByte(255), e.writeBytes(t, i, 255), i += 255;
		e.writeByte(t.length - i), e.writeBytes(t, i, t.length - i), e.writeByte(0), e.writeString(";");
	};
	let o = function(e) {
		let t = e, n = 0, r = 0, i = {};
		return i.write = function(e, i) {
			if (e >>> i) throw "length over";
			for (; n + i >= 8;) t.writeByte(255 & (e << n | r)), i -= 8 - n, e >>>= 8 - n, r = 0, n = 0;
			r = e << n | r, n += i;
		}, i.flush = function() {
			n > 0 && t.writeByte(r);
		}, i;
	}, s = function(e) {
		let t = 1 << e, n = (1 << e) + 1, r = e + 1, a = c();
		for (let e = 0; e < t; e += 1) a.add(String.fromCharCode(e));
		a.add(String.fromCharCode(t)), a.add(String.fromCharCode(n));
		let s = vt(), l = o(s);
		l.write(t, r);
		let u = 0, d = String.fromCharCode(i[u]);
		for (u += 1; u < i.length;) {
			let e = String.fromCharCode(i[u]);
			u += 1, a.contains(d + e) ? d += e : (l.write(a.indexOf(d), r), a.size() < 4095 && (a.size() == 1 << r && (r += 1), a.add(d + e)), d = e);
		}
		return l.write(a.indexOf(d), r), l.write(n, r), l.flush(), s.toByteArray();
	}, c = function() {
		let e = {}, t = 0, n = {};
		return n.add = function(r) {
			if (n.contains(r)) throw "dup key:" + r;
			e[r] = t, t += 1;
		}, n.size = function() {
			return t;
		}, n.indexOf = function(t) {
			return e[t];
		}, n.contains = function(t) {
			return e[t] !== void 0;
		}, n;
	};
	return a;
}, bt = function(e, t, n) {
	let r = j(e, t);
	for (let i = 0; i < t; i += 1) for (let t = 0; t < e; t += 1) r.setPixel(t, i, n(t, i));
	let i = vt();
	r.write(i);
	let a = yt(), o = i.toByteArray();
	for (let e = 0; e < o.length; e += 1) a.writeByte(o[e]);
	return a.flush(), "data:image/gif;base64," + a;
};
ot.stringToBytes;
//#endregion
//#region node_modules/.pnpm/react@19.2.6/node_modules/react/cjs/react-jsx-runtime.production.js
var xt = /* @__PURE__ */ o(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.fragment");
	function r(e, n, r) {
		var i = null;
		if (r !== void 0 && (i = "" + r), n.key !== void 0 && (i = "" + n.key), "key" in n) for (var a in r = {}, n) a !== "key" && (r[a] = n[a]);
		else r = n;
		return n = r.ref, {
			$$typeof: t,
			type: e,
			key: i,
			ref: n === void 0 ? null : n,
			props: r
		};
	}
	e.Fragment = n, e.jsx = r, e.jsxs = r;
})), M = (/* @__PURE__ */ o(((e, t) => {
	t.exports = xt();
})))();
function St({ liner: e, width: t, depth: n, id: r }) {
	let i = (0, _.useRef)(null), a = (0, _.useRef)(null);
	return (0, _.useEffect)(() => {
		if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
		let e = i.current?.animate([{ transform: "scaleY(0)" }, { transform: "scaleY(1)" }], {
			duration: 950,
			easing: "cubic-bezier(.32,.72,0,1)"
		}), t = a.current?.animate([
			{
				transform: "translateY(0px)",
				opacity: 1
			},
			{
				transform: `translateY(${n - 8}px)`,
				opacity: 1,
				offset: .92
			},
			{
				transform: `translateY(${n}px)`,
				opacity: 0
			}
		], {
			duration: 950,
			easing: "cubic-bezier(.32,.72,0,1)"
		});
		return () => {
			e?.cancel(), t?.cancel();
		};
	}, [e.id, n]), /* @__PURE__ */ (0, M.jsxs)("g", {
		pointerEvents: "none",
		"aria-hidden": "true",
		children: [
			/* @__PURE__ */ (0, M.jsxs)("defs", { children: [/* @__PURE__ */ (0, M.jsx)("pattern", {
				id: `${r}-weave`,
				width: "5",
				height: "5",
				patternUnits: "userSpaceOnUse",
				children: /* @__PURE__ */ (0, M.jsx)("path", {
					d: "M.7 .7h1.5v1.5H.7z M3.2 3.2h1v1h-1z",
					fill: "none",
					stroke: "#53594e",
					strokeWidth: ".35",
					opacity: ".45"
				})
			}), /* @__PURE__ */ (0, M.jsx)("clipPath", {
				id: `${r}-unroll`,
				children: /* @__PURE__ */ (0, M.jsx)("rect", {
					ref: i,
					width: t,
					height: n,
					rx: "4",
					style: { transformOrigin: "0 0" }
				})
			})] }),
			/* @__PURE__ */ (0, M.jsxs)("g", {
				clipPath: `url(#${r}-unroll)`,
				children: [/* @__PURE__ */ (0, M.jsx)("rect", {
					width: t,
					height: n,
					rx: "4",
					fill: e.colour,
					fillOpacity: ".48"
				}), /* @__PURE__ */ (0, M.jsx)("rect", {
					width: t,
					height: n,
					rx: "4",
					fill: `url(#${r}-weave)`
				})]
			}),
			/* @__PURE__ */ (0, M.jsxs)("g", {
				ref: a,
				opacity: "0",
				children: [/* @__PURE__ */ (0, M.jsx)("rect", {
					x: "1",
					y: "0",
					width: t - 2,
					height: "8",
					rx: "4",
					fill: "#e8e9e1",
					stroke: "#8b9184",
					strokeWidth: ".65"
				}), /* @__PURE__ */ (0, M.jsx)("path", {
					d: `M5 3H${t - 5}`,
					stroke: "#bec2b6",
					strokeWidth: ".5"
				})]
			})
		]
	});
}
//#endregion
//#region components/sketch-tray.tsx
var Ct = Math.cos(Math.PI / 6), N = (e, t, n) => [(e - t) * Ct, (e + t) * .34 - n * 1.15], P = (e) => e.toFixed(1), F = (e) => e.map((e, t) => `${t ? "L" : "M"}${P(e[0])} ${P(e[1])}`).join("") + "Z", wt = "#000000", Tt = {
	white: {
		top: "#ffffff",
		mid: "#f1f1ee",
		dark: "#e4e4e0",
		well: "#f3f3f3",
		hi: "#ffffff"
	},
	anthracite: {
		top: "#e6e7e8",
		mid: "#d9dbdd",
		dark: "#cbced1",
		well: "#dfe1e3",
		hi: "#ffffff"
	},
	steel: {
		top: "#f4f5f6",
		mid: "#e8eaec",
		dark: "#dcdfe2",
		well: "#eef0f1",
		hi: "#ffffff"
	},
	other: {
		top: "#f8f7f4",
		mid: "#eeede9",
		dark: "#e2e1dc",
		well: "#f2f1ee",
		hi: "#ffffff"
	}
}, Et = {
	oak: {
		floor: "#f6efe3",
		grain: "#d8c4a2",
		top: "#fbf7f0",
		wall: "#efe4d1",
		inner: "#e6d7bd",
		edge: "#ffffff"
	},
	ash: {
		floor: "#e6e1dc",
		grain: "#bfb5ab",
		top: "#f1eeea",
		wall: "#ddd6cf",
		inner: "#d2c9c0",
		edge: "#ffffff"
	},
	bamboo: {
		floor: "#f7f0df",
		grain: "#dccaa0",
		top: "#fcf8ee",
		wall: "#f0e5ca",
		inner: "#e7d8b5",
		edge: "#ffffff"
	}
}, Dt = (e) => e.finish === "anthracite" || e.finish === "black" || e.finish === "grey", Ot = (e) => e.finish === "timber" || e.finish === "bamboo", kt = (e) => e.finish === "bamboo" ? Et.bamboo : /black|ash/i.test(e.finishName ?? "") && !/nordic/i.test(e.finishName ?? "") ? Et.ash : Et.oak, I = (e) => Dt(e) ? Tt.anthracite : e.finish === "white" ? Tt.white : e.finish === "stainless" ? Tt.steel : Tt.other;
function At(e) {
	let t = [...e].sort((e, t) => e[0] - t[0] || e[1] - t[1]), n = (e, t, n) => (t[0] - e[0]) * (n[1] - e[1]) - (t[1] - e[1]) * (n[0] - e[0]), r = [], i = [];
	for (let e of t) {
		for (; r.length > 1 && n(r[r.length - 2], r[r.length - 1], e) <= 0;) r.pop();
		r.push(e);
	}
	for (let e of [...t].reverse()) {
		for (; i.length > 1 && n(i[i.length - 2], i[i.length - 1], e) <= 0;) i.pop();
		i.push(e);
	}
	return r.slice(0, -1).concat(i.slice(0, -1));
}
function jt(e, t, n, r, i, a) {
	i = Math.max(0, Math.min(i, n / 2, r / 2));
	let o = [], s = (e, t, n) => {
		for (let r = 0; r <= 5; r++) {
			let s = n + r * Math.PI / 10;
			o.push(N(e + Math.cos(s) * i, t + Math.sin(s) * i, a));
		}
	};
	return s(e + n - i, t + i, -Math.PI / 2), s(e + n - i, t + r - i, 0), s(e + i, t + r - i, Math.PI / 2), s(e + i, t + i, Math.PI), o;
}
function Mt(e, t, n, r = .9, i = 1) {
	let a = t[0] - e[0], o = t[1] - e[1], s = Math.hypot(a, o) || 1, c = a / s, l = o / s, u = [e[0] - c * 0, e[1] - l * 0], d = [t[0] + c * 0, t[1] + l * 0];
	return /* @__PURE__ */ (0, M.jsx)("g", { children: /* @__PURE__ */ (0, M.jsx)("path", {
		d: `M${P(u[0])} ${P(u[1])}L${P(d[0])} ${P(d[1])}`,
		stroke: wt,
		strokeWidth: r,
		opacity: i,
		strokeLinecap: "round",
		vectorEffect: "non-scaling-stroke"
	}) }, n);
}
function Nt(e, t, n, r, i, a, o, s = 1) {
	let c = [
		[e, t],
		[e + n, t],
		[e + n, t + r],
		[e, t + r]
	], l = [];
	for (let e = 0; e < 4; e++) {
		let [t, n] = c[e], [r, i] = c[(e + 1) % 4];
		l.push(Mt(N(t, n, a), N(r, i, a), `${o}t${e}`, .9, s));
	}
	for (let [c, [u, d]] of [
		[e + n, t],
		[e + n, t + r],
		[e, t + r]
	].entries()) l.push(Mt(N(u, d, a), N(u, d, i), `${o}v${c}`, .9, s));
	return l.push(Mt(N(e, t + r, i), N(e + n, t + r, i), `${o}b0`, .9, s), Mt(N(e + n, t, i), N(e + n, t + r, i), `${o}b1`, .9, s)), l;
}
var Pt = (e, t) => {
	let n = parseInt(e.slice(1), 16);
	return "#" + [
		n >> 16,
		n >> 8 & 255,
		n & 255
	].map((e) => Math.max(0, Math.min(255, Math.round(e * t))).toString(16).padStart(2, "0")).join("");
}, Ft = 1, It = () => (Ft = Ft * 16807 % 2147483647) / 2147483647, Lt = (e) => e.compartments.map((t) => ({
	x: t.x,
	y: e.depth - t.y - t.depth,
	w: t.width,
	d: t.depth
}));
function Rt({ p: e, id: t, shadow: n }) {
	let r = I(e), i = e.width, a = e.depth, o = Math.max(e.height, 20), s = Lt(e), c = Math.min(...s.map((e) => Math.min(e.w, e.d)), i, a), l = Math.max(3, Math.min(6, c * .08)), u = e.brand === "Hettich" ? Math.min(c * .34, 22) : Math.min(16, c * .25), d = s.map((e, t) => ({
		i: t,
		top: jt(e.x, e.y, e.w, e.d, u, o),
		bot: jt(e.x + l, e.y + l, e.w - 2 * l, e.d - 2 * l, Math.max(2, u - l), 2),
		floor: jt(e.x + l, e.y + l, e.w - 2 * l, e.d - 2 * l, Math.max(2, u - l), 3.5),
		k: e.x + e.y
	})).sort((e, t) => e.k - t.k), f = o * .9, p = -o * .6, m = At([
		[0, 0],
		[i, 0],
		[i, a],
		[0, a]
	].map(([e, t]) => N(e + f, t + p, 0)).concat(d.flatMap((e) => e.bot))), h = e.trimEdges !== "right", g = i - e.minWidth, _ = a - (e.minDepth ?? a), v = h ? g / 2 : 0, y = i - (h ? g / 2 : g), b = _ / 2, x = a - _ / 2;
	return /* @__PURE__ */ (0, M.jsxs)("g", { children: [
		/* @__PURE__ */ (0, M.jsxs)("defs", { children: [/* @__PURE__ */ (0, M.jsxs)("linearGradient", {
			id: `g${t}`,
			x1: "0",
			y1: "0",
			x2: "1",
			y2: "1",
			children: [/* @__PURE__ */ (0, M.jsx)("stop", {
				offset: "0",
				stopColor: r.top
			}), /* @__PURE__ */ (0, M.jsx)("stop", {
				offset: "1",
				stopColor: r.mid
			})]
		}), d.map((e) => /* @__PURE__ */ (0, M.jsx)("clipPath", {
			id: `c${t}${e.i}`,
			children: /* @__PURE__ */ (0, M.jsx)("path", { d: F(e.top) })
		}, e.i))] }),
		n && /* @__PURE__ */ (0, M.jsx)("path", {
			d: F(m),
			fill: "#000000",
			opacity: ".78"
		}),
		d.map((e) => /* @__PURE__ */ (0, M.jsx)("path", {
			d: F(At(e.top.concat(e.bot))),
			fill: r.dark,
			stroke: wt,
			strokeWidth: ".5",
			strokeOpacity: ".5",
			vectorEffect: "non-scaling-stroke"
		}, e.i)),
		/* @__PURE__ */ (0, M.jsx)("path", {
			d: F([
				N(0, a, o),
				N(i, a, o),
				N(i, a, o - 2),
				N(0, a, o - 2)
			]),
			fill: r.mid
		}),
		/* @__PURE__ */ (0, M.jsx)("path", {
			d: F([
				N(i, 0, o),
				N(i, a, o),
				N(i, a, o - 2),
				N(i, 0, o - 2)
			]),
			fill: r.dark
		}),
		/* @__PURE__ */ (0, M.jsx)("path", {
			d: F([
				N(0, 0, o),
				N(i, 0, o),
				N(i, a, o),
				N(0, a, o)
			]) + d.map((e) => F(e.top)).join(""),
			fill: `url(#g${t})`,
			fillRule: "evenodd"
		}),
		d.map((e) => /* @__PURE__ */ (0, M.jsxs)("g", { children: [/* @__PURE__ */ (0, M.jsx)("path", {
			d: F(e.top),
			fill: r.dark
		}), /* @__PURE__ */ (0, M.jsx)("path", {
			d: F(e.floor),
			fill: r.well,
			clipPath: `url(#c${t}${e.i})`
		})] }, e.i)),
		[].map((e) => /* @__PURE__ */ (0, M.jsx)("path", {
			d: F([
				N(i * e, 0, o),
				N(i * (e + .04), 0, o),
				N(i * (e + .04) - a * .06, a, o),
				N(i * e - a * .06, a, o)
			]),
			fill: r.hi,
			opacity: ".45"
		}, e)),
		d.map((e) => /* @__PURE__ */ (0, M.jsx)("path", {
			d: F(e.top),
			fill: "none",
			stroke: wt,
			strokeWidth: ".7",
			opacity: ".85",
			vectorEffect: "non-scaling-stroke"
		}, e.i)),
		Nt(0, 0, i, a, o - 2, o, "s"),
		(g > 0 || _ > 0) && /* @__PURE__ */ (0, M.jsx)("path", {
			d: F([
				N(v, b, o + .1),
				N(y, b, o + .1),
				N(y, x, o + .1),
				N(v, x, o + .1)
			]),
			fill: "none",
			stroke: "#333333",
			strokeWidth: ".7",
			strokeDasharray: "4 4",
			opacity: ".55",
			vectorEffect: "non-scaling-stroke"
		})
	] });
}
function zt({ p: e, shadow: t }) {
	Ft = 7 + e.width;
	let n = kt(e), r = e.width, i = e.depth, a = Math.max(e.height, 20), o = Math.min(9, r * .05), s = Math.min(6, a * .15), c = [], l = 0, u = (e) => c.push(/* @__PURE__ */ (0, M.jsx)("g", { children: e }, l++)), d = (e, t, r, i, a, o, s, c, l, d = !0) => {
		u(/* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
			/* @__PURE__ */ (0, M.jsx)("path", {
				d: F([
					N(e, i, o),
					N(r, i, o),
					N(r, i, a),
					N(e, i, a)
				]),
				fill: c
			}),
			/* @__PURE__ */ (0, M.jsx)("path", {
				d: F([
					N(r, t, o),
					N(r, i, o),
					N(r, i, a),
					N(r, t, a)
				]),
				fill: l
			}),
			/* @__PURE__ */ (0, M.jsx)("path", {
				d: F([
					N(e, t, o),
					N(r, t, o),
					N(r, i, o),
					N(e, i, o)
				]),
				fill: s
			}),
			d && /* @__PURE__ */ (0, M.jsx)("path", {
				d: `M${N(e, i, o).map(P).join(" ")}L${N(r, i, o).map(P).join(" ")}L${N(r, t, o).map(P).join(" ")}`,
				stroke: n.edge,
				strokeWidth: ".8",
				fill: "none",
				opacity: ".9",
				vectorEffect: "non-scaling-stroke"
			})
		] }));
	}, f = (e, t, r, i, a, o) => {
		let s = Math.max(2, Math.round((o - a) / 9));
		for (let c = 1; c <= s; c++) {
			let l = a + (o - a) * c / (s + 1), d = It() * 6, f = [];
			for (let n = 0; n <= 8; n++) {
				let a = n / 8;
				f.push(N(e + (r - e) * a, t + (i - t) * a, l + Math.sin(d + n * .9) * 1.1));
			}
			u(/* @__PURE__ */ (0, M.jsx)("path", {
				d: "M" + f.map((e) => `${P(e[0])} ${P(e[1])}`).join("L"),
				stroke: n.grain,
				strokeWidth: ".6",
				opacity: ".55",
				fill: "none",
				vectorEffect: "non-scaling-stroke"
			}));
		}
	}, p = a * 1.2, m = -a * .8;
	t && u(/* @__PURE__ */ (0, M.jsx)("path", {
		d: F([
			N(0, i, 0),
			N(p, i + m, 0),
			N(r + p, i + m, 0),
			N(r + p, m, 0),
			N(r, 0, 0),
			N(r, i, 0)
		]),
		fill: "#000000",
		opacity: ".8"
	})), d(0, 0, r, i, 0, s, n.floor, n.wall, n.inner, !1);
	let h = Math.max(2, Math.round(r / 120)), g = r / h;
	for (let e = 0; e < h; e++) {
		let t = e * g, r = Pt(n.floor, .86 + It() * .26);
		u(/* @__PURE__ */ (0, M.jsx)("path", {
			d: F([
				N(t, 0, s),
				N(t + g, 0, s),
				N(t + g, i, s),
				N(t, i, s)
			]),
			fill: r
		}));
		for (let e = 0; e < g / 7; e++) {
			let r = t + 3 + e * 7 + It() * 2, a = 1 + It() * 2.4, c = It() * 6, l = [];
			for (let e = 0; e <= 10; e++) l.push(N(r + Math.sin(c + e * .7) * a, o + (i - 2 * o) * e / 10, s + .05));
			u(/* @__PURE__ */ (0, M.jsx)("path", {
				d: "M" + l.map((e) => `${P(e[0])} ${P(e[1])}`).join("L"),
				stroke: n.grain,
				strokeWidth: .45 + It() * .4,
				opacity: .45 + It() * .35,
				fill: "none",
				vectorEffect: "non-scaling-stroke"
			}));
		}
		e && u(/* @__PURE__ */ (0, M.jsx)("path", {
			d: `M${N(t, 0, s).map(P).join(" ")}L${N(t, i, s).map(P).join(" ")}`,
			stroke: n.inner,
			strokeWidth: ".7",
			vectorEffect: "non-scaling-stroke"
		}));
	}
	d(0, 0, r, o, 0, a, n.top, n.inner, n.wall), d(0, 0, o, i, 0, a, n.top, n.wall, n.inner), f(o, o, r, o, s, a), f(o, o, o, i, s, a);
	let _ = /* @__PURE__ */ new Set(), v = /* @__PURE__ */ new Set();
	for (let t of Lt(e)) t.x > o + 2 && _.add(Math.round(t.x)), t.x + t.w < r - o - 2 && _.add(Math.round(t.x + t.w)), t.y > o + 2 && v.add(Math.round(t.y)), t.y + t.d < i - o - 2 && v.add(Math.round(t.y + t.d));
	for (let t of be(e)) {
		let e = t.anchor === "right" ? r - t.x - t.width : t.x;
		for (let n of [e, e + t.width]) n > o + 2 && n < r - o - 2 && _.add(Math.round(n));
	}
	for (let e of [..._].sort((e, t) => e - t)) d(e - 3, o, e + 3, i - o, s, a * .86, n.top, n.wall, n.inner), f(e + 3, o, e + 3, i - o, s, a * .86);
	for (let e of [...v].sort((e, t) => e - t)) d(o, e - 3, r - o, e + 3, s, a * .86, n.top, n.inner, n.wall);
	d(r - o, 0, r, i, 0, a, n.top, n.wall, n.wall), d(0, i - o, r, i, 0, a, n.top, n.wall, n.inner), f(0, i, r, i, 0, a), f(r, 0, r, i, 0, a);
	for (let [e, t] of [
		[0, 0],
		[r - o, 0],
		[0, i - o],
		[r - o, i - o]
	]) u(/* @__PURE__ */ (0, M.jsx)("path", {
		d: F([
			N(e, t, a + .1),
			N(e + o, t, a + .1),
			N(e + o, t + o, a + .1),
			N(e, t + o, a + .1)
		]),
		fill: n.edge
	}));
	return /* @__PURE__ */ (0, M.jsxs)("g", { children: [c, Nt(0, 0, r, i, 0, a, "o", .8)] });
}
var Bt = {
	top: "#fbf7f0",
	mid: "#f1e7d6",
	dark: "#e6d7bd",
	well: "#f6efe3",
	hi: "#ffffff"
}, Vt = {
	top: "#f1eeea",
	mid: "#e3ddd7",
	dark: "#d2c9c0",
	well: "#e9e5e0",
	hi: "#ffffff"
}, Ht = (e) => Ot(e) ? kt(e) === Et.ash ? Vt : Bt : e.parts?.length || /ORGA-LINE/.test(e.name) ? Tt.steel : I(e), Ut = (e) => e.finish === "white" ? Tt.white : Dt(e) ? Tt.anthracite : Tt.other;
function Wt(e, t, n, r, i, a, o, s, c = 1) {
	let l = e.n++;
	e.els.push(/* @__PURE__ */ (0, M.jsxs)("g", { children: [
		/* @__PURE__ */ (0, M.jsx)("path", {
			d: F([
				N(t, n + i, o),
				N(t + r, n + i, o),
				N(t + r, n + i, a),
				N(t, n + i, a)
			]),
			fill: s.mid
		}),
		/* @__PURE__ */ (0, M.jsx)("path", {
			d: F([
				N(t + r, n, o),
				N(t + r, n + i, o),
				N(t + r, n + i, a),
				N(t + r, n, a)
			]),
			fill: s.dark
		}),
		/* @__PURE__ */ (0, M.jsx)("path", {
			d: F([
				N(t, n, o),
				N(t + r, n, o),
				N(t + r, n + i, o),
				N(t, n + i, o)
			]),
			fill: s.top
		}),
		/* @__PURE__ */ (0, M.jsx)("path", {
			d: `M${N(t + 1, n + i - 1, o).map(P).join(" ")}L${N(t + r - 1, n + i - 1, o).map(P).join(" ")}L${N(t + r - 1, n + 1, o).map(P).join(" ")}`,
			stroke: s.hi,
			strokeWidth: ".8",
			fill: "none",
			opacity: ".8",
			vectorEffect: "non-scaling-stroke"
		}),
		Nt(t, n, r, i, a, o, `i${l}`, c * .9)
	] }, `b${l}`));
}
function Gt(e, t, n, r, i, a, o, s, c) {
	if (r < 4 || i < 4) return;
	let l = e.n++, u = `${e.id}w${l}`, d = jt(t, n, r, i, s, a), f = jt(t, n, r, i, s, a - o);
	e.els.push(/* @__PURE__ */ (0, M.jsxs)("g", { children: [
		/* @__PURE__ */ (0, M.jsx)("clipPath", {
			id: u,
			children: /* @__PURE__ */ (0, M.jsx)("path", { d: F(d) })
		}),
		/* @__PURE__ */ (0, M.jsx)("path", {
			d: F(d),
			fill: c.dark
		}),
		/* @__PURE__ */ (0, M.jsx)("path", {
			d: F(f),
			fill: c.well,
			clipPath: `url(#${u})`
		}),
		/* @__PURE__ */ (0, M.jsx)("path", {
			d: F(d),
			fill: "none",
			stroke: wt,
			strokeWidth: ".6",
			opacity: ".8",
			vectorEffect: "non-scaling-stroke"
		})
	] }, `w${l}`));
}
function Kt(e, t, n, r, i) {
	for (let a of t) e.els.push(/* @__PURE__ */ (0, M.jsx)("path", {
		d: `M${N(a, n, i + .1).map(P).join(" ")}L${N(a, r, i + .1).map(P).join(" ")}`,
		stroke: "#000000",
		strokeWidth: "1.1",
		opacity: ".8",
		vectorEffect: "non-scaling-stroke"
	}, `s${e.n++}`));
}
function qt({ p: e, id: t }) {
	let n = {
		els: [],
		id: t,
		n: 0
	}, r = Ht(e), i = e.width, a = e.depth, o = Math.max(e.height, 12), s = Lt(e), c = Math.min(...s.map((e) => Math.min(e.w, e.d)), i, a);
	if (e.parts?.length) {
		let t = e.parts.map((e) => ({
			...e,
			y: a - e.y - e.depth
		})).sort((e, t) => e.x + e.y - (t.x + t.y));
		for (let r of t) {
			let t = Math.max(4, r.height);
			r.kind === "end" ? Wt(n, r.x, r.y, r.width, r.depth, 0, t, Ut(e)) : (Wt(n, r.x, r.y, r.width, r.depth, 0, t, Tt.steel), r.kind === "body" && r.width > 12 && r.depth > 12 && Gt(n, r.x + 2, r.y + 2, r.width - 4, r.depth - 4, t, t * .8, 3, Tt.steel));
		}
	} else if (/ORGA-LINE/.test(e.name) && !/Frame|Divider|Rack|Cutter|Adaptor|Clip|Spice|Knife|Bottle/.test(e.name)) {
		let t = Math.max(1, Math.round(i / 90)), r = i / t, s = Math.min(14, a * .04);
		for (let i = 0; i < t; i++) {
			let t = i * r;
			Wt(n, t + 1, 0, r - 2, a, 0, o, Tt.steel), Gt(n, t + r * .12, s + 3, r * .76, a - 2 * s - 6, o, o * .8, Math.min(r * .42, 22), Tt.steel), Wt(n, t + 1, 0, r - 2, s, 0, o, Ut(e)), Wt(n, t + 1, a - s, r - 2, s, 0, o, Ut(e));
		}
	} else if (e.role === "frame" || e.pocket) {
		let t = Math.max(4, Math.min(i, a) * .025);
		for (let t of be(e)) {
			let e = t.anchor === "right" ? i - t.x - t.width : t.x;
			n.els.push(/* @__PURE__ */ (0, M.jsx)("path", {
				d: F([
					N(e, a - t.y - t.depth, .1),
					N(e + t.width, a - t.y - t.depth, .1),
					N(e + t.width, a - t.y, .1),
					N(e, a - t.y, .1)
				]),
				fill: "none",
				stroke: wt,
				strokeDasharray: "3 3",
				strokeWidth: ".6",
				opacity: ".5",
				vectorEffect: "non-scaling-stroke"
			}, `k${n.n++}`));
		}
		Wt(n, 0, 0, i, t, 0, o, r), Wt(n, 0, t, t, a - 2 * t, 0, o, r), Wt(n, i - t, t, t, a - 2 * t, 0, o, r), Wt(n, 0, a - t, i, t, 0, o, r);
	} else if (s.length >= 5 && e.compartments.every((e) => e.width <= 5)) {
		let e = a * .45, t = o * .62, c = s.map((e) => e.x + e.w / 2);
		Wt(n, 0, 0, i, e, 0, o, r), Wt(n, 0, e, i, a - e, 0, t, r), Kt(n, c, a * .06, e, o), Kt(n, c, e + a * .02, a * .94, t);
	} else if (e.tiered) {
		Wt(n, 0, 0, i, a, 0, o * .9, r);
		for (let e of s) Gt(n, e.x, e.y, e.w, e.d, o * (.35 + .55 * (1 - (e.y + e.d) / a)), o * .25, Math.min(10, c * .2), r);
	} else {
		Wt(n, 0, 0, i, a, 0, o, r);
		let t = e.brand === "Ninka" ? 1 : e.brand === "Hettich" ? Math.min(c * .34, 22) : Math.min(16, c * .22), l = Math.min(o - 4, o * .8);
		for (let e of s.length ? s : [{
			x: i * .04,
			y: a * .04,
			w: i * .92,
			d: a * .92
		}]) Gt(n, e.x, e.y, e.w, e.d, o, l, t, r);
	}
	return /* @__PURE__ */ (0, M.jsx)("g", { children: n.els });
}
var L = (e) => !0;
function Jt({ p: e, shadow: t = !1 }) {
	let n = (0, _.useId)().replace(/:/g, ""), r = e.width, i = e.depth, a = Math.max(e.height, 20), o = [
		N(0, 0, 0),
		N(r, 0, 0),
		N(r, i, 0),
		N(0, i, 0),
		N(0, 0, a),
		N(r, 0, a),
		N(r, i, a),
		N(0, i, a),
		...t ? [N(r + a * 1.2, -a * .8, 0), N(r + a * 1.2, i - a * .8, 0)] : []
	], s = o.map((e) => e[0]), c = o.map((e) => e[1]), l = Math.min(...s), u = Math.min(...c), d = Math.max(...s) - l, f = Math.max(...c) - u, p = Math.max(d, f) * .05;
	return /* @__PURE__ */ (0, M.jsx)("svg", {
		"aria-hidden": "true",
		className: "sketch-tray",
		viewBox: `${P(l - p)} ${P(u - p)} ${P(d + 2 * p)} ${P(f + 2 * p)}`,
		children: e.trim && !Ot(e) && e.compartments.length > 0 ? /* @__PURE__ */ (0, M.jsx)(Rt, {
			p: e,
			id: n,
			shadow: t
		}) : Ot(e) && !e.insertOnly && !e.tiered && !e.parts?.length && e.depth > e.height * 2 && !(e.compartments.length >= 5 && e.compartments.every((e) => e.width <= 5)) ? /* @__PURE__ */ (0, M.jsx)(zt, {
			p: e,
			shadow: t
		}) : /* @__PURE__ */ (0, M.jsx)(qt, {
			p: e,
			id: n
		})
	});
}
//#endregion
//#region components/drawer-orbit.tsx
var Yt = "rgba(244,244,239,.35)", Xt = {
	light: "#f6f6f2",
	lightSide: "#e8e8e2",
	dark: "#55585b",
	darkSide: "#3f4245",
	steel: "#e9ecee",
	steelSide: "#d4d8db",
	well: "#d9dcde",
	wellDark: "#3a3d40",
	timber: "#dcc39b",
	timberSide: "#c9ab7c"
};
function R(e) {
	let t = e.product.finish, n = t === "anthracite" || t === "black" || t === "grey";
	return /ORGA-LINE/.test(e.product.name) || e.product.parts?.length ? {
		top: Xt.steel,
		side: Xt.steelSide,
		well: Xt.well
	} : t === "timber" || t === "bamboo" ? {
		top: Xt.timber,
		side: Xt.timberSide,
		well: "#c9ab7c"
	} : n ? {
		top: Xt.dark,
		side: Xt.darkSide,
		well: Xt.wellDark
	} : {
		top: Xt.light,
		side: Xt.lightSide,
		well: "#e3e3dc"
	};
}
function Zt({ drawer: e, placed: t }) {
	let n = -.5, r = .95, i = e.width, a = e.depth, o = Math.max(60, e.height), s = i / 2, c = a / 2, l = Math.cos(n), u = Math.sin(n), d = Math.cos(r), f = Math.sin(r), p = (e, t, n) => {
		let r = e - s, i = t - c, a = r * l - i * u, o = r * u + i * l;
		return [
			a,
			-o * f - n * d,
			-o * d + n * f
		];
	}, m = [], h = (e, t, n = "#8d9188") => {
		let r = e.map((e) => p(...e));
		m.push({
			pts: r.map((e) => [e[0], e[1]]),
			fill: t,
			stroke: n,
			depth: r.reduce((e, t) => e + t[2], 0) / r.length
		});
	}, g = (e, t, n, r, i, a, o, s, c) => {
		let d = (e, t, n) => [
			e,
			t,
			n
		];
		h([
			d(e, t, a),
			d(n, t, a),
			d(n, r, a),
			d(e, r, a)
		], o, c);
		let f = (e, t) => e * u + t * l < 0;
		f(0, -1) && h([
			d(e, t, i),
			d(n, t, i),
			d(n, t, a),
			d(e, t, a)
		], s, c), f(0, 1) && h([
			d(e, r, i),
			d(n, r, i),
			d(n, r, a),
			d(e, r, a)
		], s, c), f(-1, 0) && h([
			d(e, t, i),
			d(e, r, i),
			d(e, r, a),
			d(e, t, a)
		], s, c), f(1, 0) && h([
			d(n, t, i),
			d(n, r, i),
			d(n, r, a),
			d(n, t, a)
		], s, c);
	};
	g(-12, -12, i + 12, a + 12, -12, 0, "#f1f1ec", "#e2e2e2"), g(-12, a, i + 12, a + 12, 0, o, Yt, Yt), g(-12, -12, 0, a + 12, 0, o, Yt, Yt), g(i, -12, i + 12, a + 12, 0, o, Yt, Yt), g(-12, -30, i + 12, -12, 0, o * .35, Yt, Yt);
	for (let e of t) {
		let t = R(e), n = Math.max(10, e.product.height), r = e.x, i = e.y, a = e.x + e.width, o = e.y + e.depth, s = m.length;
		if (g(r, i, a, o, 0, n, t.top, t.side), e.product.topImage) {
			let t = e.product.trimEdges === "right" ? 0 : (e.product.width - e.width) / 2, i = (e.product.depth - e.depth) / 2, a = m[s], c = p(r - t, o + i, n + .2), l = p(r - t + e.product.width, o + i, n + .2), u = p(r - t, o + i - e.product.depth, n + .2), d = e.product.width, f = e.product.depth;
			a.img = {
				href: e.product.topImage,
				w: d,
				h: f,
				m: `matrix(${(l[0] - c[0]) / d} ${(l[1] - c[1]) / d} ${(u[0] - c[0]) / f} ${(u[1] - c[1]) / f} ${c[0]} ${c[1]})`,
				clip: "M" + a.pts.map((e) => e[0].toFixed(1) + " " + e[1].toFixed(1)).join("L") + "Z"
			};
			continue;
		}
		let c = e.product.parts?.length ? e.product.parts.filter((e) => e.kind === "body").map((e) => ({
			x: e.x,
			y: e.y,
			w: e.width,
			d: e.depth
		})) : e.product.compartments.map((e) => ({
			x: e.x,
			y: e.y,
			w: e.width,
			d: e.depth
		})), l = e.product.trimEdges === "both" ? (e.product.width - e.width) / 2 : 0, u = (e.product.depth - e.depth) / 2;
		for (let e of c) {
			let s = Math.max(r + 2, r + e.x - l + 2), c = Math.min(a - 2, r + e.x - l + e.w - 2), d = Math.max(i + 2, i + e.y - u + 2), f = Math.min(o - 2, i + e.y - u + e.d - 2);
			c - s < 3 || f - d < 3 || h([
				[
					s,
					d,
					n + .1
				],
				[
					c,
					d,
					n + .1
				],
				[
					c,
					f,
					n + .1
				],
				[
					s,
					f,
					n + .1
				]
			], t.well, "#9ea29b");
		}
	}
	m.sort((e, t) => e.depth - t.depth);
	let _ = m.flatMap((e) => e.pts.map((e) => e[0])), v = m.flatMap((e) => e.pts.map((e) => e[1])), y = Math.min(..._), b = Math.min(...v), x = Math.max(..._) - y, ee = Math.max(...v) - b, S = Math.max(x, ee) * .04;
	return /* @__PURE__ */ (0, M.jsx)("svg", {
		className: "drawer-orbit",
		viewBox: `${y - S} ${b - S} ${x + S * 2} ${ee + S * 2}`,
		role: "img",
		"aria-label": "3D view of this drawer",
		children: m.map((e, t) => e.img ? /* @__PURE__ */ (0, M.jsxs)("g", { children: [
			/* @__PURE__ */ (0, M.jsx)("clipPath", {
				id: `orb-${t}`,
				children: /* @__PURE__ */ (0, M.jsx)("path", { d: e.img.clip })
			}),
			/* @__PURE__ */ (0, M.jsx)("path", {
				d: e.img.clip,
				fill: e.fill,
				stroke: e.stroke,
				strokeWidth: ".7",
				vectorEffect: "non-scaling-stroke"
			}),
			/* @__PURE__ */ (0, M.jsx)("g", {
				clipPath: `url(#orb-${t})`,
				children: /* @__PURE__ */ (0, M.jsx)("image", {
					href: e.img.href,
					width: e.img.w,
					height: e.img.h,
					preserveAspectRatio: "none",
					transform: e.img.m
				})
			})
		] }, t) : /* @__PURE__ */ (0, M.jsx)("path", {
			d: "M" + e.pts.map((e) => e[0].toFixed(1) + " " + e[1].toFixed(1)).join("L") + "Z",
			fill: e.fill,
			stroke: e.stroke,
			strokeWidth: ".7",
			strokeLinejoin: "round",
			vectorEffect: "non-scaling-stroke"
		}, t))
	});
}
//#endregion
//#region node_modules/.pnpm/@floating-ui+utils@0.2.12/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function Qt() {
	return typeof window < "u";
}
function $t(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function en(e) {
	return Qt() ? e instanceof HTMLElement || e instanceof $t(e).HTMLElement : !1;
}
//#endregion
//#region node_modules/.pnpm/@base-ui+utils@0.3.2_@types_cb475dbffe3dec9e898f6077a0a349f0/node_modules/@base-ui/utils/safeReact.mjs
var tn = { ..._ }, nn = {};
function rn(e, t) {
	let n = _.useRef(nn);
	return n.current === nn && (n.current = e(t)), n;
}
//#endregion
//#region node_modules/.pnpm/@base-ui+utils@0.3.2_@types_cb475dbffe3dec9e898f6077a0a349f0/node_modules/@base-ui/utils/useStableCallback.mjs
var an = tn.useInsertionEffect, on = an && an !== tn.useLayoutEffect ? an : (e) => e();
function sn(e) {
	let t = rn(cn).current;
	return t.next = e, on(t.effect), t.trampoline;
}
function cn() {
	let e = {
		next: void 0,
		callback: z,
		trampoline: (...t) => e.callback?.(...t),
		effect: () => {
			e.callback = e.next;
		}
	};
	return e;
}
function z() {}
var ln = typeof document < "u" ? _.useLayoutEffect : () => {};
//#endregion
//#region node_modules/.pnpm/@base-ui+utils@0.3.2_@types_cb475dbffe3dec9e898f6077a0a349f0/node_modules/@base-ui/utils/mergeObjects.mjs
function un(e, t) {
	if (e && !t) return e;
	if (!e && t) return t;
	if (e || t) return {
		...e,
		...t
	};
}
//#endregion
//#region node_modules/.pnpm/@base-ui+react@1.7.0_@date-_628258a3ea3cacf06f3d8216c02e09ef/node_modules/@base-ui/react/merge-props/mergeProps.mjs
var dn = {};
function fn(e, t, n, r, i) {
	if (!n && !r && !i && !e) return mn(t);
	let a = mn(e);
	return t && (a = B(a, t)), n && (a = B(a, n)), r && (a = B(a, r)), i && (a = B(a, i)), a;
}
function pn(e) {
	if (e.length === 0) return dn;
	if (e.length === 1) return mn(e[0]);
	let t = mn(e[0]);
	for (let n = 1; n < e.length; n += 1) t = B(t, e[n]);
	return t;
}
function mn(e) {
	return gn(e) ? { ..._n(e, dn) } : V(e);
}
function B(e, t) {
	return gn(t) ? _n(t, e) : hn(e, t);
}
function V(e) {
	let t = { ...e };
	for (let e in t) {
		let n = t[e];
		H(e, n) && (t[e] = yn(n));
	}
	return t;
}
function hn(e, t) {
	if (!t) return e;
	for (let n in t) {
		let r = t[n];
		switch (n) {
			case "style":
				e[n] = un(e.style, r);
				break;
			case "className":
				e[n] = xn(e.className, r);
				break;
			default: H(n, r) ? e[n] = vn(e[n], r) : e[n] = r;
		}
	}
	return e;
}
function H(e, t) {
	let n = e.charCodeAt(0), r = e.charCodeAt(1), i = e.charCodeAt(2);
	return n === 111 && r === 110 && i >= 65 && i <= 90 && (typeof t == "function" || t === void 0);
}
function gn(e) {
	return typeof e == "function";
}
function _n(e, t) {
	return gn(e) ? e(t) : e ?? dn;
}
function vn(e, t) {
	return t ? e ? (...n) => {
		let r = n[0];
		if (Sn(r)) {
			let i = r;
			bn(i);
			let a = t(...n);
			return i.baseUIHandlerPrevented || e?.(...n), a;
		}
		let i = t(...n);
		return e?.(...n), i;
	} : yn(t) : e;
}
function yn(e) {
	return e && ((...t) => {
		let n = t[0];
		return Sn(n) && bn(n), e(...t);
	});
}
function bn(e) {
	return e.preventBaseUIHandler = () => {
		e.baseUIHandlerPrevented = !0;
	}, e;
}
function xn(e, t) {
	return t ? e ? t + " " + e : t : e;
}
function Sn(e) {
	return typeof e == "object" && !!e && "nativeEvent" in e;
}
//#endregion
//#region node_modules/.pnpm/@base-ui+utils@0.3.2_@types_cb475dbffe3dec9e898f6077a0a349f0/node_modules/@base-ui/utils/formatErrorMessage.mjs
function Cn(e, t) {
	return function(n, ...r) {
		let i = new URL(e);
		return i.searchParams.set("code", n.toString()), r.forEach((e) => i.searchParams.append("args[]", e)), `${t} error #${n}; visit ${i} for the full message.`;
	};
}
var wn = Cn("https://base-ui.com/production-error", "Base UI"), Tn = /* @__PURE__ */ _.createContext(void 0);
function En(e = !1) {
	let t = _.useContext(Tn);
	if (t === void 0 && !e) throw Error(wn(16));
	return t;
}
//#endregion
//#region node_modules/.pnpm/@base-ui+react@1.7.0_@date-_628258a3ea3cacf06f3d8216c02e09ef/node_modules/@base-ui/react/utils/useFocusableWhenDisabled.mjs
function Dn(e) {
	let { focusableWhenDisabled: t, disabled: n, composite: r = !1, tabIndex: i = 0, isNativeButton: a } = e, o = r && t !== !1, s = r && t === !1;
	return { props: _.useMemo(() => {
		let e = { onKeyDown(e) {
			n && t && e.key !== "Tab" && e.preventDefault();
		} };
		return r || (e.tabIndex = i, !a && n && (e.tabIndex = t ? i : -1)), (a && (t || o) || !a && n) && (e["aria-disabled"] = n), a && (!t || s) && (e.disabled = n), e;
	}, [
		r,
		n,
		t,
		o,
		s,
		a,
		i
	]) };
}
//#endregion
//#region node_modules/.pnpm/@base-ui+react@1.7.0_@date-_628258a3ea3cacf06f3d8216c02e09ef/node_modules/@base-ui/react/utils/dispatchClickWithModifiers.mjs
function On(e, t, { detail: n = 0 } = {}) {
	e.dispatchEvent(new ($t(e)).PointerEvent("click", {
		bubbles: !0,
		cancelable: !0,
		composed: !0,
		detail: n,
		shiftKey: t.shiftKey,
		ctrlKey: t.ctrlKey,
		altKey: t.altKey,
		metaKey: t.metaKey
	}));
}
//#endregion
//#region node_modules/.pnpm/@base-ui+react@1.7.0_@date-_628258a3ea3cacf06f3d8216c02e09ef/node_modules/@base-ui/react/internals/use-button/useButton.mjs
function kn(e = {}) {
	let { disabled: t = !1, focusableWhenDisabled: n, tabIndex: r = 0, native: i = !0, composite: a } = e, o = _.useRef(null), s = En(!0), c = a ?? s !== void 0, { props: l } = Dn({
		focusableWhenDisabled: n,
		disabled: t,
		composite: c,
		tabIndex: r,
		isNativeButton: i
	}), u = _.useCallback(() => {
		let e = o.current;
		An(e) && c && t && l.disabled === void 0 && e.disabled && (e.disabled = !1);
	}, [
		t,
		l.disabled,
		c
	]);
	return ln(u, [u]), {
		getButtonProps: _.useCallback((e = {}) => {
			let { onClick: n, onMouseDown: r, onKeyUp: a, onKeyDown: o, onPointerDown: s, ...u } = e;
			return fn({
				onClick(e) {
					if (t) {
						e.preventDefault();
						return;
					}
					n?.(e);
				},
				onMouseDown(e) {
					t || r?.(e);
				},
				onKeyDown(e) {
					if (t || (bn(e), o?.(e), e.baseUIHandlerPrevented)) return;
					let n = e.target === e.currentTarget, r = e.currentTarget, a = An(r), s = !i && jn(r), l = n && (i ? a : !s), u = e.key === "Enter", d = e.key === " ", f = r.getAttribute("role"), p = f?.startsWith("menuitem") || f === "option" || f === "gridcell";
					if (n && c && d) {
						if (e.defaultPrevented && p) return;
						e.preventDefault(), (!i || a) && (e.preventBaseUIHandler(), On(r, e));
						return;
					}
					if (!l || i || !d && !u) {
						n && s && d && e.preventDefault();
						return;
					}
					e.defaultPrevented || (e.preventDefault(), u && (e.preventBaseUIHandler(), On(r, e)));
				},
				onKeyUp(e) {
					if (!t) {
						if (bn(e), a?.(e), e.target === e.currentTarget && i && c && An(e.currentTarget) && e.key === " ") {
							e.preventDefault();
							return;
						}
						e.baseUIHandlerPrevented || e.target === e.currentTarget && !i && !c && !e.defaultPrevented && e.key === " " && (e.preventBaseUIHandler(), On(e.currentTarget, e));
					}
				},
				onPointerDown(e) {
					if (t) {
						e.preventDefault();
						return;
					}
					s?.(e);
				}
			}, i ? { type: "button" } : { role: "button" }, l, u);
		}, [
			t,
			l,
			c,
			i
		]),
		buttonRef: sn((e) => {
			o.current = e, u();
		})
	};
}
function An(e) {
	return en(e) && e.tagName === "BUTTON";
}
function jn(e) {
	return en(e) && e.tagName === "A" && !!e.href;
}
//#endregion
//#region node_modules/.pnpm/@base-ui+utils@0.3.2_@types_cb475dbffe3dec9e898f6077a0a349f0/node_modules/@base-ui/utils/useMergedRefs.mjs
function Mn(e, t, n, r) {
	let i = rn(Pn).current;
	return Fn(i, e, t, n, r) && Ln(i, [
		e,
		t,
		n,
		r
	]), i.callback;
}
function Nn(e) {
	let t = rn(Pn).current;
	return In(t, e) && Ln(t, e), t.callback;
}
function Pn() {
	return {
		callback: null,
		cleanup: null,
		refs: []
	};
}
function Fn(e, t, n, r, i) {
	return e.refs[0] !== t || e.refs[1] !== n || e.refs[2] !== r || e.refs[3] !== i;
}
function In(e, t) {
	return e.refs.length !== t.length || e.refs.some((e, n) => e !== t[n]);
}
function Ln(e, t) {
	if (e.refs = t, t.every((e) => e == null)) {
		e.callback = null;
		return;
	}
	e.callback = (n) => {
		if (e.cleanup &&= (e.cleanup(), null), n != null) {
			let r = Array(t.length).fill(null);
			for (let e = 0; e < t.length; e += 1) {
				let i = t[e];
				if (i != null) switch (typeof i) {
					case "function": {
						let t = i(n);
						typeof t == "function" && (r[e] = t);
						break;
					}
					case "object":
						i.current = n;
						break;
					default:
				}
			}
			e.cleanup = () => {
				for (let e = 0; e < t.length; e += 1) {
					let n = t[e];
					if (n != null) switch (typeof n) {
						case "function": {
							let t = r[e];
							typeof t == "function" ? t() : n(null);
							break;
						}
						case "object":
							n.current = null;
							break;
						default:
					}
				}
			};
		}
	};
}
//#endregion
//#region node_modules/.pnpm/@base-ui+utils@0.3.2_@types_cb475dbffe3dec9e898f6077a0a349f0/node_modules/@base-ui/utils/reactVersion.mjs
var Rn = 19;
function zn(e) {
	return Rn >= e;
}
//#endregion
//#region node_modules/.pnpm/@base-ui+utils@0.3.2_@types_cb475dbffe3dec9e898f6077a0a349f0/node_modules/@base-ui/utils/getReactElementRef.mjs
function Bn(e) {
	if (!/* @__PURE__ */ _.isValidElement(e)) return null;
	let t = e, n = t.props;
	return (zn(19) ? n?.ref : t.ref) ?? null;
}
Object.freeze([]);
var Vn = Object.freeze({});
//#endregion
//#region node_modules/.pnpm/@base-ui+react@1.7.0_@date-_628258a3ea3cacf06f3d8216c02e09ef/node_modules/@base-ui/react/internals/getStateAttributesProps.mjs
function Hn(e, t) {
	let n = {};
	for (let r in e) {
		let i = e[r];
		if (t?.hasOwnProperty(r)) {
			let e = t[r](i);
			e != null && Object.assign(n, e);
			continue;
		}
		i === !0 ? n[`data-${r.toLowerCase()}`] = "" : i && (n[`data-${r.toLowerCase()}`] = i.toString());
	}
	return n;
}
//#endregion
//#region node_modules/.pnpm/@base-ui+react@1.7.0_@date-_628258a3ea3cacf06f3d8216c02e09ef/node_modules/@base-ui/react/utils/resolveClassName.mjs
function Un(e, t) {
	return typeof e == "function" ? e(t) : e;
}
//#endregion
//#region node_modules/.pnpm/@base-ui+react@1.7.0_@date-_628258a3ea3cacf06f3d8216c02e09ef/node_modules/@base-ui/react/utils/resolveStyle.mjs
function Wn(e, t) {
	return typeof e == "function" ? e(t) : e;
}
//#endregion
//#region node_modules/.pnpm/@base-ui+react@1.7.0_@date-_628258a3ea3cacf06f3d8216c02e09ef/node_modules/@base-ui/react/internals/useRenderElement.mjs
function Gn(e, t, n = {}) {
	let r = t.render, i = Kn(t, n);
	return n.enabled === !1 ? null : Yn(e, r, i, n.state ?? Vn);
}
function Kn(e, t = {}) {
	let { className: n, style: r, render: i } = e, { state: a = Vn, ref: o, props: s, stateAttributesMapping: c, enabled: l = !0 } = t, u = l ? Un(n, a) : void 0, d = l ? Wn(r, a) : void 0, f = l ? Hn(a, c) : Vn, p = l && s ? qn(s) : void 0, m = l ? un(f, p) ?? {} : Vn;
	return typeof document < "u" && (l ? Array.isArray(o) ? m.ref = Nn([
		m.ref,
		Bn(i),
		...o
	]) : m.ref = Mn(m.ref, Bn(i), o) : Mn(null, null)), l ? (u !== void 0 && (m.className = xn(m.className, u)), d !== void 0 && (m.style = un(m.style, d)), m) : Vn;
}
function qn(e) {
	return Array.isArray(e) ? pn(e) : fn(void 0, e);
}
var Jn = Symbol.for("react.lazy");
function Yn(e, t, n, r) {
	if (t) {
		if (typeof t == "function") return t(n, r);
		let e = fn(n, t.props);
		e.ref = n.ref;
		let i = t;
		return i?.$$typeof === Jn && (i = _.Children.toArray(t)[0]), /* @__PURE__ */ _.cloneElement(i, e);
	}
	if (e && typeof e == "string") return Xn(e, n);
	throw Error(wn(8));
}
function Xn(e, t) {
	return e === "button" ? /* @__PURE__ */ (0, _.createElement)("button", {
		type: "button",
		...t,
		key: t.key
	}) : e === "img" ? /* @__PURE__ */ (0, _.createElement)("img", {
		alt: "",
		...t,
		key: t.key
	}) : /* @__PURE__ */ _.createElement(e, t);
}
//#endregion
//#region node_modules/.pnpm/@base-ui+react@1.7.0_@date-_628258a3ea3cacf06f3d8216c02e09ef/node_modules/@base-ui/react/button/Button.mjs
var Zn = /* @__PURE__ */ _.forwardRef(function(e, t) {
	let { render: n, className: r, disabled: i = !1, focusableWhenDisabled: a = !1, nativeButton: o = !0, style: s, ...c } = e, { getButtonProps: l, buttonRef: u } = kn({
		disabled: i,
		focusableWhenDisabled: a,
		native: o
	});
	return Gn("button", e, {
		state: { disabled: i },
		ref: [t, u],
		props: [c, l]
	});
});
//#endregion
//#region node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.mjs
function Qn(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = Qn(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function $n() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = Qn(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.mjs
var er = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, tr = $n, nr = (e, t) => (n) => {
	if (t?.variants == null) return tr(e, n?.class, n?.className);
	let { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((e) => {
		let t = n?.[e], a = i?.[e];
		if (t === null) return null;
		let o = er(t) || er(a);
		return r[e][o];
	}), o = n && Object.entries(n).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return tr(e, a, t?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...a } = t;
		return Object.entries(a).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...i,
				...o
			}[t]) : {
				...i,
				...o
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), n?.class, n?.className);
}, rr = (e, t) => {
	let n = Array(e.length + t.length);
	for (let t = 0; t < e.length; t++) n[t] = e[t];
	for (let r = 0; r < t.length; r++) n[e.length + r] = t[r];
	return n;
}, ir = (e, t) => ({
	classGroupId: e,
	validator: t
}), ar = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
	nextPart: e,
	validators: t,
	classGroupId: n
}), or = "-", sr = [], cr = "arbitrary..", lr = (e) => {
	let t = fr(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			if (e.startsWith("[") && e.endsWith("]")) return dr(e);
			let n = e.split(or);
			return ur(n, +(n[0] === "" && n.length > 1), t);
		},
		getConflictingClassGroupIds: (e, t) => {
			if (t) {
				let t = r[e], i = n[e];
				return t ? i ? rr(i, t) : t : i || sr;
			}
			return n[e] || sr;
		}
	};
}, ur = (e, t, n) => {
	if (e.length - t === 0) return n.classGroupId;
	let r = e[t], i = n.nextPart.get(r);
	if (i) {
		let n = ur(e, t + 1, i);
		if (n) return n;
	}
	let a = n.validators;
	if (a === null) return;
	let o = t === 0 ? e.join(or) : e.slice(t).join(or), s = a.length;
	for (let e = 0; e < s; e++) {
		let t = a[e];
		if (t.validator(o)) return t.classGroupId;
	}
}, dr = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
	let t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
	return r ? cr + r : void 0;
})(), fr = (e) => {
	let { theme: t, classGroups: n } = e;
	return pr(n, t);
}, pr = (e, t) => {
	let n = ar();
	for (let r in e) {
		let i = e[r];
		mr(i, n, r, t);
	}
	return n;
}, mr = (e, t, n, r) => {
	let i = e.length;
	for (let a = 0; a < i; a++) {
		let i = e[a];
		hr(i, t, n, r);
	}
}, hr = (e, t, n, r) => {
	if (typeof e == "string") {
		gr(e, t, n);
		return;
	}
	if (typeof e == "function") {
		_r(e, t, n, r);
		return;
	}
	vr(e, t, n, r);
}, gr = (e, t, n) => {
	let r = e === "" ? t : yr(t, e);
	r.classGroupId = n;
}, _r = (e, t, n, r) => {
	if (br(e)) {
		mr(e(r), t, n, r);
		return;
	}
	t.validators === null && (t.validators = []), t.validators.push(ir(n, e));
}, vr = (e, t, n, r) => {
	let i = Object.entries(e), a = i.length;
	for (let e = 0; e < a; e++) {
		let [a, o] = i[e];
		mr(o, yr(t, a), n, r);
	}
}, yr = (e, t) => {
	let n = e, r = t.split(or), i = r.length;
	for (let e = 0; e < i; e++) {
		let t = r[e], i = n.nextPart.get(t);
		i || (i = ar(), n.nextPart.set(t, i)), n = i;
	}
	return n;
}, br = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, xr = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = Object.create(null), r = Object.create(null), i = (i, a) => {
		n[i] = a, t++, t > e && (t = 0, r = n, n = Object.create(null));
	};
	return {
		get(e) {
			let t = n[e];
			if (t !== void 0) return t;
			if ((t = r[e]) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			e in n ? n[e] = t : i(e, t);
		}
	};
}, Sr = "!", Cr = ":", wr = [], Tr = (e, t, n, r, i) => ({
	modifiers: e,
	hasImportantModifier: t,
	baseClassName: n,
	maybePostfixModifierPosition: r,
	isExternal: i
}), Er = (e) => {
	let { prefix: t, experimentalParseClassName: n } = e, r = (e) => {
		let t = [], n = 0, r = 0, i = 0, a, o = e.length;
		for (let s = 0; s < o; s++) {
			let o = e[s];
			if (n === 0 && r === 0) {
				if (o === Cr) {
					t.push(e.slice(i, s)), i = s + 1;
					continue;
				}
				if (o === "/") {
					a = s;
					continue;
				}
			}
			o === "[" ? n++ : o === "]" ? n-- : o === "(" ? r++ : o === ")" && r--;
		}
		let s = t.length === 0 ? e : e.slice(i), c = s, l = !1;
		s.endsWith(Sr) ? (c = s.slice(0, -1), l = !0) : s.startsWith(Sr) && (c = s.slice(1), l = !0);
		let u = a && a > i ? a - i : void 0;
		return Tr(t, l, c, u);
	};
	if (t) {
		let e = t + Cr, n = r;
		r = (t) => t.startsWith(e) ? n(t.slice(e.length)) : Tr(wr, !1, t, void 0, !0);
	}
	if (n) {
		let e = r;
		r = (t) => n({
			className: t,
			parseClassName: e
		});
	}
	return r;
}, Dr = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.orderSensitiveModifiers.forEach((e, n) => {
		t.set(e, 1e6 + n);
	}), (e) => {
		let n = [], r = [];
		for (let i = 0; i < e.length; i++) {
			let a = e[i], o = a[0] === "[", s = t.has(a);
			o || s ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(a)) : r.push(a);
		}
		return r.length > 0 && (r.sort(), n.push(...r)), n;
	};
}, Or = (e) => ({
	cache: xr(e.cacheSize),
	parseClassName: Er(e),
	sortModifiers: Dr(e),
	postfixLookupClassGroupIds: kr(e),
	...lr(e)
}), kr = (e) => {
	let t = Object.create(null), n = e.postfixLookupClassGroups;
	if (n) for (let e = 0; e < n.length; e++) t[n[e]] = !0;
	return t;
}, Ar = /\s+/, jr = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a, postfixLookupClassGroupIds: o } = t, s = [], c = e.trim().split(Ar), l = "";
	for (let e = c.length - 1; e >= 0; --e) {
		let t = c[e], { isExternal: u, modifiers: d, hasImportantModifier: f, baseClassName: p, maybePostfixModifierPosition: m } = n(t);
		if (u) {
			l = t + (l.length > 0 ? " " + l : l);
			continue;
		}
		let h = !!m, g;
		if (h) {
			g = r(p.substring(0, m));
			let e = g && o[g] ? r(p) : void 0;
			e && e !== g && (g = e, h = !1);
		} else g = r(p);
		if (!g) {
			if (!h) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			if (g = r(p), !g) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			h = !1;
		}
		let _ = d.length === 0 ? "" : d.length === 1 ? d[0] : a(d).join(":"), v = f ? _ + Sr : _, y = v + g;
		if (s.indexOf(y) > -1) continue;
		s.push(y);
		let b = i(g, h);
		for (let e = 0; e < b.length; ++e) {
			let t = b[e];
			s.push(v + t);
		}
		l = t + (l.length > 0 ? " " + l : l);
	}
	return l;
}, Mr = (...e) => {
	let t = 0, n, r, i = "";
	for (; t < e.length;) (n = e[t++]) && (r = Nr(n)) && (i && (i += " "), i += r);
	return i;
}, Nr = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = Nr(e[r])) && (n && (n += " "), n += t);
	return n;
}, Pr = (e, ...t) => {
	let n, r, i, a, o = (o) => (n = Or(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o)), s = (e) => {
		let t = r(e);
		if (t) return t;
		let a = jr(e, n);
		return i(e, a), a;
	};
	return a = o, (...e) => a(Mr(...e));
}, Fr = [], Ir = (e) => {
	let t = (t) => t[e] || Fr;
	return t.isThemeGetter = !0, t;
}, Lr = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Rr = /^\((?:(\w[\w-]*):)?(.+)\)$/i, zr = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, Br = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Vr = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Hr = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Ur = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Wr = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Gr = (e) => zr.test(e), U = (e) => !!e && !Number.isNaN(Number(e)), Kr = (e) => !!e && Number.isInteger(Number(e)), qr = (e) => e.endsWith("%") && U(e.slice(0, -1)), Jr = (e) => Br.test(e), Yr = () => !0, Xr = (e) => Vr.test(e) && !Hr.test(e), Zr = () => !1, Qr = (e) => Ur.test(e), $r = (e) => Wr.test(e), ei = (e) => !G(e) && !K(e), W = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), ti = (e) => gi(e, bi, Zr), G = (e) => Lr.test(e), ni = (e) => gi(e, xi, Xr), ri = (e) => gi(e, q, U), ii = (e) => gi(e, Si, Yr), ai = (e) => gi(e, J, Zr), oi = (e) => gi(e, vi, Zr), si = (e) => gi(e, yi, $r), ci = (e) => gi(e, Y, Qr), K = (e) => Rr.test(e), li = (e) => _i(e, xi), ui = (e) => _i(e, J), di = (e) => _i(e, vi), fi = (e) => _i(e, bi), pi = (e) => _i(e, yi), mi = (e) => _i(e, Y, !0), hi = (e) => _i(e, Si, !0), gi = (e, t, n) => {
	let r = Lr.exec(e);
	return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, _i = (e, t, n = !1) => {
	let r = Rr.exec(e);
	return r ? r[1] ? t(r[1]) : n : !1;
}, vi = (e) => e === "position" || e === "percentage", yi = (e) => e === "image" || e === "url", bi = (e) => e === "length" || e === "size" || e === "bg-size", xi = (e) => e === "length", q = (e) => e === "number", J = (e) => e === "family-name", Si = (e) => e === "number" || e === "weight", Y = (e) => e === "shadow", Ci = /* @__PURE__ */ Pr(() => {
	let e = Ir("color"), t = Ir("font"), n = Ir("text"), r = Ir("font-weight"), i = Ir("tracking"), a = Ir("leading"), o = Ir("breakpoint"), s = Ir("container"), c = Ir("spacing"), l = Ir("radius"), u = Ir("shadow"), d = Ir("inset-shadow"), f = Ir("text-shadow"), p = Ir("drop-shadow"), m = Ir("blur"), h = Ir("perspective"), g = Ir("aspect"), _ = Ir("ease"), v = Ir("animate"), y = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], b = () => [
		"center",
		"top",
		"bottom",
		"left",
		"right",
		"top-left",
		"left-top",
		"top-right",
		"right-top",
		"bottom-right",
		"right-bottom",
		"bottom-left",
		"left-bottom"
	], x = () => [
		...b(),
		K,
		G
	], ee = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], S = () => [
		"auto",
		"contain",
		"none"
	], C = () => [
		K,
		G,
		c
	], w = () => [
		Gr,
		"full",
		"auto",
		...C()
	], te = () => [
		Kr,
		"none",
		"subgrid",
		K,
		G
	], ne = () => [
		"auto",
		{ span: [
			"full",
			Kr,
			K,
			G
		] },
		Kr,
		K,
		G
	], re = () => [
		Kr,
		"auto",
		K,
		G
	], ie = () => [
		"auto",
		"min",
		"max",
		"fr",
		K,
		G
	], ae = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch",
		"baseline",
		"center-safe",
		"end-safe"
	], oe = () => [
		"start",
		"end",
		"center",
		"stretch",
		"center-safe",
		"end-safe"
	], se = () => ["auto", ...C()], ce = () => [
		Gr,
		"auto",
		"full",
		"dvw",
		"dvh",
		"lvw",
		"lvh",
		"svw",
		"svh",
		"min",
		"max",
		"fit",
		...C()
	], le = () => [
		Gr,
		"screen",
		"full",
		"dvw",
		"lvw",
		"svw",
		"min",
		"max",
		"fit",
		...C()
	], ue = () => [
		Gr,
		"screen",
		"full",
		"lh",
		"dvh",
		"lvh",
		"svh",
		"min",
		"max",
		"fit",
		...C()
	], T = () => [
		e,
		K,
		G
	], E = () => [
		...b(),
		di,
		oi,
		{ position: [K, G] }
	], de = () => ["no-repeat", { repeat: [
		"",
		"x",
		"y",
		"space",
		"round"
	] }], fe = () => [
		"auto",
		"cover",
		"contain",
		fi,
		ti,
		{ size: [K, G] }
	], pe = () => [
		qr,
		li,
		ni
	], me = () => [
		"",
		"none",
		"full",
		l,
		K,
		G
	], D = () => [
		"",
		U,
		li,
		ni
	], he = () => [
		"solid",
		"dashed",
		"dotted",
		"double"
	], ge = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], _e = () => [
		U,
		qr,
		di,
		oi
	], ve = () => [
		"",
		"none",
		m,
		K,
		G
	], ye = () => [
		"none",
		U,
		K,
		G
	], be = () => [
		"none",
		U,
		K,
		G
	], xe = () => [
		U,
		K,
		G
	], Se = () => [
		Gr,
		"full",
		...C()
	];
	return {
		cacheSize: 500,
		theme: {
			animate: [
				"spin",
				"ping",
				"pulse",
				"bounce"
			],
			aspect: ["video"],
			blur: [Jr],
			breakpoint: [Jr],
			color: [Yr],
			container: [Jr],
			"drop-shadow": [Jr],
			ease: [
				"in",
				"out",
				"in-out"
			],
			font: [ei],
			"font-weight": [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black"
			],
			"inset-shadow": [Jr],
			leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose"
			],
			perspective: [
				"dramatic",
				"near",
				"normal",
				"midrange",
				"distant",
				"none"
			],
			radius: [Jr],
			shadow: [Jr],
			spacing: ["px", U],
			text: [Jr],
			"text-shadow": [Jr],
			tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest"
			]
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				Gr,
				G,
				K,
				g
			] }],
			container: ["container"],
			"container-type": [{ "@container": [
				"",
				"normal",
				"size",
				K,
				G
			] }],
			"container-named": [W],
			columns: [{ columns: [
				U,
				G,
				K,
				s
			] }],
			"break-after": [{ "break-after": y() }],
			"break-before": [{ "break-before": y() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			sr: ["sr-only", "not-sr-only"],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: x() }],
			overflow: [{ overflow: ee() }],
			"overflow-x": [{ "overflow-x": ee() }],
			"overflow-y": [{ "overflow-y": ee() }],
			overscroll: [{ overscroll: S() }],
			"overscroll-x": [{ "overscroll-x": S() }],
			"overscroll-y": [{ "overscroll-y": S() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: w() }],
			"inset-x": [{ "inset-x": w() }],
			"inset-y": [{ "inset-y": w() }],
			start: [{
				"inset-s": w(),
				start: w()
			}],
			end: [{
				"inset-e": w(),
				end: w()
			}],
			"inset-bs": [{ "inset-bs": w() }],
			"inset-be": [{ "inset-be": w() }],
			top: [{ top: w() }],
			right: [{ right: w() }],
			bottom: [{ bottom: w() }],
			left: [{ left: w() }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				Kr,
				"auto",
				K,
				G
			] }],
			basis: [{ basis: [
				Gr,
				"full",
				"auto",
				s,
				...C()
			] }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"nowrap",
				"wrap",
				"wrap-reverse"
			] }],
			flex: [{ flex: [
				U,
				Gr,
				"auto",
				"initial",
				"none",
				G
			] }],
			grow: [{ grow: [
				"",
				U,
				K,
				G
			] }],
			shrink: [{ shrink: [
				"",
				U,
				K,
				G
			] }],
			order: [{ order: [
				Kr,
				"first",
				"last",
				"none",
				K,
				G
			] }],
			"grid-cols": [{ "grid-cols": te() }],
			"col-start-end": [{ col: ne() }],
			"col-start": [{ "col-start": re() }],
			"col-end": [{ "col-end": re() }],
			"grid-rows": [{ "grid-rows": te() }],
			"row-start-end": [{ row: ne() }],
			"row-start": [{ "row-start": re() }],
			"row-end": [{ "row-end": re() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": ie() }],
			"auto-rows": [{ "auto-rows": ie() }],
			gap: [{ gap: C() }],
			"gap-x": [{ "gap-x": C() }],
			"gap-y": [{ "gap-y": C() }],
			"justify-content": [{ justify: [...ae(), "normal"] }],
			"justify-items": [{ "justify-items": [...oe(), "normal"] }],
			"justify-self": [{ "justify-self": ["auto", ...oe()] }],
			"align-content": [{ content: ["normal", ...ae()] }],
			"align-items": [{ items: [...oe(), { baseline: ["", "last"] }] }],
			"align-self": [{ self: [
				"auto",
				...oe(),
				{ baseline: ["", "last"] }
			] }],
			"place-content": [{ "place-content": ae() }],
			"place-items": [{ "place-items": [...oe(), "baseline"] }],
			"place-self": [{ "place-self": ["auto", ...oe()] }],
			p: [{ p: C() }],
			px: [{ px: C() }],
			py: [{ py: C() }],
			ps: [{ ps: C() }],
			pe: [{ pe: C() }],
			pbs: [{ pbs: C() }],
			pbe: [{ pbe: C() }],
			pt: [{ pt: C() }],
			pr: [{ pr: C() }],
			pb: [{ pb: C() }],
			pl: [{ pl: C() }],
			m: [{ m: se() }],
			mx: [{ mx: se() }],
			my: [{ my: se() }],
			ms: [{ ms: se() }],
			me: [{ me: se() }],
			mbs: [{ mbs: se() }],
			mbe: [{ mbe: se() }],
			mt: [{ mt: se() }],
			mr: [{ mr: se() }],
			mb: [{ mb: se() }],
			ml: [{ ml: se() }],
			"space-x": [{ "space-x": C() }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": C() }],
			"space-y-reverse": ["space-y-reverse"],
			size: [{ size: ce() }],
			"inline-size": [{ inline: ["auto", ...le()] }],
			"min-inline-size": [{ "min-inline": ["auto", ...le()] }],
			"max-inline-size": [{ "max-inline": ["none", ...le()] }],
			"block-size": [{ block: ["auto", ...ue()] }],
			"min-block-size": [{ "min-block": ["auto", ...ue()] }],
			"max-block-size": [{ "max-block": ["none", ...ue()] }],
			w: [{ w: [
				s,
				"screen",
				...ce()
			] }],
			"min-w": [{ "min-w": [
				s,
				"screen",
				"none",
				...ce()
			] }],
			"max-w": [{ "max-w": [
				s,
				"screen",
				"none",
				"prose",
				{ screen: [o] },
				...ce()
			] }],
			h: [{ h: [
				"screen",
				"lh",
				...ce()
			] }],
			"min-h": [{ "min-h": [
				"screen",
				"lh",
				"none",
				...ce()
			] }],
			"max-h": [{ "max-h": [
				"screen",
				"lh",
				...ce()
			] }],
			"font-size": [{ text: [
				"base",
				n,
				li,
				ni
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				r,
				hi,
				ii
			] }],
			"font-stretch": [{ "font-stretch": [
				"ultra-condensed",
				"extra-condensed",
				"condensed",
				"semi-condensed",
				"normal",
				"semi-expanded",
				"expanded",
				"extra-expanded",
				"ultra-expanded",
				qr,
				G
			] }],
			"font-family": [{ font: [
				ui,
				ai,
				t
			] }],
			"font-features": [{ "font-features": [G] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				i,
				K,
				G
			] }],
			"line-clamp": [{ "line-clamp": [
				U,
				"none",
				K,
				ri
			] }],
			leading: [{ leading: [a, ...C()] }],
			"list-image": [{ "list-image": [
				"none",
				K,
				G
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"list-style-type": [{ list: [
				"disc",
				"decimal",
				"none",
				K,
				G
			] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"placeholder-color": [{ placeholder: T() }],
			"text-color": [{ text: T() }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...he(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				U,
				"from-font",
				"auto",
				K,
				ni
			] }],
			"text-decoration-color": [{ decoration: T() }],
			"underline-offset": [{ "underline-offset": [
				U,
				"auto",
				K,
				G
			] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: C() }],
			"tab-size": [{ tab: [
				Kr,
				K,
				G
			] }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				K,
				G
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			wrap: [{ wrap: [
				"break-word",
				"anywhere",
				"normal"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: [
				"none",
				K,
				G
			] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: E() }],
			"bg-repeat": [{ bg: de() }],
			"bg-size": [{ bg: fe() }],
			"bg-image": [{ bg: [
				"none",
				{
					linear: [
						{ to: [
							"t",
							"tr",
							"r",
							"br",
							"b",
							"bl",
							"l",
							"tl"
						] },
						Kr,
						K,
						G
					],
					radial: [
						"",
						K,
						G
					],
					conic: [
						Kr,
						K,
						G
					]
				},
				pi,
				si
			] }],
			"bg-color": [{ bg: T() }],
			"gradient-from-pos": [{ from: pe() }],
			"gradient-via-pos": [{ via: pe() }],
			"gradient-to-pos": [{ to: pe() }],
			"gradient-from": [{ from: T() }],
			"gradient-via": [{ via: T() }],
			"gradient-to": [{ to: T() }],
			rounded: [{ rounded: me() }],
			"rounded-s": [{ "rounded-s": me() }],
			"rounded-e": [{ "rounded-e": me() }],
			"rounded-t": [{ "rounded-t": me() }],
			"rounded-r": [{ "rounded-r": me() }],
			"rounded-b": [{ "rounded-b": me() }],
			"rounded-l": [{ "rounded-l": me() }],
			"rounded-ss": [{ "rounded-ss": me() }],
			"rounded-se": [{ "rounded-se": me() }],
			"rounded-ee": [{ "rounded-ee": me() }],
			"rounded-es": [{ "rounded-es": me() }],
			"rounded-tl": [{ "rounded-tl": me() }],
			"rounded-tr": [{ "rounded-tr": me() }],
			"rounded-br": [{ "rounded-br": me() }],
			"rounded-bl": [{ "rounded-bl": me() }],
			"border-w": [{ border: D() }],
			"border-w-x": [{ "border-x": D() }],
			"border-w-y": [{ "border-y": D() }],
			"border-w-s": [{ "border-s": D() }],
			"border-w-e": [{ "border-e": D() }],
			"border-w-bs": [{ "border-bs": D() }],
			"border-w-be": [{ "border-be": D() }],
			"border-w-t": [{ "border-t": D() }],
			"border-w-r": [{ "border-r": D() }],
			"border-w-b": [{ "border-b": D() }],
			"border-w-l": [{ "border-l": D() }],
			"divide-x": [{ "divide-x": D() }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": D() }],
			"divide-y-reverse": ["divide-y-reverse"],
			"border-style": [{ border: [
				...he(),
				"hidden",
				"none"
			] }],
			"divide-style": [{ divide: [
				...he(),
				"hidden",
				"none"
			] }],
			"border-color": [{ border: T() }],
			"border-color-x": [{ "border-x": T() }],
			"border-color-y": [{ "border-y": T() }],
			"border-color-s": [{ "border-s": T() }],
			"border-color-e": [{ "border-e": T() }],
			"border-color-bs": [{ "border-bs": T() }],
			"border-color-be": [{ "border-be": T() }],
			"border-color-t": [{ "border-t": T() }],
			"border-color-r": [{ "border-r": T() }],
			"border-color-b": [{ "border-b": T() }],
			"border-color-l": [{ "border-l": T() }],
			"divide-color": [{ divide: T() }],
			"outline-style": [{ outline: [
				...he(),
				"none",
				"hidden"
			] }],
			"outline-offset": [{ "outline-offset": [
				U,
				K,
				G
			] }],
			"outline-w": [{ outline: [
				"",
				U,
				li,
				ni
			] }],
			"outline-color": [{ outline: T() }],
			shadow: [{ shadow: [
				"",
				"none",
				u,
				mi,
				ci
			] }],
			"shadow-color": [{ shadow: T() }],
			"inset-shadow": [{ "inset-shadow": [
				"none",
				d,
				mi,
				ci
			] }],
			"inset-shadow-color": [{ "inset-shadow": T() }],
			"ring-w": [{ ring: D() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: T() }],
			"ring-offset-w": [{ "ring-offset": [U, ni] }],
			"ring-offset-color": [{ "ring-offset": T() }],
			"inset-ring-w": [{ "inset-ring": D() }],
			"inset-ring-color": [{ "inset-ring": T() }],
			"text-shadow": [{ "text-shadow": [
				"none",
				f,
				mi,
				ci
			] }],
			"text-shadow-color": [{ "text-shadow": T() }],
			opacity: [{ opacity: [
				U,
				K,
				G
			] }],
			"mix-blend": [{ "mix-blend": [
				...ge(),
				"plus-darker",
				"plus-lighter"
			] }],
			"bg-blend": [{ "bg-blend": ge() }],
			"mask-clip": [{ "mask-clip": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }, "mask-no-clip"],
			"mask-composite": [{ mask: [
				"add",
				"subtract",
				"intersect",
				"exclude"
			] }],
			"mask-image-linear-pos": [{ "mask-linear": [U] }],
			"mask-image-linear-from-pos": [{ "mask-linear-from": _e() }],
			"mask-image-linear-to-pos": [{ "mask-linear-to": _e() }],
			"mask-image-linear-from-color": [{ "mask-linear-from": T() }],
			"mask-image-linear-to-color": [{ "mask-linear-to": T() }],
			"mask-image-t-from-pos": [{ "mask-t-from": _e() }],
			"mask-image-t-to-pos": [{ "mask-t-to": _e() }],
			"mask-image-t-from-color": [{ "mask-t-from": T() }],
			"mask-image-t-to-color": [{ "mask-t-to": T() }],
			"mask-image-r-from-pos": [{ "mask-r-from": _e() }],
			"mask-image-r-to-pos": [{ "mask-r-to": _e() }],
			"mask-image-r-from-color": [{ "mask-r-from": T() }],
			"mask-image-r-to-color": [{ "mask-r-to": T() }],
			"mask-image-b-from-pos": [{ "mask-b-from": _e() }],
			"mask-image-b-to-pos": [{ "mask-b-to": _e() }],
			"mask-image-b-from-color": [{ "mask-b-from": T() }],
			"mask-image-b-to-color": [{ "mask-b-to": T() }],
			"mask-image-l-from-pos": [{ "mask-l-from": _e() }],
			"mask-image-l-to-pos": [{ "mask-l-to": _e() }],
			"mask-image-l-from-color": [{ "mask-l-from": T() }],
			"mask-image-l-to-color": [{ "mask-l-to": T() }],
			"mask-image-x-from-pos": [{ "mask-x-from": _e() }],
			"mask-image-x-to-pos": [{ "mask-x-to": _e() }],
			"mask-image-x-from-color": [{ "mask-x-from": T() }],
			"mask-image-x-to-color": [{ "mask-x-to": T() }],
			"mask-image-y-from-pos": [{ "mask-y-from": _e() }],
			"mask-image-y-to-pos": [{ "mask-y-to": _e() }],
			"mask-image-y-from-color": [{ "mask-y-from": T() }],
			"mask-image-y-to-color": [{ "mask-y-to": T() }],
			"mask-image-radial": [{ "mask-radial": [K, G] }],
			"mask-image-radial-from-pos": [{ "mask-radial-from": _e() }],
			"mask-image-radial-to-pos": [{ "mask-radial-to": _e() }],
			"mask-image-radial-from-color": [{ "mask-radial-from": T() }],
			"mask-image-radial-to-color": [{ "mask-radial-to": T() }],
			"mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
			"mask-image-radial-size": [{ "mask-radial": [{
				closest: ["side", "corner"],
				farthest: ["side", "corner"]
			}] }],
			"mask-image-radial-pos": [{ "mask-radial-at": b() }],
			"mask-image-conic-pos": [{ "mask-conic": [U] }],
			"mask-image-conic-from-pos": [{ "mask-conic-from": _e() }],
			"mask-image-conic-to-pos": [{ "mask-conic-to": _e() }],
			"mask-image-conic-from-color": [{ "mask-conic-from": T() }],
			"mask-image-conic-to-color": [{ "mask-conic-to": T() }],
			"mask-mode": [{ mask: [
				"alpha",
				"luminance",
				"match"
			] }],
			"mask-origin": [{ "mask-origin": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }],
			"mask-position": [{ mask: E() }],
			"mask-repeat": [{ mask: de() }],
			"mask-size": [{ mask: fe() }],
			"mask-type": [{ "mask-type": ["alpha", "luminance"] }],
			"mask-image": [{ mask: [
				"none",
				K,
				G
			] }],
			filter: [{ filter: [
				"",
				"none",
				K,
				G
			] }],
			blur: [{ blur: ve() }],
			brightness: [{ brightness: [
				U,
				K,
				G
			] }],
			contrast: [{ contrast: [
				U,
				K,
				G
			] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				p,
				mi,
				ci
			] }],
			"drop-shadow-color": [{ "drop-shadow": T() }],
			grayscale: [{ grayscale: [
				"",
				U,
				K,
				G
			] }],
			"hue-rotate": [{ "hue-rotate": [
				U,
				K,
				G
			] }],
			invert: [{ invert: [
				"",
				U,
				K,
				G
			] }],
			saturate: [{ saturate: [
				U,
				K,
				G
			] }],
			sepia: [{ sepia: [
				"",
				U,
				K,
				G
			] }],
			"backdrop-filter": [{ "backdrop-filter": [
				"",
				"none",
				K,
				G
			] }],
			"backdrop-blur": [{ "backdrop-blur": ve() }],
			"backdrop-brightness": [{ "backdrop-brightness": [
				U,
				K,
				G
			] }],
			"backdrop-contrast": [{ "backdrop-contrast": [
				U,
				K,
				G
			] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [
				"",
				U,
				K,
				G
			] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [
				U,
				K,
				G
			] }],
			"backdrop-invert": [{ "backdrop-invert": [
				"",
				U,
				K,
				G
			] }],
			"backdrop-opacity": [{ "backdrop-opacity": [
				U,
				K,
				G
			] }],
			"backdrop-saturate": [{ "backdrop-saturate": [
				U,
				K,
				G
			] }],
			"backdrop-sepia": [{ "backdrop-sepia": [
				"",
				U,
				K,
				G
			] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": C() }],
			"border-spacing-x": [{ "border-spacing-x": C() }],
			"border-spacing-y": [{ "border-spacing-y": C() }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"",
				"all",
				"colors",
				"opacity",
				"shadow",
				"transform",
				"none",
				K,
				G
			] }],
			"transition-behavior": [{ transition: ["normal", "discrete"] }],
			duration: [{ duration: [
				U,
				"initial",
				K,
				G
			] }],
			ease: [{ ease: [
				"linear",
				"initial",
				_,
				K,
				G
			] }],
			delay: [{ delay: [
				U,
				K,
				G
			] }],
			animate: [{ animate: [
				"none",
				v,
				K,
				G
			] }],
			backface: [{ backface: ["hidden", "visible"] }],
			perspective: [{ perspective: [
				h,
				K,
				G
			] }],
			"perspective-origin": [{ "perspective-origin": x() }],
			rotate: [{ rotate: ye() }],
			"rotate-x": [{ "rotate-x": ye() }],
			"rotate-y": [{ "rotate-y": ye() }],
			"rotate-z": [{ "rotate-z": ye() }],
			scale: [{ scale: be() }],
			"scale-x": [{ "scale-x": be() }],
			"scale-y": [{ "scale-y": be() }],
			"scale-z": [{ "scale-z": be() }],
			"scale-3d": ["scale-3d"],
			skew: [{ skew: xe() }],
			"skew-x": [{ "skew-x": xe() }],
			"skew-y": [{ "skew-y": xe() }],
			transform: [{ transform: [
				K,
				G,
				"",
				"none",
				"gpu",
				"cpu"
			] }],
			"transform-origin": [{ origin: x() }],
			"transform-style": [{ transform: ["3d", "flat"] }],
			translate: [{ translate: Se() }],
			"translate-x": [{ "translate-x": Se() }],
			"translate-y": [{ "translate-y": Se() }],
			"translate-z": [{ "translate-z": Se() }],
			"translate-none": ["translate-none"],
			zoom: [{ zoom: [
				Kr,
				K,
				G
			] }],
			accent: [{ accent: T() }],
			appearance: [{ appearance: ["none", "auto"] }],
			"caret-color": [{ caret: T() }],
			"color-scheme": [{ scheme: [
				"normal",
				"dark",
				"light",
				"light-dark",
				"only-dark",
				"only-light"
			] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				K,
				G
			] }],
			"field-sizing": [{ "field-sizing": ["fixed", "content"] }],
			"pointer-events": [{ "pointer-events": ["auto", "none"] }],
			resize: [{ resize: [
				"none",
				"",
				"y",
				"x"
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scrollbar-thumb-color": [{ "scrollbar-thumb": T() }],
			"scrollbar-track-color": [{ "scrollbar-track": T() }],
			"scrollbar-gutter": [{ "scrollbar-gutter": [
				"auto",
				"stable",
				"both"
			] }],
			"scrollbar-w": [{ scrollbar: [
				"auto",
				"thin",
				"none"
			] }],
			"scroll-m": [{ "scroll-m": C() }],
			"scroll-mx": [{ "scroll-mx": C() }],
			"scroll-my": [{ "scroll-my": C() }],
			"scroll-ms": [{ "scroll-ms": C() }],
			"scroll-me": [{ "scroll-me": C() }],
			"scroll-mbs": [{ "scroll-mbs": C() }],
			"scroll-mbe": [{ "scroll-mbe": C() }],
			"scroll-mt": [{ "scroll-mt": C() }],
			"scroll-mr": [{ "scroll-mr": C() }],
			"scroll-mb": [{ "scroll-mb": C() }],
			"scroll-ml": [{ "scroll-ml": C() }],
			"scroll-p": [{ "scroll-p": C() }],
			"scroll-px": [{ "scroll-px": C() }],
			"scroll-py": [{ "scroll-py": C() }],
			"scroll-ps": [{ "scroll-ps": C() }],
			"scroll-pe": [{ "scroll-pe": C() }],
			"scroll-pbs": [{ "scroll-pbs": C() }],
			"scroll-pbe": [{ "scroll-pbe": C() }],
			"scroll-pt": [{ "scroll-pt": C() }],
			"scroll-pr": [{ "scroll-pr": C() }],
			"scroll-pb": [{ "scroll-pb": C() }],
			"scroll-pl": [{ "scroll-pl": C() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				K,
				G
			] }],
			fill: [{ fill: ["none", ...T()] }],
			"stroke-w": [{ stroke: [
				U,
				li,
				ni,
				ri
			] }],
			stroke: [{ stroke: ["none", ...T()] }],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			"container-named": ["container-type"],
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"inset-bs",
				"inset-be",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pbs",
				"pbe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mbs",
				"mbe",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-x",
				"border-w-y",
				"border-w-s",
				"border-w-e",
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-x",
				"border-color-y",
				"border-color-s",
				"border-color-e",
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			translate: [
				"translate-x",
				"translate-y",
				"translate-none"
			],
			"translate-none": [
				"translate",
				"translate-x",
				"translate-y",
				"translate-z"
			],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] },
		postfixLookupClassGroups: ["container-type"],
		orderSensitiveModifiers: [
			"*",
			"**",
			"after",
			"backdrop",
			"before",
			"details-content",
			"file",
			"first-letter",
			"first-line",
			"marker",
			"placeholder",
			"selection"
		]
	};
});
//#endregion
//#region lib/utils.ts
function X(...e) {
	return Ci($n(e));
}
//#endregion
//#region components/ui/button.tsx
var wi = nr("group/button inline-flex shrink-0 items-center justify-center rounded-lg border border-transparent bg-clip-padding text-sm font-medium whitespace-nowrap transition-all outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 active:not-aria-[haspopup]:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", {
	variants: {
		variant: {
			default: "bg-primary text-primary-foreground hover:bg-primary/80",
			outline: "border-border bg-background hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
			secondary: "bg-secondary text-secondary-foreground hover:bg-[color-mix(in_oklch,var(--secondary),var(--foreground)_5%)] aria-expanded:bg-secondary aria-expanded:text-secondary-foreground",
			ghost: "hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:hover:bg-muted/50",
			destructive: "bg-destructive/10 text-destructive hover:bg-destructive/20 focus-visible:border-destructive/40 focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:hover:bg-destructive/30 dark:focus-visible:ring-destructive/40",
			link: "text-primary underline-offset-4 hover:underline"
		},
		size: {
			default: "h-8 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2",
			xs: "h-6 gap-1 rounded-[min(var(--radius-md),10px)] px-2 text-xs in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3",
			sm: "h-7 gap-1 rounded-[min(var(--radius-md),12px)] px-2.5 text-[0.8rem] in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3.5",
			lg: "h-9 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2",
			icon: "size-8",
			"icon-xs": "size-6 rounded-[min(var(--radius-md),10px)] in-data-[slot=button-group]:rounded-lg [&_svg:not([class*='size-'])]:size-3",
			"icon-sm": "size-7 rounded-[min(var(--radius-md),12px)] in-data-[slot=button-group]:rounded-lg",
			"icon-lg": "size-9"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function Ti({ className: e, variant: t = "default", size: n = "default", ...r }) {
	return /* @__PURE__ */ (0, M.jsx)(Zn, {
		"data-slot": "button",
		className: X(wi({
			variant: t,
			size: n,
			className: e
		})),
		...r
	});
}
//#endregion
//#region lib/catalog.ts
var Ei = (e, t, n) => Array.from({ length: n }, (r, i) => ({
	x: 9 + i * (e - 18) / n,
	y: 9,
	width: (e - 18) / n - 5,
	depth: t - 18
})), Di = [
	{
		id: "cutlery",
		name: "Everyday cutlery",
		sku: "DEMO-01",
		price: 39,
		currency: "AUD",
		width: 240,
		minWidth: 240,
		depth: 430,
		height: 45,
		trim: !1,
		step: 1,
		short: !1,
		tiered: !1,
		colour: "#d8d8d8",
		compartments: [...Ei(240, 325, 3), {
			x: 9,
			y: 335,
			width: 222,
			depth: 86
		}],
		verified: !1,
		instructions: "Example only. Follow the approved instructions supplied with the actual product.",
		available: !0
	},
	{
		id: "utensils",
		name: "Utensil organiser",
		sku: "DEMO-02",
		price: 32,
		currency: "AUD",
		width: 180,
		minWidth: 180,
		depth: 430,
		height: 45,
		trim: !1,
		step: 1,
		short: !1,
		tiered: !1,
		colour: "#d8d8d8",
		compartments: Ei(180, 430, 2),
		verified: !1,
		instructions: "",
		available: !0
	},
	{
		id: "small",
		name: "Little essentials",
		sku: "DEMO-03",
		price: 16,
		currency: "AUD",
		width: 130,
		minWidth: 130,
		depth: 205,
		height: 40,
		trim: !1,
		step: 1,
		short: !0,
		tiered: !1,
		colour: "#e4e4e4",
		compartments: [{
			x: 9,
			y: 9,
			width: 112,
			depth: 187
		}],
		verified: !1,
		instructions: "",
		available: !0
	},
	{
		id: "wide-small",
		name: "Everyday extras",
		sku: "DEMO-04",
		price: 22,
		currency: "AUD",
		width: 200,
		minWidth: 200,
		depth: 205,
		height: 42,
		trim: !1,
		step: 1,
		short: !0,
		tiered: !1,
		colour: "#e4e4e4",
		compartments: Ei(200, 205, 2),
		verified: !1,
		instructions: "",
		available: !0
	},
	{
		id: "trim",
		name: "Cut-to-fit tray",
		sku: "DEMO-05",
		price: 28,
		currency: "AUD",
		width: 400,
		minWidth: 100,
		depth: 430,
		height: 45,
		trim: !0,
		step: 1,
		short: !1,
		tiered: !1,
		colour: "#bfbfbf",
		compartments: [{
			x: 9,
			y: 9,
			width: 382,
			depth: 412
		}],
		verified: !1,
		instructions: "DEMO ONLY — no physical product or cutting method has been verified. Do not use this example guide to cut a product.",
		available: !0
	},
	{
		id: "tier",
		name: "Tiered cutlery",
		sku: "DEMO-06",
		price: 45,
		currency: "AUD",
		width: 175,
		minWidth: 175,
		depth: 430,
		height: 85,
		trim: !1,
		step: 1,
		short: !1,
		tiered: !0,
		colour: "#cccccc",
		compartments: [
			{
				x: 9,
				y: 9,
				width: 157,
				depth: 124
			},
			{
				x: 9,
				y: 145,
				width: 157,
				depth: 124
			},
			{
				x: 9,
				y: 281,
				width: 157,
				depth: 140
			}
		],
		verified: !1,
		instructions: "",
		available: !0
	},
	{
		id: "demo-frame",
		name: "Organiser frame",
		sku: "DEMO-FRAME",
		price: 35,
		currency: "AUD",
		width: 200,
		minWidth: 200,
		depth: 430,
		height: 50,
		trim: !1,
		step: 1,
		short: !1,
		tiered: !1,
		colour: "#aaa",
		compartments: [{
			x: 10,
			y: 10,
			width: 180,
			depth: 410
		}],
		pocket: {
			x: 10,
			y: 10,
			width: 180,
			depth: 410,
			height: 60,
			accepts: ["demo-knife"],
			approved: !1
		},
		verified: !1,
		instructions: "Illustrative open-bottom frame. Not a verified Blum product.",
		available: !0
	},
	{
		id: "demo-knife",
		name: "Knife holder insert",
		sku: "DEMO-INSERT",
		price: 25,
		currency: "AUD",
		width: 170,
		minWidth: 170,
		depth: 390,
		height: 48,
		trim: !1,
		step: 1,
		short: !1,
		tiered: !1,
		colour: "#b9b9b9",
		compartments: Array.from({ length: 5 }, (e, t) => ({
			x: 12 + t * 30,
			y: 22,
			width: 5,
			depth: 345
		})),
		insertOnly: !0,
		verified: !1,
		instructions: "Illustrative insert, compatible only with the sample organiser frame. Not a verified Blum product.",
		available: !0
	}
], Oi = {
	cutlery: { finish: "white" },
	utensils: { finish: "anthracite" },
	small: { finish: "white" },
	"wide-small": { finish: "anthracite" },
	trim: { finish: "stainless" },
	tier: {
		finish: "timber",
		premium: !0
	},
	"demo-frame": { finish: "anthracite" },
	"demo-knife": {
		finish: "timber",
		premium: !0
	}
}, ki = [...Di.map((e) => ({
	...e,
	...Oi[e.id]
})), {
	...Di[0],
	id: "demo-expand",
	name: "Expanding utensil tray",
	sku: "DEMO-EXP",
	width: 480,
	minWidth: 290,
	expand: !0,
	step: 1,
	finish: "white",
	instructions: "Illustrative expanding tray. Not a real product."
}], Ai = (e) => `https://cdn.shopify.com/s/files/1/0855/4558/2866/files/${e}${e.includes("?") ? "&" : "?"}width=240`, ji = "https://www.blum.com/au/en/company/quality-innovation/identify-blum-products/boxsystems/", Mi = [
	{
		brand: "blum",
		line: "ambia",
		title: "Blum LEGRABOX",
		features: ["Very slim metal sides, about 13 mm thick, dead straight inside and out", "Blum logo on the cap at the front of each side"],
		photos: [
			{
				src: Ai("WBL1001_1.jpg"),
				alt: "LEGRABOX drawer open in a kitchen"
			},
			{
				src: Ai("770F550IA_1.jpg"),
				alt: "LEGRABOX drawer sides, slim and straight"
			},
			{
				src: Ai("770C50ASR_2.jpg"),
				alt: "LEGRABOX side, straight profile"
			}
		],
		sources: ["https://www.blum.com/au/en/products/boxsystems/legrabox/overview/", ji]
	},
	{
		brand: "blum",
		line: "ambia",
		title: "Blum MERIVOBOX",
		features: ["Straight metal sides with a design line along the side that catches the light", "Taller drawers have glass or metal panels, or a rail, above the side"],
		photos: [{
			src: Ai("WBM1013TB_1.jpg"),
			alt: "MERIVOBOX drawer open in a kitchen"
		}, {
			src: Ai("WBM1162TB_1.jpg"),
			alt: "Tall MERIVOBOX drawer with a panel above the side"
		}],
		sources: ["https://www.blum.com/au/en/products/boxsystems/merivobox/overview/"]
	},
	{
		brand: "blum",
		line: "orga",
		title: "Blum TANDEMBOX",
		features: [
			"Metal sides with a square-edged, rectangular look",
			"Taller drawers have rails along the top, or a glass or metal panel",
			"Blum logo on the cap at the front of each side"
		],
		photos: [
			{
				src: Ai("WB0306A_1.jpg"),
				alt: "TANDEMBOX drawer with a rail along the top"
			},
			{
				src: Ai("378M350AS_4.jpg"),
				alt: "TANDEMBOX drawer pulled open"
			},
			{
				src: Ai("378M350AS_1.jpg"),
				alt: "TANDEMBOX drawer sides"
			}
		],
		sources: ["https://blum.com/tw/en/products/boxsystems/tandembox/tandembox-antaro/programme", ji]
	},
	{
		brand: "blum",
		line: "orga",
		title: "Blum runners under a timber drawer",
		features: ["Timber drawer box with no metal sides showing; the runners are hidden underneath", "A clip under the front of the drawer with the Blum logo, often with orange levers"],
		photos: [{
			src: Ai("TWDTML51_1.jpg"),
			alt: "Orange Blum locking clip from under a timber drawer"
		}],
		sources: ["https://www.blum.com/au/en/company/quality-innovation/identify-blum-products/runnersystems/", "https://woodworkinstitute.com/wp-content/uploads/2024/07/Blum-Movento-Brochure.pdf"]
	},
	{
		brand: "hettich",
		line: "ayou",
		title: "Hettich AvanTech YOU",
		features: [
			"Slim straight metal sides, about 13 mm wide",
			"No caps or holes on the sides",
			"Some have a strip of glass, timber or stone along the side"
		],
		photos: [{
			src: Ai("GetImageNoResize.jpg?v=1751823067"),
			alt: "AvanTech YOU drawer sides"
		}, {
			src: Ai("GetImageNoResize_a532c526-1e9b-4714-83e9-a6eb04760e8d.jpg"),
			alt: "AvanTech YOU drawer sides"
		}],
		sources: ["https://www.hettich.com/en-au/products/drawer-systems/avantech-you"]
	},
	{
		brand: "hettich",
		line: "arci",
		title: "Hettich ArciTech",
		features: [
			"Double-walled metal sides with plastic caps carrying the Hettich logo",
			"Caps in anthracite, silver or white",
			"Taller drawers have a rail, two rails, or a glass or steel panel above the side"
		],
		photos: [],
		sources: ["https://www.hettich.com/en-au/products/drawer-systems/arcitech", "https://eboss.co.nz/library/hettich/arcitech-double-walled-drawer-system"]
	},
	{
		brand: "hettich",
		line: "atira",
		title: "Hettich InnoTech Atira",
		features: ["Sleek, square-cut metal sides with an accent line", "Caps with or without the Hettich logo, anthracite or stainless look"],
		photos: [{
			src: Ai("GetImageNoResize_bde263d1-f825-4225-a5e1-bea1b9dfdf74.jpg"),
			alt: "InnoTech Atira drawer side"
		}, {
			src: Ai("GetImageNoResize_310ec5a5-6543-442a-9939-defc7c21e156.jpg"),
			alt: "InnoTech Atira lengthwise rail"
		}],
		sources: ["https://www.hettich.com/en-au/products/drawer-systems/innotech-atira"]
	},
	{
		brand: "grass",
		title: "Grass Nova Pro Scala or Häfele Matrix Box",
		features: ["Double-walled metal sides with slim edges, straight on the inside", "The tallest drawers have a rectangular rail along the top"],
		photos: [],
		sources: ["https://www.hafele.co.uk/en/info/about-haefele/latest-news/versatile-drawer-solutions-why-matrix-box-is-always-the-answer/190342/", "https://www.woodworkingnetwork.com/product/components-hardware-and-assembly/double-walled-drawer-system"]
	}
];
//#endregion
//#region components/planner.tsx
async function Ni(e) {
	let t = {};
	for (let n of [...e].reverse()) {
		let e = Pi.get(n);
		if (e) {
			t[n] = [];
			for (let r of [...e.keys()].sort((e, t) => t - e)) {
				let i = await e.get(r)();
				i && t[n].push(i);
			}
		}
	}
	return t;
}
var Pi = /* @__PURE__ */ new Map(), Fi = 150, Ii = 10, Li = (e) => btoa(unescape(encodeURIComponent(e))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, ""), Ri = (e) => decodeURIComponent(escape(atob(e.replace(/-/g, "+").replace(/_/g, "/"))));
function zi(e) {
	let t = new URL(location.href);
	return t.hash = "ds-plan=" + Li(JSON.stringify(e)), t.toString();
}
function Bi(e) {
	let t = ot(0, "L");
	return t.addData(e), t.make(), t.createSvgTag({
		cellSize: 3,
		margin: 2,
		scalable: !0
	});
}
var Vi = (e) => e.trim ? "" : e.brand === "Blum" ? "blum" : e.brand === "Hettich" ? "hettich" : e.brand === "DTC" ? "dtc" : e.brand === "Krome" ? "krome" : "", Hi = (e, t) => {
	try {
		let n = window;
		n.Shopify?.analytics?.publish?.("drawer_studio_" + e, t), (n.dataLayer ??= []).push({
			event: "drawer_studio_" + e,
			...t
		});
	} catch {}
}, Ui = 68, Wi = (e) => /Standing Spice/i.test(e.name), Gi = {
	blum: "Blum",
	hettich: "Hettich",
	grass: "Grass or Häfele",
	dtc: "DTC",
	krome: "Krome",
	fgv: "FGV Unilux",
	other: "Other or not sure"
}, Ki = (e) => e.brand ? [
	Gi[e.brand] ?? e.brand,
	{
		orga: "TANDEMBOX or timber",
		ambia: "LEGRABOX or MERIVOBOX",
		arci: "ArciTech",
		ayou: "AvanTech YOU",
		atira: "InnoTech Atira"
	}[e.line] ?? "",
	e.nl ? `${e.nl} runner` : ""
].filter(Boolean).join(" · ") : "", qi = (e, t = "AUD") => new Intl.NumberFormat("en-AU", {
	style: "currency",
	currency: t
}).format(e), Ji = (e) => Number.isInteger(e) ? String(e) : e.toFixed(1), Yi = {
	light: {
		rim: "#ffffff",
		well: "#f7f7f7",
		floor: "#efefef",
		line: "#8c8c8c",
		fine: "#c4c4c4"
	},
	dark: {
		rim: "#55585b",
		well: "#46494c",
		floor: "#3b3e41",
		line: "#26282a",
		fine: "#76797c"
	},
	steel: {
		rim: "#dde0e2",
		well: "#e1e4e5",
		floor: "#d6d9db",
		line: "#848a8d",
		fine: "#aeb3b6"
	},
	timber: {
		rim: "#e2cba5",
		well: "#d6bb90",
		floor: "#c9ab7c",
		line: "#8e7048",
		fine: "#b3956a"
	}
}, Xi = (e, t, n, r) => {
	let i = r.l || r.t ? 0 : n, a = r.r || r.t ? 0 : n, o = r.r || r.b ? 0 : n, s = r.l || r.b ? 0 : n;
	return `M${i} 0H${e - a}${a ? `A${a} ${a} 0 0 1 ${e} ${a}` : ""}V${t - o}${o ? `A${o} ${o} 0 0 1 ${e - o} ${t}` : ""}H${s}${s ? `A${s} ${s} 0 0 1 0 ${t - s}` : ""}V${i}${i ? `A${i} ${i} 0 0 1 ${i} 0` : ""}Z`;
}, Zi = (e) => e.brand === "Ninka", Qi = (e, t = e.width) => {
	let n = /Container/.test(e.name) ? 1 : Math.max(1, Math.round(t / 90)), r = t / n;
	return Array.from({ length: n }, (e, t) => ({
		x: t * r,
		w: r
	}));
}, $i = (e) => e.finish === "white" ? "#f1f1ec" : e.finish === "anthracite" || e.finish === "black" || e.finish === "grey" ? "#4c4f52" : "#9a9ea0", ea = (e) => /ORGA-LINE/.test(e.name) && !/Frame|Divider|Rack|Cutter|Adaptor|Clip|Spice|Knife|Bottle/.test(e.name) ? "orga" : e.compartments.length >= 5 && e.compartments.every((e) => e.width <= 5) ? "knife" : e.role === "frame" || e.pocket || /Steel Frame|Utensil Frame/.test(e.name) ? "frame" : e.tiered ? "tiered" : "tray", ta = (e) => e.finish === "bamboo" || e.finish === "timber", na = (e, t, n) => {
	if (ta(e)) return 1;
	if (e.brand !== "Hettich") return Math.min(t, n) * .09;
	let r = Math.min(...e.compartments.length ? e.compartments.map((e) => Math.min(e.width, e.depth)) : [Math.min(e.width, e.depth)]);
	return Math.min(r * .34, t / 2, n / 2);
}, ra = (e) => Yi[e.finish === "anthracite" || e.finish === "black" || e.finish === "grey" ? "dark" : e.finish === "stainless" ? "steel" : e.finish === "timber" || e.finish === "bamboo" ? "timber" : "light"], ia = /* @__PURE__ */ new Map();
function aa(e) {
	return ia.has(e) || ia.set(e, fetch(e).then((e) => e.ok ? e.text() : "").then((e) => {
		let t = e.match(/viewBox="0 0 ([\d.]+) ([\d.]+)"/), n = [...e.matchAll(/ d="([^"]*)"/g)].map((e) => e[1]).join("");
		return t && n ? {
			w: +t[1],
			d: +t[2],
			path: n
		} : null;
	}).catch(() => null)), ia.get(e);
}
function oa({ url: e, width: t, depth: n, line: r, fill: i, outline: a, full: o }) {
	let [s, c] = (0, _.useState)(null), l = (0, _.useId)().replace(/[^a-zA-Z0-9_-]/g, "");
	return (0, _.useEffect)(() => {
		let t = !0;
		return aa(e).then((e) => {
			t && c(e);
		}), () => {
			t = !1;
		};
	}, [e]), /* @__PURE__ */ (0, M.jsxs)("g", {
		className: "hairline-tray",
		children: [
			/* @__PURE__ */ (0, M.jsx)("rect", {
				width: t,
				height: n,
				fill: i
			}),
			s && (() => {
				let e = o.w / s.w, i = o.d / s.d, a = o.both ? (o.w - t) / 2 : 0, c = o.front ? 0 : (o.d - n) / 2, u = `vt${l}`;
				return /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [/* @__PURE__ */ (0, M.jsx)("clipPath", {
					id: u,
					children: /* @__PURE__ */ (0, M.jsx)("rect", {
						width: t,
						height: n
					})
				}), /* @__PURE__ */ (0, M.jsx)("g", {
					clipPath: `url(#${u})`,
					children: /* @__PURE__ */ (0, M.jsx)("path", {
						d: s.path,
						transform: `translate(${-a} ${-c}) scale(${e} ${i})`,
						fill: "none",
						stroke: r,
						strokeWidth: ".75",
						vectorEffect: "non-scaling-stroke",
						strokeLinecap: "round"
					})
				})] });
			})(),
			/* @__PURE__ */ (0, M.jsx)("path", {
				d: `M0 0H${t}V${n}H0Z`,
				fill: "none",
				...a
			})
		]
	});
}
function sa({ product: e, width: t, depth: n, selected: r = !1 }) {
	let i = /LiniQ|OrganiQ/i.test(e.name) && e.expand ? e.minWidth <= 300 ? [[0]] : e.minWidth <= 400 ? [[138, 0]] : e.minWidth <= 600 ? [[138, 0], [
		138,
		138,
		138
	]] : null : null;
	if (i) {
		let a = ra(e), o = { vectorEffect: "non-scaling-stroke" }, s = n / 472, c = i.map((e) => ({
			lanes: e,
			w: e[0] === 0 && e.length === 1 ? 239 : e.length === 3 ? 448 : 384
		})), l = (t - c.reduce((e, t) => e + t.w, 0)) / 2;
		c.length === 2 && (c.reverse(), l = 0);
		let u = r ? "#000000" : a.line;
		return /* @__PURE__ */ (0, M.jsxs)("g", {
			className: "hairline-tray",
			children: [/* @__PURE__ */ (0, M.jsx)("rect", {
				width: t,
				height: n,
				fill: a.floor,
				stroke: u,
				strokeWidth: ".7",
				...o
			}), c.map((e, i) => {
				let d = c.length === 2 && i === 1 ? Math.max(0, Math.min(t - 384, 448)) : l;
				l += e.w;
				let f = [], p = d + 7;
				if (e.w === 448) for (let e = 0; e < 3; e++) f.push({
					x: p,
					w: 140,
					split: !1
				}), p += 147;
				else {
					e.w === 384 && (f.push({
						x: p,
						w: 138,
						split: !1
					}), p += 145);
					let t = (d + e.w - 7 - p - 14) / 3;
					for (let e = 0; e < 3; e++) f.push({
						x: p,
						w: t,
						split: !0
					}), p += t + 7;
				}
				return /* @__PURE__ */ (0, M.jsxs)("g", { children: [/* @__PURE__ */ (0, M.jsx)("rect", {
					x: d,
					y: 0,
					width: e.w,
					height: n,
					fill: a.rim,
					stroke: u,
					strokeWidth: r ? 1.4 : .9,
					...o
				}), f.map((e, t) => e.split ? /* @__PURE__ */ (0, M.jsxs)("g", { children: [/* @__PURE__ */ (0, M.jsx)("rect", {
					x: e.x,
					y: 7 * s,
					width: e.w,
					height: 181 * s - 7 * s,
					fill: a.floor,
					stroke: a.line,
					strokeWidth: ".6",
					...o
				}), /* @__PURE__ */ (0, M.jsx)("rect", {
					x: e.x,
					y: 187 * s,
					width: e.w,
					height: n - 187 * s - 7 * s,
					fill: a.floor,
					stroke: a.line,
					strokeWidth: ".6",
					...o
				})] }, t) : /* @__PURE__ */ (0, M.jsx)("rect", {
					x: e.x,
					y: 7 * s,
					width: e.w,
					height: n - 14 * s,
					fill: a.floor,
					stroke: a.line,
					strokeWidth: ".6",
					...o
				}, t))] }, i);
			})]
		});
	}
	if (e.expand && t < e.width - 1) {
		let i = t / 2, a = e.width, o = {
			...e,
			expand: !1
		};
		return /* @__PURE__ */ (0, M.jsxs)("g", {
			className: "expand-pair",
			children: [
				/* @__PURE__ */ (0, M.jsx)("svg", {
					width: i,
					height: n,
					viewBox: `0 0 ${i} ${n}`,
					overflow: "hidden",
					children: /* @__PURE__ */ (0, M.jsx)(sa, {
						product: o,
						width: a,
						depth: n,
						selected: r
					})
				}),
				/* @__PURE__ */ (0, M.jsx)("svg", {
					x: i,
					width: i,
					height: n,
					viewBox: `${a - i} 0 ${i} ${n}`,
					overflow: "hidden",
					children: /* @__PURE__ */ (0, M.jsx)(sa, {
						product: o,
						width: a,
						depth: n,
						selected: r
					})
				}),
				/* @__PURE__ */ (0, M.jsx)("path", {
					d: `M${i} 0V${n}`,
					stroke: r ? "#000000" : "#8a8a84",
					strokeWidth: ".9",
					strokeDasharray: "4 3",
					vectorEffect: "non-scaling-stroke"
				})
			]
		});
	}
	let a = ra(e), o = { vectorEffect: "non-scaling-stroke" }, s = {
		stroke: r ? "#000000" : a.line,
		strokeWidth: r ? 1.6 : .85,
		...o
	};
	if (!e.topImage && (/Utensil Frame/i.test(e.name) || e.role === "standalone" && e.expand && e.parts?.length && !e.compartments.length)) {
		let r = Math.max(3, Math.min(t, n) * .02), i = e.depth, c = (e.parts ?? []).filter((e) => e.kind === "divider" && e.width > e.depth).map((e) => n - (e.y + e.depth / 2) * n / i);
		return /* @__PURE__ */ (0, M.jsxs)("g", {
			className: "hairline-tray",
			children: [/* @__PURE__ */ (0, M.jsx)("path", {
				d: `M0 0H${t}V${n}H0Z M${r} ${r}V${n - r}H${t - r}V${r}Z`,
				fill: a.rim,
				fillRule: "evenodd",
				...s
			}), c.map((e, n) => /* @__PURE__ */ (0, M.jsx)("path", {
				d: `M${r} ${e.toFixed(1)}H${t - r}`,
				stroke: a.line,
				strokeWidth: ".8",
				...o
			}, n))]
		});
	}
	if (e.pocket && !e.topImage) return /* @__PURE__ */ (0, M.jsxs)("g", {
		className: "hairline-tray",
		children: [/* @__PURE__ */ (0, M.jsx)("path", {
			d: `M0 0H${t}V${n}H0Z` + be(e).map((e) => `M${e.anchor === "right" ? t - e.x - e.width : e.x} ${n - e.y - e.depth}v${e.depth}h${e.width}v-${e.depth}Z`).join(""),
			fill: a.rim,
			fillRule: "evenodd",
			...s
		}), /* @__PURE__ */ (0, M.jsx)("rect", {
			x: "3",
			y: "3",
			width: t - 6,
			height: n - 6,
			rx: "2",
			fill: "none",
			stroke: a.fine,
			strokeWidth: ".55",
			...o
		})]
	});
	let c = e.brand === "Hettich" && /OrgaTray 630/i.test(e.name);
	if (e.topImage && /^https:\/\/.*\.svg(\?|$)/.test(e.topImage)) return /* @__PURE__ */ (0, M.jsx)(oa, {
		url: e.topImage,
		width: t,
		depth: n,
		line: a.line,
		fill: c ? "none" : a.rim,
		outline: c ? {
			...s,
			fill: "none",
			stroke: r ? "#000000" : "none"
		} : {
			...s,
			fill: "none"
		},
		full: {
			w: e.width,
			d: e.depth,
			both: e.trimEdges !== "right",
			front: /Salsa Pro/i.test(e.name)
		}
	});
	if (e.topImage && /^(https:\/\/|data:image\/(png|webp|jpeg);base64,|\/(?!\/))/.test(e.topImage)) return /* @__PURE__ */ (0, M.jsxs)("g", {
		className: "hairline-tray",
		children: [/* @__PURE__ */ (0, M.jsx)("svg", {
			width: t,
			height: n,
			viewBox: `0 0 ${t} ${n}`,
			overflow: "hidden",
			children: /* @__PURE__ */ (0, M.jsx)("image", {
				href: e.topImage,
				width: e.width,
				height: e.depth,
				preserveAspectRatio: "xMinYMin meet"
			})
		}), /* @__PURE__ */ (0, M.jsx)("rect", {
			width: t,
			height: n,
			fill: "none",
			...s
		})]
	});
	if (e.brand === "Hettich" && /OrgaTray 270/i.test(e.name)) return /* @__PURE__ */ (0, M.jsxs)("g", {
		className: "hairline-tray",
		transform: `translate(0 ${n}) scale(1 -1)`,
		children: [/* @__PURE__ */ (0, M.jsx)("rect", {
			width: t,
			height: n,
			fill: a.rim,
			...s
		}), e.compartments.map((e, t) => /* @__PURE__ */ (0, M.jsx)("rect", {
			x: e.x,
			y: e.y,
			width: e.width,
			height: e.depth,
			fill: a.floor,
			stroke: a.line,
			strokeWidth: ".6",
			...o
		}, t))]
	});
	let l = Math.max(5, Math.min(t, n) * .035), u = e.trimEdges === "both" ? (e.width - t) / 2 : 0, d = e.depthTrim === "back" ? 0 : (e.depth - n) / 2, f = (e.compartments.length ? e.compartments : [{
		x: l,
		y: l,
		width: e.width - l * 2,
		depth: e.depth - l * 2
	}]).map((e) => {
		let r = Math.max(l, e.x - u), i = Math.min(t - l, e.x - u + e.width), a = Math.max(l, e.y - d), o = Math.min(n - l, e.y - d + e.depth);
		return i - r > 2 && o - a > 2 ? {
			x: r,
			y: a,
			w: i - r,
			h: o - a
		} : null;
	}).filter(Boolean), p = ea(e);
	if (e.parts?.length) {
		let t = Yi.steel, i = $i(e), a = (e.depth - n) / 2, s = `br${e.id}`;
		return /* @__PURE__ */ (0, M.jsxs)("g", {
			className: "hairline-tray",
			transform: `translate(0 ${n}) scale(1 -1)`,
			children: [/* @__PURE__ */ (0, M.jsx)("defs", { children: /* @__PURE__ */ (0, M.jsxs)("pattern", {
				id: s,
				width: "3",
				height: "40",
				patternUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ (0, M.jsx)("rect", {
					width: "3",
					height: "40",
					fill: t.floor
				}), /* @__PURE__ */ (0, M.jsx)("path", {
					d: "M1.5 0V40",
					stroke: "#c4c8cb",
					strokeWidth: ".35"
				})]
			}) }), e.parts.map((e, c) => {
				let l = Math.max(0, e.y - a), u = Math.min(e.depth, n - l);
				if (e.y - a + e.depth < 0 || e.y - a > n || u <= 0) return null;
				if (e.kind !== "body") return /* @__PURE__ */ (0, M.jsx)("rect", {
					x: e.x,
					y: l,
					width: e.width,
					height: u,
					fill: i,
					stroke: r ? "#000000" : "#6d7174",
					strokeWidth: ".5",
					...o
				}, c);
				let d = 2.2;
				return /* @__PURE__ */ (0, M.jsxs)("g", { children: [/* @__PURE__ */ (0, M.jsx)("rect", {
					x: e.x,
					y: l,
					width: e.width,
					height: u,
					rx: "1.5",
					fill: t.rim,
					stroke: r ? "#000000" : t.line,
					strokeWidth: ".6",
					...o
				}), e.width > 12 && u > 12 && /* @__PURE__ */ (0, M.jsx)("rect", {
					x: e.x + d,
					y: l + d,
					width: e.width - 2 * d,
					height: u - 2 * d,
					rx: "3",
					fill: `url(#${s})`,
					stroke: "#a9aeb1",
					strokeWidth: ".45",
					...o
				})] }, c);
			})]
		});
	}
	if (p === "knife") return /* @__PURE__ */ (0, M.jsxs)("g", {
		className: "hairline-tray",
		transform: `translate(0 ${n}) scale(1 -1)`,
		children: [
			/* @__PURE__ */ (0, M.jsx)("rect", {
				width: t,
				height: n,
				fill: a.rim,
				...s
			}),
			/* @__PURE__ */ (0, M.jsx)("path", {
				d: `M2 ${n * .55}H${t - 2}`,
				stroke: a.fine,
				strokeWidth: ".6",
				...o
			}),
			e.compartments.map((e, t) => /* @__PURE__ */ (0, M.jsx)("path", {
				d: `M${e.x + e.width / 2} ${n * .06}V${n * .94}`,
				stroke: a.line,
				strokeWidth: ".7",
				...o
			}, t))
		]
	});
	if (p === "orga") {
		let r = Yi.steel, i = $i(e), c = Math.min(14, n * .04);
		return /* @__PURE__ */ (0, M.jsx)("g", {
			className: "hairline-tray",
			transform: `translate(0 ${n}) scale(1 -1)`,
			children: Qi(e, t).map((e, t) => /* @__PURE__ */ (0, M.jsxs)("g", { children: [
				/* @__PURE__ */ (0, M.jsx)("rect", {
					x: e.x + 1,
					y: 0,
					width: e.w - 2,
					height: n,
					fill: r.rim,
					...s
				}),
				/* @__PURE__ */ (0, M.jsx)("rect", {
					x: e.x + 1,
					y: 0,
					width: e.w - 2,
					height: c,
					fill: i,
					stroke: a.line,
					strokeWidth: ".6",
					...o
				}),
				/* @__PURE__ */ (0, M.jsx)("rect", {
					x: e.x + 1,
					y: n - c,
					width: e.w - 2,
					height: c,
					fill: i,
					stroke: a.line,
					strokeWidth: ".6",
					...o
				}),
				/* @__PURE__ */ (0, M.jsx)("rect", {
					x: e.x + e.w * .12,
					y: c + 3,
					width: e.w * .76,
					height: n - 2 * c - 6,
					rx: 3,
					fill: r.floor,
					stroke: r.line,
					strokeWidth: ".6",
					...o
				})
			] }, t))
		});
	}
	if (p === "frame" && !e.pocket) {
		let e = Math.max(4, Math.min(t, n) * .025);
		return /* @__PURE__ */ (0, M.jsx)("g", {
			className: "hairline-tray",
			children: /* @__PURE__ */ (0, M.jsx)("path", {
				d: `M0 0H${t}V${n}H0Z M${e} ${e}V${n - e}H${t - e}V${e}Z`,
				fill: a.rim,
				fillRule: "evenodd",
				...s
			})
		});
	}
	return /* @__PURE__ */ (0, M.jsxs)("g", {
		className: "hairline-tray",
		transform: `translate(0 ${n}) scale(1 -1)`,
		children: [
			e.ribbed && /* @__PURE__ */ (0, M.jsx)("defs", { children: /* @__PURE__ */ (0, M.jsxs)("pattern", {
				id: `rib${e.id}`,
				width: "6.5",
				height: "6.5",
				patternUnits: "userSpaceOnUse",
				patternTransform: "rotate(-45)",
				children: [/* @__PURE__ */ (0, M.jsx)("rect", {
					width: "6.5",
					height: "6.5",
					fill: a.floor
				}), /* @__PURE__ */ (0, M.jsx)("path", {
					d: "M0 3.25H6.5",
					stroke: a.fine,
					strokeWidth: ".95"
				})]
			}) }),
			/* @__PURE__ */ (0, M.jsx)("path", {
				d: Xi(t, n, 0, {
					l: e.trim && e.trimEdges === "both" && t < e.width,
					r: e.trim && t < e.width,
					t: n < e.depth,
					b: n < e.depth
				}),
				fill: a.rim,
				...s
			}),
			f.map((t, n) => ta(e) ? /* @__PURE__ */ (0, M.jsxs)("g", { children: [/* @__PURE__ */ (0, M.jsx)("rect", {
				x: t.x,
				y: t.y,
				width: t.w,
				height: t.h,
				rx: "1",
				fill: a.floor,
				stroke: a.line,
				strokeWidth: ".55",
				...o
			}), /* @__PURE__ */ (0, M.jsx)("path", {
				d: `M${t.x + t.w * .5} ${t.y + t.h * .12}V${t.y + t.h * .88}`,
				stroke: a.fine,
				strokeWidth: ".35",
				opacity: ".7",
				...o
			})] }, n) : Zi(e) ? /* @__PURE__ */ (0, M.jsx)("rect", {
				x: t.x,
				y: t.y,
				width: t.w,
				height: t.h,
				rx: "2",
				fill: "none",
				stroke: a.fine,
				strokeWidth: ".65",
				...o
			}, n) : /* @__PURE__ */ (0, M.jsx)("rect", {
				x: t.x,
				y: t.y,
				width: t.w,
				height: t.h,
				rx: na(e, t.w, t.h),
				fill: e.ribbed ? `url(#rib${e.id})` : a.floor,
				stroke: a.line,
				strokeWidth: ".7",
				...o
			}, n)),
			e.tiered && /* @__PURE__ */ (0, M.jsx)("path", {
				d: `M 8 ${n * .5} H ${t - 8}`,
				stroke: a.line,
				strokeWidth: ".7",
				strokeDasharray: "4 3",
				...o
			})
		]
	});
}
var ca = (e) => Z(e).replace(/^(Blum|Hettich|Häfele|Kesseböhmer|Ninka|Agoform|Joseph Joseph|Salice)\s+((ORGA-LINE|AMBIA-LINE|FineLine|OrganiQ|LiniQ|DrawerStore|Cuisio)\s+)*/i, ""), Z = (e) => e.split(" | ")[0].replace(/\s+[—-]\s+Single-End Lock$/i, ""), la = [
	{
		key: "cutlery",
		label: "Cutlery",
		room: "kitchen",
		re: /cutlery|orgatray|cuisio|classico/i
	},
	{
		key: "utensils",
		label: "Utensils",
		room: "kitchen",
		re: /utensil|gadget/i
	},
	{
		key: "knives",
		label: "Knives",
		room: "kitchen",
		re: /knife|knives/i
	},
	{
		key: "spices",
		label: "Spices",
		room: "kitchen",
		re: /spice|salsa/i
	},
	{
		key: "wraps",
		label: "Wraps & foil",
		room: "kitchen",
		re: /foil|wrap|film/i
	},
	{
		key: "pots",
		label: "Pots & pans",
		room: "kitchen",
		re: /$^/
	},
	{
		key: "bits",
		label: "Odds & ends",
		room: "kitchen",
		re: /container|storage|insert|bits/i
	},
	{
		key: "jewellery",
		label: "Jewellery",
		room: "wardrobe",
		re: /jewel|ring|earring/i
	},
	{
		key: "watches",
		label: "Watches",
		room: "wardrobe",
		re: /watch/i
	},
	{
		key: "accessories",
		label: "Belts, ties & glasses",
		room: "wardrobe",
		re: /storage|divided|accessor/i
	}
], ua = (e, t, n) => {
	let r = (/^kitchen ?library$/i.test(e.brand || "") ? "" : e.brand || "").toUpperCase(), i = Z(e.name).toUpperCase();
	return {
		brand: r,
		model: r && i.startsWith(r) ? i.slice(r.length).trim() : i,
		size: `${Math.round(t)} × ${Math.round(n)}`
	};
};
function da({ x: e, d: t, w: n, ok: r }) {
	let i = Math.min(14, t * .05);
	return /* @__PURE__ */ (0, M.jsxs)("g", {
		className: "side-rail",
		pointerEvents: "none",
		children: [/* @__PURE__ */ (0, M.jsx)("rect", {
			x: e,
			y: 0,
			width: n,
			height: t,
			fill: "#e9eae8",
			stroke: r ? "#000000" : "#9a9a94",
			strokeDasharray: r ? void 0 : "4 3",
			strokeWidth: ".8",
			vectorEffect: "non-scaling-stroke"
		}), [0, 1].map((r) => /* @__PURE__ */ (0, M.jsx)("path", {
			d: `M${e + n / 2} ${r ? t : 0}` + [
				1,
				2,
				3,
				4
			].map((a) => ` L${e + (a % 2 ? n * .15 : n * .85)} ${r ? t - a * i / 4 : a * i / 4}`).join(""),
			fill: "none",
			stroke: "#000000",
			strokeWidth: ".8",
			vectorEffect: "non-scaling-stroke"
		}, r))]
	});
}
function fa({ p: e, w: t, d: n, u: r, lift: i = 0 }) {
	let a = Math.min(12 * r, t / 15), o = 4 * r, s = a * .64, { brand: c, model: l, size: u } = ua(e, t, n), d = (c ? c + "   " : "") + u, f = l.split(" "), p = [], m = (e) => {
		p.length = 0;
		let t = "";
		for (let n of f) {
			let r = t ? t + " " + n : n;
			r.length * s + o * 2 > e && t ? (p.push(t), t = n) : t = r;
		}
		return t && p.push(t), p.slice(0, 3);
	}, h = t - 6 * r;
	if (h < a * 8 || t < 120) return null;
	let g = m(h), _ = Math.min(h, Math.max(d.length, ...g.map((e) => e.length)) * s + o * 2), v = a * 1.25, y = o * 1.2 + v * (1 + g.length);
	return /* @__PURE__ */ (0, M.jsxs)("g", {
		className: "spec-tag",
		pointerEvents: "none",
		transform: `translate(${3 * r} ${n - 3 * r - y - i})`,
		children: [
			/* @__PURE__ */ (0, M.jsx)("rect", {
				width: _,
				height: y,
				fill: "#111"
			}),
			/* @__PURE__ */ (0, M.jsxs)("text", {
				x: o,
				y: o * .6 + a,
				fontSize: a,
				fill: "#fff",
				letterSpacing: a * .08,
				children: [/* @__PURE__ */ (0, M.jsx)("tspan", {
					fontWeight: "700",
					children: c
				}), /* @__PURE__ */ (0, M.jsx)("tspan", {
					dx: c ? a * .9 : 0,
					fill: "#bdbdb6",
					children: u
				})]
			}),
			g.map((e, t) => /* @__PURE__ */ (0, M.jsx)("text", {
				x: o,
				y: o * .6 + a + v * (t + 1),
				fontSize: a,
				fill: "#fff",
				letterSpacing: a * .08,
				children: e
			}, t))
		]
	});
}
var pa = (e) => {
	let t = e.finish ?? "", n = (e.finishName ?? "") + " " + (e.variantTitle ?? "");
	return /moka|brown|mink/i.test(n) ? [
		"#b8a596",
		"#a08b7a",
		"#8a7463"
	] : /sand|taupe|beige|flax|shell|stone|champagne/i.test(n) ? [
		"#e9dfcf",
		"#dccdb6",
		"#cdb99c"
	] : t === "timber" ? /black|ash/i.test(n) && !/nordic/i.test(n) ? [
		"#a69a8e",
		"#8f8277",
		"#796c61"
	] : [
		"#ecd8b6",
		"#dfc398",
		"#cfae7d"
	] : t === "bamboo" ? [
		"#eedbb0",
		"#e1c793",
		"#d2b47a"
	] : t === "stainless" || /stainless|steel/i.test(n) ? [
		"#e3e7ea",
		"#d0d6db",
		"#bcc4ca"
	] : t === "anthracite" || t === "black" || t === "grey" || /slate|graphite|anthracite|grey|black/i.test(n) ? [
		"#b9bec3",
		"#a3a9af",
		"#8c939a"
	] : [
		"#ffffff",
		"#f2f0e9",
		"#e4e1d8"
	];
};
function ma({ p: e }) {
	let [t, n] = (0, _.useState)(!1);
	return e.sketchUrl && !t ? /* @__PURE__ */ (0, M.jsx)("img", {
		className: "sketch-img",
		src: e.sketchUrl,
		alt: "",
		loading: "lazy",
		decoding: "async",
		onError: () => n(!0)
	}) : e.topImage ? /* @__PURE__ */ (0, M.jsx)("svg", {
		"aria-hidden": "true",
		viewBox: `-5 -5 ${e.width + 10} ${e.depth + 10}`,
		children: /* @__PURE__ */ (0, M.jsx)(sa, {
			product: e,
			width: e.width,
			depth: e.depth
		})
	}) : L(e) ? /* @__PURE__ */ (0, M.jsx)(Jt, { p: e }) : /* @__PURE__ */ (0, M.jsx)(ha, { p: e });
}
function ha({ p: e }) {
	let t = ra(e), n = Math.cos(Math.PI / 6), r = e.width, i = e.depth, a = Math.max(e.height, 10), o = ea(e), s = (e, t, r) => [(e - t) * n, (e + t) * .5 - r], c = (e) => e.map((e, t) => `${t ? "L" : "M"}${e[0].toFixed(1)} ${e[1].toFixed(1)}`).join("") + "Z", l = (e, t) => `M${e[0].toFixed(1)} ${e[1].toFixed(1)}L${t[0].toFixed(1)} ${t[1].toFixed(1)}`, u = (e, t, n, r, i, a = 0) => {
		let o = Math.max(0, Math.min(a, (n - e) / 2, (r - t) / 2));
		if (!o) return c([
			s(e, t, i),
			s(n, t, i),
			s(n, r, i),
			s(e, r, i)
		]);
		let l = [], u = (e, t, n) => {
			for (let r = 0; r <= 5; r++) {
				let a = n + r * Math.PI / 10;
				l.push(s(e + Math.cos(a) * o, t + Math.sin(a) * o, i));
			}
		};
		return u(n - o, t + o, -Math.PI / 2), u(n - o, r - o, 0), u(e + o, r - o, Math.PI / 2), u(e + o, t + o, Math.PI), c(l);
	}, d = (e, n, r, i, a, o, l, d, f = t.rim, p = t.well) => /* @__PURE__ */ (0, M.jsxs)("g", { children: [
		/* @__PURE__ */ (0, M.jsx)("path", {
			d: c([
				s(e, i, o),
				s(r, i, o),
				s(r, i, a),
				s(e, i, a)
			]),
			fill: f,
			...m
		}),
		/* @__PURE__ */ (0, M.jsx)("path", {
			d: c([
				s(r, n, o),
				s(r, i, o),
				s(r, i, a),
				s(r, n, a)
			]),
			fill: p,
			...m
		}),
		/* @__PURE__ */ (0, M.jsx)("path", {
			d: u(e, n, r, i, o),
			fill: l,
			...m
		})
	] }, d), f = (0, _.useId)().replace(/[^a-zA-Z0-9_-]/g, ""), p = (n, r, i, a, o, s, c, l, d, p, m) => {
		let h = `w${f}${m}`, g = Math.max(0, o - s);
		return /* @__PURE__ */ (0, M.jsxs)("g", { children: [
			e.ribbed && /* @__PURE__ */ (0, M.jsx)("defs", { children: /* @__PURE__ */ (0, M.jsxs)("pattern", {
				id: `rc${f}`,
				width: "6.5",
				height: "6.5",
				patternUnits: "userSpaceOnUse",
				patternTransform: "rotate(-35)",
				children: [/* @__PURE__ */ (0, M.jsx)("rect", {
					width: "6.5",
					height: "6.5",
					fill: d
				}), /* @__PURE__ */ (0, M.jsx)("path", {
					d: "M0 3.25H6.5",
					stroke: t.fine,
					strokeWidth: ".8"
				})]
			}) }),
			/* @__PURE__ */ (0, M.jsx)("clipPath", {
				id: h,
				children: /* @__PURE__ */ (0, M.jsx)("path", { d: u(n, r, i, a, o, c) })
			}),
			/* @__PURE__ */ (0, M.jsx)("path", {
				d: u(n, r, i, a, o, c),
				fill: l
			}),
			/* @__PURE__ */ (0, M.jsx)("path", {
				d: u(n, r, i, a, g, c),
				fill: e.ribbed ? `url(#rc${f})` : d,
				clipPath: `url(#${h})`
			}),
			/* @__PURE__ */ (0, M.jsx)("path", {
				d: u(n, r, i, a, o, c),
				fill: "none",
				stroke: p,
				strokeWidth: .6,
				vectorEffect: "non-scaling-stroke"
			})
		] }, m);
	}, m = {
		stroke: t.line,
		strokeWidth: .9,
		vectorEffect: "non-scaling-stroke",
		strokeLinejoin: "round"
	}, h = {
		...m,
		stroke: t.fine,
		strokeWidth: .6,
		fill: "none"
	}, g = [
		s(0, 0, 0),
		s(r, 0, 0),
		s(r, i, 0),
		s(0, i, 0),
		s(0, 0, a),
		s(r, 0, a),
		s(r, i, a),
		s(0, i, a)
	], v = g.map((e) => e[0]), y = g.map((e) => e[1]), b = Math.min(...v), x = Math.min(...y), ee = Math.max(...v) - b, S = Math.max(...y) - x, C = Math.max(ee, S) * .05, w = `${b - C} ${x - C} ${ee + C * 2} ${S + C * 2}`;
	if (o === "knife") {
		let n = i * .45, o = a * .62, c = e.compartments.map((e) => e.x + e.width / 2);
		return /* @__PURE__ */ (0, M.jsxs)("svg", {
			"aria-hidden": "true",
			viewBox: w,
			children: [
				d(0, 0, r, n, 0, a, t.rim, "back"),
				d(0, n, r, i, 0, o, t.rim, "front"),
				c.map((e, t) => /* @__PURE__ */ (0, M.jsxs)("g", { children: [/* @__PURE__ */ (0, M.jsx)("path", {
					d: l(s(e, i * .06, a), s(e, n, a)),
					...h
				}), /* @__PURE__ */ (0, M.jsx)("path", {
					d: l(s(e, n + i * .02, o), s(e, i * .94, o)),
					...h
				})] }, t))
			]
		});
	}
	if (e.parts?.length) {
		let t = Yi.steel, n = $i(e);
		return /* @__PURE__ */ (0, M.jsx)("svg", {
			"aria-hidden": "true",
			viewBox: w,
			children: [...e.parts].sort((e, t) => t.y + t.depth - (e.y + e.depth) || e.x - t.x).map((e, r) => {
				let a = i - e.y - e.depth, o = i - e.y, s = e.kind === "rail" ? t.well : e.kind === "body" ? t.rim : n;
				return /* @__PURE__ */ (0, M.jsxs)("g", { children: [d(e.x, a, e.x + e.width, o, 0, e.height, s, "s" + r, e.kind === "end" ? n : t.well, e.kind === "end" ? n : t.floor), e.kind === "body" && e.width > 20 && e.depth > 20 && p(e.x + 2.5, a + 2.5, e.x + e.width - 2.5, o - 2.5, e.height, e.height * .8, 3, "#c3c8cb", t.floor, t.line, "b" + r)] }, r);
			})
		});
	}
	if (o === "orga") {
		let t = Yi.steel, n = $i(e), r = Math.min(7, i * .03);
		return /* @__PURE__ */ (0, M.jsx)("svg", {
			"aria-hidden": "true",
			viewBox: w,
			children: Qi(e).map((e, o) => {
				let l = e.x + .5, d = e.x + e.w - .5, f = Math.min(e.w * .3, 16), h = Math.min(4, e.w * .06);
				return /* @__PURE__ */ (0, M.jsxs)("g", { children: [
					/* @__PURE__ */ (0, M.jsx)("path", {
						d: c([
							s(l, i, a),
							s(d, i, a),
							s(d, i, 0),
							s(l, i, 0)
						]),
						fill: t.well,
						...m,
						stroke: t.line,
						strokeWidth: .7
					}),
					/* @__PURE__ */ (0, M.jsx)("path", {
						d: c([
							s(d, 0, a),
							s(d, i, a),
							s(d, i, 0),
							s(d, 0, 0)
						]),
						fill: t.floor,
						...m,
						stroke: t.line,
						strokeWidth: .7
					}),
					/* @__PURE__ */ (0, M.jsx)("path", {
						d: u(l, 0, d, i, a),
						fill: t.rim,
						...m,
						stroke: t.line,
						strokeWidth: .7
					}),
					p(l + h, r + h, d - h, i - r - h, a, a * .8, Math.min(f, 4), "#c3c8cb", t.floor, t.line, "t" + o),
					/* @__PURE__ */ (0, M.jsx)("path", {
						d: u(l, 0, d, r, a),
						fill: n,
						...m,
						stroke: t.line,
						strokeWidth: .5
					}),
					/* @__PURE__ */ (0, M.jsx)("path", {
						d: u(l, i - r, d, i, a),
						fill: n,
						...m,
						stroke: t.line,
						strokeWidth: .5
					})
				] }, o);
			})
		});
	}
	if (o === "frame") {
		let e = Math.max(4, Math.min(r, i) * .025);
		return /* @__PURE__ */ (0, M.jsxs)("svg", {
			"aria-hidden": "true",
			viewBox: w,
			children: [
				d(0, 0, r, e, 0, a, t.rim, "back"),
				d(0, 0, e, i, 0, a, t.rim, "left"),
				d(r - e, 0, r, i, 0, a, t.rim, "right"),
				d(0, i - e, r, i, 0, a, t.rim, "front")
			]
		});
	}
	let te = (e.compartments.length ? e.compartments : [{
		x: r * .035,
		y: i * .035,
		width: r * .93,
		depth: i * .93
	}]).map((e) => ({
		x0: e.x,
		x1: e.x + e.width,
		y0: i - e.y - e.depth,
		y1: i - e.y
	}));
	if (o === "tiered") {
		let n = te.map((e) => a * (.35 + .55 * (1 - e.y1 / i)));
		return /* @__PURE__ */ (0, M.jsxs)("svg", {
			"aria-hidden": "true",
			viewBox: w,
			children: [d(0, 0, r, i, 0, a * .9, t.rim, "body"), te.map((r, i) => /* @__PURE__ */ (0, M.jsx)("path", {
				d: u(r.x0, r.y0, r.x1, r.y1, n[i], na(e, r.x1 - r.x0, r.y1 - r.y0)),
				fill: t.floor,
				...m,
				strokeWidth: .7
			}, i))]
		});
	}
	return /* @__PURE__ */ (0, M.jsxs)("svg", {
		"aria-hidden": "true",
		viewBox: w,
		children: [d(0, 0, r, i, 0, a, t.rim, "body"), te.map((n, r) => Zi(e) ? /* @__PURE__ */ (0, M.jsx)("path", {
			d: u(n.x0, n.y0, n.x1, n.y1, a, 1),
			...h
		}, r) : /* @__PURE__ */ (0, M.jsx)("path", {
			d: u(n.x0, n.y0, n.x1, n.y1, a, na(e, n.x1 - n.x0, n.y1 - n.y0)),
			fill: t.floor,
			...m,
			strokeWidth: .7
		}, r))]
	});
}
function ga() {
	let e = Math.cos(Math.PI / 6), t = (t, n, r) => [(t - n) * e, (t + n) * .5 - r], n = (...e) => e.map((e, t) => `${t ? "L" : "M"}${e[0].toFixed(1)} ${e[1].toFixed(1)}`).join(""), r = [
		n(t(0, 0, 70), t(300, 0, 70), t(300, 240, 70), t(0, 240, 70), t(0, 0, 70)),
		n(t(0, 0, 0), t(300, 0, 0), t(300, 0, 70)),
		n(t(0, 0, 0), t(0, 0, 70)),
		n(t(0, 0, 0), t(0, 240, 0), t(0, 240, 70)),
		n(t(0, 240, 0), t(300, 240, 0), t(300, 240, 70)),
		n(t(300, 0, 0), t(300, 240, 0))
	], i = (e, t, r) => n([e[0] - t, e[1] - r], [e[0] + t, e[1] + r]), a = t(0, 226, 6), o = t(300, 226, 6), s = t(286, 0, 6), c = t(286, 240, 6), l = t(14, 14, 0), u = t(14, 14, 70), d = [
		{
			d: n(a, o) + i(a, 0, 6) + i(o, 0, 6),
			t: "W",
			at: t(300 / 2, 262, 0)
		},
		{
			d: n(s, c) + i(s, 0, 6) + i(c, 0, 6),
			t: "D",
			at: t(324, 240 / 2, 0)
		},
		{
			d: n(l, u) + i(l, 6, 0) + i(u, 6, 0),
			t: "H",
			at: t(-6, 22, 70 / 2)
		}
	];
	return /* @__PURE__ */ (0, M.jsxs)("svg", {
		className: "measure-guide",
		viewBox: "-262 -100 566 392",
		role: "img",
		"aria-label": "Measure inside the drawer: W side to side, D front to back, H from the floor to the lowest obstruction when closed.",
		children: [/* @__PURE__ */ (0, M.jsx)("g", {
			fill: "none",
			stroke: "#9a9a94",
			strokeWidth: ".8",
			vectorEffect: "non-scaling-stroke",
			strokeLinejoin: "round",
			children: r.map((e, t) => /* @__PURE__ */ (0, M.jsx)("path", { d: e }, t))
		}), d.map((e, t) => /* @__PURE__ */ (0, M.jsxs)("g", {
			className: `dim dim-${t}`,
			children: [/* @__PURE__ */ (0, M.jsx)("path", {
				d: e.d,
				fill: "none",
				stroke: "#000000",
				strokeWidth: "1.3",
				pathLength: 100,
				vectorEffect: "non-scaling-stroke"
			}), /* @__PURE__ */ (0, M.jsx)("text", {
				x: e.at[0],
				y: e.at[1],
				textAnchor: "middle",
				fontSize: "15",
				fill: "#000000",
				children: e.t
			})]
		}, e.t))]
	});
}
var _a = (e) => String(e).replace(/[&<>"']/g, (e) => ({
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
})[e]);
function va(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		let e = `${n.product.id}|${n.width}|${n.depth}`, r = t.get(e);
		r ? r.qty++ : t.set(e, {
			p: n,
			qty: 1
		});
	}
	return [...t.values()].map(({ p: e, qty: t }) => {
		let n = e.product.width - e.width, r = e.product.depth - e.depth, i = e.product.trimEdges !== "right", a = e.product.expand ? `Set to ${Ji(e.width)} mm wide` : e.product.trim && n > 0 ? `Cut to ${Ji(e.width)} mm wide · ${i ? `${Ji(n / 2)} mm off each side` : `${Ji(n)} mm off the right`}` : "No width cut";
		return {
			img: e.product.sketchUrl || e.product.image || "",
			name: e.product.name,
			colour: e.product.finishName || "",
			sku: e.product.sku,
			qty: t,
			size: `${Ji(e.width)} × ${Ji(e.depth)} mm`,
			cut: a + (r > 0 ? ` · depth ${Ji(e.depth)} mm (${e.product.depthTrim === "back" ? `${Ji(r)} mm off the back` : `${Ji(r / 2)} mm off front and back`})` : ""),
			each: e.product.price,
			currency: e.product.currency,
			inside: !!e.parentKey
		};
	});
}
function ya(e, t, n, r, i, a, o = "", s = "", c = "", l) {
	let u = va(n), d = u.reduce((e, t) => e + t.each * t.qty, 0), f = u[0]?.currency ?? "AUD", p = (() => {
		if (!e) return "";
		let t = e.cloneNode(!0);
		return t.querySelectorAll(".piece-actions,.piece-remove,.piece-turn,.spec-tag,.rail-arrows,.bay-ghost,.divider-btn,.divider-ctl,.resize-edge,.ghost-offer,.drop-spot").forEach((e) => e.remove()), t.outerHTML;
	})(), m = `<!doctype html><html lang="en-AU"><meta charset="utf-8"><title>${_a(r)} · plan</title><link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Abel&display=swap"><style>body{font:13px/1.5 Helvetica,Arial,sans-serif;color:#111;max-width:900px;margin:28px auto;padding:0 28px}.hd{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:26px}.hd img{height:56px;filter:invert(1)}.who{text-align:right;font-size:12px;color:#555;line-height:1.6}.who b{font:400 16px Abel,Helvetica,sans-serif;color:#111;letter-spacing:.04em}.kicker{font:400 12px Abel,Helvetica,sans-serif;letter-spacing:.18em;text-transform:uppercase;color:#777;margin:0 0 4px}h1{font:400 34px/1.1 Abel,Helvetica,sans-serif;margin:0 0 8px;display:flex;align-items:center;gap:12px;flex-wrap:wrap}h1 .dot{display:inline-grid;place-items:center;width:42px;height:42px;border-radius:50%;background:#111;color:#fff;font-size:20px;-webkit-print-color-adjust:exact;print-color-adjust:exact}h1 .sep{color:#bbb}.lede{font-size:14px;color:#333;margin:0;max-width:620px}.facts{display:flex;flex-wrap:wrap;gap:6px 34px;margin:16px 0 18px;padding:12px 0;border-top:1.5px solid #111;border-bottom:1px solid #ddd}.facts span{display:block;font:400 10px Abel,Helvetica,sans-serif;letter-spacing:.16em;text-transform:uppercase;color:#888}.facts b{font-weight:400;font-size:14px}.art svg{width:100%;height:auto;max-height:400px}.art .front-svg,.art .dim-label{font-family:Abel,Arial;letter-spacing:2px;fill:#606060}.art .piece-dimension{display:none}table{border-collapse:collapse;width:100%;margin-top:16px}th,td{border-bottom:1px solid #e4e4e4;padding:9px 6px;text-align:left;vertical-align:middle}th{font:400 10px Abel,Helvetica,sans-serif;letter-spacing:.16em;text-transform:uppercase;color:#888}td.t img{width:60px;height:40px;object-fit:contain;display:block}td.n{text-align:right;white-space:nowrap}.notes{display:grid;grid-template-columns:1fr 1fr;gap:22px;margin-top:22px;padding-top:14px;border-top:1.5px solid #111}.notes h3{font:400 12px Abel,Helvetica,sans-serif;letter-spacing:.16em;text-transform:uppercase;margin:0 0 6px}.notes p,.notes li{font-size:12px;color:#444;margin:0 0 5px}.notes ul{margin:0;padding-left:16px}.note{margin-top:14px;color:#555;font-size:12px}.demo{border:1px solid #111;padding:8px 12px;margin:10px 0}button{margin-top:18px;padding:10px 18px;border-radius:999px;border:0;background:#111;color:#fff;font:inherit;cursor:pointer}@media print{button{display:none}body{margin:0}}</style>
<div class="hd">${c ? `<img src="${_a(c.startsWith("//") ? "https:" + c : c)}" alt="KitchenLibrary">` : "<b>KitchenLibrary</b>"}<div class="who"><b>KitchenLibrary</b><br>kitchenlibrary.au<br>Drawer plan · confirmed ${(/* @__PURE__ */ new Date()).toLocaleDateString("en-AU")}</div></div><p class="kicker">Your drawer plan</p><h1>${l ? `<span class="dot">${_a(l.no)}</span> ${_a(l.set)} <span class="sep">|</span> <span class="dot">${_a(l.letter)}</span> ${_a(l.name)}` : _a(r)}</h1><p class="lede">Every piece measured to your drawer and placed with purpose. Keep this with your order: it will be just as useful the day you fit it.</p><div class="facts"><div><span>Inside the drawer</span><b>${t.width} × ${t.depth} × ${t.height} mm</b></div>${o ? `<div><span>Drawer system</span><b>${_a(o)}</b></div>` : ""}<div><span>Pieces</span><b>${u.reduce((e, t) => e + t.qty, 0)}${a ? " + liner" : ""}</b></div><div><span>Planned</span><b>${(/* @__PURE__ */ new Date()).toLocaleDateString("en-AU")}</b></div></div>
<div class="art">${p}</div>
<table><tr><th></th><th>Qty</th><th>Product</th><th>SKU</th><th>Size in drawer</th><th>Cut</th><th class="n">Each</th></tr>${u.map((e) => `<tr><td class="t">${e.img ? `<img src="${_a(e.img.startsWith("//") ? "https:" + e.img : e.img)}" alt="">` : ""}</td><td>${e.qty}</td><td>${_a(e.name)}${e.colour ? ` · ${_a(e.colour)}` : ""}${e.inside ? " <small>(inside frame)</small>" : ""}</td><td>${_a(e.sku)}</td><td>${e.size}</td><td>${_a(e.cut)}</td><td class="n">${qi(e.each, e.currency)}</td></tr>`).join("")}${a ? `<tr><td class="t"></td><td>1</td><td>Drawer liner · ${_a(a.name)}</td><td>${_a(a.sku ?? "")}</td><td>${t.width} × ${t.depth} mm</td><td>Trim to fit</td><td class="n">${a.price === void 0 ? "—" : qi(a.price, f)}</td></tr>` : ""}<tr><td></td><td></td><td colspan="4"><b>Trays total</b>${a ? " <small>(liner priced in your cart)</small>" : ""}</td><td class="n"><b>${qi(d, f)}</b></td></tr></table>
<div class="notes"><div><h3>Before you cut</h3><p>Cut-to-size trays are sized to the full inside of your drawer: lift them out by a compartment. Other trays already have ${O.width} mm spare.</p><p>Cut-to-size trays and liners are cut at home. Check before cutting. We do not accept change-of-mind returns on cut-to-size trays or liners. Your Australian Consumer Law rights are unaffected.</p></div><div><h3>Cutting safely</h3><ul><li>Work on a stable bench with the tray held flat or clamped, hands clear of the cut line.</li><li>Use a sharp blade and several light passes. Never force the cut.</li><li>Wear safety glasses and cut-resistant gloves. Keep children away.</li><li>Not confident? Have a qualified cabinet maker trim and fit it.</li></ul></div></div><p class="note"><b>Please check before you order.</b> This plan is a guide built from the measurements and drawer system you entered; we have not seen your drawers. Confirm each size inside the drawer, the clear height with the drawer closed, and that any system insert (Blum, Hettich, DTC) matches your drawer's maker and model. Suggested layouts are ideas only. Prices are as at the planning date.</p>${s ? `<div class="qr">${Bi(s)}<p><b>Lost this plan?</b> Scan the code, or open <a href="${_a(s)}">this link</a>, to reopen it on any device.</p></div>` : ""}<style>.qr{display:flex;gap:16px;align-items:center;margin-top:18px;break-inside:avoid}.qr svg{width:120px;height:120px;flex:none}.qr p{margin:0;font-size:12px;color:#333333}</style><button onclick="print()">Print or save as PDF</button></html>`, h = window.open("", "_blank");
	if (h) {
		h.document.write(m), h.document.close();
		return;
	}
	let g = URL.createObjectURL(new Blob([m], { type: "text/html" })), _ = document.createElement("a");
	_.href = g, _.download = "drawer-plan.html", _.click(), setTimeout(() => URL.revokeObjectURL(g), 1e3);
}
function ba({ k: e }) {
	let t = {
		stroke: "#111",
		strokeWidth: 1.6,
		markerStart: "url(#pf-ar)",
		markerEnd: "url(#pf-ar)"
	};
	return /* @__PURE__ */ (0, M.jsxs)("svg", {
		className: "pf-diagram",
		viewBox: "0 0 400 230",
		"aria-hidden": "true",
		children: [/* @__PURE__ */ (0, M.jsx)("defs", { children: /* @__PURE__ */ (0, M.jsx)("marker", {
			id: "pf-ar",
			viewBox: "0 0 10 10",
			refX: "5",
			refY: "5",
			markerWidth: "7",
			markerHeight: "7",
			orient: "auto-start-reverse",
			children: /* @__PURE__ */ (0, M.jsx)("path", {
				d: "M0 1L9 5L0 9",
				fill: "none",
				stroke: "#111",
				strokeWidth: "1.2"
			})
		}) }), e === "height" ? /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
			/* @__PURE__ */ (0, M.jsx)("rect", {
				x: "104",
				y: "30",
				width: "14",
				height: "172",
				fill: "#fff",
				stroke: "#111",
				strokeWidth: "1.2"
			}),
			/* @__PURE__ */ (0, M.jsx)("rect", {
				x: "118",
				y: "194",
				width: "210",
				height: "8",
				fill: "#fff",
				stroke: "#111",
				strokeWidth: "1.2"
			}),
			/* @__PURE__ */ (0, M.jsx)("line", {
				x1: "200",
				y1: "36",
				x2: "200",
				y2: "190",
				...t
			}),
			/* @__PURE__ */ (0, M.jsx)("text", {
				x: "132",
				y: "24",
				fontSize: "18",
				fontFamily: "Abel,Helvetica,Arial,sans-serif",
				children: "drawer side, seen from the end"
			})
		] }) : /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
			/* @__PURE__ */ (0, M.jsx)("rect", {
				x: "40",
				y: "20",
				width: "320",
				height: "170",
				fill: "#fff",
				stroke: "#111",
				strokeWidth: "1.2"
			}),
			/* @__PURE__ */ (0, M.jsx)("rect", {
				x: "52",
				y: "30",
				width: "296",
				height: "150",
				fill: "none",
				stroke: "#111",
				strokeWidth: ".7"
			}),
			/* @__PURE__ */ (0, M.jsx)("rect", {
				x: "30",
				y: "190",
				width: "340",
				height: "12",
				fill: "#fff",
				stroke: "#111",
				strokeWidth: "1.2"
			}),
			/* @__PURE__ */ (0, M.jsx)("text", {
				x: "200",
				y: "222",
				fontSize: "12",
				fill: "#111",
				textAnchor: "middle",
				letterSpacing: "3",
				fontFamily: "Abel,Helvetica,Arial,sans-serif",
				children: "FRONT"
			}),
			e === "width" ? /* @__PURE__ */ (0, M.jsx)("line", {
				x1: "56",
				y1: "105",
				x2: "344",
				y2: "105",
				...t
			}) : /* @__PURE__ */ (0, M.jsx)("line", {
				x1: "200",
				y1: "34",
				x2: "200",
				y2: "176",
				...t
			})
		] })]
	});
}
function xa({ config: e = {}, onSummary: t, onConfirmed: n }) {
	let r = (0, _.useId)().replace(/[^a-zA-Z0-9_-]/g, ""), i = !!e.products, [a, o] = (0, _.useState)("all"), [s, c] = (0, _.useState)("white"), l = e.finish ?? s, [u, d] = (0, _.useState)(""), f = e.room ?? u, [p, m] = (0, _.useState)(""), [h, g] = (0, _.useState)(""), [y, x] = (0, _.useState)([]), [ee, S] = (0, _.useState)({
		brand: "",
		line: "",
		nl: 0
	}), [C, w] = (0, _.useState)(!1), [te, ne] = (0, _.useState)(() => typeof window < "u" && window.matchMedia("(max-width:900px)").matches);
	(0, _.useEffect)(() => {
		let e = window.matchMedia("(max-width:900px)"), t = () => ne(e.matches);
		return e.addEventListener("change", t), () => e.removeEventListener("change", t);
	}, []);
	let [re, ie] = (0, _.useState)(!1), [ae, ye] = (0, _.useState)(""), [xe, Te] = (0, _.useState)({}), [De, Oe] = (0, _.useState)(!1), [Me, Ne] = (0, _.useState)(!1), [et, ot] = (0, _.useState)(!1), [st, ct] = (0, _.useState)(1), [lt, ut] = (0, _.useState)(!1), [dt, ft] = (0, _.useState)([]), pt = (0, _.useRef)(null), [mt, ht] = (0, _.useState)(!0), gt = (0, _.useRef)(null), [k, _t] = (0, _.useState)(null), [vt, yt] = (0, _.useState)(null);
	(0, _.useEffect)(() => {
		if (!i) try {
			let e = localStorage.getItem("drawer-studio-photo-product");
			if (e) {
				let t = JSON.parse(e);
				Fe(t) && yt({
					...t,
					verified: !1,
					variantId: void 0
				});
			}
		} catch {}
	}, [i]);
	let A = (0, _.useMemo)(() => (e.products ?? [...ki, ...vt ? [vt] : []]).filter((e) => Fe(e) && e.brand !== "Kimberley" && (!Wi(e) || Ui > 0)).map((e) => Wi(e) ? {
		...e,
		height: Math.max(e.height, Ui)
	} : e), [e.products, vt]), j = e.system ?? ee, bt = (t) => {
		let n = typeof t == "function" ? t(j) : t;
		e.onSystem ? e.onSystem(n) : S(n);
	}, [xt, Ct] = (0, _.useState)(!e.system?.brand), [N, P] = (0, _.useState)(!1), F = [...new Set(A.flatMap((e) => e.rooms ?? []))].filter((e) => e !== "accessory");
	[...new Set(A.map((e) => e.brand).filter(Boolean))].sort();
	let wt = (0, _.useMemo)(() => Ee(A, l, F.length > 1 ? f || F[0] : "", p), [
		A,
		l,
		f,
		p,
		F.join()
	]), Tt = (0, _.useMemo)(() => {
		let e = la.filter((e) => y.includes(e.key)).map((e) => e.re), t = (t) => e.some((e) => e.test(t.name));
		return wt.filter((n) => {
			let r = Vi(n);
			if (r && r !== j.brand || e.length && !t(n) && !(be(n).length && wt.some((e) => e.insertOnly && t(e))) || j.brand === "blum" && n.brand === "Blum" && (j.line === "orga" && /AMBIA/i.test(n.name) || j.line === "ambia" && /ORGA-LINE/i.test(n.name) || j.nl && !we(n) && n.depth >= 380 && Math.abs(n.depth - (j.nl - 26)) > 1)) return !1;
			if (j.brand === "hettich" && n.brand === "Hettich") {
				let e = j.line === "arci" ? "arcitech" : j.line === "ayou" ? "avantech_you" : j.line === "atira" ? "atira" : "";
				if (e && n.systems?.length && !n.systems.includes(e) || j.nl && n.nl?.length && !n.nl.includes(j.nl)) return !1;
			}
			return !(j.brand === "hettich" && j.nl && !n.insertOnly && /OrgaTray/i.test(n.name) && !n.nl?.length && !(n.depth <= 440 ? [420, 450] : n.depth <= 520 ? [
				470,
				500,
				520
			] : n.depth <= 620 ? [620, 650] : []).includes(j.nl) || j.brand === "grass" && j.nl && /Cuisio/i.test(n.name) && !/Spice/i.test(n.name) && Math.round(n.depth) !== (j.nl === 500 ? 480 : 430));
		});
	}, [
		wt,
		y.join(),
		j
	]), Et = !!e.live && !!e.allowancesApproved && A.length > 0 && A.length === (e.products ?? []).filter((e) => e.brand !== "Kimberley").length && A.every((e) => e.variantId && e.currency === A[0].currency), [Dt, Ot] = (0, _.useState)(""), kt = e.liners ?? (i ? [] : $e), I = kt.find((e) => e.id === Dt), At = (0, _.useRef)(!1), jt = (0, _.useRef)(!1), [Mt, Nt] = (0, _.useState)(null), [Pt, Ft] = (0, _.useState)(!0), [It, Lt] = (0, _.useState)("trays"), Rt = (0, _.useRef)(null), zt = (0, _.useRef)(null), [Bt, Vt] = (0, _.useState)(-1), [Ht, Ut] = (0, _.useState)(""), [Wt, Gt] = (0, _.useState)(), [Kt, qt] = (0, _.useState)(null), [L, Jt] = (0, _.useState)(0), [Yt, Xt] = (0, _.useState)({
		width: String(e.initialDimensions?.width ?? (i ? "" : "600")),
		depth: String(e.initialDimensions?.depth ?? (i ? "" : "480")),
		height: String(e.initialDimensions?.height ?? (i ? "" : e.initialHeight ?? "100"))
	}), [R, Qt] = (0, _.useState)([]), [$t, en] = (0, _.useState)([]), [tn, nn] = (0, _.useState)(""), [rn, an] = (0, _.useState)(e.drawerName ?? "My kitchen drawer"), [on, sn] = (0, _.useState)(!1), [cn, z] = (0, _.useState)(""), [ln, un] = (0, _.useState)(null), [dn, fn] = (0, _.useState)(!1), [pn, mn] = (0, _.useState)("idle");
	(0, _.useEffect)(() => {
		if (!/^(Remix |Placed\.|Tray removed|Suggested layout|This is the only|Set pushed|A \d+ mm Blum)/.test(cn)) return;
		let e = setTimeout(() => z(""), 3e3);
		return () => clearTimeout(e);
	}, [cn]);
	let B = (0, _.useMemo)(() => ({
		width: Number(Yt.width),
		depth: Number(Yt.depth),
		height: Number(Yt.height)
	}), [Yt]), V = (0, _.useMemo)(() => rt(B, I), [B, I]), hn = tt(I, B, e.cabinetWidth), H = (0, _.useMemo)(() => {
		let e = Ie(V, R, A);
		return hn ? {
			...e,
			ok: !1,
			errors: [hn, ...e.errors]
		} : e;
	}, [
		V,
		R,
		A,
		hn
	]);
	(0, _.useEffect)(() => {
		!At.current && !on && e.initialDimensions && Xt((t) => ({
			...t,
			width: String(e.initialDimensions.width)
		}));
	}, [e.initialDimensions?.width]);
	let gn = Pe(B), _n = gn.length === 0, vn = R.find((e) => e.id === tn), yn = H.placed.filter((e) => e.laneId === tn), bn = I ? Qe(I, B, e.cabinetWidth).quantity : 0, xn = H.placed.filter((e) => !e.key.includes("-div")).reduce((e, t) => e + t.product.price, 0) + [...H.placed.filter((e) => e.key.includes("-div")).reduce((e, t) => e.set(t.product, (e.get(t.product) ?? 0) + 1), /* @__PURE__ */ new Map())].reduce((e, [t, n]) => e + t.price * Math.ceil(n / We(t)), 0) + (I?.price ?? 0) * bn, Sn = A[0]?.currency ?? "AUD", Cn = !I || nt(I, Sn) && !hn, wn = H.placed.length + +!!I;
	function Tn(e) {
		jt.current = !0, Ot(e), mn("idle");
		let t = Zr.current?.getBoundingClientRect();
		e && t && (t.bottom < 100 || t.top > window.innerHeight * .7) && Zr.current?.scrollIntoView({
			behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth",
			block: "center"
		});
	}
	let En = H.ok && H.spare > Ii && H.placed.some((e) => !e.parentKey && e.product.trim && e.width < e.product.width);
	(0, _.useEffect)(() => {
		let e = (e) => {
			let t = A.find((t) => t.id === e);
			return !!t && !!Vi(t) && Vi(t) !== j.brand;
		};
		R.some((t) => t.items.some(e)) && (jn(R.map((t) => ({
			...t,
			items: t.items.filter((t) => !e(t))
		})).filter((e) => e.items.length)), z("Removed pieces made for a different drawer system."));
	}, [j.brand]);
	function Dn() {
		let e = H.ok ? H.placed.filter((e) => !e.parentKey) : [];
		if (!e.length) return "";
		let t = e.some((e) => Vi(e.product) || be(e.product).length > 0), n = H.spare >= Fi;
		return e.length === 1 && e[0].product.trim && H.spare, I && e.some((e) => e.product.trim) ? "Not needed with a cut-to-size tray." : !I && t ? "Recommended: the drawer floor shows between the frame and its bays. Line the whole drawer." : !I && n ? "Recommended: the open side of this drawer shows its floor. Line the whole drawer." : "";
	}
	function On() {
		let e = /* @__PURE__ */ new Map(), t = kt.some(Ze);
		for (let n of kt) {
			if (t && !Ze(n) || n.id !== Dt && (n.cutToSize || it(n)) && Number.isFinite(n.rollWidth) && B.depth > 0 && n.rollWidth < B.depth) continue;
			let r = e.get(n.name);
			(!r || n.id === Dt || r.id !== Dt && (n.rollWidth ?? 0) < (r.rollWidth ?? 0)) && e.set(n.name, n);
		}
		return [...e.values()];
	}
	function kn() {
		return kt.length > 0 ? /* @__PURE__ */ (0, M.jsxs)("details", {
			className: "liner-picker",
			children: [
				/* @__PURE__ */ (0, M.jsxs)("summary", { children: [
					/* @__PURE__ */ (0, M.jsx)(fe, { size: 15 }),
					/* @__PURE__ */ (0, M.jsxs)("span", { children: ["Drawer liner ", /* @__PURE__ */ (0, M.jsx)("small", { children: I ? I.name : "Optional · lay it down first. Popular for drawers with an exposed base." })] }),
					Dn() && /* @__PURE__ */ (0, M.jsx)("em", {
						className: "liner-advice",
						children: Dn()
					})
				] }),
				/* @__PURE__ */ (0, M.jsxs)("div", {
					className: "liner-swatches",
					children: [/* @__PURE__ */ (0, M.jsxs)("button", {
						"aria-pressed": !I,
						onClick: () => Tn(""),
						children: [/* @__PURE__ */ (0, M.jsx)("i", { className: "no-liner" }), "None"]
					}), On().map((e) => /* @__PURE__ */ (0, M.jsxs)("button", {
						disabled: e.available === !1,
						"aria-pressed": Dt === e.id,
						"aria-label": `Use ${e.name} drawer liner`,
						onClick: () => Tn(e.id),
						children: [/* @__PURE__ */ (0, M.jsx)("i", { style: { backgroundColor: e.colour } }), e.name]
					}, e.id))]
				}),
				/* @__PURE__ */ (0, M.jsx)("p", { children: I?.price === void 0 ? I ? "Colour preview · price, roll size and thickness to be confirmed." : "A textured layer beneath your trays and open spaces." : I.cutToSize ? (() => {
					let t = Qe(I, B, e.cabinetWidth);
					return (I.sellUnitMm ?? 1e3) >= (I.rollLength ?? Infinity) ? `${qi(I.price, I.currency ?? Sn)} · one roll, cut to ${t.cutLength} mm` : `${qi(I.price * t.quantity, I.currency ?? Sn)} · cut to ${t.cutLength} mm × ${t.sheetDepth} mm, you trim to fit`;
				})() : `${qi(I.price, I.currency ?? Sn)} · one ${(I.rollLength ?? 5e3) / 1e3} m roll · your drawers share it, more rolls only when they need them` }),
				hn && /* @__PURE__ */ (0, M.jsx)("p", {
					role: "alert",
					children: hn
				})
			]
		}) : null;
	}
	(0, _.useEffect)(() => {
		t?.({
			pieces: wn,
			total: xn,
			currency: Sn,
			dimensions: `${Yt.width} × ${Yt.depth} × ${Yt.height}mm`,
			valid: H.ok,
			layout: {
				w: B.width,
				d: B.depth,
				h: B.height,
				pieces: H.ok ? H.placed.map((e) => ({
					x: e.x,
					y: e.y,
					w: e.width,
					d: e.depth,
					h: e.product.height,
					tone: pa(e.product),
					img: e.product.topImage && /^https:\/\//.test(e.product.topImage) ? e.product.topImage : void 0,
					comps: (e.product.parts?.length ? e.product.parts.filter((e) => e.kind === "body").map((e) => ({
						x: e.x,
						y: e.y,
						w: e.width,
						d: e.depth
					})) : e.product.compartments.map((e) => ({
						x: e.x,
						y: e.y,
						w: e.width,
						d: e.depth
					}))).filter((t) => t.x < e.width && t.y < e.depth).slice(0, 24)
				})) : []
			}
		});
	}, [
		H,
		xn,
		Sn,
		Yt,
		t,
		wn,
		B
	]);
	let An = e.storageKey ?? "kitchen-library-drawer-v1";
	(0, _.useEffect)(() => {
		try {
			un(localStorage.getItem(An));
		} catch {}
	}, [An]), (0, _.useEffect)(() => {
		if (!R.length && !I) {
			if ($t.length || jt.current) try {
				localStorage.removeItem(An);
			} catch {}
			return;
		}
		try {
			localStorage.setItem(An, JSON.stringify({
				version: 1,
				values: Yt,
				lanes: R,
				name: rn,
				linerId: Dt
			}));
		} catch {}
	}, [
		Yt,
		R,
		rn,
		An,
		$t.length,
		Dt
	]);
	function jn(e) {
		en((e) => [...e, R].slice(-20)), Qt(e), z(""), mn("idle");
	}
	function Mn() {
		try {
			let e = JSON.parse(ln);
			if (e.version !== 1 || !Array.isArray(e.lanes) || e.lanes.length > 12 || !e.values || !e.lanes.every((e) => typeof e.id == "string" && Array.isArray(e.items) && e.items.length <= 10 && e.items.every((e) => A.some((t) => t.id === e)))) throw Error();
			At.current = !0, Ot(kt.some((t) => t.id === e.linerId) ? e.linerId : ""), Xt({
				width: String(e.values.width),
				depth: String(e.values.depth),
				height: String(e.values.height)
			});
			let t = /* @__PURE__ */ new Set();
			Qt(e.lanes.map((e) => {
				let n = e.items.map((e, t) => A.find((t) => t.id === e)?.available ? t : -1).filter((e) => e >= 0);
				if (e.items.forEach((e) => {
					A.find((t) => t.id === e)?.available || t.add(Z(A.find((t) => t.id === e)?.name ?? "A tray"));
				}), n.length === e.items.length) return e;
				let r = new Map(n.map((e, t) => [e, t])), i = (e) => e && Object.fromEntries(Object.entries(e).flatMap(([e, t]) => {
					let [n, ...i] = String(e).split("-"), a = r.get(Number(n));
					return a === void 0 ? [] : [[[a, ...i].join("-"), t]];
				}));
				return {
					...e,
					items: n.map((t) => e.items[t]),
					inserts: i(e.inserts),
					dividers: i(e.dividers),
					turned: e.turned?.filter((e) => r.has(e)).map((e) => r.get(e))
				};
			}).filter((e) => e.items.length)), an(String(e.name).slice(0, 60)), sn(!0), ot(!1), n?.({
				width: Number(e.values.width),
				depth: Number(e.values.depth),
				height: Number(e.values.height)
			}), ei(1), lt || setTimeout(() => Tr(3), 80), z(t.size ? `${[...t].join(", ")} ${t.size === 1 ? "is" : "are"} no longer available, so we took ${t.size === 1 ? "it" : "them"} out.` : "Your drawer is back where you left it."), un(null);
		} catch {
			z("This saved layout is no longer supported. Start a new one."), un(null);
		}
	}
	function Nn(e) {
		let t = pr(e);
		if (t) {
			z(t);
			return;
		}
		if (Gt(void 0), e.insertOnly) {
			let t = Bn(e);
			if (t) {
				jn(t.lanes), nn(t.laneId), qt(null), z(te ? "" : `Added ${Z(e.name)} into the frame.`);
				return;
			}
			let n = Ln(e);
			if (n) {
				jn(n.lanes), qt(null), z(`Added ${Z(e.name)} with its frame (${Z(n.frame.name)}). Both are in your total.`);
				return;
			}
		}
		if (!e.insertOnly) try {
			let t = Be(V, R, A, e.id, `lane-${Date.now().toString(36)}`, tn);
			jn(t.lanes), nn(t.laneId), qt(null), z(te ? "" : `Added ${Z(e.name)}. Drag it to move.`);
			return;
		} catch {}
		qt(e.id), Ft(!1), z("Choose an outlined spot in your drawer.");
	}
	function Pn(e) {
		let t = e.parentKey ?? e.key;
		return {
			laneId: e.laneId,
			index: Number(t.slice(t.lastIndexOf("-") + 1)),
			...e.parentKey ? {
				insert: !0,
				slot: Number(e.key.split("-insert")[1] || 0)
			} : {}
		};
	}
	(0, _.useEffect)(() => {
		if (L !== 1 || !Ht) return;
		let e = (e) => {
			if (e.key !== "Delete" && e.key !== "Backspace") return;
			let t = e.composedPath()[0];
			if (t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
			let n = H.placed.find((e) => e.key === Ht);
			n && (e.preventDefault(), jn(Ye(R, Pn(n))), Ut(""), z("Removed. Undo brings it back."));
		};
		return window.addEventListener("keydown", e), () => window.removeEventListener("keydown", e);
	});
	function Fn(e) {
		if (e.parentKey) return "Inside frame";
		let t = H.placed.filter((t) => t.laneId === e.laneId && !t.parentKey), n = t.findIndex((t) => t.key === e.key);
		return t.length < 2 ? "Tray" : n === 0 ? "Front" : n === t.length - 1 ? "Back" : `Middle ${n + 1}`;
	}
	function In(e) {
		nn(e.laneId), Ut(e.key), qt(null), Gt(void 0), z("");
	}
	(0, _.useEffect)(() => {
		if (!cn.startsWith("Added ")) return;
		let e = setTimeout(() => z(""), 2500);
		return () => clearTimeout(e);
	}, [cn]);
	let Ln = (0, _.useMemo)(() => {
		let e = /* @__PURE__ */ new Map(), t = A.filter((e) => e.available && !e.insertOnly && be(e).length > 0);
		return (n) => {
			if (e.has(n.id)) return e.get(n.id);
			let r = null, i = t.filter((e) => be(e).some((t, r) => Je(e, n, V, r))).sort((e, t) => Number(t.finish === n.finish) - Number(e.finish === n.finish) || e.width - t.width || e.price - t.price);
			for (let e of i) try {
				let t = `lane-${Date.now().toString(36)}f`, i = Be(V, R, A, e.id, t), a = Ie(V, i.lanes, A).placed.find((t) => t.laneId === i.laneId && t.product.id === e.id && !t.parentKey);
				if (!a) continue;
				r = {
					frame: e,
					lanes: Xe(V, i.lanes, A, n.id, a.key).lanes
				};
				break;
			} catch {}
			return e.set(n.id, r), r;
		};
	}, [
		A,
		R,
		V
	]), Rn = (e) => {
		let t = A.filter((t) => !t.insertOnly && be(t).some((t) => t.accepts.includes(e.id)));
		if (!t.length) return "";
		let n = /* @__PURE__ */ new Map();
		for (let e of t) n.set(e.name, [...n.get(e.name) ?? [], e]);
		return "Goes in " + [...n].map(([e, t]) => {
			let n = Math.min(...t.map((e) => e.minWidth || e.width)), r = A.filter((t) => t.name === e && !t.insertOnly);
			return Z(e) + (t.length < r.length ? ` (${Math.round(n)} mm wide and up)` : "");
		}).join(" or ");
	}, zn = (e) => new Set(A.filter((t) => !t.insertOnly && be(t).some((t) => t.accepts.includes(e.id))).map((e) => e.name)).size, Bn = (e) => {
		for (let t of H.placed.filter((e) => e.product.pocket && !e.parentKey)) try {
			return Xe(V, R, A, e.id, t.key);
		} catch {}
		return null;
	}, Vn = Tt.filter((e) => Ve(e, B) && (a === "all" || (a === "premium" ? e.premium : e.pocket || e.insertOnly))), Hn = (e) => e.trim && !e.insertOnly && !/spice/i.test(e.name) && e.minWidth + ke(e) <= B.width && B.width - (e.width + ke(e)) <= 25, Un = (e) => Hn(e) ? -1 : e.width < 40 ? 4 : f === "wardrobe" || /cutlery/i.test(e.name) && !/rail/i.test(e.name) ? 0 : e.trim || e.expand ? 1 : e.insertOnly ? 3 : 2, Wn = (e) => `${e.width}|${e.minWidth}|${e.depth}`, Gn = (e) => `${e.name}|${Wn(e)}`, Kn = /* @__PURE__ */ new Map(), qn = /* @__PURE__ */ new Map();
	for (let e of Vn) {
		let t = Gn(e);
		Kn.set(t, [...Kn.get(t) ?? [], e]), qn.set(e.name, [...qn.get(e.name) ?? [], e]);
	}
	let Jn = (e) => e.find((t) => t.id === xe[e[0].name]) ?? [...e].sort((e, t) => Number(!!pr(e)) - Number(!!pr(t)) || Number(t.finish === l) - Number(e.finish === l) || t.width - e.width)[0], Yn = (e) => {
		let t = Kn.get(Gn(e)) ?? [e];
		return t.some((e) => !pr(e)) ? "" : t.some((e) => e.available) ? "won't fit" : "out of stock";
	}, Xn = j.brand === "blum" ? "Blum" : j.brand === "hettich" ? "Hettich" : j.brand === "dtc" ? "DTC" : j.brand === "krome" ? "Krome" : "", Zn = (e) => Xn ? e.brand === Xn || Xn === "Blum" && !!je(e) && (!j.line || je(e) === j.line) : j.brand === "grass" ? /^(Ninka|Häfele)$/.test(e.brand ?? "") : !1, Qn = (e) => Se(e, B) > 10 ? Se(e, B) : 0, $n = (e) => (qn.get(e.name) ?? [e]).reduce((e, t) => Math.max(e, t.bestSeller ? 1e6 : t.sales ?? 0), 0), er = (e) => nr(e) >= V.width * V.depth * .5, tr = (e) => !!Qn(e) || !Le(e, V), nr = (e) => Math.min(e.width, V.width) * Math.min(e.depth, V.depth), rr = (e) => e.trim && !e.insertOnly && !/spice/i.test(e.name) && e.minWidth + ke(e) <= B.width && e.width + ke(e) >= B.width * .85, ir = (e) => !e.insertOnly && !e.trim && nr(e) >= V.width * V.depth * .5 && (e.premium || e.finish === "stainless" || /stainless|timber|bamboo|beech|oak|walnut/i.test(e.name)), ar = [...qn.values()].map(Jn).map((e) => [e, pr(e)]).sort((e, t) => Number(!!e[1]) - Number(!!t[1]) || Number(Zn(t[0])) - Number(Zn(e[0])) || Number(t[0].brand === Xn) - Number(e[0].brand === Xn) || Number(Hn(t[0])) - Number(Hn(e[0])) || Number(rr(t[0])) - Number(rr(e[0])) || Number(tr(e[0])) - Number(tr(t[0])) || (tr(e[0]) && tr(t[0]) ? nr(t[0]) - nr(e[0]) : Number(er(t[0])) - Number(er(e[0]))) || (j.brand && j.brand !== "other" ? $n(t[0]) - $n(e[0]) : Un(e[0]) - Un(t[0]) || e[0].price - t[0].price) || Un(e[0]) - Un(t[0])).map((e) => e[0]), or = (e) => !/bamboo/i.test(e.name + " " + (e.finish ?? "")) * 1e7 + nr(e) / 10, sr = ar.reduce((e, t, n) => n > 0 && ir(t) && !pr(t) && (e < 0 || or(t) > or(ar[e])) ? n : e, -1), cr = sr > 1 && !ir(ar[0]) && !(Zn(ar[0]) && !ar[0].trim), lr = cr ? [
		ar[0],
		ar[sr],
		...ar.slice(1).filter((e, t) => t + 1 !== sr)
	] : ar, ur = new Set([...lr.filter((e) => $n(e) > 0).slice(0, 3).map((e) => e.name), ...lr.filter((e) => (qn.get(e.name) ?? [e]).some((e) => e.bestSeller)).map((e) => e.name)]), dr = lr.filter((e) => !!pr(e)).length;
	function fr() {
		let e = Tt.filter((e) => e.available && !e.insertOnly);
		if (!e.length) return "No trays fit these measurements";
		let t = Math.min(...e.map((e) => e.height + O.height)), n = Math.min(...e.map((e) => Ce(e) + Ae(e))), r = Math.min(...e.map((e) => e.minWidth + ke(e)));
		return t > V.height ? `No trays fit: the lowest needs ${t} mm clear height, and yours is ${B.height} mm` : n > B.depth ? `No trays fit: the shortest needs ${n} mm depth, and yours is ${B.depth} mm` : r > B.width ? `No trays fit: the narrowest needs ${r} mm width, and yours is ${B.width} mm` : "No trays fit these measurements";
	}
	function pr(e) {
		if (!e.available) return "Currently unavailable";
		if (e.height + O.height > V.height) return `Too tall — requires ${e.height + O.height}mm clearance`;
		if (Ce(e) + Ae(e) > B.depth) return `Too deep — requires ${Ce(e) + Ae(e)}mm depth`;
		if (e.minWidth + ke(e) > B.width) return `Too wide — requires ${e.minWidth + ke(e)}mm width`;
		if (e.trim && !Le(e, V)) return `No size of this tray reaches ${B.width} mm wide`;
		if (e.trim && e.depth < B.depth - Ae(e) - 10) return `No size of this tray reaches ${B.depth} mm deep`;
		if (e.insertOnly) return Bn(e) || Ln(e) ? "" : "No frame for this fits here";
		for (let t = 0; t <= R.length; t++) try {
			return Ke(V, R, A, e.id, "check-new", null, t), "";
		} catch {}
		for (let t of R) try {
			return Ke(V, R, A, e.id, "check-new", t.id, t.items.length), "";
		} catch {}
		return "No space in this layout";
	}
	function mr(e) {
		return e.width >= e.product.width && H.spare > 0 ? `Maximum tray width reached: ${e.product.width}mm. ${Ji(H.spare)}mm remains.` : H.spare > 0 && H.spare < e.product.step ? `${Ji(H.spare)}mm remains to respect the ${e.product.step}mm cutting increment.` : H.spare === 0 ? "Remaining width filled. Fitting clearance is already included." : `${Ji(H.spare)}mm spare width. Use Fill remaining width to expand safely.`;
	}
	let [hr, gr] = (0, _.useState)(!1), [_r, vr] = (0, _.useState)(!1);
	function yr() {
		let e = la.filter((e) => y.includes(e.key));
		if (!e.length) return [];
		let t = (e) => Tt.filter((t) => !t.insertOnly && Le(t, V) && e.test(t.name) && t.width >= 40 && !pr(t)).sort((e, t) => t.width * t.depth - e.width * e.depth), n = [], r = /* @__PURE__ */ new Set();
		for (let i of t(e[0].re).slice(0, 5)) {
			let a = [];
			try {
				a = Be(V, [], A, i.id, "lane-i0").lanes;
			} catch {
				continue;
			}
			e.slice(1).forEach((e, n) => {
				for (let r of t(e.re)) try {
					a = Be(V, a, A, r.id, `lane-i${n + 1}`).lanes;
					return;
				} catch {}
			});
			let o = JSON.stringify(a.map((e) => e.items));
			r.has(o) || (r.add(o), n.push(a));
		}
		return n;
	}
	function br(e) {
		let t = e.flatMap((e) => e.items).map((e) => A.find((t) => t.id === e)).filter(Boolean);
		if (t.some((e) => Re(e) === "Blum AMBIA-LINE") && t.some((e) => Re(e) === "Blum ORGA-LINE") || t.filter((e) => we(e) && !e.insertOnly).length > 1) return !1;
		let n = /* @__PURE__ */ new Map();
		for (let e of t) e.insertOnly || n.set(e.name, [...n.get(e.name) ?? [], e]);
		for (let [e, t] of n) if (t.length > 1) {
			let n = Math.max(...t.map((e) => e.width));
			if (A.some((t) => t.name === e && t.width > n && t.width <= V.width - O.width && Ce(t) <= V.depth - O.depth)) return !1;
		}
		return !0;
	}
	function xr() {
		let e = [], t = [], n = /* @__PURE__ */ new Set(), r = (e) => {
			let t = Ie(V, e, A);
			return t.ok ? t : null;
		}, i = (r, i) => {
			let a = JSON.stringify(r.map((e) => e.items));
			return n.has(a) || !br(r) ? !1 : (n.add(a), e.push(r), t.push(i), !0);
		}, a = (e) => {
			let t = r(e);
			return !!t && t.spare <= Ii && t.placed.every((e) => e.parentKey || Se(e.product, B) <= 10);
		}, o = wt.filter((e) => !Vi(e) || Vi(e) === j.brand), s = (e) => e.available !== !1 && e.height + O.height <= V.height && Ce(e) + Ae(e) <= B.depth && e.minWidth + ke(e) <= B.width, c = o.filter((e) => e.trim && !e.insertOnly && !Vi(e) && !/Salsa|Spice/i.test(e.name) && s(e)).sort((e, t) => (t.sales ?? 0) - (e.sales ?? 0)), l = (e) => {
			let t = [];
			try {
				e.forEach((e, n) => {
					t = Be(V, t, A, e, `lane-s${n}`).lanes;
				});
			} catch {
				return null;
			}
			return t;
		};
		for (let t of c) {
			let n = l([t.id]);
			if (n && a(n) && i(n, "one cut-to-size tray, no gaps") && e.length >= 2) break;
		}
		if (B.height >= Fi) {
			let e = o.filter((e) => /Salsa Pro/i.test(e.name) && s(e));
			outer: for (let t of e) for (let e of c) {
				let n = l([t.id, e.id]);
				if (n && a(n) && i(n, "spice tray and cut-to-size tray")) break outer;
			}
		}
		let u = o.filter((e) => Vi(e) && Vi(e) === j.brand);
		if (u.length) for (let t of ze(V, u, 6)) {
			let n = r(t);
			if (!(!n || n.spare > Ii + 12 && n.spare < Fi) && (i(t, n.spare >= Fi ? `${Gi[j.brand]} set · ${Math.round(n.spare)} mm left for utensils` : `${Gi[j.brand]} set`), e.length >= 6)) break;
		}
		return {
			list: e,
			labels: t
		};
	}
	let Sr = (0, _.useMemo)(() => hr ? xr() : {
		list: [],
		labels: []
	}, [
		hr,
		V,
		Tt,
		wt,
		j,
		B.height,
		p,
		y.join()
	]), Cr = Sr.list;
	(0, _.useEffect)(() => {
		Vt(-1);
	}, [Cr]);
	function wr() {
		let e = hr ? Sr : xr(), t = e.list;
		if (hr || gr(!0), !t.length) {
			z("No suggested layout fits. Check your measurements or choose individual trays.");
			return;
		}
		let n = (Bt + 1) % t.length;
		jn(t[n]), Vt(n), nn(""), Ut(""), qt(null), Gt(void 0), z(t.length === 1 ? "This is the only layout that fits." : `Suggested layout ${n + 1} of ${t.length}${e.labels[n] ? ` · ${e.labels[n]}` : ""}`);
	}
	(0, _.useEffect)(() => {
		let e = window.matchMedia?.("(max-width: 900px)");
		if (!e) return;
		let t = () => ut(e.matches);
		return t(), e.addEventListener?.("change", t), () => e.removeEventListener?.("change", t);
	}, []);
	let Tr = (e) => {
		let t = pt.current?.querySelector(`[data-step="${e}"]`);
		if (!t) return;
		let n = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", r = pt.current?.closest(".inspector");
		if (r && !lt && r.scrollHeight > r.clientHeight) {
			let e = pt.current?.querySelector(".flow-nav")?.offsetHeight ?? 0;
			r.scrollTo({
				top: t.getBoundingClientRect().top - r.getBoundingClientRect().top + r.scrollTop - e,
				behavior: n
			});
			return;
		}
		t.scrollIntoView({
			behavior: n,
			block: "start"
		});
	};
	(0, _.useEffect)(() => {
		if (lt) return;
		let e = 0, t = () => pt.current?.querySelector(".flow-nav"), n = () => {
			cancelAnimationFrame(e), e = requestAnimationFrame(() => {
				let e = [...pt.current?.querySelectorAll("[data-step]") ?? []];
				if (!e.length) return;
				let n = (t()?.getBoundingClientRect().bottom ?? 0) + 40, r = 1;
				for (let t of e) t.getBoundingClientRect().top <= n && (r = Number(t.dataset.step));
				let i = pt.current?.closest(".inspector");
				(i && i.scrollHeight > i.clientHeight ? i.scrollTop + i.clientHeight >= i.scrollHeight - 4 : window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) && (r = Number(e[e.length - 1].dataset.step)), ct((e) => e === r ? e : r);
			});
		}, r = pt.current?.closest(".inspector");
		return n(), window.addEventListener("scroll", n, { passive: !0 }), r?.addEventListener("scroll", n, { passive: !0 }), window.addEventListener("resize", n), () => {
			cancelAnimationFrame(e), window.removeEventListener("scroll", n), r?.removeEventListener("scroll", n), window.removeEventListener("resize", n);
		};
	}, [
		lt,
		L,
		on
	]);
	let Er = (e) => {
		let t = e.product.width - e.width, n = e.product.depth - e.depth, r = e.product.trimEdges !== "right", i = /Salsa Pro/i.test(e.product.name), a = [];
		return e.product.expand ? a.push(`set to ${Ji(e.width)} mm wide`) : t > .5 && a.push(r ? `cut to ${Ji(e.width)} mm wide: ${Ji(t / 2)} mm off each side` : `cut to ${Ji(e.width)} mm wide: ${Ji(t)} mm off the right`), n > .5 && a.push(i ? `cut to ${Ji(e.depth)} mm deep: ${Ji(n)} mm off the front` : e.product.depthTrim === "back" ? `cut to ${Ji(e.depth)} mm deep: ${Ji(n)} mm off the back` : `cut to ${Ji(e.depth)} mm deep: ${Ji(n / 2)} mm off front and back each`), a.length ? a.join(" · ") : `${Ji(e.width)} × ${Ji(e.depth)} mm`;
	}, Dr = (() => {
		let e = [];
		for (let t of H.placed) {
			let n = t.parentKey ? H.placed.find((e) => e.key === t.parentKey) : void 0, r = n ? ` · in the ${Z(n.product.name)}` : "";
			if (t.key.includes("-div")) {
				let n = e.find((e) => e.p.product.id === t.product.id && e.key.startsWith("div"));
				if (n) {
					n.qty++, n.price = Math.ceil(n.qty / We(t.product)) * t.product.price, n.detail = `${We(t.product) > 1 ? `${Math.ceil(n.qty / We(t.product))} pack of ${We(t.product)} · ` : ""}clip into the frame${r}`;
					continue;
				}
				e.push({
					key: "div" + t.key,
					p: t,
					qty: 1,
					price: t.product.price,
					detail: `${We(t.product) > 1 ? `1 pack of ${We(t.product)} · ` : ""}clip into the frame${r}`
				});
				continue;
			}
			e.push({
				key: t.key,
				p: t,
				qty: 1,
				price: t.product.price,
				detail: Er(t) + r + (t.product.tiered && !n ? " · tiered" : "")
			});
		}
		return e;
	})(), Or = /* @__PURE__ */ new Map();
	Dr.forEach((e, t) => {
		e.key.startsWith("div") ? H.placed.filter((t) => t.key.includes("-div") && t.product.id === e.p.product.id).forEach((e) => Or.set(e.key, t + 1)) : Or.set(e.key, t + 1);
	}), (0, _.useEffect)(() => {
		let e = H.placed.map((e) => e.product.rooms ?? []);
		e.length && e.every((e) => e.includes("wardrobe") && !e.includes("kitchen")) && F.includes("wardrobe") && d((e) => e === "wardrobe" ? e : "wardrobe");
	}, [H.placed.length]), (0, _.useEffect)(() => {
		if (!lt || !cn || /can't|won't|doesn|needs|unavailable|no longer/i.test(cn)) return;
		let e = setTimeout(() => z(""), 4e3);
		return () => clearTimeout(e);
	}, [cn, lt]);
	let kr = j.brand !== "hettich" || !j.nl ? 0 : j.line === "atira" ? j.nl - 7.7 : j.line === "arci" || j.line === "ayou" ? j.nl - 27 : 0, Ar = (e) => j.line === "arci" || j.line === "ayou" ? e - 27 : e - 7.7, jr = j.line === "arci" || j.line === "ayou" ? [
		450,
		500,
		550,
		600
	] : j.line === "atira" ? [
		420,
		470,
		520
	] : [
		420,
		450,
		470,
		500,
		520,
		550
	], Mr = j.brand === "hettich" && !!j.nl && !!Yt.depth && !(j.line === "" && j.nl >= 550) && Number(Yt.depth) > Ar(j.nl) + 2, [Nr, Pr] = (0, _.useState)(0), [Fr, Ir] = (0, _.useState)("");
	(0, _.useEffect)(() => {
		if (!Mr) return;
		let e = Number(Yt.depth), t = setTimeout(() => {
			let t = jr.find((t) => Ar(t) + 2 >= e || j.line === "" && t >= 550);
			t && t > j.nl && (bt((e) => ({
				...e,
				nl: t
			})), Pr(t));
		}, 700);
		return () => clearTimeout(t);
	}, [
		Mr,
		Yt.depth,
		j.nl,
		j.line
	]);
	let Lr = [
		300,
		400,
		450,
		500,
		600,
		700,
		800,
		900,
		1e3,
		1200
	], Rr = Number(Yt.width), zr = Rr > Lr[Lr.length - 1] - 32 ? Math.round(Rr / 10) : 0, Br = Number(Yt.depth) > 700 ? Math.round(Number(Yt.depth) / 10) : 0, [Vr, Hr] = (0, _.useState)(null), [Ur, Wr] = (0, _.useState)(0), Gr = !!e.cabinetWidth && !zr && Rr > e.cabinetWidth - 32 && (!e.onCabinetWidth || Ur === Rr);
	(0, _.useEffect)(() => {
		let t = e.cabinetWidth;
		if (!e.onCabinetWidth || !t || !Rr || zr || Ur === Rr || Rr <= t - 32) return;
		let n = setTimeout(() => {
			let n = Lr.find((e) => e - 32 >= Rr);
			n && n > t && (Hr({
				from: t,
				to: n
			}), e.onCabinetWidth(n));
		}, 700);
		return () => clearTimeout(n);
	}, [
		Rr,
		e.cabinetWidth,
		Ur
	]);
	function U() {
		if (L === 0) {
			if (Mr) {
				z("Check the drawer depth or the runner length first.");
				return;
			}
			if (!_n) {
				z(gn[0]);
				return;
			}
			sn(!0), ot(!1), n?.(B), ei(1), z(""), lt || setTimeout(() => Tr(2), 60);
		} else H.ok && (R.length || I) ? (lt ? ei(2) : Tr(4), z("")) : z(H.errors[0] ?? "Add an organiser to your drawer first.");
	}
	let Kr = (0, _.useRef)(async () => null);
	Kr.current = () => Yr(!0), (0, _.useEffect)(() => {
		let t = e.setKey, n = e.drawerIndex;
		if (t === void 0 || n === void 0) return;
		let r = Pi.get(t) ?? /* @__PURE__ */ new Map();
		return Pi.set(t, r), R.length || I ? r.set(n, () => Kr.current()) : r.delete(n), () => {
			r.delete(n);
		};
	}, [
		e.setKey,
		e.drawerIndex,
		R.length,
		!!I
	]);
	async function qr() {
		let t = Pi.get(e.setKey ?? "");
		if (t) {
			for (let e of [...t.keys()].sort((e, t) => t - e)) await t.get(e)();
			z("Every planned drawer in this set has been added. Review the final prices in your cart.");
		}
	}
	async function Jr(e, t, n, r) {
		let i = t.rollLength, a = await fetch(e + "cart.js").then((e) => e.ok ? e.json() : null).catch(() => null);
		if (!a) return null;
		let o = a.items?.find((e) => e.variant_id === t.variantId && e.properties?._liner_roll === "1"), s = (o?.properties?._pieces ?? "").split(",").filter(Boolean).map(Number).concat(n), c = [...(o?.properties?._drawers ?? "").split("|").filter(Boolean), r], { rolls: l, spare: u } = at(s, i), d = {
			_liner_roll: "1",
			_pieces: s.join(","),
			_drawers: c.join("|"),
			"Drawer liner": t.name,
			"Drawers lined": String(s.length),
			"Pieces to cut (mm)": s.join(" + "),
			Rolls: `${l} × ${i / 1e3} m`
		};
		return (o ? await fetch(e + "cart/change.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				id: o.key,
				quantity: l,
				properties: d
			})
		}) : await fetch(e + "cart/add.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ items: [{
				id: t.variantId,
				quantity: l,
				properties: d
			}] })
		})).ok ? {
			rolls: l,
			spare: u,
			count: s.length
		} : null;
	}
	async function Yr(t = !1) {
		if (!Et || !on || !Cn || !t && pn !== "idle") return null;
		fn(!0), z("");
		let n = crypto.randomUUID();
		try {
			let t = R.length ? Ge(Ie(V, R, A), n, rn, V) : [], r = !!I && !!I.variantId && it(I);
			if (I && I.variantId && !r) {
				let r = Qe(I, B, e.cabinetWidth);
				t.push({
					id: I.variantId,
					quantity: r.quantity,
					properties: {
						_drawer_id: n,
						_piece_id: "liner",
						_config_version: "3",
						"Drawer name": rn,
						"Drawer liner": I.name,
						...I.cutToSize ? {
							"Cut to cabinet width (mm)": String(r.cutLength),
							"Supplied depth (mm)": String(r.sheetDepth),
							"Final trim": "By you, to suit the drawer"
						} : {
							"Cut width (mm)": String(B.width),
							"Cut depth (mm)": String(B.depth)
						}
					}
				});
			}
			let i = e.cartRoot ?? "/";
			if (!i.startsWith("/") || i.startsWith("//") || i.includes("..")) throw Error("Invalid cart route.");
			let a = await fetch(i + "cart/add.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ items: t })
			}), o = await fetch(i + "cart.js").then((e) => {
				if (!e.ok) throw Error();
				return e.json();
			}), s = o.items?.filter((e) => e.properties?._drawer_id === n) ?? [], c = (e) => t.find((t) => t.properties._piece_id === e.properties?._piece_id)?.quantity;
			if (!a.ok || s.length !== t.length || s.some((e) => e.quantity !== c(e))) return mn("uncertain"), z("Your cart may contain part of this drawer. Open your cart to check it before adding again."), null;
			let l = "", u = o;
			if (r) {
				let e = await Jr(i, I, Math.ceil(B.width) + 20, rn);
				if (!e) return mn("uncertain"), z("Your drawer is in the cart, but the liner roll may not be. Open your cart to check it."), null;
				l = ` Liner: ${e.count === 1 ? "this drawer takes" : `your ${e.count} drawers take`} ${e.rolls === 1 ? "one" : e.rolls} ${I.rollLength / 1e3} m roll${e.rolls === 1 ? "" : "s"}, about ${Math.floor(e.spare / 10) * 10} mm left on the last.`, u = await fetch(i + "cart.js").then((e) => e.json()).catch(() => o);
			}
			return mn("success"), Hi("add_to_cart", Xr()), z("Your drawer has been added." + l + " Review the final prices in your cart."), window.dispatchEvent(new CustomEvent("drawer-studio:cart-updated", { detail: { cart: u } })), n;
		} catch (e) {
			return console.error("drawer-studio cart", e), mn("uncertain"), z("We could not confirm the cart update. Open your cart before trying again."), null;
		} finally {
			fn(!1);
		}
	}
	let Xr = () => ({
		system: j.brand || "unknown",
		line: j.line || void 0,
		width: B.width,
		depth: B.depth,
		height: B.height,
		trays: H.placed.length,
		brands: [...new Set(H.placed.map((e) => e.product.brand).filter(Boolean))],
		ids: H.placed.map((e) => String(e.product.variantId)),
		liner: I ? I.name : void 0,
		value: Math.round(xn * 100) / 100,
		currency: Sn
	});
	(0, _.useEffect)(() => {
		Hi("step", {
			step: st,
			...Xr()
		});
	}, [st]), (0, _.useEffect)(() => {
		if (L !== 1 || !R.length) return;
		try {
			if (localStorage.getItem("ds-tip-1")) return;
			localStorage.setItem("ds-tip-1", "1");
		} catch {
			return;
		}
		ye(te ? "Drag to move · drag the dotted edge to cut to size" : "Drag a tray to move it · drag its dotted edge to cut to size");
		let e = setTimeout(() => ye(""), 7e3);
		return () => clearTimeout(e);
	}, [L, R.length > 0]);
	let Zr = (0, _.useRef)(null), [Qr, $r] = (0, _.useState)(1);
	(0, _.useEffect)(() => {
		let e = Zr.current;
		if (!e) return;
		let t = new ResizeObserver(() => {
			let t = e.getBoundingClientRect();
			t.width && $r(e.viewBox.baseVal.width / t.width);
		});
		return t.observe(e), () => t.disconnect();
	}, [L]);
	function ei(e) {
		let t = Zr.current?.closest(".drawer-studio-set");
		e !== L && (t ? b(t, () => (0, v.flushSync)(() => Jt(e)), e > L ? 1 : -1) : Jt(e));
	}
	let [W, ti] = (0, _.useState)(null);
	function G(e) {
		return A.filter((t) => t.name === e.name && t.width === e.width && t.minWidth === e.minWidth && t.depth === e.depth && t.available).sort((e, t) => (e.finish ?? "").localeCompare(t.finish ?? "") || e.id.localeCompare(t.id));
	}
	let ni = (() => {
		if (!H.ok || H.spare >= 150) return null;
		for (let e of H.placed) {
			if (e.parentKey || e.product.brand !== "KitchenLibrary" || !/Stainless Steel Cutlery Organiser/i.test(e.product.name)) continue;
			let t = Pn(e);
			for (let n of A.filter((t) => t.name === e.product.name && t.finish === e.product.finish && t.width < e.product.width && t.available).sort((e, t) => t.width - e.width)) {
				let e = R.map((e) => e.id === t.laneId ? {
					...e,
					items: e.items.map((e, r) => r === t.index ? n.id : e)
				} : e), r = Ie(V, e, A);
				if (r.ok && r.spare >= 150) return {
					lanes: e,
					spare: r.spare,
					size: n.width
				};
			}
		}
		return null;
	})();
	function ri(e) {
		let t = G(e.product);
		if (t.length < 2) {
			z("This tray comes in one colour.");
			return;
		}
		let n = t[(t.findIndex((t) => t.id === e.product.id) + 1) % t.length], r = Pn(e), i = R.map((e) => e.id === r.laneId ? {
			...e,
			items: e.items.map((e, t) => t === r.index ? n.id : e)
		} : e);
		if (!Ie(V, i, A).ok) {
			z("That colour does not fit here.");
			return;
		}
		jn(i), z(`Changed to ${n.finishName || n.finish}.`);
	}
	function ii(e, t) {
		g("");
		let r = Math.round(Number(t));
		!Number.isFinite(r) || r <= 0 || String(r) === Yt[e] || (Xt((t) => ({
			...t,
			[e]: String(r)
		})), n?.({
			...B,
			[e]: r
		}), z(`Drawer ${e} changed to ${r} mm.`));
	}
	function ai(e, t, n) {
		let r = Pn(e);
		jn(R.map((e) => e.id === r.laneId ? {
			...e,
			dividers: {
				...e.dividers ?? {},
				[`${r.index}-${t}`]: Math.max(0, Math.min(12, n))
			}
		} : e)), z(n > 0 ? `${n} ${n === 1 ? "divider" : "dividers"} in that bay. They clip into the frame's rail.` : "");
	}
	function oi(e) {
		let t = Pn(e), n = R.map((e) => {
			if (e.id !== t.laneId) return e;
			let n = new Set(e.turned ?? []);
			n.has(t.index) ? n.delete(t.index) : n.add(t.index);
			let r = { ...e.inserts ?? {} };
			return delete r[t.index], {
				...e,
				turned: [...n],
				inserts: r
			};
		}), r = Ie(V, n, A);
		if (!r.ok) {
			z(r.errors[0]);
			return;
		}
		jn(n), z("Turned around. Tap again to turn it back.");
	}
	function si(e, t) {
		let n = t === "left" ? O.width / 2 : V.width - O.width / 2 - e.width, r = R.map((t) => t.id === e.laneId ? {
			...t,
			x: n,
			width: t.width ?? (we(e.product) ? e.width : void 0)
		} : t), i = Ie(V, r, A);
		if (!i.ok) {
			z(i.errors[0]);
			return;
		}
		jn(r), z(`Set pushed ${t} · its rail sits on the ${t === "left" ? "right" : "left"}`);
	}
	function ci(e, t) {
		if (L !== 1 || e.button !== 0) return;
		e.preventDefault(), e.stopPropagation();
		let n = Zr.current;
		if (!n) return;
		let r = n.getBoundingClientRect(), i = n.viewBox.baseVal.width / Math.max(1, r.width), a = H.placed.find((e) => e.laneId === t.laneId && !e.parentKey), o = R.map((e) => e.id === t.laneId && e.width === void 0 && we(t.product) ? {
			...e,
			width: t.width
		} : e);
		gt.current = {
			laneId: t.laneId,
			startX: e.clientX,
			startY: e.clientY,
			from: t.x,
			fromY: a.y,
			scale: i,
			base: o
		}, Ut(t.key);
		let s = (e) => {
			let t = gt.current;
			if (!t) return;
			let n = Math.max(O.width / 2, Math.round(t.from + (e.clientX - t.startX) * t.scale)), r = Math.max(O.depth / 2, Math.round(t.fromY - (e.clientY - t.startY) * t.scale)), i = (e, n) => {
				let r = t.base.map((r) => r.id === t.laneId ? {
					...r,
					x: e,
					y: n
				} : r);
				return Ie(V, r, A).ok ? r : null;
			}, a = (e) => {
				if (i(n, e)) return n;
				let r = t.from, a = n;
				if (!i(r, e)) return null;
				for (let t = 0; t < 14 && Math.abs(a - r) > 1; t++) {
					let t = Math.round((r + a) / 2);
					i(t, e) ? r = t : a = t;
				}
				return r;
			};
			for (let e of [r, t.fromY]) {
				let t = a(e);
				if (t !== null) {
					let n = i(t, e);
					if (n) {
						Qt(n);
						break;
					}
				}
			}
		}, c = () => {
			window.removeEventListener("pointermove", s), window.removeEventListener("pointerup", c);
			let e = gt.current;
			gt.current = null, e && en((t) => [...t, e.base].slice(-20));
		};
		window.addEventListener("pointermove", s), window.addEventListener("pointerup", c);
	}
	function K(e, t, n) {
		if (!(L !== 1 || e.button !== 0)) {
			if (!n) {
				let e = A.find((e) => e.id === t);
				if (e && pr(e)) return;
			}
			Gt(void 0), e.preventDefault(), e.currentTarget.setPointerCapture(e.pointerId), ti({
				id: t,
				x: e.clientX,
				y: e.clientY,
				startX: e.clientX,
				startY: e.clientY,
				source: n
			});
		}
	}
	let li = W?.id ?? Kt, ui = W?.source ?? Wt, di = A.find((e) => e.id === li), fi = (0, _.useMemo)(() => {
		if (!li) return [];
		let e = [];
		function t(t, n, r) {
			try {
				let i = Ke(V, R, A, li, "drop-new", t, n, ui), a = Ie(V, i.lanes, A), o = n;
				ui && t === ui.laneId && ui.index < n && o--;
				let s = a.placed.filter((e) => e.laneId === i.laneId && !e.parentKey), c = t ? s[Math.max(0, Math.min(o, s.length - 1))] : s[0];
				c && e.push({
					key: `${t ?? "new"}-${n}`,
					lanes: i.lanes,
					laneId: i.laneId,
					piece: c,
					label: r
				});
			} catch {}
		}
		if (di?.insertOnly) {
			for (let t of H.placed.filter((e) => e.product.pocket)) try {
				let n = Xe(V, R, A, li, t.key, ui);
				e.push({
					key: `nest-${t.key}`,
					...n,
					label: "Place inside"
				});
			} catch {}
			return e;
		}
		for (let e = 0; e <= R.length; e++) t(null, e, e === 0 && R.length ? "Left" : e === R.length && R.length ? "Right" : R.length ? "Between" : "Place here");
		for (let e of R) for (let n = 0; n <= e.items.length; n++) t(e.id, n, n === 0 ? "Front" : n === e.items.length ? "Back" : "Here");
		let n = /* @__PURE__ */ new Set();
		return e.filter((e) => {
			let t = `${Math.round(e.piece.x)}-${Math.round(e.piece.y)}`;
			return n.has(t) ? !1 : (n.add(t), !0);
		});
	}, [
		li,
		V,
		R,
		A,
		ui
	]);
	function pi(e, t) {
		let n = Zr.current?.getScreenCTM();
		if (!n) return null;
		let r = new DOMPoint(e, t).matrixTransform(n.inverse());
		return r.x < 0 || r.x > B.width || r.y < 0 || r.y > B.depth ? null : [...fi].sort((e, t) => Math.hypot(e.piece.x + e.piece.width / 2 - r.x, B.depth - e.piece.y - e.piece.depth / 2 - r.y) - Math.hypot(t.piece.x + t.piece.width / 2 - r.x, B.depth - t.piece.y - t.piece.depth / 2 - r.y))[0] ?? null;
	}
	let mi = W ? pi(W.x, W.y) : null;
	function hi(e) {
		let t = crypto.randomUUID();
		jn(e.lanes.map((e) => e.id === "drop-new" ? {
			...e,
			id: t
		} : e)), nn(e.laneId === "drop-new" ? t : e.laneId), Ut(e.piece.key.replace("drop-new", t)), Gt(void 0), qt(null), Ft(!1), z("Placed. Tap a tray to edit it.");
	}
	function gi(e) {
		if (!W) return;
		let t = pi(e.clientX, e.clientY);
		if (ti(null), Math.hypot(e.clientX - W.startX, e.clientY - W.startY) < 5) {
			if (W.source) {
				let e = H.placed.find((e) => e.key === `${W.source.laneId}-${W.source.index}${W.source.insert ? "-insert" + (W.source.slot || "") : ""}`);
				e && In(e);
			} else {
				let e = A.find((e) => e.id === W.id);
				e && Nn(e);
			}
			return;
		}
		if (W.source) {
			let t = Zr.current?.getScreenCTM();
			if (t) {
				let n = new DOMPoint(e.clientX, e.clientY).matrixTransform(t.inverse());
				if (n.x < 0 || n.x > B.width || n.y < 0 || n.y > B.depth) {
					jn(Ye(R, W.source)), Ut(""), nn(""), qt(null), Gt(void 0), z("Tray removed from your drawer and total. Undo brings it back.");
					return;
				}
			}
		}
		t ? hi(t) : !W.source && A.find((e) => e.id === W.id)?.insertOnly ? Nn(A.find((e) => e.id === W.id)) : z(fi.length ? "Move over the drawer until a placement preview appears." : "This tray cannot fit alongside the current pieces. Remove a piece or try a narrower or shorter tray.");
	}
	function _i(e) {
		if (!Mt) return;
		let t = Zr.current?.getScreenCTM(), n = H.placed.find((e) => e.laneId === Mt.laneId);
		if (!t || !n) return;
		let r = new DOMPoint(e, 0).matrixTransform(t.inverse());
		try {
			Qt(qe(V, Mt.start, A, Mt.laneId, r.x - n.x)), mn("idle");
		} catch {}
	}
	function vi() {
		Mt && (en((e) => [...e, Mt.start].slice(-20)), Nt(null));
	}
	function yi(e) {
		try {
			let t = qe(V, R, A, e, 2e3);
			jn(t);
			let n = Ie(V, t, A), r = n.placed.find((t) => t.laneId === e);
			r && n.spare > 0 && z(`Maximum fitting width: ${r.width}mm. ${Ji(n.spare)}mm remains; this tray cannot fill that gap.`);
		} catch (e) {
			z(e instanceof Error ? e.message : "Check the tray width.");
		}
	}
	let bi = yn.find((e) => e.product.trim && R.find((t) => t.id === e.laneId)?.items.length === 1) ?? H.placed.find((e) => e.product.trim && R.find((t) => t.id === e.laneId)?.items.length === 1);
	(0, _.useEffect)(() => {
		bi || Lt("trays");
	}, [bi]);
	let xi = H.ok && L > 0 ? H.placed : [], q = _n ? B.width : 600, J = _n ? B.depth : 480, Si = Math.max(18, Math.max(q, J) * .036, Math.min(12 * Qr, Math.max(q, J) * .045)), Y = Math.max(46, Math.max(q, J) * .06), [Ci, X] = (0, _.useState)(0), [wi, Ei] = (0, _.useState)([]), [Di, Oi] = (0, _.useState)(""), [Ai, ji] = (0, _.useState)(!1), Ni = [
		"width",
		"depth",
		"height",
		"style",
		"items"
	];
	function Li() {
		let e = (e) => Ie(V, e, A).ok, t = xr(), n = (e) => t.list.filter((n, r) => e.test(t.labels[r])), r = y.length ? yr().filter(e) : [], i = (Di === "set" && j.brand ? [
			...n(/\bset\b/),
			...r,
			...t.list
		] : [
			...y.includes("spices") ? n(/spice/) : [],
			...t.list,
			...r
		])[0];
		i ? (jn(i), gr(!0), nn(""), Ut(""), z("")) : z("No ready-made layout fits these measurements. Tap a tray below to add it, or check the measurements.");
	}
	(0, _.useEffect)(() => {
		!Ai || L !== 1 || (ji(!1), Li());
	}, [Ai, L]);
	function Ri() {
		let t = Ni[Ci];
		if (t === "width" || t === "depth" || t === "height") {
			if (!((on || wi.includes(t) ? Number(Yt[t]) : 0) > 0)) {
				z("Type the measurement in millimetres.");
				return;
			}
			if (t === "height" && !_n) {
				z(gn[0]);
				return;
			}
		}
		if (t === "style" && !Di) {
			z("Choose one.");
			return;
		}
		if (z(""), Ci < Ni.length - 1) {
			X(Ci + 1);
			return;
		}
		let n = la.filter((e) => y.includes(e.key)), r = n.length && n.every((e) => e.room === "wardrobe") ? "wardrobe" : "kitchen";
		F.length > 1 && F.includes(r) && (f || F[0]) !== r && (e.room && e.onRoom ? e.onRoom(r) : d(r)), Di === "one" && j.brand && bt({
			brand: "",
			line: "",
			nl: 0
		}), ji(!0), U();
	}
	let Bi = L === 1 ? H.placed.find((e) => e.key === Ht && !e.parentKey) : void 0, Yi = (0, _.useMemo)(() => {
		if (!te || L !== 1) return [];
		let e = [], t = /* @__PURE__ */ new Set(), n = Tt.filter((e) => !e.insertOnly && !pr(e));
		if (Bi) {
			let r = Pn(Bi);
			for (let i of [...n].sort((e, t) => Math.abs(e.width - Bi.width) - Math.abs(t.width - Bi.width)).slice(0, 60)) {
				if (i.id === Bi.product.id || t.has(Z(i.name) + i.width)) continue;
				let n = R.map((e) => e.id === r.laneId ? {
					...e,
					items: e.items.map((e, t) => t === r.index ? i.id : e),
					width: void 0
				} : e);
				if (Ie(V, n, A).ok && (t.add(Z(i.name) + i.width), e.push({
					c: i,
					next: n
				})), e.length >= 10) break;
			}
		} else for (let r of [...n].sort((e, t) => (t.sales ?? 0) - (e.sales ?? 0)).slice(0, 60)) if (!t.has(Z(r.name) + r.width)) {
			try {
				let n = Be(V, R, A, r.id, `lane-p${Date.now().toString(36)}${e.length}`).lanes;
				Ie(V, n, A).ok && (t.add(Z(r.name) + r.width), e.push({
					c: r,
					next: n
				}));
			} catch {}
			if (e.length >= 10) break;
		}
		return e;
	}, [
		te,
		L,
		Tt,
		R,
		Ht,
		V
	]), Xi = On()[0], Zi = H.placed.filter((e) => !e.parentKey), Qi = !!I && H.ok && H.spare <= Ii && Zi.length > 0 && Zi.every((e) => e.product.trim);
	return /* @__PURE__ */ (0, M.jsxs)("main", {
		className: `ds studio-v2${te ? " pf" : ""} step-${L} ${li ? "picking" : ""} ${L === 1 ? "arranging" : ""} ${Pt ? "sheet-open" : "sheet-closed"} mobile-panel-${It}`,
		onKeyDown: (e) => {
			e.key === "Escape" && (Mt && Qt(Mt.start), Nt(null), ti(null), qt(null), Gt(void 0));
		},
		onPointerMove: (e) => {
			if (Mt) {
				_i(e.clientX);
				return;
			}
			W && ti({
				...W,
				x: e.clientX,
				y: e.clientY
			});
		},
		onPointerUp: (e) => {
			Mt ? vi() : gi(e);
		},
		onPointerCancel: () => {
			Mt && Qt(Mt.start), Nt(null), ti(null);
		},
		children: [
			te && L === 0 && (() => {
				let e = Ni[Ci], t = e === "width" || e === "depth" || e === "height", n = {
					width: ["How wide is the inside of your drawer?", "Open the drawer and measure side to side, inside the walls."],
					depth: ["How deep is the inside?", "Measure from the inside of the front to the inside of the back."],
					height: ["How tall is the inside?", "Measure from the floor of the drawer to the top of its sides."],
					style: ["How do you like your drawers?", "This decides which trays we show you."],
					items: ["What’s going in this drawer?", "Pick one or more. We fill it for you, and you can change anything."]
				}[e], r = la.filter((e) => !F.length || F.includes(e.room));
				return /* @__PURE__ */ (0, M.jsxs)("div", {
					className: "pf-q",
					children: [
						/* @__PURE__ */ (0, M.jsx)("div", {
							className: "pf-prog",
							"aria-hidden": "true",
							children: Ni.map((e, t) => /* @__PURE__ */ (0, M.jsx)("i", { className: t <= Ci ? "on" : "" }, t))
						}),
						Ci > 0 ? /* @__PURE__ */ (0, M.jsxs)("button", {
							type: "button",
							className: "pf-back",
							onClick: () => {
								X(Ci - 1), z("");
							},
							children: [/* @__PURE__ */ (0, M.jsx)(oe, { size: 16 }), " Back"]
						}) : /* @__PURE__ */ (0, M.jsx)("span", { className: "pf-back" }),
						/* @__PURE__ */ (0, M.jsx)("h2", {
							className: "pf-title",
							children: n[0]
						}),
						/* @__PURE__ */ (0, M.jsx)("p", {
							className: "pf-sub",
							children: n[1]
						}),
						t && /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [/* @__PURE__ */ (0, M.jsx)(ba, { k: e }), /* @__PURE__ */ (0, M.jsxs)("label", {
							className: "pf-big",
							children: [/* @__PURE__ */ (0, M.jsx)("input", {
								type: "number",
								inputMode: "numeric",
								enterKeyHint: "next",
								"aria-label": `Inside ${e} in millimetres`,
								value: on || wi.includes(e) ? Yt[e] : "",
								onChange: (t) => {
									let n = t.target.value.replace(/[^\d]/g, "");
									Ei((t) => t.includes(e) ? t : [...t, e]), Xt((t) => ({
										...t,
										[e]: n
									}));
								},
								onKeyDown: (e) => {
									e.key === "Enter" && Ri();
								}
							}), /* @__PURE__ */ (0, M.jsx)("span", { children: "mm" })]
						})] }),
						e === "style" && /* @__PURE__ */ (0, M.jsxs)("div", {
							className: "pf-opts",
							children: [[[
								"one",
								"One tray, trimmed to fit",
								"A single moulded tray cut to your drawer. Clean and simple, and it suits any drawer."
							], [
								"set",
								"Every piece in its place",
								"Separate trays and inserts, each made for your drawer. More choice, more to love."
							]].map(([e, t, n]) => /* @__PURE__ */ (0, M.jsxs)("button", {
								type: "button",
								className: "pf-opt",
								"aria-pressed": Di === e,
								onClick: () => {
									Oi(e), z(""), e === "set" && !j.brand && Oe(!0);
								},
								children: [/* @__PURE__ */ (0, M.jsxs)("span", { children: [/* @__PURE__ */ (0, M.jsx)("b", { children: t }), /* @__PURE__ */ (0, M.jsx)("small", { children: n })] }), /* @__PURE__ */ (0, M.jsx)("i", {})]
							}, e)), Di === "set" && /* @__PURE__ */ (0, M.jsx)("p", {
								className: "pf-sys",
								children: j.brand ? /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
									"Your drawer: ",
									/* @__PURE__ */ (0, M.jsx)("b", { children: Ki(j) }),
									" ",
									/* @__PURE__ */ (0, M.jsx)("button", {
										type: "button",
										onClick: () => Oe(!0),
										children: "Change"
									})
								] }) : /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
									"Trays made for one drawer need to know which drawer you have. ",
									/* @__PURE__ */ (0, M.jsx)("button", {
										type: "button",
										onClick: () => Oe(!0),
										children: "Show me how to tell"
									}),
									" Not sure? We",
									"’",
									"ll use trays that fit any drawer."
								] })
							})]
						}),
						e === "items" && /* @__PURE__ */ (0, M.jsx)("div", {
							className: "pf-opts",
							children: r.map((e) => /* @__PURE__ */ (0, M.jsxs)("button", {
								type: "button",
								className: "pf-opt pf-item",
								"aria-pressed": y.includes(e.key),
								onClick: () => x((t) => t.includes(e.key) ? t.filter((t) => t !== e.key) : [...t, e.key]),
								children: [/* @__PURE__ */ (0, M.jsx)("span", { children: /* @__PURE__ */ (0, M.jsx)("b", { children: e.label }) }), /* @__PURE__ */ (0, M.jsx)("i", {})]
							}, e.key))
						}),
						/* @__PURE__ */ (0, M.jsx)("button", {
							type: "button",
							className: "pf-next",
							onClick: Ri,
							children: e === "items" ? "Fill my drawer" : "Next"
						})
					]
				});
			})(),
			te && L > 0 && /* @__PURE__ */ (0, M.jsxs)("div", {
				className: "pf-head",
				children: [/* @__PURE__ */ (0, M.jsx)("b", { children: L === 1 ? "Your drawer" : "Ready for your drawer" }), /* @__PURE__ */ (0, M.jsxs)("button", {
					type: "button",
					"aria-label": "Change the measurements",
					onClick: () => {
						ei(0), X(0);
					},
					children: [
						B.width,
						" × ",
						B.depth,
						" × ",
						B.height
					]
				})]
			}),
			/* @__PURE__ */ (0, M.jsxs)("div", {
				className: "workspace",
				children: [/* @__PURE__ */ (0, M.jsxs)("section", {
					className: "stage",
					children: [
						/* @__PURE__ */ (0, M.jsxs)("div", {
							className: "stage-top",
							children: [/* @__PURE__ */ (0, M.jsxs)("h1", {
								className: "drawer-name",
								children: [e.bankName && /* @__PURE__ */ (0, M.jsxs)("span", {
									className: "bank-prefix",
									children: [
										/* @__PURE__ */ (0, M.jsx)("b", { children: e.bankNo || 1 }),
										e.bankName,
										/* @__PURE__ */ (0, M.jsx)("i", {
											"aria-hidden": "true",
											children: "|"
										})
									]
								}), e.onRename ? /* @__PURE__ */ (0, M.jsxs)("label", { children: [
									/* @__PURE__ */ (0, M.jsx)("span", {
										className: "sr-only",
										children: "Drawer name"
									}),
									/* @__PURE__ */ (0, M.jsx)("input", {
										"aria-label": "Drawer name",
										value: e.drawerLabel ?? "",
										maxLength: 40,
										placeholder: "Name this drawer",
										onChange: (t) => e.onRename(t.target.value)
									}),
									/* @__PURE__ */ (0, M.jsx)(me, {
										size: 15,
										"aria-hidden": "true"
									})
								] }) : e.drawerLabel ?? "Your drawer"]
							}), /* @__PURE__ */ (0, M.jsx)("div", {
								className: "stage-meta",
								children: /* @__PURE__ */ (0, M.jsx)("nav", {
									className: "steps",
									"aria-label": "Planner steps",
									children: [
										"Measure",
										"Arrange",
										"Review"
									].map((e, t) => /* @__PURE__ */ (0, M.jsxs)("button", {
										disabled: t > L,
										onClick: () => {
											ei(t), z("");
										},
										"aria-current": t === L ? "step" : void 0,
										children: [/* @__PURE__ */ (0, M.jsx)("span", {
											className: t === L ? "current" : "",
											children: t < L ? /* @__PURE__ */ (0, M.jsx)(ce, { size: 14 }) : null
										}), e]
									}, e))
								})
							})]
						}),
						/* @__PURE__ */ (0, M.jsxs)("div", {
							className: "drawing-wrap",
							children: [
								ae && /* @__PURE__ */ (0, M.jsxs)("button", {
									type: "button",
									className: "coach-tip",
									onClick: () => ye(""),
									children: [ae, /* @__PURE__ */ (0, M.jsx)("span", {
										"aria-hidden": "true",
										children: "×"
									})]
								}),
								L === 1 && /* @__PURE__ */ (0, M.jsxs)("div", {
									className: "toolbar docked",
									"aria-label": "Layout actions",
									children: [
										/* @__PURE__ */ (0, M.jsxs)("button", {
											"aria-label": `Remix layout${Bt >= 0 ? ` ${Bt + 1} of ${Cr.length}` : ""}`,
											title: "Remix · try another of five layouts",
											onClick: wr,
											children: [/* @__PURE__ */ (0, M.jsx)(_e, { size: 17 }), /* @__PURE__ */ (0, M.jsx)("span", {
												className: "tool-tip",
												children: "Remix"
											})]
										}),
										/* @__PURE__ */ (0, M.jsxs)("button", {
											"aria-label": "Free placement",
											"aria-pressed": mt,
											title: "Free placement · drag trays anywhere",
											className: mt ? "is-on" : "",
											onClick: () => {
												let e = !mt;
												ht(e), z(e ? "Drag trays anywhere. Tap the icon again when done." : "");
											},
											children: [/* @__PURE__ */ (0, M.jsx)(pe, { size: 17 }), /* @__PURE__ */ (0, M.jsx)("span", {
												className: "tool-tip",
												children: "Free placement"
											})]
										}),
										/* @__PURE__ */ (0, M.jsxs)("button", {
											"aria-label": "Undo",
											title: "Undo last change",
											disabled: !$t.length,
											onClick: () => {
												Qt($t[$t.length - 1]), en($t.slice(0, -1)), z(""), Ut(""), qt(null), Gt(void 0);
											},
											children: [/* @__PURE__ */ (0, M.jsx)(ge, { size: 17 }), /* @__PURE__ */ (0, M.jsx)("span", {
												className: "tool-tip",
												children: "Undo"
											})]
										}),
										/* @__PURE__ */ (0, M.jsxs)("button", {
											"aria-label": "Clear drawer",
											title: "Clear drawer",
											disabled: !R.length,
											onClick: () => {
												jn([]), qt(null), Ut(""), Gt(void 0);
											},
											children: [/* @__PURE__ */ (0, M.jsx)(E, { size: 17 }), /* @__PURE__ */ (0, M.jsx)("span", {
												className: "tool-tip",
												children: "Clear"
											})]
										})
									]
								}),
								_r && L > 0 && H.placed.length > 0 && /* @__PURE__ */ (0, M.jsxs)("div", {
									className: "orbit-overlay",
									children: [/* @__PURE__ */ (0, M.jsx)(Zt, {
										drawer: V,
										placed: H.placed
									}), /* @__PURE__ */ (0, M.jsxs)("small", { children: ["3D preview · ", /* @__PURE__ */ (0, M.jsx)("button", {
										type: "button",
										className: "inline-link",
										onClick: () => vr(!1),
										children: "back to the plan"
									})] })]
								}),
								/* @__PURE__ */ (0, M.jsxs)("svg", {
									ref: Zr,
									className: `drawer-svg ${W ? "is-dragging" : ""} ${li ? "is-picking" : ""}`,
									viewBox: te ? `${-Math.max(26, q * .03)} -34 ${q + 2 * Math.max(26, q * .03)} ${J + 70}` : `${-Math.max(65, q * 6 / 88 + 10)} -50 ${q + 2 * Math.max(65, q * 6 / 88 + 10)} ${J + 110}`,
									role: "img",
									"aria-label": `Drawer plan, ${q} millimetres wide by ${J} deep. ${xi.length} organisers.`,
									children: [
										/* @__PURE__ */ (0, M.jsxs)("defs", { children: [/* @__PURE__ */ (0, M.jsx)("pattern", {
											id: `${r}-empty-hatch`,
											width: "9",
											height: "9",
											patternUnits: "userSpaceOnUse",
											patternTransform: "rotate(45)",
											children: /* @__PURE__ */ (0, M.jsx)("line", {
												x1: "0",
												y1: "0",
												x2: "0",
												y2: "9",
												stroke: "#c1c1c1",
												strokeWidth: "1"
											})
										}), /* @__PURE__ */ (0, M.jsx)("filter", {
											id: `${r}-tray-shadow`,
											x: "-20%",
											y: "-20%",
											width: "140%",
											height: "150%",
											children: /* @__PURE__ */ (0, M.jsx)("feDropShadow", {
												dx: "0",
												dy: "8",
												stdDeviation: "8",
												floodColor: "#5d5d5d",
												floodOpacity: ".13"
											})
										})] }),
										/* @__PURE__ */ (0, M.jsxs)("g", {
											stroke: "#8f8f8f",
											strokeWidth: "1",
											fill: "none",
											vectorEffect: "non-scaling-stroke",
											children: [/* @__PURE__ */ (0, M.jsx)("path", { d: `M0 ${-Y} H${q} M0 ${-Y - 6} V${-Y + 6} M${q} ${-Y - 6} V${-Y + 6} M${-Y} 0 V${J} M${-Y - 6} 0 H${-Y + 6} M${-Y - 6} ${J} H${-Y + 6}` }), /* @__PURE__ */ (0, M.jsx)("path", {
												d: `M0 0 V${-Y + 8} M${q} 0 V${-Y + 8} M0 0 H${-Y + 8} M0 ${J} H${-Y + 8}`,
												strokeDasharray: "2 3",
												opacity: ".6"
											})]
										}),
										h === "width" ? /* @__PURE__ */ (0, M.jsx)("foreignObject", {
											x: q / 2 - Si * 4,
											y: -Y - Si * 1.9,
											width: Si * 8,
											height: Si * 1.8,
											children: /* @__PURE__ */ (0, M.jsx)("input", {
												className: "dim-input",
												autoFocus: !0,
												type: "number",
												defaultValue: q,
												style: { fontSize: Si * .8 },
												onBlur: (e) => ii("width", e.currentTarget.value),
												onKeyDown: (e) => {
													e.key === "Enter" && ii("width", e.target.value), e.key === "Escape" && g("");
												}
											})
										}) : /* @__PURE__ */ (0, M.jsxs)("text", {
											x: q / 2,
											y: -Y - Si * .7,
											textAnchor: "middle",
											className: "front-svg dim-label dim-editable",
											style: { fontSize: Si * .7 },
											onPointerDown: (e) => e.stopPropagation(),
											onMouseDown: (e) => e.stopPropagation(),
											onClick: () => g("width"),
											children: [
												/* @__PURE__ */ (0, M.jsx)("title", { children: "Click to change the width" }),
												q,
												" MM INSIDE"
											]
										}),
										h === "depth" ? /* @__PURE__ */ (0, M.jsx)("foreignObject", {
											x: -Y - Si * 4.5,
											y: J / 2 - Si * .9,
											width: Si * 8,
											height: Si * 1.8,
											children: /* @__PURE__ */ (0, M.jsx)("input", {
												className: "dim-input",
												autoFocus: !0,
												type: "number",
												defaultValue: J,
												style: { fontSize: Si * .8 },
												onBlur: (e) => ii("depth", e.currentTarget.value),
												onKeyDown: (e) => {
													e.key === "Enter" && ii("depth", e.target.value), e.key === "Escape" && g("");
												}
											})
										}) : /* @__PURE__ */ (0, M.jsxs)("text", {
											transform: `translate(${-Y - Si * .7} ${J / 2}) rotate(-90)`,
											textAnchor: "middle",
											className: "front-svg dim-label dim-editable",
											style: { fontSize: Si * .7 },
											onPointerDown: (e) => e.stopPropagation(),
											onMouseDown: (e) => e.stopPropagation(),
											onClick: () => g("depth"),
											children: [
												/* @__PURE__ */ (0, M.jsx)("title", { children: "Click to change the depth" }),
												J,
												" MM INSIDE"
											]
										}),
										/* @__PURE__ */ (0, M.jsxs)("g", {
											className: "drawer-shell",
											stroke: "#92978d",
											strokeWidth: ".8",
											vectorEffect: "non-scaling-stroke",
											children: [
												/* @__PURE__ */ (0, M.jsx)("rect", {
													width: q,
													height: J,
													rx: "2",
													fill: "#ffffff"
												}),
												/* @__PURE__ */ (0, M.jsx)("rect", {
													x: -q / 44,
													y: -J * 2 / 61,
													width: q * 46 / 44,
													height: J * 2 / 61,
													rx: "2",
													fill: "#ffffff"
												}),
												/* @__PURE__ */ (0, M.jsx)("rect", {
													x: -q / 44,
													width: q / 44,
													height: J,
													rx: "2",
													fill: "#ffffff"
												}),
												/* @__PURE__ */ (0, M.jsx)("rect", {
													x: q,
													width: q / 44,
													height: J,
													rx: "2",
													fill: "#ffffff"
												}),
												/* @__PURE__ */ (0, M.jsx)("rect", {
													x: -q * 6 / 88,
													y: J,
													width: q * 100 / 88,
													height: J * 3 / 61,
													rx: "3",
													fill: "#ffffff"
												}),
												/* @__PURE__ */ (0, M.jsx)("path", {
													d: `M${-q * 6 / 88 + 3} ${J + J * 3 / 61 - 3}H${q + q * 6 / 88 - 3}`,
													fill: "none",
													stroke: "#b7bcb0",
													strokeWidth: ".55"
												})
											]
										}),
										I && /* @__PURE__ */ (0, M.jsx)(St, {
											liner: I,
											width: q,
											depth: J,
											id: r
										}, I.id),
										L === 0 ? /* @__PURE__ */ (0, M.jsx)(M.Fragment, { children: h === "height" ? /* @__PURE__ */ (0, M.jsx)("foreignObject", {
											x: q / 2 - Si * 4,
											y: J / 2 - Si * .9,
											width: Si * 8,
											height: Si * 1.8,
											children: /* @__PURE__ */ (0, M.jsx)("input", {
												className: "dim-input",
												autoFocus: !0,
												type: "number",
												defaultValue: B.height,
												style: { fontSize: Si * .8 },
												onBlur: (e) => ii("height", e.currentTarget.value),
												onKeyDown: (e) => {
													e.key === "Enter" && ii("height", e.target.value), e.key === "Escape" && g("");
												}
											})
										}) : /* @__PURE__ */ (0, M.jsxs)("text", {
											x: q / 2,
											y: J / 2 + 6,
											textAnchor: "middle",
											className: "front-svg dim-label dim-editable",
											style: { fontSize: Si * .7 },
											onPointerDown: (e) => e.stopPropagation(),
											onMouseDown: (e) => e.stopPropagation(),
											onClick: () => g("height"),
											children: [/* @__PURE__ */ (0, M.jsx)("title", { children: "Click to change the clear height" }), _n ? `${B.height} MM CLEAR HEIGHT` : "ENTER YOUR MEASUREMENTS"]
										}) }) : xi.length ? xi.map((e, t) => e.key.includes("-div") ? /* @__PURE__ */ (0, M.jsx)("g", {
											transform: `translate(${e.x} ${J - e.y - e.depth})`,
											className: "cross-divider",
											pointerEvents: "none",
											children: (() => {
												let t = (e.depth - 8) / 2, n = e.product.brand === "Blum" ? Math.max(0, Math.floor((e.width - 16) / 16)) : -1;
												return /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
													/* @__PURE__ */ (0, M.jsx)("rect", {
														y: t,
														width: e.width,
														height: 8,
														fill: "#fff",
														stroke: "#000000",
														strokeWidth: "1.2",
														vectorEffect: "non-scaling-stroke"
													}),
													/* @__PURE__ */ (0, M.jsx)("path", {
														d: Array.from({ length: n + 1 }, (e, n) => `M${8 + n * 16 - 1.6} ${t + 8 / 2 - 1.6}h3.2v3.2h-3.2Z`).join(""),
														fill: "none",
														stroke: "#000000",
														strokeWidth: "1",
														vectorEffect: "non-scaling-stroke"
													}),
													L === 1 && Or.has(e.key) && e.key.endsWith("-1") && /* @__PURE__ */ (0, M.jsxs)("g", {
														className: "piece-pin",
														transform: `translate(${e.width - 13.4 * Qr} ${e.depth / 2})`,
														children: [/* @__PURE__ */ (0, M.jsx)("circle", {
															r: 8 * Qr,
															fill: "#111"
														}), /* @__PURE__ */ (0, M.jsx)("text", {
															y: 3.2 * Qr,
															textAnchor: "middle",
															fontSize: 9 * Qr,
															fill: "#fff",
															children: Or.get(e.key)
														})]
													})
												] });
											})()
										}, e.key) : /* @__PURE__ */ (0, M.jsxs)("g", {
											transform: `translate(${e.x} ${J - e.y - e.depth})`,
											className: "tray-group",
											opacity: mi ? .15 : 1,
											onPointerDown: (t) => {
												if (mt && !e.parentKey) {
													ci(t, e);
													return;
												}
												K(t, e.product.id, Pn(e));
											},
											role: "button",
											tabIndex: L === 1 ? 0 : -1,
											"aria-label": `${Z(e.product.name)}, ${e.width} by ${e.depth} millimetres. ${Fn(e)}. Select to edit.`,
											onClick: (t) => {
												t.detail === 0 && In(e);
											},
											onKeyDown: (t) => {
												(t.key === "Enter" || t.key === " ") && (t.preventDefault(), In(e));
											},
											children: [
												e.product.turned ? /* @__PURE__ */ (0, M.jsx)("g", {
													transform: `rotate(180 ${e.width / 2} ${e.depth / 2})`,
													children: /* @__PURE__ */ (0, M.jsx)(sa, {
														product: e.product,
														width: e.width,
														depth: e.depth,
														selected: L === 1 && Ht === e.key
													})
												}) : /* @__PURE__ */ (0, M.jsx)(sa, {
													product: e.product,
													width: e.width,
													depth: e.depth,
													selected: L === 1 && Ht === e.key
												}),
												L === 1 && (() => {
													let t = 1.6 * Math.min(16 * Qr, Math.max(e.width / 9, 14 * Qr));
													return /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [!e.parentKey && Ht === e.key && /* @__PURE__ */ (0, M.jsxs)("g", {
														className: "piece-remove piece-turn",
														role: "button",
														tabIndex: 0,
														"aria-label": `Turn ${Z(e.product.name)} around`,
														transform: `translate(${e.width - t * 2.4} ${t * .9})`,
														onPointerDown: (e) => e.stopPropagation(),
														onClick: (t) => {
															t.stopPropagation(), oi(e);
														},
														onKeyDown: (t) => {
															(t.key === "Enter" || t.key === " ") && (t.preventDefault(), oi(e));
														},
														children: [
															/* @__PURE__ */ (0, M.jsx)("title", { children: "Turn around" }),
															/* @__PURE__ */ (0, M.jsx)("circle", {
																r: t * .8,
																fill: "#fff",
																stroke: "#9a9a94",
																strokeWidth: ".7",
																vectorEffect: "non-scaling-stroke"
															}),
															/* @__PURE__ */ (0, M.jsx)("path", {
																d: `M${-t * .26} ${-t * .05}A${t * .27} ${t * .27} 0 1 0 ${-t * .05} ${-t * .27}M${-t * .05} ${-t * .27}l${-t * .12} ${-t * .1}M${-t * .05} ${-t * .27}l${-t * .1} ${t * .12}`,
																fill: "none",
																stroke: "#000000",
																strokeWidth: "1.2",
																vectorEffect: "non-scaling-stroke"
															})
														]
													}), /* @__PURE__ */ (0, M.jsxs)("g", {
														className: "piece-remove",
														role: "button",
														tabIndex: 0,
														"aria-label": `Remove ${Z(e.product.name)}`,
														transform: `translate(${e.width < t * 2.4 ? e.width / 2 : e.width - t * .9} ${e.width < t * 2.4 ? e.depth - t * .9 : t * .9})`,
														onPointerDown: (e) => e.stopPropagation(),
														onClick: (t) => {
															t.stopPropagation();
															let n = !!e.product.pocket && H.placed.some((t) => t.parentKey === e.key);
															jn(Ye(R, Pn(e))), Ut(""), z(n ? "Removed with its insert. Undo brings both back." : "Removed. Undo brings it back.");
														},
														onKeyDown: (t) => {
															(t.key === "Enter" || t.key === " ") && (t.preventDefault(), jn(Ye(R, Pn(e))));
														},
														children: [/* @__PURE__ */ (0, M.jsx)("circle", {
															r: t * .8,
															fill: "#fff",
															stroke: "#9a9a94",
															strokeWidth: ".7",
															vectorEffect: "non-scaling-stroke"
														}), /* @__PURE__ */ (0, M.jsx)("path", {
															d: `M${-t * .22} ${-t * .22}L${t * .22} ${t * .22}M${t * .22} ${-t * .22}L${-t * .22} ${t * .22}`,
															stroke: "#000000",
															strokeWidth: "1.2",
															vectorEffect: "non-scaling-stroke"
														})]
													})] });
												})(),
												L === 1 && (Ht === e.key ? null : Or.has(e.key) && /* @__PURE__ */ (0, M.jsxs)("g", {
													className: "piece-pin",
													pointerEvents: "none",
													transform: `translate(${e.width - 13.4 * Qr} ${e.depth - 13.4 * Qr})`,
													children: [/* @__PURE__ */ (0, M.jsx)("circle", {
														r: 8 * Qr,
														fill: "#111"
													}), /* @__PURE__ */ (0, M.jsx)("text", {
														y: 3.2 * Qr,
														textAnchor: "middle",
														fontSize: 9 * Qr,
														fill: "#fff",
														children: Or.get(e.key)
													})]
												})),
												L === 1 && !e.parentKey && be(e.product).length > 0 && (() => {
													let t = 17.5 * Qr, n = e.product.trimEdges === "right" ? 0 : (e.product.width - e.width) / 2, r = Ue(e.product), i = r.map((t, n) => H.placed.some((t) => t.key === `${e.key}-insert${n || ""}`)), a = [], o = r.some((e, t) => i[t] && !e.sub && r.some((t) => t.sub && t.accepts.some((t) => e.accepts.includes(t))));
													return r.map((e, t) => t).sort((e, t) => o ? Number(!!r[t].sub) - Number(!!r[e].sub) : 0).forEach((e) => {
														let t = r[e];
														i[e] || r.some((n, r) => r !== e && i[r] && ve(t, n)) || a.some((e) => ve(t, r[e])) || a.push(e);
													}), r.map((i, o) => {
														let s = H.placed.filter((t) => t.parentKey === e.key && /-insert/.test(t.key) && r.some((n, r) => t.key === `${e.key}-insert${r || ""}` && (r === o || ve(n, i)))), c = s.length ? e.y + i.y + i.depth - Math.max(...s.map((e) => e.y + e.depth)) : 0, l = s.length > 0 && !i.sub && c >= 60;
														if (!a.includes(o) && !l || !l && H.placed.some((t) => t.parentKey === e.key && t.key === `${e.key}-insert${o || ""}`) || dt.includes(`${e.product.id}-${o}`)) return null;
														let u = Pn(e), d = R.find((e) => e.id === u.laneId)?.dividers?.[`${u.index}-${o}`] ?? 0, f = !i.sub && A.some((t) => t.insertOnly && /Divider/i.test(t.name) && !/Set/i.test(t.name) && t.brand === e.product.brand && t.available && t.width <= i.width), p = i.anchor === "right" ? e.width - i.x - i.width : i.x - n, m = e.depth - i.y - i.depth, h = p + i.width / 2, g = m + t * 2.4, _ = (e, n, r = 0, i = 4.8) => /* @__PURE__ */ (0, M.jsxs)("g", {
															className: "divider-btn",
															role: "button",
															tabIndex: 0,
															transform: `translate(${h + r} ${g})`,
															onPointerDown: (e) => e.stopPropagation(),
															onClick: (e) => {
																e.stopPropagation(), n();
															},
															onKeyDown: (e) => {
																(e.key === "Enter" || e.key === " ") && (e.preventDefault(), e.stopPropagation(), n());
															},
															children: [/* @__PURE__ */ (0, M.jsx)("rect", {
																x: -t * i / 2,
																y: -t * .62,
																width: t * i,
																height: t * 1.24,
																rx: t * .62,
																fill: "#fff",
																stroke: "#333333",
																strokeWidth: ".8",
																vectorEffect: "non-scaling-stroke"
															}), /* @__PURE__ */ (0, M.jsx)("text", {
																y: t * .27,
																textAnchor: "middle",
																fontSize: t * .72,
																fill: "#000000",
																children: e
															})]
														});
														if (d > 0) {
															let n = Math.min(i.width * .86, t * 6.4), r = (n, r, i) => /* @__PURE__ */ (0, M.jsxs)("g", {
																className: "divider-btn",
																role: "button",
																tabIndex: 0,
																"aria-label": n === "+" ? "Add a divider" : "Remove a divider",
																transform: `translate(${h + i} ${g})`,
																onPointerDown: (e) => e.stopPropagation(),
																onClick: (t) => {
																	t.stopPropagation(), ai(e, o, r);
																},
																onKeyDown: (t) => {
																	(t.key === "Enter" || t.key === " ") && (t.preventDefault(), t.stopPropagation(), ai(e, o, r));
																},
																children: [/* @__PURE__ */ (0, M.jsx)("circle", {
																	r: t * .55,
																	fill: "transparent"
																}), /* @__PURE__ */ (0, M.jsx)("text", {
																	y: t * .3,
																	textAnchor: "middle",
																	fontSize: t * .9,
																	fill: "#000000",
																	children: n
																})]
															});
															return /* @__PURE__ */ (0, M.jsxs)("g", {
																className: "divider-ctl",
																children: [
																	/* @__PURE__ */ (0, M.jsx)("rect", {
																		x: h - n / 2,
																		y: g - t * .62,
																		width: n,
																		height: t * 1.24,
																		rx: t * .62,
																		fill: "#fff",
																		stroke: "#333333",
																		strokeWidth: ".8",
																		vectorEffect: "non-scaling-stroke"
																	}),
																	r("−", d - 1, -n / 2 + t * .62),
																	/* @__PURE__ */ (0, M.jsxs)("text", {
																		x: h,
																		y: g + t * .27,
																		textAnchor: "middle",
																		fontSize: t * .72,
																		fill: "#000000",
																		pointerEvents: "none",
																		children: [d, n >= t * 5.6 ? ` ${d === 1 ? "divider" : "dividers"}` : ""]
																	}),
																	r("+", d + 1, n / 2 - t * .62)
																]
															}, `div-${o}`);
														}
														let v = f ? t * 5.2 <= i.width ? _("+ Divider", () => ai(e, o, 1)) : _("+", () => ai(e, o, 1), 0, 1.24) : null;
														if (l) return v ? /* @__PURE__ */ (0, M.jsx)("g", { children: v }, `ghost-${o}`) : null;
														let y = e.product.trim ? void 0 : A.find((t) => i.accepts.includes(t.id) && t.available && Je(e.product, t, V, o));
														if (!y) return v ? /* @__PURE__ */ (0, M.jsx)("g", { children: v }, `ghost-${o}`) : null;
														let b = Math.min(y.width, i.width), x = Math.min(y.depth, i.depth), ee = i.x + (i.width - b) / 2, S = e.depth - i.y - x, C = i.accepts.map((e) => A.find((t) => t.id === e && t.available)).filter(Boolean), w = [...new Set(C.map((e) => ca(e.name).replace(/\s+for\s+\w+$/i, "")))], te = C.length > 1 && /(film|foil)/i.test(y.name) ? "+ Film or foil cutter" : w.length === 2 && w.join(" or ").length <= 34 ? `+ ${w.join(" or ")}` : `+ ${ca(y.name)}`;
														return /* @__PURE__ */ (0, M.jsxs)("g", {
															className: "bay-ghost",
															role: "button",
															tabIndex: 0,
															"aria-label": `Add ${Z(y.name)} into this set, ${qi(y.price, y.currency)}`,
															onPointerDown: (e) => e.stopPropagation(),
															onClick: (t) => {
																t.stopPropagation();
																try {
																	jn(Xe(V, R, A, y.id, e.key).lanes), z(`Nice. ${ca(y.name)} added.`);
																} catch (e) {
																	z(e instanceof Error ? e.message : "That piece does not fit this bay.");
																}
															},
															children: [
																/* @__PURE__ */ (0, M.jsx)("rect", {
																	className: "ghost-bay",
																	x: ee,
																	y: S,
																	width: b,
																	height: x,
																	rx: "6",
																	fill: "#ffffff",
																	stroke: "#c4c4be",
																	strokeWidth: "1",
																	vectorEffect: "non-scaling-stroke"
																}),
																/* @__PURE__ */ (0, M.jsxs)("g", {
																	className: "ghost-decline",
																	role: "button",
																	tabIndex: 0,
																	"aria-label": "No thanks",
																	transform: `translate(${ee + b - t * .75} ${b < t * 4 ? S + x - t * .75 : S + t * .75})`,
																	onPointerDown: (e) => e.stopPropagation(),
																	onClick: (t) => {
																		t.stopPropagation(), ft((t) => [...t, `${e.product.id}-${o}`]), z("No problem. That space stays free.");
																	},
																	onKeyDown: (t) => {
																		(t.key === "Enter" || t.key === " ") && (t.preventDefault(), t.stopPropagation(), ft((t) => [...t, `${e.product.id}-${o}`]));
																	},
																	children: [
																		/* @__PURE__ */ (0, M.jsx)("title", { children: "No thanks" }),
																		/* @__PURE__ */ (0, M.jsx)("circle", {
																			r: t * .75,
																			fill: "transparent"
																		}),
																		/* @__PURE__ */ (0, M.jsx)("circle", {
																			r: t * .55,
																			fill: "#fff",
																			stroke: "#a3a3a0",
																			strokeWidth: ".7",
																			vectorEffect: "non-scaling-stroke"
																		}),
																		/* @__PURE__ */ (0, M.jsx)("path", {
																			d: `M${-t * .2} ${-t * .2}L${t * .2} ${t * .2}M${t * .2} ${-t * .2}L${-t * .2} ${t * .2}`,
																			stroke: "#333333",
																			strokeWidth: "1.2",
																			vectorEffect: "non-scaling-stroke"
																		})
																	]
																}),
																(() => {
																	13.4 / t;
																	let e = Math.min(b * .8, x * .45, 140), n = ee + b / 2, r = S + x / 2 - e * .25, i = te.replace(/^\+ /, "") + "?", a = (/(film|foil)/i.test(i) ? "Foil cutter" : i.replace(/\?$/, "").split(/\s+or\s+/)[0].split(/\s+/).slice(0, 2).join(" ")) + "?", o = t / 13.4, s = b * .88, c = (e) => Math.min(13 * o, s / (e.length * .52), s / 6.8), l = c(i) >= 10 * o ? i : a, u = c(l);
																	if (u < 10 * o) {
																		let e = Math.min(11 * o, b * .9 / (qi(y.price, y.currency).length * .56 + 1.2)), n = Math.max(S, m + t * 3.4), r = n + (S + x - n) / 2, i = y.topImage || y.sketchUrl;
																		return /* @__PURE__ */ (0, M.jsxs)("g", {
																			className: "ghost-offer narrow",
																			children: [
																				i && /* @__PURE__ */ (0, M.jsx)("image", {
																					href: i,
																					x: ee + 2 * o,
																					y: S + 2 * o,
																					width: b - 4 * o,
																					height: x - 4 * o,
																					opacity: ".35",
																					preserveAspectRatio: "xMidYMid meet"
																				}),
																				/* @__PURE__ */ (0, M.jsx)("circle", {
																					cx: ee + b / 2,
																					cy: r,
																					r: Math.min(t * .62, b * .32),
																					fill: "#111"
																				}),
																				/* @__PURE__ */ (0, M.jsx)("path", {
																					d: `M${ee + b / 2 - Math.min(t * .25, b * .13)} ${r}H${ee + b / 2 + Math.min(t * .25, b * .13)}M${ee + b / 2} ${r - Math.min(t * .25, b * .13)}V${r + Math.min(t * .25, b * .13)}`,
																					stroke: "#fff",
																					strokeWidth: "1.6",
																					vectorEffect: "non-scaling-stroke"
																				}),
																				/* @__PURE__ */ (0, M.jsx)("text", {
																					x: ee + b / 2,
																					y: r + Math.min(t * .62, b * .32) + e * 1.5,
																					textAnchor: "middle",
																					fontSize: e,
																					fill: "#000000",
																					fontFamily: "Abel,Helvetica,Arial,sans-serif",
																					children: qi(y.price, y.currency)
																				}),
																				v,
																				/* @__PURE__ */ (0, M.jsx)("title", { children: `Add ${Z(y.name)} · ${qi(y.price, y.currency)}` })
																			]
																		});
																	}
																	return /* @__PURE__ */ (0, M.jsxs)("g", {
																		className: "ghost-offer",
																		children: [
																			y.sketchUrl ? /* @__PURE__ */ (0, M.jsx)("image", {
																				href: y.sketchUrl,
																				x: n - e / 2,
																				y: r - e / 2,
																				width: e,
																				height: e,
																				preserveAspectRatio: "xMidYMid meet"
																			}) : /* @__PURE__ */ (0, M.jsx)("circle", {
																				cx: n,
																				cy: r,
																				r: e / 3,
																				fill: "#ececea"
																			}),
																			/* @__PURE__ */ (0, M.jsx)("text", {
																				x: n,
																				y: r + e / 2 + u * 1.4,
																				textAnchor: "middle",
																				fontSize: u,
																				fill: "#000000",
																				fontFamily: "Abel,Helvetica,Arial,sans-serif",
																				children: l
																			}),
																			/* @__PURE__ */ (0, M.jsxs)("g", {
																				transform: `translate(${n} ${r + e / 2 + u * 3.1})`,
																				children: [/* @__PURE__ */ (0, M.jsx)("rect", {
																					x: -u * 3.4,
																					y: -u * .95,
																					width: u * 6.8,
																					height: u * 1.9,
																					rx: u * .95,
																					fill: "#111"
																				}), /* @__PURE__ */ (0, M.jsxs)("text", {
																					y: u * .35,
																					textAnchor: "middle",
																					fontSize: u * .9,
																					fill: "#fff",
																					children: ["+ ", qi(y.price, y.currency)]
																				})]
																			}),
																			v,
																			/* @__PURE__ */ (0, M.jsx)("title", { children: `Add ${Z(y.name)} · ${qi(y.price, y.currency)}` })
																		]
																	});
																})()
															]
														}, `ghost-${o}`);
													});
												})(),
												e.product.railVariant && !e.parentKey && (() => {
													let t = He(e, V), n = 13.4 * Qr;
													return /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [t.sides.map((n) => /* @__PURE__ */ (0, M.jsx)(da, {
														x: n.side === "left" ? -n.w : e.width,
														d: e.depth,
														w: n.w,
														ok: t.room
													}, n.side)), L === 1 && Ht === e.key && /* @__PURE__ */ (0, M.jsx)("g", {
														className: "rail-arrows",
														transform: `translate(${e.width / 2} ${n * 1.1})`,
														children: ["left", "right"].map((t, r) => /* @__PURE__ */ (0, M.jsxs)("g", {
															role: "button",
															"aria-label": `Push the set to the ${t} side`,
															transform: `translate(${(r ? 1 : -1) * n * .85} 0)`,
															onPointerDown: (e) => e.stopPropagation(),
															onClick: (n) => {
																n.stopPropagation(), si(e, t);
															},
															children: [/* @__PURE__ */ (0, M.jsx)("circle", {
																r: n * .6,
																fill: "#111"
															}), /* @__PURE__ */ (0, M.jsx)("path", {
																d: t === "left" ? `M${n * .2} ${-n * .28} L${-n * .2} 0 L${n * .2} ${n * .28}` : `M${-n * .2} ${-n * .28} L${n * .2} 0 L${-n * .2} ${n * .28}`,
																fill: "none",
																stroke: "#fff",
																strokeWidth: "1.4",
																vectorEffect: "non-scaling-stroke"
															})]
														}, t))
													})] });
												})(),
												L === 1 && !e.parentKey && (() => {
													let t = 1.6 * Math.min(16 * Qr, Math.max(e.width / 9, 14 * Qr)), n = G(e.product);
													return /* @__PURE__ */ (0, M.jsxs)("g", {
														className: "piece-actions",
														transform: `translate(${t * 1.1} ${t * 1.1})`,
														children: [/* @__PURE__ */ (0, M.jsxs)("g", {
															role: "button",
															"aria-label": `About ${Z(e.product.name)}`,
															onPointerDown: (e) => e.stopPropagation(),
															onClick: (t) => {
																t.stopPropagation(), _t(e.product);
															},
															children: [/* @__PURE__ */ (0, M.jsx)("circle", {
																r: t * .8,
																fill: "#fff",
																stroke: "#9a9a94",
																strokeWidth: ".7",
																vectorEffect: "non-scaling-stroke"
															}), /* @__PURE__ */ (0, M.jsx)("text", {
																y: t * .22,
																textAnchor: "middle",
																fontSize: t * .75,
																fontStyle: "italic",
																fontFamily: "Georgia,serif",
																fill: "#333333",
																children: "i"
															})]
														}), n.length > 1 && /* @__PURE__ */ (0, M.jsx)("g", {
															transform: `translate(${t * 1.9} 0)`,
															role: "button",
															"aria-label": n.length > 1 ? "Change colour" : "Colour",
															onPointerDown: (e) => e.stopPropagation(),
															onClick: (t) => {
																t.stopPropagation(), ri(e);
															},
															children: /* @__PURE__ */ (0, M.jsx)("circle", {
																r: t * .55,
																fill: ra(e.product).rim,
																stroke: n.length > 1 ? "#000000" : "#9a9a94",
																strokeWidth: n.length > 1 ? 1.2 : .7,
																vectorEffect: "non-scaling-stroke"
															})
														})]
													});
												})(),
												e.width > 110 && Ht === e.key && /* @__PURE__ */ (0, M.jsxs)("text", {
													x: e.width / 2,
													y: e.depth - 15,
													textAnchor: "middle",
													className: "piece-dimension",
													children: [
														e.width,
														" mm",
														e.product.expand ? " · set" : e.product.trim ? " · trim" : ""
													]
												})
											]
										}, e.key)) : /* @__PURE__ */ (0, M.jsx)("text", {
											x: q / 2,
											y: J / 2,
											textAnchor: "middle",
											className: "empty-label",
											children: H.ok ? y.length ? te ? "Tap + on a tray below to add it" : "Tap or drag a tray in →" : te ? "Choose what goes in this drawer below ↓" : "Choose what goes in this drawer →" : H.errors.length ? "This layout doesn’t fit. See the message." : "Check your layout"
										}),
										L === 1 && !li && xi.filter((e) => e.product.trim && R.find((t) => t.id === e.laneId)?.items.length === 1).map((e) => /* @__PURE__ */ (0, M.jsxs)("g", {
											className: "resize-edge",
											role: "slider",
											tabIndex: 0,
											"aria-label": `Finished width of ${Z(e.product.name)}`,
											"aria-valuemin": e.product.minWidth,
											"aria-valuemax": e.product.width,
											"aria-valuenow": e.width,
											"aria-valuetext": `${e.width} millimetres, cut at home`,
											onPointerDown: (t) => {
												t.preventDefault(), t.stopPropagation(), t.currentTarget.setPointerCapture(t.pointerId), nn(e.laneId), Ut(e.key), Nt({
													laneId: e.laneId,
													start: R
												});
											},
											onKeyDown: (t) => {
												if ([
													"ArrowLeft",
													"ArrowRight",
													"Home",
													"End"
												].includes(t.key)) {
													t.preventDefault();
													try {
														jn(qe(V, R, A, e.laneId, t.key === "Home" ? e.product.minWidth : t.key === "End" ? e.product.width : e.width + (t.key === "ArrowRight" ? 1 : -1) * e.product.step));
													} catch {}
												}
											},
											children: [
												/* @__PURE__ */ (0, M.jsx)("rect", {
													x: e.x + e.width - 12,
													y: J - e.y - e.depth * .7,
													width: "24",
													height: e.depth * .4,
													fill: "transparent"
												}),
												/* @__PURE__ */ (0, M.jsx)("line", {
													x1: e.x + e.width,
													x2: e.x + e.width,
													y1: J - e.y - e.depth + 8,
													y2: J - e.y - 8,
													stroke: "#111",
													strokeWidth: "1",
													strokeDasharray: "3 3",
													vectorEffect: "non-scaling-stroke"
												}),
												/* @__PURE__ */ (0, M.jsx)("rect", {
													x: e.x + e.width - 8,
													y: J - e.y - e.depth / 2 - 24,
													width: "16",
													height: "48",
													rx: "8",
													fill: "#111"
												}),
												/* @__PURE__ */ (0, M.jsx)("path", {
													d: `M${e.x + e.width - 2} ${J - e.y - e.depth / 2 - 9} v18 M${e.x + e.width + 2} ${J - e.y - e.depth / 2 - 9} v18`,
													stroke: "white"
												}),
												/* @__PURE__ */ (0, M.jsxs)("g", {
													pointerEvents: "none",
													children: [/* @__PURE__ */ (0, M.jsx)("rect", {
														x: e.x + (e.width - Math.min(Si * 8.5, Math.max(50, e.width - 8))) / 2,
														y: J - e.y - Si * 1.8,
														width: Math.min(Si * 8.5, Math.max(50, e.width - 8)),
														height: Si * 1.5,
														rx: "5",
														fill: "#ffffffed"
													}), /* @__PURE__ */ (0, M.jsxs)("text", {
														x: e.x + e.width / 2,
														y: J - e.y - Si * .62,
														textAnchor: "middle",
														fill: "#333",
														fontSize: Si * .72,
														children: [
															e.product.expand ? "Set to" : "Cut to",
															" ",
															e.width,
															" mm"
														]
													})]
												})
											]
										}, `resize-${e.key}`)),
										L === 1 && (() => {
											let e = xi.find((e) => e.key === Ht);
											if (!e) return null;
											let t = !li && e.product.trim && R.find((t) => t.id === e.laneId)?.items.length === 1;
											return /* @__PURE__ */ (0, M.jsx)("g", {
												transform: `translate(${e.x} ${J - e.y - e.depth})`,
												pointerEvents: "none",
												children: /* @__PURE__ */ (0, M.jsx)(fa, {
													p: e.product,
													w: e.width,
													d: e.depth,
													u: Qr,
													lift: t ? Si * 1.6 : 0
												})
											});
										})(),
										L === 1 && li && !W && fi.map((e) => /* @__PURE__ */ (0, M.jsxs)("g", {
											className: "drop-spot",
											role: "button",
											tabIndex: 0,
											"aria-label": `${e.label}: ${Z(di?.name ?? "")}`,
											onClick: () => hi(e),
											onKeyDown: (t) => {
												(t.key === "Enter" || t.key === " ") && (t.preventDefault(), hi(e));
											},
											children: [/* @__PURE__ */ (0, M.jsx)("rect", {
												x: e.piece.x + 3,
												y: J - e.piece.y - e.piece.depth + 3,
												width: Math.max(1, e.piece.width - 6),
												height: Math.max(1, e.piece.depth - 6),
												rx: "8"
											}), /* @__PURE__ */ (0, M.jsx)("text", {
												x: e.piece.x + e.piece.width / 2,
												y: J - e.piece.y - e.piece.depth / 2,
												textAnchor: "middle",
												children: e.label
											})]
										}, e.key)),
										mi && /* @__PURE__ */ (0, M.jsxs)("g", {
											pointerEvents: "none",
											children: [Ie(V, mi.lanes, A).placed.map((e) => /* @__PURE__ */ (0, M.jsx)("g", {
												transform: `translate(${e.x} ${J - e.y - e.depth})`,
												opacity: e.key === mi.piece.key?.toString() ? .9 : .35,
												children: /* @__PURE__ */ (0, M.jsx)(sa, {
													product: e.product,
													width: e.width,
													depth: e.depth,
													selected: e.key === mi.piece.key
												})
											}, e.key)), /* @__PURE__ */ (0, M.jsx)("rect", {
												x: mi.piece.x,
												y: J - mi.piece.y - mi.piece.depth,
												width: mi.piece.width,
												height: mi.piece.depth,
												rx: "6",
												fill: "#ffffff30",
												stroke: "#111",
												strokeWidth: "1",
												strokeDasharray: "3 3",
												vectorEffect: "non-scaling-stroke"
											})]
										}),
										/* @__PURE__ */ (0, M.jsx)("text", {
											x: q / 2,
											y: J + 38 + Si * .4,
											textAnchor: "middle",
											className: "front-svg dim-label",
											style: { fontSize: Si * .7 },
											children: "FRONT"
										})
									]
								})
							]
						}),
						/* @__PURE__ */ (0, M.jsxs)("div", {
							className: "canvas-footer",
							children: [/* @__PURE__ */ (0, M.jsx)("span", {
								className: "measurement-caption",
								children: L > 0 && /* @__PURE__ */ (0, M.jsx)("button", {
									className: "measurement-edit",
									"aria-label": "Edit drawer measurements",
									title: "Edit measurements",
									onClick: () => {
										ei(0), sn(!1);
									},
									children: /* @__PURE__ */ (0, M.jsx)(me, { size: 14 })
								})
							}), /* @__PURE__ */ (0, M.jsx)("span", { children: L > 0 && H.ok ? H.spare > 0 ? `${Math.round(H.spare)} mm still free` : "Drawer is full" : "" })]
						}),
						L === 1 && li && /* @__PURE__ */ (0, M.jsx)("div", {
							className: "placement-hint",
							children: li ? /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [/* @__PURE__ */ (0, M.jsxs)("span", { children: [
								Z(di?.name ?? ""),
								" · ",
								fi.length ? "Drop on a preview, or choose a spot" : "Remove a piece or choose a smaller tray"
							] }), /* @__PURE__ */ (0, M.jsx)(Ti, {
								variant: "ghost",
								onClick: () => {
									qt(null), Gt(void 0), ti(null);
								},
								children: "Cancel"
							})] }) : null
						}),
						L === 1 && vn && !li && /* @__PURE__ */ (0, M.jsx)("div", {
							className: "piece-tools",
							children: yn.filter((e) => e.key === Ht).map((e) => /* @__PURE__ */ (0, M.jsxs)("div", { children: [
								/* @__PURE__ */ (0, M.jsxs)("span", { children: [/* @__PURE__ */ (0, M.jsx)("b", { children: Z(e.product.name) }), we(e.product) && /* @__PURE__ */ (0, M.jsxs)("small", { children: [
									" · ",
									e.product.expand ? "set to" : "cut to",
									" ",
									e.width,
									" mm"
								] })] }),
								e.parentKey && /* @__PURE__ */ (0, M.jsx)("button", {
									onClick: () => {
										let t = H.placed.find((t) => t.key === e.parentKey);
										t && In(t);
									},
									children: "Select frame"
								}),
								/* @__PURE__ */ (0, M.jsx)("button", {
									onClick: () => {
										Gt(Pn(e)), qt(e.product.id), Ft(!1), z("Choose where to move this piece.");
									},
									children: "Move"
								}),
								we(e.product) && vn.items.length === 1 && /* @__PURE__ */ (0, M.jsx)("button", {
									onClick: () => {
										Lt("width"), Ft(!0), z("");
									},
									children: "Resize"
								}),
								we(e.product) && vn.items.length === 1 && H.spare >= e.product.step && e.width < e.product.width && /* @__PURE__ */ (0, M.jsx)("button", {
									onClick: () => yi(e.laneId),
									children: "Fill width"
								}),
								e.product.pocket && (() => {
									let t = be(e.product).length, n = t - H.placed.filter((t) => t.parentKey === e.key).length;
									if (n <= 0) return null;
									let r = /* @__PURE__ */ new Map();
									for (let t of A.filter((t) => Je(e.product, t, B))) {
										let n = Z(t.name).replace(/^(Kesseböhmer |Häfele |Blum )?(FineLine )?(LiniQ )?(OrganiQ )?/i, ""), i = r.get(n);
										(!i || t.finish === e.product.finish && i.finish !== e.product.finish) && r.set(n, t);
									}
									return /* @__PURE__ */ (0, M.jsxs)("div", {
										className: "insert-picker",
										children: [/* @__PURE__ */ (0, M.jsxs)("small", { children: [
											n,
											" of ",
											t,
											" ",
											t === 1 ? "slot" : "slots",
											" free · tap to add"
										] }), /* @__PURE__ */ (0, M.jsx)("div", {
											className: "insert-tiles",
											children: [...r].map(([t, n]) => /* @__PURE__ */ (0, M.jsxs)("button", {
												className: "insert-tile",
												onClick: () => {
													try {
														jn(Xe(V, R, A, n.id, e.key).lanes), Ut(e.key), z(`${t} added.`);
													} catch (e) {
														z(String(e));
													}
												},
												children: [/* @__PURE__ */ (0, M.jsx)(ma, { p: n }), /* @__PURE__ */ (0, M.jsx)("span", { children: t })]
											}, n.id))
										})]
									});
								})(),
								/* @__PURE__ */ (0, M.jsxs)("button", {
									"aria-label": `Remove ${Fn(e)} ${Z(e.product.name)}`,
									onClick: () => {
										jn(Ye(R, Pn(e))), Ut(""), z(e.product.pocket && H.placed.some((t) => t.parentKey === e.key) ? "Tray removed with its insert. Undo restores both." : "Tray removed from your drawer and total. Undo brings it back.");
									},
									children: [
										/* @__PURE__ */ (0, M.jsx)(he, { size: 15 }),
										" ",
										e.product.pocket && H.placed.some((t) => t.parentKey === e.key) ? "Remove frame + insert" : "Remove"
									]
								})
							] }, e.key))
						})
					]
				}), /* @__PURE__ */ (0, M.jsxs)("aside", {
					className: "inspector",
					children: [
						L === 1 && /* @__PURE__ */ (0, M.jsxs)("div", {
							className: "mobile-sheet-top",
							children: [/* @__PURE__ */ (0, M.jsxs)("button", {
								className: "sheet-grip",
								"aria-expanded": Pt,
								"aria-label": Pt ? "Collapse tray selector" : "Open tray selector",
								onPointerDown: (e) => {
									Rt.current = e.clientY, e.currentTarget.setPointerCapture(e.pointerId);
								},
								onPointerUp: (e) => {
									let t = e.clientY - (Rt.current ?? e.clientY);
									Math.abs(t) > 20 && (Ft(t < 0), Rt.current = null);
								},
								onClick: () => {
									Rt.current !== null && (Ft((e) => !e), Rt.current = null);
								},
								onKeyDown: (e) => {
									(e.key === "Enter" || e.key === " ") && (e.preventDefault(), Ft((e) => !e));
								},
								children: [
									/* @__PURE__ */ (0, M.jsx)("i", {}),
									/* @__PURE__ */ (0, M.jsx)("span", { children: li ? fi.length ? "Tap an outlined spot above" : "Choose a different tray" : Pt ? It === "width" ? "Size your tray." : "Trays" : "Add another tray" }),
									/* @__PURE__ */ (0, M.jsx)("b", { children: Pt ? "−" : "+" })
								]
							}), bi && /* @__PURE__ */ (0, M.jsxs)("div", {
								className: "mobile-sheet-tabs",
								children: [/* @__PURE__ */ (0, M.jsx)("button", {
									"aria-pressed": It === "trays",
									onClick: () => {
										Lt("trays"), Ft(!0);
									},
									children: "Trays"
								}), bi && /* @__PURE__ */ (0, M.jsxs)("button", {
									"aria-pressed": It === "width",
									onClick: () => {
										Lt("width"), Ft(!0);
									},
									children: [
										"Adjust width · ",
										bi.width,
										"mm"
									]
								})]
							})]
						}),
						L === 1 && bi && /* @__PURE__ */ (0, M.jsxs)("div", {
							className: "mobile-width-panel",
							children: [
								/* @__PURE__ */ (0, M.jsxs)("div", {
									className: "width-title",
									children: [/* @__PURE__ */ (0, M.jsx)("span", { children: "FINISHED WIDTH" }), /* @__PURE__ */ (0, M.jsxs)("strong", { children: [bi.width, /* @__PURE__ */ (0, M.jsx)("small", { children: " mm" })] })]
								}),
								/* @__PURE__ */ (0, M.jsx)("p", { children: Z(bi.product.name) }),
								/* @__PURE__ */ (0, M.jsx)("input", {
									type: "range",
									"aria-label": "Tray finished width in millimetres",
									min: bi.product.minWidth,
									max: bi.product.width,
									step: bi.product.step,
									value: bi.width,
									onPointerDown: () => {
										zt.current = R;
									},
									onChange: (e) => {
										try {
											let t = qe(V, R, A, bi.laneId, Number(e.target.value));
											zt.current ? Qt(t) : jn(t), mn("idle");
										} catch {}
									},
									onPointerUp: () => {
										if (zt.current) {
											let e = zt.current;
											en((t) => [...t, e].slice(-20)), zt.current = null;
										}
									},
									onPointerCancel: () => {
										zt.current && Qt(zt.current), zt.current = null;
									}
								}),
								/* @__PURE__ */ (0, M.jsxs)("div", {
									className: "width-limits",
									children: [/* @__PURE__ */ (0, M.jsxs)("span", { children: [bi.product.minWidth, "mm minimum"] }), /* @__PURE__ */ (0, M.jsxs)("span", { children: [bi.product.width, "mm uncut"] })]
								}),
								H.spare >= bi.product.step && bi.width < bi.product.width && /* @__PURE__ */ (0, M.jsx)(Ti, {
									className: "primary",
									onClick: () => yi(bi.laneId),
									children: "Fill remaining width"
								}),
								/* @__PURE__ */ (0, M.jsxs)("small", {
									className: "width-note",
									children: [mr(bi), " Cut at home."]
								})
							]
						}),
						/* @__PURE__ */ (0, M.jsxs)("div", {
							className: "flow",
							ref: pt,
							children: [
								/* @__PURE__ */ (0, M.jsx)("nav", {
									className: "flow-nav",
									"aria-label": "Steps",
									children: [
										[
											"Measure",
											!0,
											1
										],
										[
											"Arrange",
											L > 0,
											2
										],
										[
											"Review",
											L > 0 && H.ok && (R.length > 0 || !!I),
											4
										]
									].map(([e, t, n], r) => /* @__PURE__ */ (0, M.jsx)("button", {
										type: "button",
										"aria-current": st === n || n === 2 && st === 3 ? "step" : void 0,
										className: t ? "" : "later",
										onClick: () => {
											if (r === 0 && L > 0) ei(0), z(""), setTimeout(() => Tr(1), 40);
											else if (r > 0 && L === 0) {
												if (Mr) {
													z("Check the drawer depth or the runner length first.");
													return;
												}
												if (!_n) {
													z(gn[0]);
													return;
												}
												U(), setTimeout(() => Tr(n), 120);
											} else Tr(n);
										},
										children: e
									}, r))
								}),
								/* @__PURE__ */ (0, M.jsxs)("section", {
									id: `${r}-s1`,
									"data-step": "1",
									className: `flow-step s1 ${L === 0 ? "open" : "done"}`,
									children: [/* @__PURE__ */ (0, M.jsx)("p", {
										className: "flow-num",
										children: "Step 01"
									}), L === 0 ? /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
										/* @__PURE__ */ (0, M.jsxs)("div", {
											className: "measure-head",
											children: [/* @__PURE__ */ (0, M.jsx)("h2", { children: "Measure usable space inside the drawer" }), /* @__PURE__ */ (0, M.jsx)("button", {
												type: "button",
												className: "measure-i",
												"aria-label": "Where to measure",
												"aria-expanded": Me,
												onClick: () => Ne((e) => !e),
												children: "i"
											})]
										}),
										Me && /* @__PURE__ */ (0, M.jsxs)("div", {
											className: "measure-help",
											children: [
												/* @__PURE__ */ (0, M.jsx)(ga, {}),
												/* @__PURE__ */ (0, M.jsxs)("p", { children: [/* @__PURE__ */ (0, M.jsx)("b", { children: "W" }), " between the drawer sides, not the cabinet · measure front, middle and back and use the smallest"] }),
												/* @__PURE__ */ (0, M.jsxs)("p", { children: [/* @__PURE__ */ (0, M.jsx)("b", { children: "D" }), " from the inside face of the drawer front to the back panel or bracket, whichever is closer"] }),
												/* @__PURE__ */ (0, M.jsxs)("p", { children: [/* @__PURE__ */ (0, M.jsx)("b", { children: "H" }), " from the drawer floor to the lowest thing above it with the drawer closed"] })
											]
										}),
										e.inheritedDimensions && !N && /* @__PURE__ */ (0, M.jsxs)("div", {
											className: "inherit-measurements",
											children: [
												/* @__PURE__ */ (0, M.jsx)("strong", { children: "Same dimensions as drawer A?" }),
												/* @__PURE__ */ (0, M.jsxs)("span", { children: [
													e.inheritedDimensions.width,
													" × ",
													e.inheritedDimensions.depth,
													" × ",
													e.inheritedDimensions.height,
													" mm · W × D × H"
												] }),
												/* @__PURE__ */ (0, M.jsx)(Ti, {
													variant: "outline",
													onClick: () => {
														let t = e.inheritedDimensions;
														Pe(t).length || (Xt({
															width: String(t.width),
															depth: String(t.depth),
															height: String(t.height)
														}), sn(!0), n?.(t), ei(1), z(""));
													},
													children: "Yes, I’ve checked — use these"
												}),
												/* @__PURE__ */ (0, M.jsx)("small", { children: "Different height or depth? Edit the fields below." })
											]
										}),
										/* @__PURE__ */ (0, M.jsx)("div", {
											className: "spec-row spec-3",
											children: [
												"width",
												"depth",
												"height"
											].map((e) => /* @__PURE__ */ (0, M.jsxs)("label", {
												className: "spec",
												htmlFor: `${r}-${e}`,
												children: [/* @__PURE__ */ (0, M.jsx)("span", { children: e }), /* @__PURE__ */ (0, M.jsxs)("div", {
													className: "spec-value",
													children: [/* @__PURE__ */ (0, M.jsx)("input", {
														id: `${r}-${e}`,
														type: "number",
														onWheel: (e) => e.currentTarget.blur(),
														min: "1",
														max: e === "height" ? 500 : 2e3,
														step: "0.1",
														inputMode: "decimal",
														value: Yt[e],
														placeholder: e === "width" ? "600" : e === "depth" ? "480" : "100",
														onChange: (t) => {
															e === "width" && (At.current = !0), Xt((n) => ({
																...n,
																[e]: t.target.value
															})), P(!0), Ir(""), sn(!1), ot(!1);
														}
													}), /* @__PURE__ */ (0, M.jsx)("i", { children: "mm" })]
												})]
											}, e))
										}),
										zr > 0 && /* @__PURE__ */ (0, M.jsxs)("p", {
											className: "system-warn",
											role: "alert",
											children: [
												"Did you mean ",
												zr,
												" mm wide? ",
												/* @__PURE__ */ (0, M.jsxs)("button", {
													type: "button",
													className: "inline-link",
													onClick: () => {
														Xt((e) => ({
															...e,
															width: String(zr)
														})), sn(!1), ot(!1);
													},
													children: ["Use ", zr]
												})
											]
										}),
										Br > 0 && /* @__PURE__ */ (0, M.jsxs)("p", {
											className: "system-warn",
											role: "alert",
											children: [
												"Did you mean ",
												Br,
												" mm deep? ",
												/* @__PURE__ */ (0, M.jsxs)("button", {
													type: "button",
													className: "inline-link",
													onClick: () => {
														Xt((e) => ({
															...e,
															depth: String(Br)
														})), sn(!1), ot(!1);
													},
													children: ["Use ", Br]
												})
											]
										}),
										Gr ? /* @__PURE__ */ (0, M.jsxs)("p", {
											className: "system-warn",
											role: "alert",
											children: [
												"That’s wider than the ",
												e.cabinetWidth,
												" mm cabinet. Measure inside the drawer box, side to side."
											]
										}) : Vr && Vr.to === e.cabinetWidth && /* @__PURE__ */ (0, M.jsxs)("p", {
											className: "system-note",
											children: [
												"Set to a ",
												Vr.to,
												" mm cabinet to match your measurement. ",
												/* @__PURE__ */ (0, M.jsxs)("button", {
													type: "button",
													className: "inline-link",
													onClick: () => {
														Wr(Rr), e.onCabinetWidth?.(Vr.from), Hr(null);
													},
													children: [
														"Keep ",
														Vr.from,
														" mm"
													]
												})
											]
										}),
										_n && /* @__PURE__ */ (0, M.jsxs)("p", {
											className: "clearance-note",
											children: [
												"We leave ",
												O.width,
												" mm spare across and ",
												O.depth,
												" mm front to back (",
												B.width - O.width,
												" × ",
												B.depth - O.depth,
												" mm), so trays lift in and out easily. Trays made by your drawer’s brand fit it exactly."
											]
										}),
										!xt && j.brand ? /* @__PURE__ */ (0, M.jsxs)("p", {
											className: "system-note system-same",
											children: [
												"Drawer system for this cabinet: ",
												/* @__PURE__ */ (0, M.jsx)("b", { children: Ki(j) }),
												" ",
												/* @__PURE__ */ (0, M.jsx)("button", {
													type: "button",
													className: "inline-link",
													onClick: () => Ct(!0),
													children: "Change"
												})
											]
										}) : /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
											/* @__PURE__ */ (0, M.jsxs)("div", {
												className: "system-presets",
												children: [/* @__PURE__ */ (0, M.jsxs)("span", { children: [
													"My drawer is ",
													/* @__PURE__ */ (0, M.jsx)("small", { children: "(asked once per cabinet)" }),
													Mi.length > 0 && /* @__PURE__ */ (0, M.jsx)("button", {
														type: "button",
														className: "measure-i",
														"aria-label": "How to tell which drawer you have",
														"aria-expanded": De,
														onClick: () => Oe(!0),
														children: "i"
													})
												] }), [
													["blum", "Blum"],
													["hettich", "Hettich"],
													["grass", "Grass or Häfele"],
													["dtc", "DTC"],
													["krome", "Krome"],
													["fgv", "FGV Unilux"],
													["other", "Other or not sure"]
												].map(([e, t]) => /* @__PURE__ */ (0, M.jsx)("button", {
													type: "button",
													"aria-pressed": j.brand === e,
													onClick: () => bt((t) => t.brand === e ? {
														brand: "",
														line: "",
														nl: 0
													} : {
														brand: e,
														line: "",
														nl: 0
													}),
													children: t
												}, e))]
											}),
											j.brand === "blum" && /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [/* @__PURE__ */ (0, M.jsxs)("div", {
												className: "system-presets sub",
												children: [/* @__PURE__ */ (0, M.jsxs)("span", { children: ["Which Blum drawer? ", /* @__PURE__ */ (0, M.jsx)("small", { children: "TANDEMBOX has curved metal sides, often with gallery rails; LEGRABOX has slim straight sides" })] }), [["orga", "TANDEMBOX or timber"], ["ambia", "LEGRABOX or MERIVOBOX"]].map(([e, t]) => /* @__PURE__ */ (0, M.jsx)("button", {
													type: "button",
													"aria-pressed": j.line === e,
													onClick: () => bt((t) => ({
														...t,
														line: t.line === e ? "" : e
													})),
													children: t
												}, e))]
											}), /* @__PURE__ */ (0, M.jsxs)("div", {
												className: "system-presets sub",
												children: [/* @__PURE__ */ (0, M.jsx)("span", { children: "Its length, printed on the runner" }), [
													450,
													500,
													550,
													600,
													650
												].map((e) => /* @__PURE__ */ (0, M.jsx)("button", {
													type: "button",
													"aria-pressed": j.nl === e,
													onClick: () => {
														bt((t) => ({
															...t,
															nl: t.nl === e ? 0 : e
														})), z("");
													},
													children: e
												}, e))]
											})] }),
											j.brand === "fgv" && /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [/* @__PURE__ */ (0, M.jsxs)("div", {
												className: "system-presets sub",
												children: [/* @__PURE__ */ (0, M.jsx)("span", { children: "Its length, printed on the runner" }), [
													270,
													300,
													350,
													400,
													450,
													500,
													550
												].map((e) => /* @__PURE__ */ (0, M.jsx)("button", {
													type: "button",
													"aria-pressed": j.nl === e,
													onClick: () => {
														let t = j.nl !== e;
														if (bt((n) => ({
															...n,
															nl: t ? e : 0
														})), z(""), t) {
															let t = e - 26;
															Xt((e) => ({
																...e,
																depth: String(t)
															})), sn(!1), ot(!1), Ir(`Depth set to ${t} mm, inside a ${e} FGV Unilux drawer.`);
														} else Ir("");
													},
													children: e
												}, e))]
											}), Fr && /* @__PURE__ */ (0, M.jsx)("p", {
												className: "system-note",
												children: Fr
											})] }),
											j.brand === "hettich" && /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
												/* @__PURE__ */ (0, M.jsxs)("div", {
													className: "system-presets sub",
													children: [/* @__PURE__ */ (0, M.jsxs)("span", { children: ["Which Hettich drawer? ", /* @__PURE__ */ (0, M.jsx)("small", { children: "the name is on the runner or the front fixing. Not sure? Skip this" })] }), [
														["arci", "ArciTech"],
														["ayou", "AvanTech YOU"],
														["atira", "InnoTech Atira"]
													].map(([e, t]) => /* @__PURE__ */ (0, M.jsx)("button", {
														type: "button",
														"aria-pressed": j.line === e,
														onClick: () => {
															bt((t) => ({
																...t,
																line: t.line === e ? "" : e,
																nl: 0
															})), z("");
														},
														children: t
													}, e))]
												}),
												/* @__PURE__ */ (0, M.jsxs)("div", {
													className: "system-presets sub",
													children: [/* @__PURE__ */ (0, M.jsx)("span", { children: "Its length, printed on the runner" }), (j.line === "arci" || j.line === "ayou" ? [
														[450, "450"],
														[500, "500"],
														[550, "550"],
														[600, "600"]
													] : j.line === "atira" ? [
														[420, "420"],
														[470, "470"],
														[520, "520"]
													] : [
														[420, "420"],
														[450, "450"],
														[470, "470"],
														[500, "500"],
														[520, "520"],
														[550, "550 or longer"]
													]).map(([e, t]) => /* @__PURE__ */ (0, M.jsx)("button", {
														type: "button",
														"aria-pressed": j.nl === e,
														onClick: () => {
															let t = j.nl !== e;
															if (bt((n) => ({
																...n,
																nl: t ? e : 0
															})), z(""), Pr(0), t && j.line) {
																let t = Math.floor(j.line === "atira" ? e - 7.7 : e - 27);
																Xt((e) => ({
																	...e,
																	depth: String(t)
																})), sn(!1), ot(!1), Ir(`Depth set to ${t} mm, inside a ${e} ${j.line === "atira" ? "InnoTech Atira" : j.line === "ayou" ? "AvanTech YOU" : "ArciTech"} drawer.`);
															} else Ir("");
														},
														children: t
													}, e))]
												}),
												Fr && !Mr && /* @__PURE__ */ (0, M.jsx)("p", {
													className: "system-note",
													children: Fr
												}),
												!Fr && kr > 0 && Number(Yt.depth) !== Math.floor(kr) && Nr !== j.nl && /* @__PURE__ */ (0, M.jsxs)("p", {
													className: "system-note",
													children: [
														"A ",
														j.nl,
														" ",
														j.line === "atira" ? "InnoTech Atira" : j.line === "ayou" ? "AvanTech YOU" : "ArciTech",
														" drawer is ",
														Math.floor(kr),
														" mm deep inside. ",
														/* @__PURE__ */ (0, M.jsxs)("button", {
															type: "button",
															className: "inline-link",
															onClick: () => {
																Xt((e) => ({
																	...e,
																	depth: String(Math.floor(kr))
																})), sn(!1), ot(!1), z("");
															},
															children: [
																"Use ",
																Math.floor(kr),
																" mm"
															]
														})
													]
												}),
												!Fr && Nr > 0 && Nr === j.nl && !Mr && /* @__PURE__ */ (0, M.jsxs)("p", {
													className: "system-note",
													children: [
														"Set to a ",
														Nr,
														" runner to match your measurement."
													]
												}),
												Mr ? /* @__PURE__ */ (0, M.jsxs)("p", {
													className: "system-warn",
													role: "alert",
													children: [
														"A ",
														j.nl,
														" mm Hettich drawer can't be ",
														Yt.depth,
														" mm deep inside. Check the depth, or the length printed on the runner."
													]
												}) : /* @__PURE__ */ (0, M.jsx)("p", {
													className: "system-note",
													children: j.nl && j.nl >= 550 ? "We don’t stock a Hettich OrgaTray for this drawer length yet. Every other tray that fits your measurements is shown." : j.nl ? `Hettich OrgaTrays for a ${j.nl} drawer come first.` : "Hettich organisers come first. Tap the length on the runner."
												})
											] }),
											j.brand === "grass" && /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [/* @__PURE__ */ (0, M.jsxs)("div", {
												className: "system-presets sub",
												children: [/* @__PURE__ */ (0, M.jsx)("span", { children: "Its length, printed on the runner" }), [450, 500].map((e) => /* @__PURE__ */ (0, M.jsx)("button", {
													type: "button",
													"aria-pressed": j.nl === e,
													onClick: () => bt((t) => ({
														...t,
														nl: t.nl === e ? 0 : e
													})),
													children: e
												}, e))]
											}), /* @__PURE__ */ (0, M.jsx)("p", {
												className: "system-note",
												children: "For Grass Nova Pro and Häfele Matrix Box drawers. Still measure inside the drawer."
											})] }),
											(j.brand === "dtc" || j.brand === "krome" || j.brand === "fgv") && /* @__PURE__ */ (0, M.jsxs)("p", {
												className: "system-note",
												children: [j.brand === "dtc" ? "DTC’s own stainless cutlery set is shown first. " : "", "Measure inside the drawer box: side to side between the drawer sides, front to back from the inside of the front to the back panel, and the clear height above the drawer floor. We’ll show every tray that fits."]
											}),
											j.brand === "other" && /* @__PURE__ */ (0, M.jsx)("p", {
												className: "system-note",
												children: "No problem. Measure inside the drawer and we'll show every tray that suits any drawer."
											}),
											!j.brand && /* @__PURE__ */ (0, M.jsx)("p", {
												className: "system-note",
												children: "Blum, Hettich, DTC and Krome organisers only fit their own drawers, so they show once you choose yours."
											})
										] }),
										ln ? /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [/* @__PURE__ */ (0, M.jsxs)(Ti, {
											className: "primary",
											onClick: Mn,
											children: ["Resume this drawer ", /* @__PURE__ */ (0, M.jsx)(se, { size: 16 })]
										}), /* @__PURE__ */ (0, M.jsx)("button", {
											type: "button",
											className: "start-again",
											onClick: () => {
												try {
													localStorage.removeItem(An);
												} catch {}
												un(null);
											},
											children: "Start this drawer again"
										})] }) : /* @__PURE__ */ (0, M.jsx)(Ti, {
											className: `primary${et ? " armed" : ""}`,
											onClick: U,
											children: et ? /* @__PURE__ */ (0, M.jsxs)("span", {
												className: "two-line",
												children: [/* @__PURE__ */ (0, M.jsx)("span", { children: "Measurements checked · see trays" }), /* @__PURE__ */ (0, M.jsx)("small", { children: "Usable space and drawer closing clearance" })]
											}) : /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: ["See trays that fit ", /* @__PURE__ */ (0, M.jsx)(se, { size: 16 })] })
										})
									] }) : /* @__PURE__ */ (0, M.jsxs)("div", {
										className: "flow-summary",
										children: [/* @__PURE__ */ (0, M.jsxs)("span", { children: [
											/* @__PURE__ */ (0, M.jsx)("b", { children: "Measure" }),
											B.width,
											" × ",
											B.depth,
											" × ",
											B.height,
											" mm",
											/* @__PURE__ */ (0, M.jsx)("small", { children: "W × D × H, usable inside" })
										] }), /* @__PURE__ */ (0, M.jsx)("button", {
											type: "button",
											onClick: () => {
												ei(0), setTimeout(() => Tr(1), 40);
											},
											children: "Edit"
										})]
									})]
								}),
								/* @__PURE__ */ (0, M.jsxs)("section", {
									id: `${r}-s2`,
									"data-step": "2",
									className: `flow-step s2 ${L === 0 ? "locked" : ""}`,
									children: [/* @__PURE__ */ (0, M.jsx)("p", {
										className: "flow-num",
										children: "Step 02"
									}), L === 0 ? /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [/* @__PURE__ */ (0, M.jsx)("h2", { children: "What goes in this drawer?" }), /* @__PURE__ */ (0, M.jsx)("p", {
										className: "flow-locked",
										children: "Measure your drawer first. Then tell us what it holds and we suggest a layout."
									})] }) : /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
										/* @__PURE__ */ (0, M.jsx)("div", {
											className: "section-label",
											children: /* @__PURE__ */ (0, M.jsx)("span", { children: lr.length - dr > 0 ? `${lr.length - dr} ${lr.length - dr === 1 ? "tray fits" : "trays fit"} · drag or tap to add` : H.placed.length ? "" : fr() })
										}),
										F.length > 1 && /* @__PURE__ */ (0, M.jsx)("div", {
											className: "collection-tabs room-toggle",
											role: "group",
											"aria-label": e.room ? "Room for this drawer set" : "Room",
											children: F.map((t) => /* @__PURE__ */ (0, M.jsx)("button", {
												type: "button",
												"aria-pressed": (f || F[0]) === t,
												onClick: () => {
													(f || F[0]) !== t && (e.room && e.onRoom ? e.onRoom(t) : d(t), x([]));
												},
												children: t[0].toUpperCase() + t.slice(1)
											}, t))
										}),
										/* @__PURE__ */ (0, M.jsxs)("div", {
											className: "item-tiles",
											role: "group",
											"aria-label": "What goes in this drawer?",
											children: [/* @__PURE__ */ (0, M.jsx)("span", { children: "What goes in this drawer?" }), /* @__PURE__ */ (0, M.jsx)("div", { children: la.filter((e) => e.room === (f || F[0] || "kitchen")).map((e) => /* @__PURE__ */ (0, M.jsx)("button", {
												type: "button",
												"aria-pressed": y.includes(e.key),
												onClick: () => x((t) => t.includes(e.key) ? t.filter((t) => t !== e.key) : [...t, e.key]),
												children: e.label
											}, e.key)) })]
										})
									] })]
								}),
								/* @__PURE__ */ (0, M.jsxs)("section", {
									id: `${r}-s3`,
									"data-step": "3",
									className: `flow-step s3 ${L === 0 ? "locked" : ""}`,
									children: [/* @__PURE__ */ (0, M.jsx)("p", {
										className: "flow-num",
										children: "Step 03"
									}), L === 0 ? /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [/* @__PURE__ */ (0, M.jsx)("h2", { children: "Trays and liner" }), /* @__PURE__ */ (0, M.jsx)("p", {
										className: "flow-locked",
										children: "Trays that fit your measurements show here."
									})] }) : /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
										ni && /* @__PURE__ */ (0, M.jsxs)("p", {
											className: "utensil-offer",
											children: ["Want to leave space for utensils? ", /* @__PURE__ */ (0, M.jsxs)("button", {
												type: "button",
												onClick: () => {
													jn(ni.lanes), z(`Swapped to the ${ni.size} mm organiser: ${Ji(ni.spare)} mm left for long utensils.`);
												},
												children: [
													"Yes, leave ",
													Ji(ni.spare),
													" mm"
												]
											})]
										}),
										En && /* @__PURE__ */ (0, M.jsx)("p", {
											className: "system-warn",
											role: "alert",
											children: "A cut-to-size tray should fill the drawer or sit against a framed tray. Beside open floor its cut edge shows the underside of the moulding."
										}),
										kn(),
										/* @__PURE__ */ (0, M.jsxs)("details", {
											className: "refine",
											open: !0,
											children: [/* @__PURE__ */ (0, M.jsx)("summary", { hidden: !0 }), /* @__PURE__ */ (0, M.jsxs)("div", {
												className: "collection-tabs view-tabs",
												children: [
													/* @__PURE__ */ (0, M.jsx)("button", {
														"aria-pressed": a === "all",
														onClick: () => o("all"),
														children: "All trays"
													}),
													Tt.some((e) => e.pocket || e.insertOnly) && /* @__PURE__ */ (0, M.jsxs)("button", {
														"aria-pressed": a === "nesting",
														onClick: () => o("nesting"),
														children: [/* @__PURE__ */ (0, M.jsx)(fe, { size: 14 }), " Frames & inserts"]
													}),
													Tt.some((e) => e.premium) && /* @__PURE__ */ (0, M.jsx)("button", {
														"aria-pressed": a === "premium",
														onClick: () => o("premium"),
														children: "Timber"
													})
												]
											})]
										}),
										/* @__PURE__ */ (0, M.jsx)("div", {
											className: "catalog",
											children: lr.filter((e) => re || !pr(e)).slice(0, C || re || y.length ? Infinity : 6).map((e) => /* @__PURE__ */ (0, M.jsxs)("article", {
												className: `product ${li === e.id ? "is-picked" : ""} ${pr(e) ? "is-unfit" : ""}`,
												children: [
													/* @__PURE__ */ (0, M.jsx)("button", {
														className: "product-pick",
														"aria-label": `Pick up ${Z(e.name)}`,
														onPointerDown: (t) => {
															t.pointerType === "touch" && window.matchMedia("(max-width:600px)").matches || K(t, e.id);
														},
														onClick: (t) => {
															(t.detail === 0 || window.matchMedia("(max-width:600px)").matches) && Nn(e);
														},
														disabled: !!pr(e),
														children: /* @__PURE__ */ (0, M.jsxs)("div", {
															className: "thumb",
															children: [
																/* @__PURE__ */ (0, M.jsx)(ma, { p: e }),
																e.id === lr[1]?.id && cr ? /* @__PURE__ */ (0, M.jsx)("em", {
																	className: "best-seller",
																	children: "Upgrade"
																}) : ur.has(e.name) && /* @__PURE__ */ (0, M.jsx)("em", {
																	className: "best-seller",
																	children: "Popular"
																}),
																/* @__PURE__ */ (0, M.jsxs)("span", {
																	className: "pick-affordance",
																	children: [/* @__PURE__ */ (0, M.jsx)(de, { size: 15 }), " Drag"]
																})
															]
														})
													}),
													/* @__PURE__ */ (0, M.jsx)("button", {
														type: "button",
														className: "info-dot",
														"aria-label": `About ${Z(e.name)}`,
														onPointerDown: (e) => e.stopPropagation(),
														onClick: (t) => {
															t.stopPropagation(), _t(e);
														},
														children: "i"
													}),
													(Kn.get(Gn(e))?.length ?? 0) > 1 && (() => {
														let t = Kn.get(Gn(e)), n = t[(t.findIndex((t) => t.id === e.id) + 1) % t.length];
														return /* @__PURE__ */ (0, M.jsx)("button", {
															type: "button",
															className: "card-swatch",
															title: `${e.finishName || e.finish} · tap for ${n.finishName || n.finish}`,
															"aria-label": `Change colour to ${n.finishName || n.finish}`,
															style: { background: ra(e).rim },
															onPointerDown: (e) => e.stopPropagation(),
															onClick: (t) => {
																t.stopPropagation(), Te((t) => ({
																	...t,
																	[e.name]: n.id
																}));
															}
														});
													})(),
													/* @__PURE__ */ (0, M.jsxs)("div", {
														className: "product-copy",
														children: [
															/* @__PURE__ */ (0, M.jsx)("h3", { children: Z(e.name) }),
															(() => {
																let t = [...new Map((qn.get(e.name) ?? []).map((e) => [Wn(e), e])).values()];
																if (t.length < 2) return null;
																let n = (e) => `${we(e) ? `${e.minWidth}–${e.width}` : e.width} × ${e.depth}`;
																return /* @__PURE__ */ (0, M.jsx)("select", {
																	className: "card-size",
																	"aria-label": "Size",
																	value: Wn(e),
																	onPointerDown: (e) => e.stopPropagation(),
																	onClick: (e) => e.stopPropagation(),
																	onChange: (t) => {
																		let n = (qn.get(e.name) ?? []).filter((e) => Wn(e) === t.target.value), r = n.find((t) => t.finish === e.finish) ?? n[0];
																		r && Te((t) => ({
																			...t,
																			[e.name]: r.id
																		}));
																	},
																	children: t.sort((e, t) => e.width - t.width || e.depth - t.depth).map((e) => /* @__PURE__ */ (0, M.jsxs)("option", {
																		value: Wn(e),
																		disabled: !!Yn(e),
																		children: [
																			n(e),
																			" mm",
																			Yn(e) ? ` · ${Yn(e)}` : ""
																		]
																	}, Wn(e)))
																});
															})(),
															(e.finishName || e.variantTitle && !/\)\s*w\s*x\s*\(|\d\s*w\s*x\s*\d|→|\d\s*mm\s*[x×]\s*\d/i.test(e.variantTitle)) && /* @__PURE__ */ (0, M.jsx)("small", {
																className: "variant-line",
																children: e.finishName || e.variantTitle.split(" / ").pop()
															}),
															/* @__PURE__ */ (0, M.jsxs)("span", { children: [
																we(e) ? `${e.minWidth}–${e.width}` : e.width,
																" × ",
																e.depth,
																" mm"
															] }),
															/* @__PURE__ */ (0, M.jsx)("small", { children: e.insertOnly && !Bn(e) && Ln(e) ? `Comes with its frame (${qi(Ln(e).frame.price, Ln(e).frame.currency)} of the price)` : e.pocket ? "Holds smaller inserts" : e.insertOnly ? zn(e) ? /* @__PURE__ */ (0, M.jsxs)("span", {
																className: "fits-hint",
																tabIndex: 0,
																"data-tip": Rn(e),
																children: [
																	"Insert · fits ",
																	zn(e),
																	" ",
																	zn(e) === 1 ? "frame" : "frames"
																]
															}) : "Needs a frame (sold separately)" : e.expand ? "Expands to fit" : e.trim ? "Cut to size" : e.premium ? "Premium timber" : e.tiered ? "Tiered" : e.short ? "Short tray" : e.depth < 300 ? "Small tray" : "Full-length tray" }),
															pr(e) ? /* @__PURE__ */ (0, M.jsx)("em", {
																className: "fit-reason",
																children: pr(e)
															}) : Qn(e) ? /* @__PURE__ */ (0, M.jsxs)("em", {
																className: "fit-soft",
																children: [
																	"Leaves ",
																	Qn(e),
																	" mm empty at the back"
																]
															}) : Le(e, V) ? null : /* @__PURE__ */ (0, M.jsx)("em", {
																className: "fit-soft",
																children: "Its largest size is narrower than your drawer, so two side by side would show a join"
															}),
															e.pocket && /* @__PURE__ */ (0, M.jsxs)("button", {
																className: "nesting-link",
																onClick: () => {
																	Nn(e);
																},
																disabled: !!pr(e),
																children: [/* @__PURE__ */ (0, M.jsx)(fe, { size: 13 }), " Add it, then fill its bays"]
															}),
															/* @__PURE__ */ (0, M.jsx)("b", { children: e.sku === "YOUR-PHOTO-PREVIEW" ? "Your photo" : e.insertOnly && !Bn(e) && Ln(e) ? qi(e.price + Ln(e).frame.price, e.currency) : qi(e.price, e.currency) })
														]
													})
												]
											}, e.id))
										}),
										!C && !re && !y.length && lr.length - dr > 6 && /* @__PURE__ */ (0, M.jsxs)("button", {
											type: "button",
											className: "see-all",
											onClick: () => w(!0),
											children: [
												"See all ",
												lr.length - dr,
												" trays that fit"
											]
										}),
										y.length === 1 && y[0] === "pots" && /* @__PURE__ */ (0, M.jsx)("p", {
											className: "system-note",
											children: "Pots and pans don’t need a tray. Choose a liner above to protect the drawer and wipe it clean."
										}),
										dr > 0 && /* @__PURE__ */ (0, M.jsx)("button", {
											className: "unfit-toggle",
											onClick: () => ie((e) => !e),
											children: re ? "Hide trays that don't fit" : lr.length - dr > 0 ? `Show trays that don't fit (${dr})` : `Nothing else here fits the space left. See why (${dr})`
										})
									] })]
								}),
								/* @__PURE__ */ (0, M.jsxs)("section", {
									id: `${r}-s4`,
									"data-step": "4",
									className: `flow-step s4 ${L > 0 && H.ok && (R.length > 0 || I) ? "" : "locked"}`,
									children: [/* @__PURE__ */ (0, M.jsx)("p", {
										className: "flow-num",
										children: "Step 04"
									}), L > 0 && H.ok && (R.length > 0 || I) ? /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
										/* @__PURE__ */ (0, M.jsx)("h2", { children: "Review" }),
										/* @__PURE__ */ (0, M.jsxs)("div", {
											className: "fit-note",
											children: [/* @__PURE__ */ (0, M.jsx)(ue, { size: 19 }), /* @__PURE__ */ (0, M.jsxs)("span", { children: ["Fits these measurements", /* @__PURE__ */ (0, M.jsxs)("small", { children: [
												B.width,
												" × ",
												B.depth,
												" × ",
												B.height,
												"mm"
											] })] })]
										}),
										/* @__PURE__ */ (0, M.jsxs)("div", {
											className: "review-items",
											children: [I && /* @__PURE__ */ (0, M.jsxs)("div", { children: [
												/* @__PURE__ */ (0, M.jsx)("span", {
													className: "piece-index",
													children: /* @__PURE__ */ (0, M.jsx)(fe, { size: 16 })
												}),
												/* @__PURE__ */ (0, M.jsxs)("div", { children: [
													/* @__PURE__ */ (0, M.jsxs)("b", { children: ["Drawer liner · ", I.name] }),
													/* @__PURE__ */ (0, M.jsxs)("small", { children: [I.cutToSize ? `Cut to ${Qe(I, B, e.cabinetWidth).cutLength} mm × ${I.rollWidth} mm · you trim to fit` : `${B.width} × ${B.depth} mm`, I.thickness ? ` · ${I.thickness} mm thick` : ""] }),
													Qi && /* @__PURE__ */ (0, M.jsxs)("em", {
														className: "fit-soft liner-hidden",
														children: [
															"The tray covers the whole drawer floor, so this liner won",
															"’",
															"t be seen. ",
															/* @__PURE__ */ (0, M.jsx)("button", {
																type: "button",
																className: "inline-link",
																onClick: () => Ot(""),
																children: "Take the liner off"
															})
														]
													})
												] }),
												/* @__PURE__ */ (0, M.jsx)("span", { children: I.price === void 0 ? "Price pending" : qi(I.price * bn, Sn) })
											] }), Dr.map((e, t) => /* @__PURE__ */ (0, M.jsxs)("div", { children: [
												/* @__PURE__ */ (0, M.jsx)("span", {
													className: "piece-index",
													children: t + 1
												}),
												e.p.product.image ? /* @__PURE__ */ (0, M.jsx)("img", {
													className: "review-thumb",
													src: /[?&]width=\d+/.test(e.p.product.image) ? e.p.product.image.replace(/([?&]width=)\d+/, "$1160") : e.p.product.image + (e.p.product.image.includes("?") ? "&" : "?") + "width=160",
													alt: "",
													loading: "lazy"
												}) : /* @__PURE__ */ (0, M.jsx)("span", {
													className: "review-thumb",
													"aria-hidden": "true"
												}),
												/* @__PURE__ */ (0, M.jsxs)("div", { children: [/* @__PURE__ */ (0, M.jsxs)("b", { children: [
													e.qty > 1 ? `${e.qty} × ` : "",
													Z(e.p.product.name),
													e.p.product.finishName ? /* @__PURE__ */ (0, M.jsxs)("em", {
														className: "finish-tag",
														children: [" · ", e.p.product.finishName]
													}) : null
												] }), /* @__PURE__ */ (0, M.jsx)("small", { children: e.detail })] }),
												/* @__PURE__ */ (0, M.jsx)("span", { children: qi(e.price, e.p.product.currency) })
											] }, e.key))]
										}),
										/* @__PURE__ */ (0, M.jsxs)("div", {
											className: "plan-actions",
											children: [/* @__PURE__ */ (0, M.jsxs)(Ti, {
												variant: "outline",
												onClick: () => {
													Hi("plan_printed", Xr()), ya(Zr.current, B, H.placed, e.drawerName ?? rn, !Et, I, Ki(j), zi({
														v: 1,
														n: e.drawerName ?? rn,
														s: j,
														c: e.cabinetWidth,
														d: Yt,
														l: R,
														li: Dt
													}), e.logoUrl, e.drawerIndex === void 0 ? void 0 : {
														no: e.bankNo || "1",
														set: e.bankName || "",
														letter: String.fromCharCode(65 + e.drawerIndex),
														name: e.drawerLabel && e.drawerLabel !== `Drawer ${String.fromCharCode(65 + e.drawerIndex)}` ? e.drawerLabel : ""
													});
												},
												children: [/* @__PURE__ */ (0, M.jsx)(T, { size: 16 }), " Print or save plan"]
											}), e.onConfirmSet && !e.locked && /* @__PURE__ */ (0, M.jsx)(Ti, {
												variant: "outline",
												onClick: e.onConfirmSet,
												children: "Confirm this drawer set"
											})]
										}),
										/* @__PURE__ */ (0, M.jsxs)("div", {
											className: "summary-price",
											children: [
												/* @__PURE__ */ (0, M.jsxs)("span", { children: ["Total", /* @__PURE__ */ (0, M.jsxs)("small", { children: [
													wn,
													" ",
													wn === 1 ? "piece" : "pieces",
													" · ",
													H.spare > 0 ? `${Ji(H.spare)}mm still free` : "drawer is full"
												] })] }),
												/* @__PURE__ */ (0, M.jsx)("b", { children: qi(xn, Sn) }),
												I && I.price === void 0 && /* @__PURE__ */ (0, M.jsx)("small", {
													className: "liner-price-note",
													children: "Liner price pending · excluded from total"
												})
											]
										}),
										I && !Cn && /* @__PURE__ */ (0, M.jsx)("p", {
											className: "liner-disclaimer",
											children: "Liner preview only until its roll size, thickness, price and product variant are verified. It is not included in purchasing."
										}),
										H.placed.some((e) => e.product.trim) && /* @__PURE__ */ (0, M.jsx)("p", {
											className: "policy",
											children: "Cut-to-size trays are cut at home. Check before cutting. We do not accept change-of-mind returns on cut-to-size trays. Your Australian Consumer Law rights are unaffected."
										}),
										Et ? /* @__PURE__ */ (0, M.jsx)(M.Fragment, { children: pn === "idle" ? /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [/* @__PURE__ */ (0, M.jsxs)(Ti, {
											className: "primary",
											disabled: dn || !H.ok || !on || !Cn,
											onClick: () => {
												Yr();
											},
											children: [/* @__PURE__ */ (0, M.jsx)(D, { size: 16 }), dn ? "Adding your drawer…" : "Add drawer to cart"]
										}), (Pi.get(e.setKey ?? "")?.size ?? 0) > 1 && /* @__PURE__ */ (0, M.jsxs)(Ti, {
											variant: "outline",
											disabled: dn,
											onClick: qr,
											children: [
												"Add the whole set to cart (",
												Pi.get(e.setKey ?? "").size,
												" drawers)"
											]
										})] }) : /* @__PURE__ */ (0, M.jsxs)("a", {
											className: "cart-link",
											href: (e.cartRoot ?? "/") + "cart",
											children: ["Open your cart ", /* @__PURE__ */ (0, M.jsx)(le, { size: 16 })]
										}) }) : /* @__PURE__ */ (0, M.jsxs)("div", {
											className: "demo-checkout",
											children: [/* @__PURE__ */ (0, M.jsx)(D, { size: 18 }), /* @__PURE__ */ (0, M.jsxs)("span", { children: ["Purchasing is off in this preview.", /* @__PURE__ */ (0, M.jsx)("small", { children: "Explore the layout and download an example guide." })] })]
										}),
										lt && /* @__PURE__ */ (0, M.jsxs)(Ti, {
											variant: "ghost",
											className: "quiet",
											onClick: () => ei(1),
											children: [/* @__PURE__ */ (0, M.jsx)(oe, { size: 16 }), " Keep arranging"]
										})
									] }) : /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [/* @__PURE__ */ (0, M.jsx)("h2", { children: "Review" }), /* @__PURE__ */ (0, M.jsx)("p", {
										className: "flow-locked",
										children: "Add a tray or a liner and your drawer list builds here, with cut sizes, print and email."
									})] })]
								}),
								/* @__PURE__ */ (0, M.jsxs)("div", {
									className: `flow-foot${st === 4 ? " at-review" : ""}`,
									children: [
										/* @__PURE__ */ (0, M.jsxs)("span", { children: ["Total", /* @__PURE__ */ (0, M.jsxs)("small", { children: [
											wn,
											" ",
											wn === 1 ? "piece" : "pieces",
											I && I.price === void 0 ? " · liner price pending" : ""
										] })] }),
										/* @__PURE__ */ (0, M.jsx)("b", { children: qi(xn, Sn) }),
										/* @__PURE__ */ (0, M.jsxs)(Ti, {
											className: "primary",
											onClick: () => L === 0 || lt ? U() : Tr(4),
											disabled: L > 0 && (!H.ok || !R.length && !I),
											children: [
												L === 0 ? "Plan my drawer" : "Review",
												" ",
												/* @__PURE__ */ (0, M.jsx)(se, { size: 16 })
											]
										})
									]
								})
							]
						})
					]
				})]
			}),
			te && L === 1 && /* @__PURE__ */ (0, M.jsxs)("div", {
				className: "pf-panel",
				children: [
					Bi ? /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
						/* @__PURE__ */ (0, M.jsxs)("p", {
							className: "pf-sel",
							children: [
								Z(Bi.product.name),
								" ",
								/* @__PURE__ */ (0, M.jsx)("span", { children: qi(Bi.product.price, Bi.product.currency) })
							]
						}),
						/* @__PURE__ */ (0, M.jsxs)("div", {
							className: "pf-acts",
							children: [
								/* @__PURE__ */ (0, M.jsx)("button", {
									type: "button",
									onClick: () => oi(Bi),
									children: "Turn around"
								}),
								/* @__PURE__ */ (0, M.jsx)("button", {
									type: "button",
									onClick: () => {
										jn(Ye(R, Pn(Bi))), Ut(""), nn("");
									},
									children: "Remove"
								}),
								/* @__PURE__ */ (0, M.jsx)("button", {
									type: "button",
									onClick: () => {
										Ut(""), nn("");
									},
									children: "Done"
								})
							]
						}),
						/* @__PURE__ */ (0, M.jsx)("p", {
							className: "pf-label",
							children: Yi.length ? "Swap it for" : "Nothing else fits this spot."
						})
					] }) : /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
						/* @__PURE__ */ (0, M.jsx)("p", {
							className: "pf-toast",
							children: R.length ? `${H.placed.filter((e) => !e.parentKey).length === 1 ? "One tray" : `${H.placed.filter((e) => !e.parentKey).length} trays`} in your drawer. Tap one to change it.` : "Your drawer is empty."
						}),
						R.length > 0 && /* @__PURE__ */ (0, M.jsx)("div", {
							className: "pf-acts",
							children: /* @__PURE__ */ (0, M.jsx)("button", {
								type: "button",
								onClick: wr,
								children: "Show me another layout"
							})
						}),
						/* @__PURE__ */ (0, M.jsx)("p", {
							className: "pf-label",
							children: Yi.length ? R.length ? "Add to the space left" : "Add a tray" : "No more trays fit."
						})
					] }),
					Yi.length > 0 && /* @__PURE__ */ (0, M.jsx)("div", {
						className: "pf-strip",
						children: Yi.map(({ c: e, next: t }) => /* @__PURE__ */ (0, M.jsxs)("button", {
							type: "button",
							onClick: () => {
								jn(t), Ut(""), nn("");
							},
							children: [
								/* @__PURE__ */ (0, M.jsx)("span", {
									className: "pf-pic",
									children: /* @__PURE__ */ (0, M.jsx)(ma, { p: e })
								}),
								/* @__PURE__ */ (0, M.jsx)("span", {
									className: "pf-name",
									children: Z(e.name)
								}),
								/* @__PURE__ */ (0, M.jsxs)("small", { children: [
									Math.round(e.width),
									" wide · ",
									qi(e.price, e.currency)
								] })
							]
						}, e.id))
					}),
					!j.brand && /* @__PURE__ */ (0, M.jsx)("button", {
						type: "button",
						className: "pf-link",
						onClick: () => Oe(!0),
						children: "Want trays made for your drawer? Find out which drawer you have"
					}),
					/* @__PURE__ */ (0, M.jsxs)("button", {
						type: "button",
						className: "pf-next",
						disabled: !R.length && !I || !H.ok,
						onClick: U,
						children: ["Looks good · ", qi(xn, Sn)]
					})
				]
			}),
			te && L === 2 && /* @__PURE__ */ (0, M.jsxs)("div", {
				className: "pf-panel pf-review",
				children: [
					/* @__PURE__ */ (0, M.jsx)("div", {
						className: "pf-rows",
						children: Dr.map((e) => /* @__PURE__ */ (0, M.jsxs)("div", { children: [/* @__PURE__ */ (0, M.jsxs)("span", { children: [e.qty > 1 ? `${e.qty} × ` : "", Z(e.p.product.name)] }), /* @__PURE__ */ (0, M.jsx)("span", { children: qi(e.price, e.p.product.currency) })] }, e.key))
					}),
					Xi && /* @__PURE__ */ (0, M.jsxs)("label", {
						className: "pf-switch",
						children: [/* @__PURE__ */ (0, M.jsxs)("span", { children: ["Add a drawer liner", /* @__PURE__ */ (0, M.jsx)("small", { children: Qi ? "The tray covers the whole floor, so a liner won’t be seen." : I ? I.price === void 0 ? "Price to come" : qi(I.price * bn, Sn) : "Laid under the trays. One roll covers several drawers." })] }), /* @__PURE__ */ (0, M.jsx)("input", {
							type: "checkbox",
							role: "switch",
							checked: !!I,
							onChange: (e) => Ot(e.target.checked ? Xi.id : "")
						})]
					}),
					/* @__PURE__ */ (0, M.jsxs)("div", {
						className: "pf-total",
						children: [/* @__PURE__ */ (0, M.jsx)("span", { children: "Total" }), /* @__PURE__ */ (0, M.jsx)("b", { children: qi(xn, Sn) })]
					}),
					H.placed.some((e) => e.product.trim) && /* @__PURE__ */ (0, M.jsx)("p", {
						className: "pf-fine",
						children: "Cut-to-size trays are cut at home. Check before cutting. We do not accept change-of-mind returns on cut-to-size trays. Your Australian Consumer Law rights are unaffected."
					}),
					/* @__PURE__ */ (0, M.jsx)("p", {
						className: "pf-fine",
						children: "Fit by a qualified cabinet maker."
					}),
					/* @__PURE__ */ (0, M.jsxs)("div", {
						className: "pf-links",
						children: [/* @__PURE__ */ (0, M.jsx)("button", {
							type: "button",
							className: "pf-link",
							onClick: () => ei(1),
							children: "Change something"
						}), /* @__PURE__ */ (0, M.jsx)("button", {
							type: "button",
							className: "pf-link",
							onClick: () => {
								Hi("plan_printed", Xr()), ya(Zr.current, B, H.placed, e.drawerName ?? rn, !Et, I, Ki(j), zi({
									v: 1,
									n: e.drawerName ?? rn,
									s: j,
									c: e.cabinetWidth,
									d: Yt,
									l: R,
									li: Dt
								}), e.logoUrl, e.drawerIndex === void 0 ? void 0 : {
									no: e.bankNo || "1",
									set: e.bankName || "",
									letter: String.fromCharCode(65 + e.drawerIndex),
									name: e.drawerLabel && e.drawerLabel !== `Drawer ${String.fromCharCode(65 + e.drawerIndex)}` ? e.drawerLabel : ""
								});
							},
							children: "Save or print the plan"
						})]
					}),
					Et ? pn === "idle" ? /* @__PURE__ */ (0, M.jsx)("button", {
						type: "button",
						className: "pf-next",
						disabled: dn || !H.ok || !on || !Cn,
						onClick: () => {
							Yr();
						},
						children: dn ? "Adding your drawer…" : "Add to cart"
					}) : /* @__PURE__ */ (0, M.jsx)("a", {
						className: "pf-next",
						href: (e.cartRoot ?? "/") + "cart",
						children: "Open your cart"
					}) : /* @__PURE__ */ (0, M.jsx)("p", {
						className: "pf-next pf-off",
						children: "Purchasing is off in this preview"
					})
				]
			}),
			(cn || !H.ok && L > 0) && /* @__PURE__ */ (0, M.jsxs)("div", {
				className: "notice",
				role: "status",
				"aria-live": "polite",
				children: [cn || H.errors[0], /* @__PURE__ */ (0, M.jsx)("button", {
					"aria-label": "Dismiss message",
					onClick: () => z(""),
					children: "×"
				})]
			}),
			De && /* @__PURE__ */ (0, M.jsx)("div", {
				className: "tray-info",
				role: "dialog",
				"aria-modal": "true",
				"aria-label": "Which drawer have I got?",
				onClick: () => Oe(!1),
				children: /* @__PURE__ */ (0, M.jsxs)("div", {
					className: "tray-info-card sys-help",
					onClick: (e) => e.stopPropagation(),
					children: [
						/* @__PURE__ */ (0, M.jsx)("button", {
							className: "tray-info-close",
							"aria-label": "Close",
							onClick: () => Oe(!1),
							children: "×"
						}),
						/* @__PURE__ */ (0, M.jsx)("h3", { children: "Which drawer have I got?" }),
						/* @__PURE__ */ (0, M.jsx)("p", { children: "Pull the drawer all the way out and look at its metal sides from the inside. You don’t need to take anything apart." }),
						/* @__PURE__ */ (0, M.jsx)("div", {
							className: "sys-cards",
							children: Mi.map((e) => /* @__PURE__ */ (0, M.jsxs)("article", {
								className: "sys-card",
								children: [
									e.photos.length > 0 && /* @__PURE__ */ (0, M.jsx)("div", {
										className: "sys-thumbs",
										children: e.photos.slice(0, 3).map((e) => /* @__PURE__ */ (0, M.jsx)("img", {
											src: e.src,
											alt: e.alt,
											loading: "lazy"
										}, e.src))
									}),
									/* @__PURE__ */ (0, M.jsx)("h4", { children: e.title }),
									/* @__PURE__ */ (0, M.jsx)("ul", { children: e.features.map((e) => /* @__PURE__ */ (0, M.jsx)("li", { children: e }, e)) }),
									/* @__PURE__ */ (0, M.jsx)("button", {
										type: "button",
										className: "sys-pick",
										onClick: () => {
											bt({
												brand: e.brand,
												line: e.line ?? "",
												nl: 0
											}), Oe(!1);
										},
										children: "This is my drawer"
									})
								]
							}, e.title))
						}),
						/* @__PURE__ */ (0, M.jsx)("p", {
							className: "sys-help-foot",
							children: "DTC, Krome or FGV Unilux? Check your kitchen quote or invoice, or ask your cabinet maker. Still not sure? Choose Other or not sure: every tray that fits your measurements is shown."
						})
					]
				})
			}),
			k && /* @__PURE__ */ (0, M.jsx)("div", {
				className: "tray-info",
				role: "dialog",
				"aria-modal": "true",
				"aria-label": Z(k.name),
				onClick: () => _t(null),
				children: /* @__PURE__ */ (0, M.jsxs)("div", {
					className: "tray-info-card",
					onClick: (e) => e.stopPropagation(),
					children: [
						/* @__PURE__ */ (0, M.jsx)("button", {
							className: "tray-info-close",
							"aria-label": "Close",
							onClick: () => _t(null),
							children: "×"
						}),
						k.image ? /* @__PURE__ */ (0, M.jsx)("img", {
							src: k.image,
							alt: Z(k.name),
							loading: "lazy"
						}) : /* @__PURE__ */ (0, M.jsx)("div", {
							className: "tray-info-art",
							children: /* @__PURE__ */ (0, M.jsx)(ha, { p: k })
						}),
						/* @__PURE__ */ (0, M.jsx)("h3", { children: Z(k.name) }),
						/* @__PURE__ */ (0, M.jsx)("small", { children: [k.finishName, k.brand].filter(Boolean).join(" · ") }),
						/* @__PURE__ */ (0, M.jsxs)("p", {
							className: "tray-info-size",
							children: [
								we(k) ? `${k.minWidth}–${k.width}` : k.width,
								" × ",
								k.minDepth && k.minDepth < k.depth ? `${k.minDepth}–${k.depth}` : k.depth,
								" × ",
								k.height,
								" mm",
								k.trim ? " · cut to size" : k.expand ? " · expands to fit" : ""
							]
						}),
						k.insertOnly && Rn(k) && /* @__PURE__ */ (0, M.jsx)("p", {
							className: "tray-info-fits",
							children: /* @__PURE__ */ (0, M.jsx)("b", { children: Rn(k) })
						}),
						Wi(k) && /* @__PURE__ */ (0, M.jsxs)("p", {
							className: "tray-info-fits",
							children: [/* @__PURE__ */ (0, M.jsx)("b", { children: "Holds 10 jars upright, up to 53 mm across." }), " Standard Masterfoods jars (57 mm) won’t fit."]
						}),
						k.blurb && /* @__PURE__ */ (0, M.jsx)("p", { children: k.blurb }),
						k.url && /* @__PURE__ */ (0, M.jsx)("a", {
							href: k.url,
							target: "_blank",
							rel: "noopener",
							children: "View product"
						})
					]
				})
			}),
			L === 1 && /* @__PURE__ */ (0, M.jsxs)("div", {
				className: "mobile-review-bar",
				children: [/* @__PURE__ */ (0, M.jsxs)("div", { children: [
					/* @__PURE__ */ (0, M.jsxs)("small", { children: [
						Et ? "Drawer subtotal" : "Sample total",
						" · ",
						wn,
						" ",
						wn === 1 ? "piece" : "pieces"
					] }),
					/* @__PURE__ */ (0, M.jsx)("b", { children: qi(xn, Sn) }),
					I && I.price === void 0 && /* @__PURE__ */ (0, M.jsx)("small", {
						className: "liner-price-note",
						children: "Liner price pending · excluded from total"
					})
				] }), /* @__PURE__ */ (0, M.jsxs)(Ti, {
					className: "primary",
					onClick: U,
					disabled: !R.length && !I || !H.ok,
					children: ["Review drawer ", /* @__PURE__ */ (0, M.jsx)(se, { size: 16 })]
				})]
			}),
			W && di && !mi && Math.hypot(W.x - W.startX, W.y - W.startY) >= 5 && /* @__PURE__ */ (0, M.jsxs)("div", {
				className: "drag-product",
				style: {
					left: W.x - 45,
					top: W.y - 65
				},
				children: [
					/* @__PURE__ */ (0, M.jsx)(ma, { p: di }),
					/* @__PURE__ */ (0, M.jsxs)("b", {
						className: "drag-spec",
						children: [
							/* @__PURE__ */ (0, M.jsx)("i", { children: ua(di, di.width, di.depth).brand }),
							" ",
							ua(di, di.width, di.depth).model,
							" ",
							/* @__PURE__ */ (0, M.jsx)("em", { children: ua(di, di.width, di.depth).size })
						]
					}),
					/* @__PURE__ */ (0, M.jsx)("span", { children: W.source ? /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [/* @__PURE__ */ (0, M.jsx)(he, { size: 14 }), " Release to remove"] }) : fi.length ? "Drop into your drawer" : "No space available" })
				]
			})
		]
	});
}
//#endregion
//#region components/drawer-studio.tsx
function Sa({ base: e, count: t, products: n, onOpen: r }) {
	let i = (e) => new Intl.NumberFormat("en-AU", {
		style: "currency",
		currency: n[0]?.currency || "AUD"
	}).format(e), a = Array.from({ length: t }, (t, r) => {
		let i = null;
		try {
			i = JSON.parse(localStorage.getItem(r === 0 ? e : `${e}-drawer-${r + 1}`) || "null");
		} catch {}
		let a = String.fromCharCode(65 + r), o = (i?.name || "").split(" · ").pop() || "", s = Number(i?.values?.width), c = Number(i?.values?.depth), l = Number(i?.values?.height), u = [];
		if (i?.lanes?.length && s > 0 && c > 0) try {
			u = Ie({
				width: s,
				depth: c,
				height: l || 100
			}, i.lanes, n).placed;
		} catch {
			u = [];
		}
		let d = [], f = /* @__PURE__ */ new Map();
		for (let e of u) {
			if (e.key.includes("-div")) {
				let t = d.find((t) => t.p.id === e.product.id && t.inside);
				if (t) {
					t.qty++, t.price = Math.ceil(t.qty / We(e.product)) * e.product.price, f.set(e.key, t.no);
					continue;
				}
			}
			d.push({
				no: d.length + 1,
				p: e.product,
				qty: 1,
				price: e.product.price,
				inside: e.key.includes("-div")
			}), f.set(e.key, d.length);
		}
		return {
			i: r,
			letter: a,
			name: o,
			w: s,
			d: c,
			placed: u,
			lines: d,
			pin: f,
			total: d.reduce((e, t) => e + t.price, 0)
		};
	});
	if (!a.some((e) => e.placed.length)) return null;
	let o = RegExp("([?&]width=)\\d+"), s = (e) => e ? o.test(e) ? e.replace(o, "$1160") : e + (e.includes("?") ? "&" : "?") + "width=160" : "", c = a.reduce((e, t) => e + t.total, 0);
	return /* @__PURE__ */ (0, M.jsxs)("div", {
		className: "set-overview",
		children: [a.map((e) => /* @__PURE__ */ (0, M.jsxs)("article", {
			className: "set-drawer",
			role: "button",
			tabIndex: 0,
			"aria-label": `Open drawer ${e.letter}`,
			onClick: () => r(e.i),
			onKeyDown: (t) => {
				(t.key === "Enter" || t.key === " ") && (t.preventDefault(), r(e.i));
			},
			children: [/* @__PURE__ */ (0, M.jsxs)("h4", { children: [
				/* @__PURE__ */ (0, M.jsx)("span", {
					className: "set-letter",
					children: e.letter
				}),
				e.name || `Drawer ${e.letter}`,
				e.placed.length ? /* @__PURE__ */ (0, M.jsxs)("small", { children: [
					e.w,
					" × ",
					e.d,
					" mm inside"
				] }) : null,
				/* @__PURE__ */ (0, M.jsxs)("span", {
					className: "set-open",
					children: [e.placed.length ? "Open" : "Plan this drawer", " →"]
				})
			] }), e.placed.length ? /* @__PURE__ */ (0, M.jsxs)("div", {
				className: "set-drawer-body",
				children: [/* @__PURE__ */ (0, M.jsxs)("svg", {
					className: "set-drawer-plan",
					viewBox: `-4 -4 ${e.w + 8} ${e.d + 8}`,
					role: "img",
					"aria-label": `Layout of drawer ${e.letter}`,
					children: [
						/* @__PURE__ */ (0, M.jsx)("rect", {
							width: e.w,
							height: e.d,
							fill: "#ffffff",
							stroke: "#000000",
							strokeWidth: "1.2",
							vectorEffect: "non-scaling-stroke"
						}),
						e.placed.map((t) => {
							let n = e.d - t.y - t.depth, r = t.product.trim && t.product.trimEdges !== "right" ? (t.product.width - t.width) / 2 : 0;
							return /* @__PURE__ */ (0, M.jsxs)("svg", {
								x: t.x,
								y: n,
								width: t.width,
								height: t.depth,
								viewBox: `${r} 0 ${t.width} ${t.depth}`,
								overflow: "hidden",
								children: [/* @__PURE__ */ (0, M.jsx)("rect", {
									x: r,
									width: t.width,
									height: t.depth,
									fill: t.parentKey ? "#efefef" : "#ffffff",
									stroke: "#000000",
									strokeWidth: ".8",
									vectorEffect: "non-scaling-stroke"
								}), t.product.topImage ? /* @__PURE__ */ (0, M.jsx)("image", {
									href: t.product.topImage,
									width: t.product.width,
									height: t.product.depth,
									preserveAspectRatio: "none"
								}) : t.product.compartments.map((e, n) => /* @__PURE__ */ (0, M.jsx)("rect", {
									x: e.x,
									y: t.product.depth - e.y - e.depth,
									width: e.width,
									height: e.depth,
									rx: "3",
									fill: "none",
									stroke: "#8c8c8c",
									strokeWidth: ".6",
									vectorEffect: "non-scaling-stroke"
								}, n))]
							}, t.key);
						}),
						e.placed.map((t) => {
							let n = e.pin.get(t.key);
							if (!n || t.key.includes("-div") && !t.key.endsWith("-1")) return null;
							let r = Math.max(14, e.w / 48), i = t.x + t.width - r * 1.6, a = t.key.includes("-div") ? e.d - t.y - t.depth / 2 : e.d - t.y - r * 1.6;
							return /* @__PURE__ */ (0, M.jsxs)("g", { children: [/* @__PURE__ */ (0, M.jsx)("circle", {
								cx: i,
								cy: a,
								r,
								fill: "#111"
							}), /* @__PURE__ */ (0, M.jsx)("text", {
								x: i,
								y: a + r * .38,
								textAnchor: "middle",
								fontSize: r * 1.1,
								fill: "#fff",
								children: n
							})] }, "n" + t.key);
						})
					]
				}), /* @__PURE__ */ (0, M.jsxs)("ol", {
					className: "set-drawer-items",
					children: [e.lines.map((e) => /* @__PURE__ */ (0, M.jsxs)("li", { children: [
						/* @__PURE__ */ (0, M.jsx)("span", {
							className: "piece-index",
							children: e.no
						}),
						e.p.image ? /* @__PURE__ */ (0, M.jsx)("img", {
							src: s(e.p.image),
							alt: "",
							loading: "lazy"
						}) : /* @__PURE__ */ (0, M.jsx)("span", { className: "ph" }),
						/* @__PURE__ */ (0, M.jsxs)("span", {
							className: "set-item-name",
							children: [e.qty > 1 ? `${e.qty} × ` : "", e.p.name.split(" | ")[0]]
						}),
						/* @__PURE__ */ (0, M.jsx)("span", {
							className: "set-item-price",
							children: i(e.price)
						})
					] }, e.no)), /* @__PURE__ */ (0, M.jsxs)("li", {
						className: "set-drawer-total",
						children: [/* @__PURE__ */ (0, M.jsxs)("span", { children: ["Drawer ", e.letter] }), /* @__PURE__ */ (0, M.jsx)("span", {
							className: "set-item-price",
							children: i(e.total)
						})]
					})]
				})]
			}) : null]
		}, e.i)), /* @__PURE__ */ (0, M.jsxs)("p", {
			className: "set-total",
			children: [/* @__PURE__ */ (0, M.jsx)("span", { children: "Set total" }), /* @__PURE__ */ (0, M.jsx)("strong", { children: i(c) })]
		})]
	});
}
var Ca = /* @__PURE__ */ new Map();
function wa(e) {
	return window.KLDrawerFigure ? Promise.resolve() : (Ca.has(e) || Ca.set(e, new Promise((t, n) => {
		let r = document.createElement("script");
		r.src = e, r.onload = () => t(), r.onerror = () => {
			Ca.delete(e), r.remove(), n(/* @__PURE__ */ Error("Figure unavailable"));
		}, document.head.appendChild(r);
	})), Ca.get(e));
}
var Ta = (e, t, n) => (t === e.index && n ? n : e.names[t]) || (t === 0 ? "Kitchen drawers" : `Drawer set ${t + 1}`), Ea = /* @__PURE__ */ new Map();
function Da({ n: e, w: t, url: n }) {
	let r = (0, _.useRef)(null), i = `${e}-${t}`, [, a] = (0, _.useState)(0), o = Ea.get(i) ?? "", [s, c] = (0, _.useState)(!n), [l, u] = (0, _.useState)(0);
	return (0, _.useEffect)(() => {
		if (o || !n) return;
		let s = !0, d, f;
		return wa(n).then(() => {
			let n = r.current;
			if (!s || !n || !window.KLDrawerFigure) return;
			let o = document.createElement("div");
			o.setAttribute("style", "position:fixed;left:0;top:0;width:400px;height:320px;opacity:0;pointer-events:none;z-index:-1"), o.setAttribute("data-hairline", "drawers"), n.getRootNode().appendChild(o), d = window.KLDrawerFigure.mount(o, { textContent: "" }, e, t, 720, !0), f = setTimeout(() => {
				let e = o.querySelector("svg")?.outerHTML ?? "";
				d?.destroy(), d = void 0, o.remove(), s && (/<(path|polygon|line|polyline)/.test(e) ? (Ea.set(i, e), a((e) => e + 1)) : l < 3 ? setTimeout(() => s && u((e) => e + 1), 1500) : c(!0));
			}, 1800);
		}).catch(() => s && c(!0)), () => {
			s = !1, f && clearTimeout(f), d?.destroy();
		};
	}, [
		i,
		n,
		o,
		l
	]), s ? /* @__PURE__ */ (0, M.jsx)(Oa, { n: e }) : /* @__PURE__ */ (0, M.jsx)("div", {
		ref: r,
		className: "bank-thumb",
		"data-hairline": "drawers",
		"aria-hidden": "true",
		dangerouslySetInnerHTML: o ? { __html: o } : void 0
	});
}
function Oa({ n: e }) {
	let t = (e, t, n) => `${((e + n) * .866 + 6).toFixed(1)},${((e - n) * .5 - t + 64).toFixed(1)}`, n = Array.from({ length: e }, (t, n) => n === 0 ? 100 : n === e - 1 ? 240 : 160), r = n.reduce((e, t) => e + t, 0), i = (e) => e.join(" "), a = 44, o = n.map((e) => {
		let n = e / r * 40, o = a - 1, s = a - n + 1;
		return a -= n, i([
			t(2, o, 0),
			t(56, o, 0),
			t(56, s, 0),
			t(2, s, 0)
		]);
	});
	return /* @__PURE__ */ (0, M.jsx)("svg", {
		className: "bank-sketch",
		viewBox: "0 0 92 96",
		"aria-hidden": "true",
		children: /* @__PURE__ */ (0, M.jsxs)("g", {
			fill: "#fff",
			stroke: "#8c8c8c",
			strokeWidth: ".8",
			strokeLinejoin: "round",
			children: [
				/* @__PURE__ */ (0, M.jsx)("polygon", { points: i([
					t(58, 0, 0),
					t(58, 0, 34),
					t(58, 44, 34),
					t(58, 44, 0)
				]) }),
				/* @__PURE__ */ (0, M.jsx)("polygon", { points: i([
					t(0, 44, 0),
					t(58, 44, 0),
					t(58, 44, 34),
					t(0, 44, 34)
				]) }),
				/* @__PURE__ */ (0, M.jsx)("polygon", { points: i([
					t(0, 0, 0),
					t(58, 0, 0),
					t(58, 44, 0),
					t(0, 44, 0)
				]) }),
				o.map((e, t) => /* @__PURE__ */ (0, M.jsx)("polygon", { points: e }, t))
			]
		})
	});
}
function ka({ config: e = {} }) {
	let t = e.storageKey ?? "kitchen-library-drawer-v1", n = `${t}-banks`, [r, i] = (0, _.useState)(1), [a, o] = (0, _.useState)(0), [s, c] = (0, _.useState)([]), [l, u] = (0, _.useState)([0]);
	(0, _.useEffect)(() => {
		let e = 1, r = [];
		try {
			let t = JSON.parse(localStorage.getItem(n) ?? "null");
			t && Number.isInteger(t.total) && t.total >= 1 && t.total <= 12 && (e = t.total, Array.isArray(t.names) && (r = t.names.map((e) => String(e ?? "").replace(/^Drawer bank (\d+)$/, "Drawer set $1").slice(0, 60))));
		} catch {}
		let a = location.hash.match(/ds-plan=([\w-]+)/);
		if (a && e < 12) try {
			let n = JSON.parse(Ri(a[1]));
			if (n?.v === 1 && Array.isArray(n.l) && n.d) {
				let i = `${t}-b${e + 1}`, a = `Saved: ${String(n.n ?? "Drawer").replace(/^\d+\s·\s/, "")}`.slice(0, 60);
				localStorage.setItem(`${i}-bank`, JSON.stringify({
					name: a,
					count: 1,
					width: Number(n.c) || 600,
					height: "",
					system: n.s
				})), localStorage.setItem(i, JSON.stringify({
					version: 1,
					values: n.d,
					lanes: n.l,
					name: String(n.n ?? ""),
					linerId: String(n.li ?? "")
				})), r[e] = a, e += 1, o(e - 1), u((t) => [...t, e - 1]), history.replaceState(null, "", location.pathname + location.search);
			}
		} catch {}
		i(e), c(r);
	}, [n]), (0, _.useEffect)(() => {
		try {
			localStorage.setItem(n, JSON.stringify({
				total: r,
				names: s
			}));
		} catch {}
	}, [
		n,
		r,
		s
	]);
	let d = (e) => {
		e < 0 || e >= r || (u((t) => t.includes(e) ? t : [...t, e]), o(e), window.scrollTo({ top: 0 }));
	}, f = () => {
		let e = r;
		i((e) => Math.min(12, e + 1)), u((t) => [...t, e]), o(e), window.scrollTo({ top: 0 });
	}, p = (e) => {
		try {
			let n = JSON.parse(localStorage.getItem(`${e === 0 ? t : `${t}-b${e + 1}`}-bank`) ?? "null");
			if (Number.isInteger(n?.count)) return n.count;
		} catch {}
		return 3;
	}, m = (e) => {
		try {
			let n = JSON.parse(localStorage.getItem(`${e === 0 ? t : `${t}-b${e + 1}`}-bank`) ?? "null");
			if (Number(n?.width) >= 100) return Number(n.width);
		} catch {}
		return 600;
	}, [h, g] = (0, _.useState)(0), [v, y] = (0, _.useState)(0), b = (e) => e === 0 ? t : `${t}-b${e + 1}`, x = [
		"",
		"-bank",
		"-bank-cart",
		"-bank-cart-stale",
		"-drawer-2",
		"-drawer-3",
		"-drawer-4",
		"-drawer-5",
		"-drawer-6"
	], [ee, S] = (0, _.useState)(null), C = async (e) => {
		r > 1 && S(e);
	}, w = async (e) => {
		if (S(null), r <= 1) return;
		await ce(e);
		try {
			for (let t = e; t < r - 1; t++) for (let e of x) {
				let n = localStorage.getItem(b(t + 1) + e);
				n === null ? localStorage.removeItem(b(t) + e) : localStorage.setItem(b(t) + e, n);
			}
			for (let e of x) localStorage.removeItem(b(r - 1) + e);
		} catch {}
		let t = a > e ? a - 1 : a === e ? Math.max(0, e - 1) : a;
		c((t) => t.filter((t, n) => n !== e)), i((e) => e - 1), o(t), u([t]), g((e) => e + 1);
	}, [, te] = (0, _.useState)(0);
	(0, _.useEffect)(() => {
		let e = () => te((e) => e + 1);
		return window.addEventListener("ds-set-saved", e), () => window.removeEventListener("ds-set-saved", e);
	}, []);
	let ne = (e) => {
		try {
			return !!JSON.parse(localStorage.getItem(`${b(e)}-bank`) ?? "null")?.locked;
		} catch {
			return !1;
		}
	}, re = (e, t) => {
		window.dispatchEvent(new CustomEvent("ds-set-lock", { detail: {
			key: `${b(e)}-bank`,
			locked: t
		} }));
	}, [ie, ae] = (0, _.useState)(""), oe = (e) => {
		try {
			return localStorage.getItem(e);
		} catch {
			return null;
		}
	}, se = (e) => !!oe(`${b(e)}-bank-cart`);
	async function ce(e) {
		let t = oe(`${b(e)}-bank-cart`);
		if (!t) return;
		let n = JSON.parse(t);
		try {
			let t = await fetch("/cart.js").then((e) => e.json());
			for (let e of t.items ?? []) n.includes(e.properties?._drawer_id ?? "") && await fetch("/cart/change.js", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					id: e.key,
					quantity: 0
				})
			});
			localStorage.removeItem(`${b(e)}-bank-cart`);
		} catch {}
		te((e) => e + 1);
	}
	(0, _.useEffect)(() => {
		let e = (e) => {
			let t = e.detail;
			if (t?.locked === !1) for (let e = 0; e < r; e++) `${b(e)}-bank` === t.key && (ce(e), ae("That set is back in edit mode, so it has been taken out of your cart."));
		};
		return window.addEventListener("ds-set-lock", e), () => window.removeEventListener("ds-set-lock", e);
	}, [r]);
	async function le(e, t) {
		if (!e.length) {
			ae("Confirm a drawer set first, or it is already in your cart.");
			return;
		}
		u(Array.from({ length: r }, (e, t) => t)), ae("Adding…"), await new Promise((e) => setTimeout(e, 1500));
		for (let t of e) {
			let e = oe(`${b(t)}-bank-cart`);
			if (e) {
				let t = JSON.parse(e), n = await fetch("/cart.js").then((e) => e.json());
				for (let e of n.items ?? []) t.includes(e.properties?._drawer_id ?? "") && await fetch("/cart/change.js", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({
						id: e.key,
						quantity: 0
					})
				});
			}
		}
		let n = await Ni(e.map((e) => `${b(e)}-bank`));
		for (let t of e) {
			let e = n[`${b(t)}-bank`] ?? [];
			try {
				e.length && (localStorage.setItem(`${b(t)}-bank-cart`, JSON.stringify(e)), localStorage.removeItem(`${b(t)}-bank-cart-stale`));
			} catch {}
		}
		ae(e.some((e) => !(n[`${b(e)}-bank`] ?? []).length) ? "Some drawers could not be added. Open your cart to check, then try again." : t), te((e) => e + 1);
	}
	let ue = () => le(Array.from({ length: r }, (e, t) => t).filter((e) => ne(e) && !se(e)), "Your confirmed drawer sets are in your cart. Anything else in your cart is untouched."), T = (e) => ({
		index: e,
		total: r,
		names: s,
		go: d,
		add: f,
		count: p,
		width: m,
		remove: C,
		home: v,
		isCurrent: e === a,
		locked: ne,
		setLocked: re,
		rename: (e, t) => c((n) => {
			let r = [...n];
			return r[e] = t, r;
		})
	}), [E, de] = (0, _.useState)(!1);
	(0, _.useEffect)(() => {
		E && fetch("/cart.js").then((e) => e.json()).then((e) => {
			let t = new Set((e.items ?? []).map((e) => e.properties?._drawer_id).filter(Boolean)), n = !1;
			for (let e = 0; e < r; e++) {
				let r = oe(`${b(e)}-bank-cart`);
				if (r && !JSON.parse(r).some((e) => t.has(e))) {
					try {
						localStorage.removeItem(`${b(e)}-bank-cart`);
					} catch {}
					n = !0;
				}
			}
			n && te((e) => e + 1);
		}).catch(() => {});
	}, [E, r]);
	let fe = T(a);
	return /* @__PURE__ */ (0, M.jsxs)(M.Fragment, { children: [
		ee !== null && /* @__PURE__ */ (0, M.jsx)("div", {
			className: "tray-info ds-confirm",
			role: "alertdialog",
			"aria-modal": "true",
			"aria-labelledby": "ds-del-title",
			onClick: () => S(null),
			onKeyDown: (e) => {
				e.key === "Escape" && S(null);
			},
			children: /* @__PURE__ */ (0, M.jsxs)("div", {
				className: "tray-info-card",
				onClick: (e) => e.stopPropagation(),
				children: [
					/* @__PURE__ */ (0, M.jsxs)("h3", {
						id: "ds-del-title",
						children: [
							"Delete ",
							s[ee] || (ee === 0 ? "Kitchen drawers" : `Drawer set ${ee + 1}`),
							"?"
						]
					}),
					/* @__PURE__ */ (0, M.jsxs)("p", { children: [
						"Its drawers and plans will be removed, and its items taken out of your cart. This can",
						"’",
						"t be undone."
					] }),
					/* @__PURE__ */ (0, M.jsxs)("div", {
						className: "ds-confirm-acts",
						children: [/* @__PURE__ */ (0, M.jsx)("button", {
							type: "button",
							autoFocus: !0,
							onClick: () => S(null),
							children: "Keep it"
						}), /* @__PURE__ */ (0, M.jsx)("button", {
							type: "button",
							className: "ds-confirm-go",
							onClick: () => {
								w(ee);
							},
							children: "Delete"
						})]
					})
				]
			})
		}),
		/* @__PURE__ */ (0, M.jsx)("button", {
			type: "button",
			className: "sets-tab",
			"aria-expanded": E,
			onClick: () => de((e) => !e),
			children: "Drawer sets"
		}),
		E && /* @__PURE__ */ (0, M.jsx)("div", {
			className: "sets-scrim",
			onClick: () => de(!1)
		}),
		/* @__PURE__ */ (0, M.jsxs)("aside", {
			className: `sets-panel${E ? " open" : ""}`,
			"aria-label": "Drawer sets",
			"aria-hidden": !E,
			children: [
				/* @__PURE__ */ (0, M.jsxs)("div", {
					className: "sets-head",
					children: [/* @__PURE__ */ (0, M.jsx)("h2", { children: "Drawer sets" }), /* @__PURE__ */ (0, M.jsx)("button", {
						type: "button",
						"aria-label": "Close",
						onClick: () => de(!1),
						children: "×"
					})]
				}),
				Array.from({ length: r }, (t, n) => /* @__PURE__ */ (0, M.jsxs)("div", {
					className: "sets-row",
					children: [
						/* @__PURE__ */ (0, M.jsxs)("button", {
							type: "button",
							className: "sets-item",
							"aria-current": n === a ? "true" : void 0,
							tabIndex: E ? 0 : -1,
							onClick: () => {
								d(n), y((e) => e + 1), de(!1);
							},
							children: [/* @__PURE__ */ (0, M.jsx)(Da, {
								n: p(n),
								w: m(n),
								url: e.figureUrl
							}), /* @__PURE__ */ (0, M.jsxs)("span", { children: [/* @__PURE__ */ (0, M.jsxs)("b", { children: [
								n + 1,
								" ",
								Ta(fe, n)
							] }), /* @__PURE__ */ (0, M.jsxs)("small", { children: [
								p(n),
								" ",
								p(n) === 1 ? "drawer" : "drawers"
							] })] })]
						}),
						ne(n) && (se(n) ? /* @__PURE__ */ (0, M.jsxs)("span", {
							className: "set-circle on",
							title: "In your cart",
							"aria-label": "In your cart",
							children: ["✓", /* @__PURE__ */ (0, M.jsx)(D, {
								size: 13,
								"aria-hidden": "true"
							})]
						}) : /* @__PURE__ */ (0, M.jsxs)("button", {
							type: "button",
							className: "set-circle",
							tabIndex: E ? 0 : -1,
							title: "Add this set to cart",
							"aria-label": "Add this set to cart",
							onClick: () => le([n], "This set is in your cart."),
							children: ["+", /* @__PURE__ */ (0, M.jsx)(D, {
								size: 13,
								"aria-hidden": "true"
							})]
						})),
						/* @__PURE__ */ (0, M.jsx)("button", {
							type: "button",
							className: "set-del",
							tabIndex: E ? 0 : -1,
							"aria-label": `Delete ${Ta(fe, n)}`,
							onClick: () => C(n),
							children: "×"
						})
					]
				}, n)),
				r < 12 && /* @__PURE__ */ (0, M.jsx)("button", {
					type: "button",
					className: "sets-add",
					tabIndex: E ? 0 : -1,
					onClick: () => {
						f(), de(!1);
					},
					children: "+ Add drawer set"
				}),
				/* @__PURE__ */ (0, M.jsx)("button", {
					type: "button",
					className: "sets-cart",
					tabIndex: E ? 0 : -1,
					disabled: !Array.from({ length: r }, (e, t) => t).some((e) => ne(e) && !se(e)),
					onClick: ue,
					children: Array.from({ length: r }, (e, t) => t).some((e) => ne(e) && !se(e)) ? Array.from({ length: r }, (e, t) => t).some(se) ? "Update cart" : "Add all sets to cart" : Array.from({ length: r }, (e, t) => t).some(se) ? "All sets are in your cart ✓" : "Confirm a set to add it"
				}),
				ie && /* @__PURE__ */ (0, M.jsx)("p", {
					className: "sets-note",
					children: ie
				})
			]
		}),
		l.filter((e) => e < r).map((n) => /* @__PURE__ */ (0, M.jsx)("div", {
			hidden: n !== a,
			children: /* @__PURE__ */ (0, M.jsx)(Aa, {
				config: {
					...e,
					storageKey: n === 0 ? t : `${t}-b${n + 1}`
				},
				nav: T(n)
			})
		}, `${n}-${h}`))
	] });
}
function Aa({ config: e = {}, nav: t }) {
	let [n, r] = (0, _.useState)(t.names[t.index] || (t.index === 0 ? "Kitchen drawers" : `Drawer set ${t.index + 1}`)), [i, a] = (0, _.useState)(String(t.index + 1)), [o, s] = (0, _.useState)({}), [c, l] = (0, _.useState)(!1), [u, d] = (0, _.useState)(3), [f, p] = (0, _.useState)("600"), [m, h] = (0, _.useState)(""), [g, y] = (0, _.useState)({
		brand: "",
		line: "",
		nl: 0
	}), [x, ee] = (0, _.useState)("kitchen"), [S, C] = (0, _.useState)(!1), [w, te] = (0, _.useState)("white"), ne = [...new Set((e.products ?? []).flatMap((e) => e.rooms ?? []))].filter((e) => e !== "accessory"), [re, ie] = (0, _.useState)({}), [ae, oe] = (0, _.useState)(!1);
	(0, _.useEffect)(() => {
		let t = e.storageKey ?? "kitchen-library-drawer-v1", n = [];
		for (let e = 0; e < u; e++) try {
			localStorage.getItem(e === 0 ? t : `${t}-drawer-${e + 1}`) && n.push(e);
		} catch {}
		n.length && de((e) => [...new Set([...e, ...n])]);
	}, [u, e.storageKey]);
	let se = `${e.storageKey ?? "kitchen-library-drawer-v1"}-bank`;
	(0, _.useEffect)(() => {
		let e = (e) => {
			let t = e.detail;
			t?.key === se && C(!!t.locked);
		};
		return window.addEventListener("ds-set-lock", e), () => window.removeEventListener("ds-set-lock", e);
	}, [se]), (0, _.useEffect)(() => {
		if (!ae) return;
		let e = setTimeout(() => window.dispatchEvent(new Event("ds-set-saved")), 0);
		return () => clearTimeout(e);
	}, [S, ae]);
	let ce = (e) => {
		r(e), t.rename(t.index, e);
	};
	(0, _.useEffect)(() => {
		try {
			let e = localStorage.getItem(se);
			if (e) {
				let t = JSON.parse(e);
				typeof t.name == "string" && ce(t.name.replace(/^Drawer bank (\d+)$/, "Drawer set $1").slice(0, 60)), Number.isInteger(t.count) && t.count >= 1 && t.count <= 6 && d(t.count), Number(t.width) >= 100 && Number(t.width) <= 2e3 && p(String(t.width)), Number(t.height) >= 200 && Number(t.height) <= 2400 && h(String(t.height)), typeof t.room == "string" && t.room && ee(t.room), C(!!t.locked), (t.finish === "white" || t.finish === "anthracite") && te(t.finish), t.system && typeof t.system.brand == "string" && y({
					brand: t.system.brand,
					line: String(t.system.line ?? ""),
					nl: Number(t.system.nl) || 0
				});
			}
		} catch {}
		oe(!0);
	}, [se]), (0, _.useEffect)(() => {
		if (ae) try {
			localStorage.setItem(se, JSON.stringify({
				name: n,
				count: u,
				width: f,
				height: m,
				system: g,
				room: x,
				locked: S,
				finish: w
			}));
		} catch {}
	}, [
		ae,
		n,
		u,
		f,
		m,
		se,
		g,
		x,
		S,
		w
	]);
	let le = Array.from({ length: u }, (e, t) => ({
		name: `Drawer ${String.fromCharCode(65 + t)}`,
		purpose: t === 0 ? "Top drawer · confirm your measurements" : "Confirm dimensions before arranging",
		height: String(t === 0 ? 100 : t === u - 1 ? 240 : 160)
	})), [ue, T] = (0, _.useState)(null), [E, de] = (0, _.useState)([]), [fe, pe] = (0, _.useState)(null), [D, he] = (0, _.useState)(null), [ge, _e] = (0, _.useState)(!1), [ve, ye] = (0, _.useState)({}), be = (0, _.useRef)(null), xe = (0, _.useRef)(null);
	(0, _.useRef)(null);
	let Se = (0, _.useRef)(null), Ce = (0, _.useRef)(!1), we = (0, _.useRef)(null), Te = (0, _.useRef)(null);
	Te.current = ue;
	let Ee = (0, _.useCallback)((e) => {
		if (Ce.current) return;
		Ce.current = !0;
		let t = () => (0, v.flushSync)(() => {
			e !== null && de((t) => t.includes(e) ? t : [...t, e]), T(e), pe(null), he(null);
		}), n = e === null ? -1 : e - (Te.current ?? -1) >= 0 ? 1 : -1;
		we.current ? b(we.current, t, n).finally(() => {
			Ce.current = !1;
		}) : (t(), Ce.current = !1);
	}, []), De = (0, _.useCallback)((e) => {
		if (e < 0 || e >= u || Ce.current) return;
		pe(e);
		let t = be.current, n = () => {
			t?.removeEventListener("drawer-ready", n), Se.current && clearTimeout(Se.current), Ee(e);
		};
		if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || ge) {
			n();
			return;
		}
		t?.addEventListener("drawer-ready", n, { once: !0 }), t?.dispatchEvent(new CustomEvent("drawer-open", { detail: {
			index: e,
			width: re[e]?.width ?? re[0]?.width ?? et(Number(f) || 600),
			depth: re[e]?.depth ?? re[0]?.depth ?? 480
		} })), Se.current = setTimeout(n, 4e3);
	}, [
		u,
		Ee,
		ge,
		f,
		re
	]);
	(0, _.useEffect)(() => () => {
		Se.current && clearTimeout(Se.current);
	}, []), (0, _.useEffect)(() => {
		if (ue !== null) return;
		let t = !1, n, r = be.current;
		if (!r) return;
		function i(e) {
			De(e.detail.index);
		}
		return r.addEventListener("drawer-select", i), wa(e.figureUrl ?? "/hairline/drawer-set.js").then(() => {
			t || !xe.current || (n = window.KLDrawerFigure?.mount(r, xe.current, u, Number(f) || 600, Number(m) || 720), ke());
		}).catch(() => {
			t || _e(!0);
		}), () => {
			t = !0, n?.destroy(), r.replaceChildren(), r.removeEventListener("drawer-select", i);
		};
	}, [
		ue,
		e.figureUrl,
		De,
		u,
		f,
		m
	]);
	let O = (0, _.useCallback)((e, t) => ye((n) => JSON.stringify(n[e]) === JSON.stringify(t) ? n : {
		...n,
		[e]: t
	}), []), Oe = (0, _.useRef)(ve);
	Oe.current = ve;
	function ke() {
		be.current?.dispatchEvent(new CustomEvent("drawer-contents", { detail: { drawers: Array.from({ length: u }, (e, t) => ({
			index: t,
			...Oe.current[t]?.layout ?? {
				w: 1,
				d: 1,
				h: 1,
				pieces: []
			}
		})) } }));
	}
	(0, _.useEffect)(() => {
		ue === null && ke();
	}, [
		ve,
		ue,
		u
	]);
	let Ae = (0, _.useRef)(Array.from({ length: 6 }, (e, t) => (e) => O(t, e)));
	function je(e) {
		he(e), be.current?.dispatchEvent(new CustomEvent("drawer-focus", { detail: { index: e ?? -1 } }));
	}
	(0, _.useEffect)(() => {
		t.home && t.isCurrent && Ee(null);
	}, [t.home]), (0, _.useEffect)(() => {
		if (ue === null || !window.matchMedia?.("(min-width: 901px)").matches) return;
		let e = we.current;
		window.scrollTo({ top: 0 });
		let t = () => {
			e && e.style.setProperty("--ds-top", `${Math.max(0, Math.round(e.getBoundingClientRect().top))}px`);
		};
		t();
		let n = setTimeout(t, 250);
		return window.addEventListener("resize", t), () => {
			clearTimeout(n), window.removeEventListener("resize", t);
		};
	}, [ue]);
	let Me = Object.entries(ve).filter(([e]) => Number(e) < u).reduce((e, [, t]) => e + t.pieces, 0);
	return /* @__PURE__ */ (0, M.jsxs)("div", {
		ref: we,
		className: `drawer-studio-set ${ue === null ? "set-overview" : "set-detail"}`,
		children: [
			ue === null && /* @__PURE__ */ (0, M.jsx)("section", {
				className: `cabinet-scene ${fe === null ? "" : "is-entering"}`,
				"aria-label": "Choose a drawer",
				style: { "--zoom-y": `${[
					39,
					49,
					60
				][fe ?? 1]}%` },
				children: /* @__PURE__ */ (0, M.jsxs)("div", {
					className: "cabinet-content",
					children: [
						/* @__PURE__ */ (0, M.jsxs)("div", {
							className: "cabinet-copy",
							children: [
								/* @__PURE__ */ (0, M.jsxs)("div", {
									className: "set-head",
									children: [/* @__PURE__ */ (0, M.jsxs)("label", {
										className: "set-no",
										title: "Your cabinet number, e.g. from your cabinet maker's drawings",
										children: [/* @__PURE__ */ (0, M.jsx)("span", {
											className: "sr-only",
											children: "Cabinet number"
										}), /* @__PURE__ */ (0, M.jsx)("input", {
											"aria-label": "Cabinet number",
											value: i,
											maxLength: 6,
											size: Math.max(1, i.length),
											onChange: (e) => a(e.target.value.replace(/\s+/g, "")),
											onBlur: () => {
												i || a("1");
											}
										})]
									}), /* @__PURE__ */ (0, M.jsxs)("label", {
										className: "set-title",
										children: [
											/* @__PURE__ */ (0, M.jsx)("span", {
												className: "sr-only",
												children: "Drawer set name"
											}),
											/* @__PURE__ */ (0, M.jsx)("input", {
												"aria-label": "Drawer set name",
												value: n,
												maxLength: 60,
												onChange: (e) => ce(e.target.value)
											}),
											/* @__PURE__ */ (0, M.jsx)(me, {
												size: 15,
												"aria-hidden": "true"
											})
										]
									})]
								}),
								/* @__PURE__ */ (0, M.jsxs)("div", {
									className: "spec-row",
									children: [
										/* @__PURE__ */ (0, M.jsxs)("div", {
											className: "spec",
											children: [/* @__PURE__ */ (0, M.jsx)("span", { children: "Drawers" }), /* @__PURE__ */ (0, M.jsxs)("div", {
												className: "stepper",
												children: [
													/* @__PURE__ */ (0, M.jsx)("button", {
														type: "button",
														"aria-label": "Fewer drawers",
														disabled: u <= 1,
														onClick: () => d((e) => Math.max(1, e - 1)),
														children: "−"
													}),
													/* @__PURE__ */ (0, M.jsx)("b", {
														"aria-live": "polite",
														children: u
													}),
													/* @__PURE__ */ (0, M.jsx)("button", {
														type: "button",
														"aria-label": "More drawers",
														disabled: u >= 6,
														onClick: () => d((e) => Math.min(6, e + 1)),
														children: "+"
													})
												]
											})]
										}),
										/* @__PURE__ */ (0, M.jsxs)("label", {
											className: "spec",
											htmlFor: "bank-width",
											children: [/* @__PURE__ */ (0, M.jsx)("span", { children: "Cabinet width" }), /* @__PURE__ */ (0, M.jsxs)("div", {
												className: "spec-value",
												children: [/* @__PURE__ */ (0, M.jsx)("input", {
													id: "bank-width",
													type: "number",
													onWheel: (e) => e.currentTarget.blur(),
													min: "100",
													max: "2000",
													value: f,
													onChange: (e) => p(e.target.value)
												}), /* @__PURE__ */ (0, M.jsx)("i", { children: "mm" })]
											})]
										}),
										/* @__PURE__ */ (0, M.jsxs)("label", {
											className: "spec",
											htmlFor: "bank-height",
											children: [/* @__PURE__ */ (0, M.jsxs)("span", { children: ["Height ", /* @__PURE__ */ (0, M.jsx)("em", { children: "optional" })] }), /* @__PURE__ */ (0, M.jsxs)("div", {
												className: "spec-value",
												children: [/* @__PURE__ */ (0, M.jsx)("input", {
													id: "bank-height",
													type: "number",
													onWheel: (e) => e.currentTarget.blur(),
													min: "200",
													max: "2400",
													placeholder: "720",
													value: m,
													onChange: (e) => h(e.target.value)
												}), /* @__PURE__ */ (0, M.jsx)("i", { children: "mm" })]
											})]
										})
									]
								}),
								ne.length > 1 && /* @__PURE__ */ (0, M.jsxs)("div", {
									className: "set-room",
									role: "group",
									"aria-label": "Room for this drawer set",
									children: [/* @__PURE__ */ (0, M.jsx)("span", { children: "This set is in" }), ne.map((e) => /* @__PURE__ */ (0, M.jsx)("button", {
										type: "button",
										"aria-pressed": x === e,
										onClick: () => ee(e),
										children: e[0].toUpperCase() + e.slice(1)
									}, e))]
								}),
								/* @__PURE__ */ (0, M.jsxs)("div", {
									className: "set-room",
									role: "group",
									"aria-label": "Colour for this drawer set",
									children: [
										/* @__PURE__ */ (0, M.jsx)("span", { children: "Colour" }),
										["white", "anthracite"].map((e) => /* @__PURE__ */ (0, M.jsx)("button", {
											type: "button",
											"aria-pressed": w === e,
											onClick: () => te(e),
											children: e === "white" ? "White" : "Anthracite"
										}, e)),
										/* @__PURE__ */ (0, M.jsx)("small", { children: "Timber and stainless show with either" })
									]
								})
							]
						}),
						/* @__PURE__ */ (0, M.jsxs)("div", {
							className: "cabinet-art",
							children: [
								/* @__PURE__ */ (0, M.jsx)("div", {
									className: "cabinet-art-caption",
									children: /* @__PURE__ */ (0, M.jsx)("span", {
										ref: xe,
										"aria-live": "off",
										hidden: !0,
										children: "rest"
									})
								}),
								/* @__PURE__ */ (0, M.jsx)("div", {
									ref: be,
									className: "hairline-stage",
									role: "group",
									"aria-label": `Interactive ${u}-drawer cabinet`
								}),
								ge && /* @__PURE__ */ (0, M.jsx)("p", {
									className: "figure-fallback",
									children: "Choose a drawer below to open its plan."
								})
							]
						}),
						/* @__PURE__ */ (0, M.jsxs)("div", {
							className: "drawer-pick",
							children: [/* @__PURE__ */ (0, M.jsx)("span", { children: "Tap a drawer in the picture to plan it" }), le.map((e, t) => /* @__PURE__ */ (0, M.jsx)("button", {
								type: "button",
								disabled: fe !== null,
								className: `${D === t ? "is-highlighted" : ""}${ve[t]?.pieces ? " has-plan" : ""}${t === 0 && !c ? " beckon" : ""}`,
								onMouseEnter: () => je(t),
								onMouseLeave: () => je(null),
								onFocus: () => je(t),
								onBlur: () => je(null),
								onClick: () => {
									l(!0), De(t);
								},
								"aria-label": `Open ${e.name.toLowerCase()}${ve[t]?.pieces ? `, ${ve[t].pieces} pieces planned` : ""}`,
								children: String.fromCharCode(65 + t)
							}, e.name))]
						}),
						t.total > 1 && /* @__PURE__ */ (0, M.jsx)("div", {
							className: "drawer-selector bank-grid",
							"aria-label": "Your drawer sets",
							style: { gridTemplateColumns: `repeat(${Math.min(t.total, 4)},1fr)` },
							children: Array.from({ length: t.total }, (r, i) => {
								let a = i === t.index ? u : t.count(i);
								return /* @__PURE__ */ (0, M.jsxs)("div", {
									className: "bank-cell",
									children: [/* @__PURE__ */ (0, M.jsxs)("button", {
										type: "button",
										"aria-current": i === t.index ? "true" : void 0,
										onClick: () => t.go(i),
										children: [/* @__PURE__ */ (0, M.jsx)(Da, {
											n: a,
											w: i === t.index ? Number(f) || 600 : t.width(i),
											url: e.figureUrl
										}), /* @__PURE__ */ (0, M.jsxs)("span", {
											className: "drawer-title",
											children: [/* @__PURE__ */ (0, M.jsxs)("strong", { children: [
												i + 1,
												" ",
												Ta(t, i, n)
											] }), /* @__PURE__ */ (0, M.jsxs)("small", { children: [
												a,
												" ",
												a === 1 ? "drawer" : "drawers",
												i === t.index && Me ? ` · ${Me} pieces planned` : ""
											] })]
										})]
									}), t.total > 1 && /* @__PURE__ */ (0, M.jsx)("button", {
										type: "button",
										className: "set-del",
										"aria-label": `Delete ${Ta(t, i, n)}`,
										onClick: () => t.remove(i),
										children: "×"
									})]
								}, i);
							})
						}),
						ue === null && e.products?.length ? /* @__PURE__ */ (0, M.jsx)(Sa, {
							base: e.storageKey ?? "kitchen-library-drawer-v1",
							count: u,
							products: e.products,
							onOpen: De
						}) : null
					]
				})
			}),
			ue !== null && /* @__PURE__ */ (0, M.jsx)("nav", {
				className: "drawer-context",
				"aria-label": "Current drawer",
				children: /* @__PURE__ */ (0, M.jsxs)("div", {
					className: "bank-group",
					children: [/* @__PURE__ */ (0, M.jsxs)("div", {
						className: "ctx-title",
						children: [
							/* @__PURE__ */ (0, M.jsx)("span", {
								className: "set-badge",
								"aria-hidden": "true",
								children: i
							}),
							/* @__PURE__ */ (0, M.jsx)("input", {
								"aria-label": "Drawer set name",
								className: "ctx-set",
								value: n,
								maxLength: 60,
								size: Math.max(4, n.length),
								onChange: (e) => ce(e.target.value)
							}),
							/* @__PURE__ */ (0, M.jsx)("i", {
								"aria-hidden": "true",
								children: "|"
							}),
							/* @__PURE__ */ (0, M.jsx)("span", {
								className: "set-badge drawer-badge",
								"aria-label": `Drawer ${String.fromCharCode(65 + ue)}`,
								children: String.fromCharCode(65 + ue)
							}),
							/* @__PURE__ */ (0, M.jsx)("input", {
								"aria-label": "Drawer name",
								className: "ctx-drawer",
								placeholder: "Name this drawer",
								value: o[ue] && o[ue] !== le[ue].name ? o[ue] : "",
								maxLength: 40,
								size: Math.max(16, (o[ue] ?? "").length),
								onChange: (e) => s((t) => ({
									...t,
									[ue]: e.target.value
								}))
							}),
							/* @__PURE__ */ (0, M.jsx)(me, {
								size: 15,
								"aria-hidden": "true"
							})
						]
					}), /* @__PURE__ */ (0, M.jsx)("div", {
						className: "drawer-travel",
						"aria-label": "Move between drawers",
						children: le.map((e, t) => /* @__PURE__ */ (0, M.jsx)("button", {
							"aria-label": `Go to ${e.name}`,
							"aria-current": ue === t ? "page" : void 0,
							onClick: () => {
								t !== ue && Ee(t);
							},
							children: String.fromCharCode(65 + t)
						}, t))
					})]
				})
			}),
			E.filter((e) => e < u).map((t) => /* @__PURE__ */ (0, M.jsxs)("div", {
				hidden: ue !== t,
				className: `drawer-room ${ue === t ? "room-active" : ""}${S ? " is-locked" : ""}`,
				children: [S && /* @__PURE__ */ (0, M.jsxs)("p", {
					className: "locked-note",
					children: ["This drawer set is confirmed. ", /* @__PURE__ */ (0, M.jsx)("button", {
						type: "button",
						onClick: () => window.dispatchEvent(new CustomEvent("ds-set-lock", { detail: {
							key: se,
							locked: !1
						} })),
						children: "Edit this set"
					})]
				}), /* @__PURE__ */ (0, M.jsx)(xa, {
					onSummary: Ae.current[t],
					onConfirmed: (e) => ie((n) => ({
						...n,
						[t]: e
					})),
					config: {
						...e,
						storageKey: t === 0 ? e.storageKey ?? "kitchen-library-drawer-v1" : `${e.storageKey ?? "kitchen-library-drawer-v1"}-drawer-${t + 1}`,
						previewStart: !1,
						cabinetWidth: Number(f) || void 0,
						onCabinetWidth: (e) => p(String(e)),
						system: g,
						onSystem: y,
						room: ne.length > 1 ? x : void 0,
						onRoom: ee,
						finish: w,
						initialDimensions: re[t] ?? {
							width: re[0]?.width ?? et(Number(f) || 600),
							depth: re[0]?.depth ?? 480,
							height: Number(le[t].height)
						},
						inheritedDimensions: t > 0 ? re[0] : void 0,
						initialHeight: le[t].height,
						drawerName: `${i} · ${n} · ${o[t] || le[t].name}`,
						drawerLabel: o[t] ?? le[t].name,
						setKey: se,
						drawerIndex: t,
						locked: S,
						onConfirmSet: () => window.dispatchEvent(new CustomEvent("ds-set-lock", { detail: {
							key: se,
							locked: !0
						} })),
						bankNo: i,
						bankName: n,
						onRename: (e) => s((n) => ({
							...n,
							[t]: e
						}))
					}
				})]
			}, t))
		]
	});
}
//#endregion
//#region shopify/mount.tsx
new FontFace("Abel", `url(${new URL("data:font/woff2;base64,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", "" + import.meta.url).href})`, {
	weight: "400",
	style: "normal"
}).load().then((e) => document.fonts.add(e)).catch(() => {});
var ja = class extends HTMLElement {
	connectedCallback() {
		if (this.root) return;
		let e = this.shadowRoot ?? this.attachShadow({ mode: "open" }), t = document.createElement("link");
		t.rel = "stylesheet", t.href = this.dataset.styles ?? "", e.append(t);
		let n = document.createElement("div");
		e.append(n);
		try {
			let e = this.querySelector("script[type=\"application/json\"]")?.textContent;
			if (!e) throw Error();
			let t = JSON.parse(e);
			if (!Array.isArray(t.products) && t.previewStart !== !0) throw Error();
			this.root = (0, y.createRoot)(n), this.root.render(/* @__PURE__ */ (0, M.jsx)(ka, { config: t }));
		} catch {
			n.textContent = "The drawer planner is temporarily unavailable. Please contact Kitchen Library for help.";
		}
	}
	disconnectedCallback() {
		this.root?.unmount(), this.root = void 0, this.shadowRoot && (this.shadowRoot.innerHTML = "");
	}
};
customElements.get("drawer-studio-app") || customElements.define("drawer-studio-app", ja);
//#endregion
